// AUTO-GENERATED by gatsby-node.js — do not edit
module.exports = {
  "config": {
    "siteId": "sun-tunnel-co-uk",
    "useTemplatePageContent": true,
    "maxQuotes": 4,
    "domain": "https://sun-tunnel.co.uk",
    "title": "Sun Tunnel",
    "tagline": "Free Quotes from Local Sun Tunnel Installers",
    "description": "Compare free quotes for sun tunnel installation, replacement and repairs. Local installers fit rigid and flexible sun tunnels, sun pipes and tubular skylights for dark hallways, landings and bathrooms across the UK.",
    "trade": "sun tunnel",
    "tradeNoun": "sun tunnel installer",
    "logo": "/sites/sun-tunnel-co-uk/sun-tunnels-uk-logo.png",
    "ogImage": "/sites/sun-tunnel-co-uk/sun-tunnels-uk.jpg",
    "footerBlurb": "Helping UK homeowners bring daylight into windowless rooms by comparing quotes from local sun tunnel, sun pipe and tubular skylight installers.",
    "siteIdInLeadsDoWork": "6627",
    "siteTokenInLeadsDoWork": "c0e869fa6d4501567b9b4c60bf2c6d24",
    "formIdInLeadsDoWork": "382",
    "mainKeyword": "",
    "leadsWidget": {
      "id_site": "6627",
      "id_form": "382",
      "sqn": "138472"
    },
    "proWidget": {
      "qwc_id_site": "6627",
      "qwc_spn": "834",
      "qwc_industry": "31"
    },
    "adsense": {
      "enabled": true,
      "clientId": "ca-pub-7344331352247981",
      "slots": {
        "sidebar": "4298666171",
        "inContent": "9359421160"
      }
    },
    "navLinks": [
      {
        "label": "Sun Tunnels",
        "path": "/sun-tunnel-installation/"
      },
      {
        "label": "Replacement",
        "path": "/sun-tunnel-replacement/"
      },
      {
        "label": "Repairs",
        "path": "/sun-tunnel-repairs/"
      },
      {
        "label": "Bathrooms & Hallways",
        "path": "/bathroom-hallway-sun-tunnels/"
      }
    ]
  },
  "theme": {
    "navy": "#1f1d3a",
    "blue": "#3b3a76",
    "teal": "#c9681c",
    "tealLight": "#fdf1e2",
    "accent": "#f5be3c",
    "accentDark": "#d99d17",
    "offWhite": "#fbfaf6",
    "fontDisplay": "Red Hat Display",
    "fontBody": "Nunito Sans",
    "googleFonts": "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&family=Red+Hat+Display:wght@600;700&display=swap",
    "heroGradient": "linear-gradient(135deg, #1f1d3a 0%, #3b3a76 55%, #c9681c 100%)"
  },
  "content": {
    "heroHeadlines": [
      "Local Installers for {service} in {town}, {county}",
      "{Compare|Get|Request} {Free|No-Obligation} Quotes for {service} in {town}",
      "{town} Homes: {Free|No-Obligation} Prices for {service}",
      "{Trusted|Experienced|Local} Fitters Quoting for {service} in {town}",
      "{Brighten Your|Bring Daylight Into Your|Light Up Your} {town} Home — Quotes for {service}"
    ],
    "heroSubheadlines": [
      "{Compare|Get|Request} {free|no-obligation} prices from {local|nearby|independent} installers who fit sun tunnels, sun pipes and tubular skylights {across|throughout|around} {town} and {county}.",
      "{Dark landing, windowless bathroom or gloomy hallway?|Got a room that never sees daylight?|Tired of switching lights on at midday?} {Installers covering|Sun tunnel fitters serving|Local daylighting specialists working in} {town} can {quote for|price up} {service} {quickly|without obligation}.",
      "{Tell us about your roof and the room you want to brighten|Describe the room and roof type in a short form|Share a few details about your home} and {receive|get} up to four {free|no-obligation} quotes for {service} from installers {covering|serving} {town}."
    ],
    "introParas": [
      "A sun tunnel {captures|collects|gathers} daylight through a small dome on the roof and {channels|reflects|carries} it down a mirrored tube to a ceiling diffuser, {so a hallway, landing or bathroom with no window can be lit naturally|bringing natural light into rooms that a window can't reach|lighting spaces that would otherwise rely on bulbs all day}. {Homeowners in {town}|Many households around {town}|Property owners across {county}} {choose|ask for} one because it {fits between existing rafters|needs only a small roof opening|avoids the cost and upheaval of a full roof window}.",
      "{Even in {county}, where skies are often grey,|Across {county}, even on dull days,} {overcast days|cloudy skies|winter afternoons} still {deliver|produce|provide} {plenty of|more than enough|useful} diffuse light for a well-installed sun tunnel. {That's why|It's one reason} {sun pipes and light tubes|tubular skylights and sun tunnels|sun tunnels and light pipes} {have become a popular|are now a common|are an increasingly requested} {fix|upgrade|improvement} for {dark interiors|windowless rooms|gloomy stairwells} in {town}.",
      "{Terraced houses, bungalows and semis|Older terraces, chalet bungalows and newer estate homes|Victorian terraces and modern semis alike} in {town} {often have|frequently include|commonly come with} {an internal bathroom, a central landing or a long hallway|at least one room with no outside wall|a dark core that a window can't light}. A {properly fitted|well-specified|correctly sized} sun tunnel {can brighten|can transform|can open up} that space {for a fraction of the cost of a roof window|without structural work in most cases|in a single visit}."
    ],
    "whyLocalParas": [
      "{An installer based near {town}|A {county}-based fitter|A local sun tunnel installer} {will already know|is likely to be familiar with} the {roof coverings|tile and slate types|roof styles} {common in the area|used on local housing|found across {county}}, {which matters because|and that's important since} the flashing kit {has to match|must suit|needs to be chosen for} {the exact tile profile|your particular roof covering|the roof it's sealing into}.",
      "{Choosing|Using|Working with} a {local|nearby} installer {in {town}|around {town}|serving {town}} {usually means|tends to mean|generally means} {a quicker site visit|a shorter wait for a survey|faster follow-up} and {easier aftercare|simpler access for any later adjustments|someone close by if a seal ever needs attention}. {Ask whether they will check|Make sure they check|It's worth asking them to check} the loft route {in person|on site|before quoting} rather than {pricing from photos alone|guessing the tube length|quoting blind}."
    ],
    "symptomsListItems": [
      "{A landing or hallway that needs lights on all day|Lights left on in the hallway even at midday|A stairwell that stays dim in daylight hours}",
      "{A windowless bathroom, en-suite or WC|An internal bathroom with no natural light|A shower room or WC with no window}",
      "{Drips or water marks around an existing sun tunnel diffuser|Water staining on the ceiling around a light tube|Damp patches near an old sun pipe}",
      "{Condensation or mist inside the ceiling diffuser|A diffuser that fogs up or collects droplets|Moisture trapped behind the ceiling lens}",
      "{A yellowed, cracked or brittle roof dome|A dome that has gone cloudy or crazed|A tired, discoloured sun tunnel dome on the roof}",
      "{An old sun pipe that gives off far less light than it used to|A light tube that looks dull even on bright days|Weak, grey light from an ageing tubular skylight}"
    ],
    "howItWorksSteps": [
      {
        "title": "{Tell us|Describe|Share} {about the room|your project|what you need}",
        "body": "{Complete|Fill in|Submit} our {short|quick|simple} form with your postcode, roof type and the {room|space|area} in your {town} home you want to brighten, or the fault with your existing sun tunnel."
      },
      {
        "title": "{Receive|Get|Compare} {free|no-obligation} quotes",
        "body": "{Up to four local installers covering {town} may contact you|Installers covering {town} may get in touch} to {ask about|check} the loft route and roof covering, arrange a visit and {provide|send} {a written quote|an itemised price}."
      },
      {
        "title": "{Choose|Pick|Select} your installer",
        "body": "{Compare|Review|Weigh up} tube type, diameter, flashing kit, diffuser and guarantee {at your own pace|before deciding|side by side}. There's no obligation to {go ahead|accept any quote|appoint anyone}."
      }
    ],
    "faqItems": [
      {
        "q": "How much does {service} cost in {town}?",
        "a": "{As a rough guide|Broadly speaking|For most homes}, {service} in {town} {costs|comes to} around {avgCost}. The {final price|exact figure|quote} {depends on|is driven by} the tube diameter, the length of the run through the loft, your roof covering and whether a rigid or flexible tube is used. A site visit {gives|will give} you a {firm|fixed|precise} price."
      },
      {
        "q": "How long does {service} take?",
        "a": "{Most|Typical} {service} jobs in {town} take {timeframe}. {Steep or high roofs|Long loft runs with extra tube sections|Roofs needing scaffold or a tower} can add time, {while|and} a simple run straight down into a landing ceiling is often finished {well within the day|by mid-afternoon|in a morning}."
      },
      {
        "q": "Will a sun tunnel work in a north-facing roof in {town}?",
        "a": "Yes. A sun tunnel collects diffuse daylight from the whole sky, not just direct sun, so a north-facing slope in {county} will still light a room. Output is lower than on a south-facing slope, so {an installer may suggest|it's worth asking about} a larger diameter or a rigid tube to make up the difference."
      },
      {
        "q": "Do I need planning permission for a sun tunnel in {town}?",
        "a": "{Usually not|In most cases, no}. A sun tunnel on a house roof {is normally treated as|generally counts as} permitted development as long as the dome doesn't project more than 150mm beyond the roof slope. Listed buildings, flats and some conservation areas are different, so check with the council covering {town} if any of these apply."
      }
    ],
    "nearbyTownsIntro": [
      "We also {help|connect} homeowners {find|compare} sun tunnel installers in {nearby towns and villages across|other parts of} {county}:",
      "{Looking for|Need|Searching for} {service} {nearby|elsewhere in {county}}? Installers in our network also cover:"
    ],
    "ctaHeadlines": [
      "Get Your Free {service} Quote",
      "Ready to Bring Daylight Into a Dark Room?",
      "Compare {service} Prices in {town}"
    ],
    "ctaSubtext": [
      "{Fill in|Complete|Submit} our {short|quick} form and {receive|get} up to four {free|no-obligation} quotes from installers {covering|serving} {town}.",
      "{No obligation to proceed|No pressure to accept}. {Just compare|Simply compare} prices, tube options and guarantees from sun tunnel installers in {county}."
    ],
    "countyIntros": [
      "{Homes across {county}|Properties throughout {county}|Houses and bungalows across {county}} {often have|commonly include} {a dark landing, an internal bathroom or a long hallway|rooms that no window can reach}, and a sun tunnel is {one of the simplest|one of the least disruptive|often the most affordable} ways to {light them naturally|bring in daylight|brighten them}. {Whether you live in a market town or a rural village|From the larger towns to smaller villages}, you can {compare|request} {free|no-obligation} quotes for {service} {here|below}.",
      "{Even under cloud|Even on grey days|Even in the winter months}, {county} {still gets|enjoys} {plenty of|ample|useful} diffuse daylight for a sun tunnel to {work well|perform|do its job} for most of the year. {Installers in our network cover|Our network includes fitters across} {the whole county|towns and villages throughout {county}}, {so|which means} finding someone to {price up|quote for} {service} {is straightforward|shouldn't take long}."
    ]
  },
  "services": [
    {
      "name": "Sun Tunnel Installation",
      "slug": "sun-tunnel-installation",
      "shortName": "sun tunnel installation",
      "keyword": "tunnel",
      "description": "Supply and fitting of new sun tunnels, sun pipes and tubular skylights to bring natural daylight into dark rooms, landings and corridors.",
      "keywords": [
        "sun tunnel",
        "sun pipe",
        "tubular skylight",
        "light tube",
        "solar tube",
        "light pipe"
      ],
      "avgCost": "£500–£1,400",
      "timeframe": "4–8 hours",
      "icon": "☀️",
      "id_form": "382",
      "jobProfile": {
        "cost": 3,
        "complexity": 3,
        "duration": 3,
        "dustiness": 3,
        "disturbance": 3
      }
    },
    {
      "name": "Sun Tunnel Replacement",
      "slug": "sun-tunnel-replacement",
      "shortName": "sun tunnel replacement",
      "keyword": "replace",
      "description": "Removal of old, yellowed or underperforming sun tunnels and light pipes and fitting of a modern, better-insulated replacement through the same roof opening.",
      "keywords": [
        "replace sun tunnel",
        "new sun pipe",
        "upgrade light tube",
        "replacement tubular skylight"
      ],
      "avgCost": "£450–£1,300",
      "timeframe": "3–6 hours",
      "icon": "🔄",
      "id_form": "382",
      "jobProfile": {
        "cost": 3,
        "complexity": 2,
        "duration": 2,
        "dustiness": 2,
        "disturbance": 2
      }
    },
    {
      "name": "Sun Tunnel Repairs",
      "slug": "sun-tunnel-repairs",
      "shortName": "sun tunnel repair",
      "keyword": "repair",
      "description": "Repairs to leaking, dripping or misted sun tunnels, including flashing reseals, cracked dome replacement, tube joint taping and new diffusers.",
      "keywords": [
        "leaking sun tunnel",
        "sun pipe condensation",
        "cracked dome",
        "light tube repair"
      ],
      "avgCost": "£120–£450",
      "timeframe": "1–3 hours",
      "icon": "🔧",
      "id_form": "382",
      "jobProfile": {
        "cost": 1,
        "complexity": 2,
        "duration": 1,
        "dustiness": 1,
        "disturbance": 1
      }
    },
    {
      "name": "Rigid Sun Tunnel Installation",
      "slug": "rigid-sun-tunnel-installation",
      "shortName": "rigid sun tunnel installation",
      "keyword": "rigid",
      "description": "High-output rigid sun tunnels with mirror-finish aluminium tubes, extensions and angled elbows for long loft runs and larger rooms.",
      "keywords": [
        "rigid sun tunnel",
        "rigid light tube",
        "high reflectance sun pipe",
        "long sun tunnel run"
      ],
      "avgCost": "£650–£1,800",
      "timeframe": "5–9 hours",
      "icon": "🔆",
      "id_form": "382",
      "jobProfile": {
        "cost": 5,
        "complexity": 4,
        "duration": 4,
        "dustiness": 3,
        "disturbance": 3
      }
    },
    {
      "name": "Flexible Sun Tunnel Installation",
      "slug": "flexible-sun-tunnel-installation",
      "shortName": "flexible sun tunnel installation",
      "keyword": "flexi",
      "description": "Budget-friendly flexible sun tunnels with a foil-lined concertina tube for short runs and awkward routes around purlins, pipes and ceiling joists.",
      "keywords": [
        "flexible sun tunnel",
        "flexi sun pipe",
        "flexible light tube",
        "short run sun tunnel"
      ],
      "avgCost": "£400–£950",
      "timeframe": "3–5 hours",
      "icon": "🌀",
      "id_form": "382",
      "jobProfile": {
        "cost": 2,
        "complexity": 2,
        "duration": 2,
        "dustiness": 3,
        "disturbance": 2
      }
    },
    {
      "name": "Sun Tunnels for Bathrooms and Hallways",
      "slug": "bathroom-hallway-sun-tunnels",
      "shortName": "bathroom and hallway sun tunnel installation",
      "keyword": "bathroom",
      "description": "Sun tunnels for windowless bathrooms, en-suites, WCs, hallways and landings, with insulated tubes, condensation-resistant diffusers and optional ventilation.",
      "keywords": [
        "bathroom sun tunnel",
        "hallway sun tunnel",
        "landing light tube",
        "en-suite sun pipe",
        "windowless bathroom skylight"
      ],
      "avgCost": "£550–£1,600",
      "timeframe": "4–8 hours",
      "icon": "🛁",
      "id_form": "382",
      "jobProfile": {
        "cost": 4,
        "complexity": 4,
        "duration": 3,
        "dustiness": 3,
        "disturbance": 4
      }
    }
  ],
  "locations": [
    {
      "name": "Aberdeen City",
      "slug": "aberdeen-city",
      "region": "Scotland",
      "council_name": "Aberdeen City Council",
      "council_url": "https://www.aberdeencity.gov.uk/",
      "climate": "cool, windy North Sea climate",
      "population": "225,000",
      "towns": [
        {
          "name": "Aberdeen",
          "slug": "aberdeen",
          "postcode": "AB10",
          "nearby_areas": [
            "Cove Bay",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie",
            "Ellon",
            "Westhill"
          ]
        },
        {
          "name": "Dyce",
          "slug": "dyce",
          "postcode": "AB21",
          "nearby_areas": [
            "Bucksburn",
            "Bridge of Don",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        },
        {
          "name": "Cove Bay",
          "slug": "cove-bay",
          "postcode": "AB12",
          "nearby_areas": [
            "Aberdeen",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie",
            "Ellon",
            "Westhill"
          ]
        },
        {
          "name": "Bridge of Don",
          "slug": "bridge-of-don",
          "postcode": "AB23",
          "nearby_areas": [
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        },
        {
          "name": "Bucksburn",
          "slug": "bucksburn",
          "postcode": "AB21",
          "nearby_areas": [
            "Dyce",
            "Bridge of Don",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        }
      ]
    },
    {
      "name": "Aberdeenshire",
      "slug": "aberdeenshire",
      "region": "Scotland",
      "council_name": "Aberdeenshire Council",
      "council_url": "https://www.aberdeenshire.gov.uk/",
      "climate": "cool, exposed and often windy",
      "population": "265,000",
      "towns": [
        {
          "name": "Peterhead",
          "slug": "peterhead",
          "postcode": "AB42",
          "nearby_areas": [
            "Banff",
            "Ellon",
            "Fraserburgh",
            "Turriff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn"
          ]
        },
        {
          "name": "Fraserburgh",
          "slug": "fraserburgh",
          "postcode": "AB43",
          "nearby_areas": [
            "Peterhead",
            "Banff",
            "Ellon",
            "Huntly",
            "Turriff",
            "Keith",
            "Aberdeen"
          ]
        },
        {
          "name": "Inverurie",
          "slug": "inverurie",
          "postcode": "AB51",
          "nearby_areas": [
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Westhill",
            "Turriff"
          ]
        },
        {
          "name": "Stonehaven",
          "slug": "stonehaven",
          "postcode": "AB39",
          "nearby_areas": [
            "Banchory",
            "Westhill",
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Brechin"
          ]
        },
        {
          "name": "Ellon",
          "slug": "ellon",
          "postcode": "AB41",
          "nearby_areas": [
            "Banff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie"
          ]
        },
        {
          "name": "Banchory",
          "slug": "banchory",
          "postcode": "AB31",
          "nearby_areas": [
            "Westhill",
            "Stonehaven",
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay"
          ]
        },
        {
          "name": "Banff",
          "slug": "banff",
          "postcode": "AB45",
          "nearby_areas": [
            "Ellon",
            "Aberdeen",
            "Cove Bay",
            "Turriff",
            "Bucksburn",
            "Dyce",
            "Bridge of Don"
          ]
        },
        {
          "name": "Turriff",
          "slug": "turriff",
          "postcode": "AB53",
          "nearby_areas": [
            "Huntly",
            "Keith",
            "Inverurie",
            "Aberdeen",
            "Cove Bay",
            "Banff",
            "Bucksburn"
          ]
        },
        {
          "name": "Huntly",
          "slug": "huntly",
          "postcode": "AB54",
          "nearby_areas": [
            "Turriff",
            "Keith",
            "Inverurie",
            "Banff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn"
          ]
        },
        {
          "name": "Westhill",
          "slug": "westhill",
          "postcode": "AB32",
          "nearby_areas": [
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Banchory"
          ]
        }
      ]
    },
    {
      "name": "Anglesey",
      "slug": "anglesey",
      "region": "Wales",
      "council_name": "Isle of Anglesey County Council",
      "council_url": "https://www.anglesey.gov.wales/",
      "climate": "coastal Welsh climate with wind and rain",
      "population": "70,000",
      "towns": [
        {
          "name": "Holyhead",
          "slug": "holyhead",
          "postcode": "LL65",
          "nearby_areas": [
            "Llangefni",
            "Rhosneigr",
            "Amlwch",
            "Benllech",
            "Caernarfon",
            "Menai Bridge",
            "Beaumaris"
          ]
        },
        {
          "name": "Llangefni",
          "slug": "llangefni",
          "postcode": "LL77",
          "nearby_areas": [
            "Rhosneigr",
            "Amlwch",
            "Benllech",
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Caernarfon"
          ]
        },
        {
          "name": "Amlwch",
          "slug": "amlwch",
          "postcode": "LL68",
          "nearby_areas": [
            "Benllech",
            "Bangor",
            "Rhosneigr",
            "Menai Bridge",
            "Beaumaris",
            "Llangefni",
            "Pwllheli"
          ]
        },
        {
          "name": "Beaumaris",
          "slug": "beaumaris",
          "postcode": "LL58",
          "nearby_areas": [
            "Menai Bridge",
            "Bangor",
            "Pwllheli",
            "Benllech",
            "Amlwch",
            "Porthmadog",
            "Rhosneigr"
          ]
        },
        {
          "name": "Menai Bridge",
          "slug": "menai-bridge",
          "postcode": "LL59",
          "nearby_areas": [
            "Beaumaris",
            "Bangor",
            "Benllech",
            "Pwllheli",
            "Amlwch",
            "Porthmadog",
            "Rhosneigr"
          ]
        },
        {
          "name": "Benllech",
          "slug": "benllech",
          "postcode": "LL74",
          "nearby_areas": [
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Amlwch",
            "Pwllheli",
            "Rhosneigr",
            "Llangefni"
          ]
        },
        {
          "name": "Rhosneigr",
          "slug": "rhosneigr",
          "postcode": "LL64",
          "nearby_areas": [
            "Llangefni",
            "Amlwch",
            "Benllech",
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Caernarfon"
          ]
        }
      ]
    },
    {
      "name": "Angus",
      "slug": "angus",
      "region": "Scotland",
      "council_name": "Angus Council",
      "council_url": "https://www.angus.gov.uk/",
      "climate": "cool east coast weather and damp winters",
      "population": "115,000",
      "towns": [
        {
          "name": "Forfar",
          "slug": "forfar",
          "postcode": "DD8",
          "nearby_areas": [
            "Kirriemuir",
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Lochee",
            "Brechin",
            "Carnoustie"
          ]
        },
        {
          "name": "Arbroath",
          "slug": "arbroath",
          "postcode": "DD11",
          "nearby_areas": [
            "Carnoustie",
            "Montrose",
            "Broughty Ferry",
            "Monifieth",
            "Lochee",
            "Brechin",
            "Forfar"
          ]
        },
        {
          "name": "Montrose",
          "slug": "montrose",
          "postcode": "DD10",
          "nearby_areas": [
            "Broughty Ferry",
            "Monifieth",
            "Forfar",
            "Lochee",
            "Arbroath",
            "Brechin",
            "Carnoustie"
          ]
        },
        {
          "name": "Brechin",
          "slug": "brechin",
          "postcode": "DD9",
          "nearby_areas": [
            "Montrose",
            "Forfar",
            "Arbroath",
            "Broughty Ferry",
            "Monifieth",
            "Kirriemuir",
            "Carnoustie"
          ]
        },
        {
          "name": "Carnoustie",
          "slug": "carnoustie",
          "postcode": "DD7",
          "nearby_areas": [
            "Arbroath",
            "Lochee",
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Dundee",
            "Forfar"
          ]
        },
        {
          "name": "Kirriemuir",
          "slug": "kirriemuir",
          "postcode": "DD8",
          "nearby_areas": [
            "Forfar",
            "Montrose",
            "Broughty Ferry",
            "Monifieth",
            "Lochee",
            "Brechin",
            "Blairgowrie"
          ]
        }
      ]
    },
    {
      "name": "Argyll and Bute",
      "slug": "argyll-and-bute",
      "region": "Scotland",
      "council_name": "Argyll and Bute Council",
      "council_url": "https://www.argyll-bute.gov.uk/",
      "climate": "very wet Atlantic coastal climate",
      "population": "85,000",
      "towns": [
        {
          "name": "Oban",
          "slug": "oban",
          "postcode": "PA34",
          "nearby_areas": [
            "Lochgilphead",
            "Campbeltown",
            "Dunoon",
            "Fort William",
            "Rothesay",
            "Helensburgh",
            "Gourock"
          ]
        },
        {
          "name": "Dunoon",
          "slug": "dunoon",
          "postcode": "PA23",
          "nearby_areas": [
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip",
            "Greenock",
            "Port Glasgow",
            "Campbeltown"
          ]
        },
        {
          "name": "Helensburgh",
          "slug": "helensburgh",
          "postcode": "G84",
          "nearby_areas": [
            "Gourock",
            "Rothesay",
            "Inverkip",
            "Port Glasgow",
            "Kilmacolm",
            "Alexandria",
            "Balloch"
          ]
        },
        {
          "name": "Campbeltown",
          "slug": "campbeltown",
          "postcode": "PA28",
          "nearby_areas": [
            "Lochgilphead",
            "Dunoon",
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip",
            "Greenock"
          ]
        },
        {
          "name": "Rothesay",
          "slug": "rothesay",
          "postcode": "PA20",
          "nearby_areas": [
            "Gourock",
            "Helensburgh",
            "Dunoon",
            "Inverkip",
            "Port Glasgow",
            "Greenock",
            "Kilmacolm"
          ]
        },
        {
          "name": "Lochgilphead",
          "slug": "lochgilphead",
          "postcode": "PA31",
          "nearby_areas": [
            "Campbeltown",
            "Oban",
            "Dunoon",
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip"
          ]
        }
      ]
    },
    {
      "name": "Bedfordshire",
      "slug": "bedfordshire",
      "region": "East of England",
      "council_name": "Central Bedfordshire Council",
      "council_url": "https://www.centralbedfordshire.gov.uk/",
      "climate": "cool, fairly dry climate with damp winters",
      "population": "700,000",
      "towns": [
        {
          "name": "Luton",
          "slug": "luton",
          "postcode": "LU1",
          "nearby_areas": [
            "Dunstable",
            "Houghton Regis",
            "Harpenden",
            "Hitchin",
            "Stotfold",
            "Cheshunt",
            "Hemel Hempstead"
          ]
        },
        {
          "name": "Bedford",
          "slug": "bedford",
          "postcode": "MK40",
          "nearby_areas": [
            "Kempston",
            "Sandy",
            "Ampthill",
            "Flitwick",
            "Shefford",
            "Biggleswade",
            "Potton"
          ]
        },
        {
          "name": "Dunstable",
          "slug": "dunstable",
          "postcode": "LU6",
          "nearby_areas": [
            "Houghton Regis",
            "Luton",
            "Leighton Buzzard",
            "Harpenden",
            "Berkhamsted",
            "Hemel Hempstead",
            "Stotfold"
          ]
        },
        {
          "name": "Leighton Buzzard",
          "slug": "leighton-buzzard",
          "postcode": "LU7",
          "nearby_areas": [
            "Houghton Regis",
            "Dunstable",
            "Luton",
            "Aylesbury",
            "Woburn",
            "Milton Keynes",
            "Berkhamsted"
          ]
        },
        {
          "name": "Kempston",
          "slug": "kempston",
          "postcode": "MK42",
          "nearby_areas": [
            "Ampthill",
            "Flitwick",
            "Olney",
            "Bedford",
            "Newport Pagnell",
            "Bletchley",
            "Milton Keynes"
          ]
        },
        {
          "name": "Biggleswade",
          "slug": "biggleswade",
          "postcode": "SG18",
          "nearby_areas": [
            "Potton",
            "Sandy",
            "Arlesey",
            "Shefford",
            "Stotfold",
            "Royston",
            "Bedford"
          ]
        },
        {
          "name": "Flitwick",
          "slug": "flitwick",
          "postcode": "MK45",
          "nearby_areas": [
            "Ampthill",
            "Olney",
            "Kempston",
            "Newport Pagnell",
            "Bletchley",
            "Bedford",
            "Woburn"
          ]
        },
        {
          "name": "Sandy",
          "slug": "sandy",
          "postcode": "SG19",
          "nearby_areas": [
            "Biggleswade",
            "Potton",
            "Shefford",
            "St Neots",
            "Arlesey",
            "Bedford",
            "Stotfold"
          ]
        },
        {
          "name": "Ampthill",
          "slug": "ampthill",
          "postcode": "MK45",
          "nearby_areas": [
            "Flitwick",
            "Olney",
            "Kempston",
            "Newport Pagnell",
            "Bletchley",
            "Bedford",
            "Woburn"
          ]
        },
        {
          "name": "Shefford",
          "slug": "shefford",
          "postcode": "SG17",
          "nearby_areas": [
            "Arlesey",
            "Potton",
            "Biggleswade",
            "Sandy",
            "Stotfold",
            "Royston",
            "Letchworth Garden City"
          ]
        },
        {
          "name": "Houghton Regis",
          "slug": "houghton-regis",
          "postcode": "LU5",
          "nearby_areas": [
            "Dunstable",
            "Leighton Buzzard",
            "Luton",
            "Berkhamsted",
            "Harpenden",
            "Hemel Hempstead",
            "Stotfold"
          ]
        },
        {
          "name": "Arlesey",
          "slug": "arlesey",
          "postcode": "SG15",
          "nearby_areas": [
            "Potton",
            "Shefford",
            "Biggleswade",
            "Royston",
            "Stotfold",
            "Letchworth Garden City",
            "Hitchin"
          ]
        },
        {
          "name": "Stotfold",
          "slug": "stotfold",
          "postcode": "SG5",
          "nearby_areas": [
            "Letchworth Garden City",
            "Hitchin",
            "Royston",
            "Arlesey",
            "Stevenage",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Potton",
          "slug": "potton",
          "postcode": "SG19",
          "nearby_areas": [
            "Biggleswade",
            "Arlesey",
            "Shefford",
            "Sandy",
            "Royston",
            "Stotfold",
            "Letchworth Garden City"
          ]
        },
        {
          "name": "Woburn",
          "slug": "woburn",
          "postcode": "MK17",
          "nearby_areas": [
            "Bletchley",
            "Milton Keynes",
            "Winslow",
            "Newport Pagnell",
            "Ampthill",
            "Flitwick",
            "Buckingham"
          ]
        }
      ]
    },
    {
      "name": "Berkshire",
      "slug": "berkshire",
      "region": "South East England",
      "council_name": "Berkshire (unitary authorities)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "mild winters with regular rainfall",
      "population": "950,000",
      "towns": [
        {
          "name": "Reading",
          "slug": "reading",
          "postcode": "RG1",
          "nearby_areas": [
            "Pangbourne",
            "Twyford",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Bracknell",
            "Maidenhead"
          ]
        },
        {
          "name": "Slough",
          "slug": "slough",
          "postcode": "SL1",
          "nearby_areas": [
            "Windsor",
            "Cookham",
            "Maidenhead",
            "Gerrards Cross",
            "Egham",
            "Staines-upon-Thames",
            "Ascot"
          ]
        },
        {
          "name": "Bracknell",
          "slug": "bracknell",
          "postcode": "RG12",
          "nearby_areas": [
            "Ascot",
            "Crowthorne",
            "Wokingham",
            "Camberley",
            "Cookham",
            "Windsor",
            "Maidenhead"
          ]
        },
        {
          "name": "Maidenhead",
          "slug": "maidenhead",
          "postcode": "SL6",
          "nearby_areas": [
            "Cookham",
            "Marlow",
            "Slough",
            "Windsor",
            "Bracknell",
            "Beaconsfield",
            "Ascot"
          ]
        },
        {
          "name": "Wokingham",
          "slug": "wokingham",
          "postcode": "RG40",
          "nearby_areas": [
            "Crowthorne",
            "Bracknell",
            "Ascot",
            "Reading",
            "Camberley",
            "Twyford",
            "Pangbourne"
          ]
        },
        {
          "name": "Newbury",
          "slug": "newbury",
          "postcode": "RG14",
          "nearby_areas": [
            "Thatcham",
            "Hungerford",
            "Twyford",
            "Pangbourne",
            "Basingstoke",
            "Reading",
            "Wantage"
          ]
        },
        {
          "name": "Windsor",
          "slug": "windsor",
          "postcode": "SL4",
          "nearby_areas": [
            "Slough",
            "Cookham",
            "Egham",
            "Maidenhead",
            "Ascot",
            "Staines-upon-Thames",
            "Bracknell"
          ]
        },
        {
          "name": "Thatcham",
          "slug": "thatcham",
          "postcode": "RG19",
          "nearby_areas": [
            "Newbury",
            "Hungerford",
            "Twyford",
            "Pangbourne",
            "Reading",
            "Basingstoke",
            "Didcot"
          ]
        },
        {
          "name": "Crowthorne",
          "slug": "crowthorne",
          "postcode": "RG45",
          "nearby_areas": [
            "Wokingham",
            "Camberley",
            "Bracknell",
            "Ascot",
            "Farnborough",
            "Fleet",
            "Aldershot"
          ]
        },
        {
          "name": "Sandhurst",
          "slug": "sandhurst",
          "postcode": "GU47",
          "nearby_areas": [
            "Farnham",
            "Aldershot",
            "Farnborough",
            "Fleet",
            "Alton",
            "Petworth",
            "Godalming"
          ]
        },
        {
          "name": "Ascot",
          "slug": "ascot",
          "postcode": "SL5",
          "nearby_areas": [
            "Bracknell",
            "Windsor",
            "Crowthorne",
            "Egham",
            "Camberley",
            "Wokingham",
            "Cookham"
          ]
        },
        {
          "name": "Hungerford",
          "slug": "hungerford",
          "postcode": "RG17",
          "nearby_areas": [
            "Newbury",
            "Thatcham",
            "Marlborough",
            "Wantage",
            "Andover",
            "Faringdon",
            "Royal Wootton Bassett"
          ]
        },
        {
          "name": "Twyford",
          "slug": "twyford",
          "postcode": "RG10",
          "nearby_areas": [
            "Pangbourne",
            "Reading",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Thatcham",
            "Bracknell"
          ]
        },
        {
          "name": "Cookham",
          "slug": "cookham",
          "postcode": "SL6",
          "nearby_areas": [
            "Maidenhead",
            "Slough",
            "Windsor",
            "Marlow",
            "Ascot",
            "Bracknell",
            "Beaconsfield"
          ]
        },
        {
          "name": "Pangbourne",
          "slug": "pangbourne",
          "postcode": "RG8",
          "nearby_areas": [
            "Twyford",
            "Reading",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Thatcham",
            "Bracknell"
          ]
        }
      ]
    },
    {
      "name": "Blaenau Gwent",
      "slug": "blaenau-gwent",
      "region": "Wales",
      "council_name": "Blaenau Gwent County Borough Council",
      "council_url": "https://www.blaenau-gwent.gov.uk/",
      "climate": "wet valleys climate and cool winters",
      "population": "66,000",
      "towns": [
        {
          "name": "Ebbw Vale",
          "slug": "ebbw-vale",
          "postcode": "NP23",
          "nearby_areas": [
            "Tredegar",
            "Abertillery",
            "Abersychan",
            "Brynmawr",
            "Nantyglo",
            "Merthyr Tydfil",
            "Blackwood"
          ]
        },
        {
          "name": "Tredegar",
          "slug": "tredegar",
          "postcode": "NP22",
          "nearby_areas": [
            "Ebbw Vale",
            "Abertillery",
            "Merthyr Tydfil",
            "Blackwood",
            "Treharris",
            "Mountain Ash",
            "Brynmawr"
          ]
        },
        {
          "name": "Abertillery",
          "slug": "abertillery",
          "postcode": "NP13",
          "nearby_areas": [
            "Abersychan",
            "Ebbw Vale",
            "Pontypool",
            "Blackwood",
            "Tredegar",
            "Abergavenny",
            "Treharris"
          ]
        },
        {
          "name": "Brynmawr",
          "slug": "brynmawr",
          "postcode": "NP23",
          "nearby_areas": [
            "Nantyglo",
            "Blaenavon",
            "New Inn",
            "Abergavenny",
            "Ebbw Vale",
            "Malpas",
            "Newport"
          ]
        },
        {
          "name": "Blaina",
          "slug": "blaina",
          "postcode": "NP13",
          "nearby_areas": [
            "Raglan",
            "Usk",
            "Llandrindod Wells",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Builth Wells"
          ]
        },
        {
          "name": "Nantyglo",
          "slug": "nantyglo",
          "postcode": "NP23",
          "nearby_areas": [
            "Brynmawr",
            "Blaenavon",
            "New Inn",
            "Abergavenny",
            "Ebbw Vale",
            "Malpas",
            "Newport"
          ]
        }
      ]
    },
    {
      "name": "Bridgend",
      "slug": "bridgend",
      "region": "Wales",
      "council_name": "Bridgend County Borough Council",
      "council_url": "https://www.bridgend.gov.uk/",
      "climate": "mild coastal climate with regular rain",
      "population": "145,000",
      "towns": [
        {
          "name": "Bridgend",
          "slug": "bridgend",
          "postcode": "CF31",
          "nearby_areas": [
            "Ogmore Vale",
            "Porthcawl",
            "Pencoed",
            "Pyle",
            "Maesteg",
            "Roath",
            "Llantwit Major"
          ]
        },
        {
          "name": "Porthcawl",
          "slug": "porthcawl",
          "postcode": "CF36",
          "nearby_areas": [
            "Bridgend",
            "Maesteg",
            "Port Talbot",
            "Ogmore Vale",
            "Pencoed",
            "Pyle",
            "Llantwit Major"
          ]
        },
        {
          "name": "Maesteg",
          "slug": "maesteg",
          "postcode": "CF34",
          "nearby_areas": [
            "Port Talbot",
            "Pyle",
            "Pencoed",
            "Ogmore Vale",
            "Neath",
            "Bridgend",
            "Treorchy"
          ]
        },
        {
          "name": "Pencoed",
          "slug": "pencoed",
          "postcode": "CF35",
          "nearby_areas": [
            "Pyle",
            "Ogmore Vale",
            "Roath",
            "Tonypandy",
            "Porth",
            "Bridgend",
            "Radyr"
          ]
        },
        {
          "name": "Pyle",
          "slug": "pyle",
          "postcode": "CF33",
          "nearby_areas": [
            "Pencoed",
            "Ogmore Vale",
            "Roath",
            "Tonypandy",
            "Porth",
            "Bridgend",
            "Treorchy"
          ]
        },
        {
          "name": "Ogmore Vale",
          "slug": "ogmore-vale",
          "postcode": "CF32",
          "nearby_areas": [
            "Pencoed",
            "Pyle",
            "Roath",
            "Tonypandy",
            "Bridgend",
            "Porth",
            "Radyr"
          ]
        }
      ]
    },
    {
      "name": "Bristol",
      "slug": "bristol",
      "region": "South West England",
      "council_name": "Bristol City Council",
      "council_url": "https://www.bristol.gov.uk/",
      "climate": "mild and damp with Atlantic rainfall",
      "population": "480,000",
      "towns": [
        {
          "name": "Bristol",
          "slug": "bristol",
          "postcode": "BS1",
          "nearby_areas": [
            "Bedminster",
            "Knowle",
            "St George",
            "Redland",
            "Bishopston",
            "Horfield",
            "Clifton"
          ]
        },
        {
          "name": "Clifton",
          "slug": "clifton",
          "postcode": "BS8",
          "nearby_areas": [
            "Henleaze",
            "Bishopston",
            "Horfield",
            "Redland",
            "St George",
            "Knowle",
            "Kingswood"
          ]
        },
        {
          "name": "Bedminster",
          "slug": "bedminster",
          "postcode": "BS3",
          "nearby_areas": [
            "Knowle",
            "St George",
            "Redland",
            "Bristol",
            "Bishopston",
            "Horfield",
            "Clifton"
          ]
        },
        {
          "name": "Redland",
          "slug": "redland",
          "postcode": "BS6",
          "nearby_areas": [
            "Bishopston",
            "Horfield",
            "St George",
            "Clifton",
            "Knowle",
            "Henleaze",
            "Bedminster"
          ]
        },
        {
          "name": "Filton",
          "slug": "filton",
          "postcode": "BS34",
          "nearby_areas": [
            "Thornbury",
            "Yate",
            "Keynsham",
            "Portishead",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Fishponds",
          "slug": "fishponds",
          "postcode": "BS16",
          "nearby_areas": [
            "Nailsea",
            "Kingswood",
            "Yate",
            "Thornbury",
            "Filton",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Horfield",
          "slug": "horfield",
          "postcode": "BS7",
          "nearby_areas": [
            "Bishopston",
            "Clifton",
            "Redland",
            "Henleaze",
            "St George",
            "Knowle",
            "Bedminster"
          ]
        },
        {
          "name": "Kingswood",
          "slug": "kingswood",
          "postcode": "BS15",
          "nearby_areas": [
            "Fishponds",
            "Nailsea",
            "Yate",
            "Filton",
            "Thornbury",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Bishopston",
          "slug": "bishopston",
          "postcode": "BS7",
          "nearby_areas": [
            "Horfield",
            "Clifton",
            "Redland",
            "Henleaze",
            "St George",
            "Knowle",
            "Bedminster"
          ]
        },
        {
          "name": "Knowle",
          "slug": "knowle",
          "postcode": "BS4",
          "nearby_areas": [
            "St George",
            "Bedminster",
            "Redland",
            "Bishopston",
            "Horfield",
            "Clifton",
            "Henleaze"
          ]
        },
        {
          "name": "St George",
          "slug": "st-george",
          "postcode": "BS5",
          "nearby_areas": [
            "Redland",
            "Knowle",
            "Bishopston",
            "Horfield",
            "Bedminster",
            "Clifton",
            "Henleaze"
          ]
        },
        {
          "name": "Henleaze",
          "slug": "henleaze",
          "postcode": "BS9",
          "nearby_areas": [
            "Clifton",
            "Bishopston",
            "Horfield",
            "Redland",
            "St George",
            "Kingswood",
            "Fishponds"
          ]
        }
      ]
    },
    {
      "name": "Buckinghamshire",
      "slug": "buckinghamshire",
      "region": "South East England",
      "council_name": "Buckinghamshire Council",
      "council_url": "https://www.buckinghamshire.gov.uk/",
      "climate": "mild but damp winters and warm summers",
      "population": "850,000",
      "towns": [
        {
          "name": "Milton Keynes",
          "slug": "milton-keynes",
          "postcode": "MK9",
          "nearby_areas": [
            "Bletchley",
            "Newport Pagnell",
            "Woburn",
            "Winslow",
            "Olney",
            "Ampthill",
            "Flitwick"
          ]
        },
        {
          "name": "High Wycombe",
          "slug": "high-wycombe",
          "postcode": "HP11",
          "nearby_areas": [
            "Marlow",
            "Beaconsfield",
            "Amersham",
            "Princes Risborough",
            "Wendover",
            "Chesham",
            "Maidenhead"
          ]
        },
        {
          "name": "Aylesbury",
          "slug": "aylesbury",
          "postcode": "HP20",
          "nearby_areas": [
            "Wendover",
            "Princes Risborough",
            "Thame",
            "Chesham",
            "Leighton Buzzard",
            "Amersham",
            "High Wycombe"
          ]
        },
        {
          "name": "Amersham",
          "slug": "amersham",
          "postcode": "HP6",
          "nearby_areas": [
            "Chesham",
            "Beaconsfield",
            "Gerrards Cross",
            "High Wycombe",
            "Wendover",
            "Berkhamsted",
            "Rickmansworth"
          ]
        },
        {
          "name": "Chesham",
          "slug": "chesham",
          "postcode": "HP5",
          "nearby_areas": [
            "Amersham",
            "Berkhamsted",
            "Wendover",
            "Beaconsfield",
            "High Wycombe",
            "Hemel Hempstead",
            "Gerrards Cross"
          ]
        },
        {
          "name": "Marlow",
          "slug": "marlow",
          "postcode": "SL7",
          "nearby_areas": [
            "High Wycombe",
            "Maidenhead",
            "Beaconsfield",
            "Cookham",
            "Henley-on-Thames",
            "Gerrards Cross",
            "Slough"
          ]
        },
        {
          "name": "Buckingham",
          "slug": "buckingham",
          "postcode": "MK18",
          "nearby_areas": [
            "Winslow",
            "Brackley",
            "Woburn",
            "Milton Keynes",
            "Bletchley",
            "Bicester",
            "Towcester"
          ]
        },
        {
          "name": "Beaconsfield",
          "slug": "beaconsfield",
          "postcode": "HP9",
          "nearby_areas": [
            "Gerrards Cross",
            "High Wycombe",
            "Amersham",
            "Marlow",
            "Chesham",
            "Maidenhead",
            "Cookham"
          ]
        },
        {
          "name": "Bletchley",
          "slug": "bletchley",
          "postcode": "MK2",
          "nearby_areas": [
            "Milton Keynes",
            "Newport Pagnell",
            "Woburn",
            "Winslow",
            "Olney",
            "Ampthill",
            "Flitwick"
          ]
        },
        {
          "name": "Newport Pagnell",
          "slug": "newport-pagnell",
          "postcode": "MK16",
          "nearby_areas": [
            "Bletchley",
            "Milton Keynes",
            "Olney",
            "Ampthill",
            "Flitwick",
            "Woburn",
            "Kempston"
          ]
        },
        {
          "name": "Princes Risborough",
          "slug": "princes-risborough",
          "postcode": "HP27",
          "nearby_areas": [
            "Wendover",
            "Aylesbury",
            "Thame",
            "High Wycombe",
            "Chesham",
            "Amersham",
            "Marlow"
          ]
        },
        {
          "name": "Gerrards Cross",
          "slug": "gerrards-cross",
          "postcode": "SL9",
          "nearby_areas": [
            "Beaconsfield",
            "Rickmansworth",
            "Slough",
            "Amersham",
            "Chesham",
            "Cookham",
            "Windsor"
          ]
        },
        {
          "name": "Winslow",
          "slug": "winslow",
          "postcode": "MK18",
          "nearby_areas": [
            "Woburn",
            "Buckingham",
            "Milton Keynes",
            "Bletchley",
            "Newport Pagnell",
            "Towcester",
            "Olney"
          ]
        },
        {
          "name": "Olney",
          "slug": "olney",
          "postcode": "MK46",
          "nearby_areas": [
            "Ampthill",
            "Flitwick",
            "Newport Pagnell",
            "Kempston",
            "Bletchley",
            "Milton Keynes",
            "Woburn"
          ]
        },
        {
          "name": "Wendover",
          "slug": "wendover",
          "postcode": "HP22",
          "nearby_areas": [
            "Princes Risborough",
            "Chesham",
            "Aylesbury",
            "Amersham",
            "High Wycombe",
            "Berkhamsted",
            "Beaconsfield"
          ]
        }
      ]
    },
    {
      "name": "Caerphilly",
      "slug": "caerphilly",
      "region": "Wales",
      "council_name": "Caerphilly County Borough Council",
      "council_url": "https://www.caerphilly.gov.uk/",
      "climate": "wet valleys climate and mild winters",
      "population": "175,000",
      "towns": [
        {
          "name": "Caerphilly",
          "slug": "caerphilly",
          "postcode": "CF83",
          "nearby_areas": [
            "Ystrad Mynach",
            "Bargoed",
            "Blackwood",
            "Pontypridd",
            "Llantrisant",
            "Cowbridge",
            "Canton"
          ]
        },
        {
          "name": "Blackwood",
          "slug": "blackwood",
          "postcode": "NP12",
          "nearby_areas": [
            "Treharris",
            "Abertillery",
            "Caerphilly",
            "Pontypool",
            "Ystrad Mynach",
            "Abersychan",
            "Nelson"
          ]
        },
        {
          "name": "Bargoed",
          "slug": "bargoed",
          "postcode": "CF81",
          "nearby_areas": [
            "Ystrad Mynach",
            "Llantrisant",
            "Cowbridge",
            "Canton",
            "Llandaff",
            "Marshfield",
            "Whitchurch"
          ]
        },
        {
          "name": "Risca",
          "slug": "risca",
          "postcode": "NP11",
          "nearby_areas": [
            "Flint",
            "Connah's Quay",
            "Shotton",
            "Holywell",
            "Mold",
            "Buckley",
            "Gresford"
          ]
        },
        {
          "name": "Ystrad Mynach",
          "slug": "ystrad-mynach",
          "postcode": "CF82",
          "nearby_areas": [
            "Bargoed",
            "Llantrisant",
            "Cowbridge",
            "Caerphilly",
            "Canton",
            "Llandaff",
            "Pontypridd"
          ]
        },
        {
          "name": "Newbridge",
          "slug": "newbridge",
          "postcode": "NP11",
          "nearby_areas": [
            "Armadale",
            "Broxburn",
            "Bo'ness",
            "Livingston",
            "Whitburn",
            "Linlithgow",
            "Edinburgh"
          ]
        },
        {
          "name": "Nelson",
          "slug": "nelson",
          "postcode": "CF46",
          "nearby_areas": [
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Mountain Ash",
            "Porth",
            "Treharris",
            "Tonypandy"
          ]
        }
      ]
    },
    {
      "name": "Cambridgeshire",
      "slug": "cambridgeshire",
      "region": "East of England",
      "council_name": "Cambridgeshire County Council",
      "council_url": "https://www.cambridgeshire.gov.uk/",
      "climate": "relatively dry with cold easterly winds",
      "population": "900,000",
      "towns": [
        {
          "name": "Cambridge",
          "slug": "cambridge",
          "postcode": "CB1",
          "nearby_areas": [
            "Histon",
            "Sawston",
            "Soham",
            "Newmarket",
            "Haverhill",
            "Ely",
            "Saffron Walden"
          ]
        },
        {
          "name": "Peterborough",
          "slug": "peterborough",
          "postcode": "PE1",
          "nearby_areas": [
            "Whittlesey",
            "Yaxley",
            "Oundle",
            "Ketton",
            "Ryhall",
            "King's Lynn",
            "March"
          ]
        },
        {
          "name": "Huntingdon",
          "slug": "huntingdon",
          "postcode": "PE29",
          "nearby_areas": [
            "St Neots",
            "Chatteris",
            "Sandy",
            "Peterborough",
            "March",
            "Biggleswade",
            "Ely"
          ]
        },
        {
          "name": "Wisbech",
          "slug": "wisbech",
          "postcode": "PE13",
          "nearby_areas": [
            "St Ives",
            "Ramsey",
            "March",
            "King's Lynn",
            "Downham Market",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "St Neots",
          "slug": "st-neots",
          "postcode": "PE19",
          "nearby_areas": [
            "Sandy",
            "Huntingdon",
            "Biggleswade",
            "Bedford",
            "Potton",
            "Shefford",
            "Arlesey"
          ]
        },
        {
          "name": "Ely",
          "slug": "ely",
          "postcode": "CB7",
          "nearby_areas": [
            "Soham",
            "Chatteris",
            "March",
            "Cambridge",
            "Newmarket",
            "Histon",
            "Sawston"
          ]
        },
        {
          "name": "March",
          "slug": "march",
          "postcode": "PE15",
          "nearby_areas": [
            "King's Lynn",
            "Chatteris",
            "Wisbech",
            "St Ives",
            "Ely",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "Whittlesey",
          "slug": "whittlesey",
          "postcode": "PE7",
          "nearby_areas": [
            "Yaxley",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "St Ives",
            "King's Lynn"
          ]
        },
        {
          "name": "St Ives",
          "slug": "st-ives",
          "postcode": "PE27",
          "nearby_areas": [
            "Ramsey",
            "Wisbech",
            "King's Lynn",
            "Whittlesey",
            "Yaxley",
            "March",
            "Oundle"
          ]
        },
        {
          "name": "Chatteris",
          "slug": "chatteris",
          "postcode": "PE16",
          "nearby_areas": [
            "March",
            "Ely",
            "King's Lynn",
            "Huntingdon",
            "Peterborough",
            "Wisbech",
            "St Ives"
          ]
        },
        {
          "name": "Soham",
          "slug": "soham",
          "postcode": "CB7",
          "nearby_areas": [
            "Cambridge",
            "Newmarket",
            "Histon",
            "Sawston",
            "Ely",
            "Haverhill",
            "Chatteris"
          ]
        },
        {
          "name": "Ramsey",
          "slug": "ramsey",
          "postcode": "PE26",
          "nearby_areas": [
            "St Ives",
            "Wisbech",
            "Whittlesey",
            "Yaxley",
            "Spalding",
            "King's Lynn",
            "March"
          ]
        },
        {
          "name": "Yaxley",
          "slug": "yaxley",
          "postcode": "PE7",
          "nearby_areas": [
            "Whittlesey",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "St Ives",
            "King's Lynn"
          ]
        },
        {
          "name": "Sawston",
          "slug": "sawston",
          "postcode": "CB22",
          "nearby_areas": [
            "Histon",
            "Cambridge",
            "Newmarket",
            "Soham",
            "Haverhill",
            "Saffron Walden",
            "Ely"
          ]
        },
        {
          "name": "Histon",
          "slug": "histon",
          "postcode": "CB24",
          "nearby_areas": [
            "Sawston",
            "Cambridge",
            "Newmarket",
            "Soham",
            "Haverhill",
            "Saffron Walden",
            "Ely"
          ]
        }
      ]
    },
    {
      "name": "Cardiff",
      "slug": "cardiff",
      "region": "Wales",
      "council_name": "Cardiff Council",
      "council_url": "https://www.cardiff.gov.uk/",
      "climate": "mild, damp and coastal",
      "population": "370,000",
      "towns": [
        {
          "name": "Cardiff",
          "slug": "cardiff",
          "postcode": "CF10",
          "nearby_areas": [
            "Penarth",
            "Dinas Powys",
            "Caerphilly",
            "Barry",
            "Rhoose",
            "Ystrad Mynach",
            "Cowbridge"
          ]
        },
        {
          "name": "Roath",
          "slug": "roath",
          "postcode": "CF24",
          "nearby_areas": [
            "Ogmore Vale",
            "Radyr",
            "Tonypandy",
            "Pencoed",
            "Pyle",
            "Porth",
            "Whitchurch"
          ]
        },
        {
          "name": "Canton",
          "slug": "canton",
          "postcode": "CF5",
          "nearby_areas": [
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Llandaff",
          "slug": "llandaff",
          "postcode": "CF5",
          "nearby_areas": [
            "Canton",
            "Whitchurch",
            "Marshfield",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Whitchurch",
          "slug": "whitchurch",
          "postcode": "CF14",
          "nearby_areas": [
            "Marshfield",
            "Canton",
            "Llandaff",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Radyr",
          "slug": "radyr",
          "postcode": "CF15",
          "nearby_areas": [
            "Marshfield",
            "Whitchurch",
            "Canton",
            "Llandaff",
            "Llantrisant",
            "Roath",
            "Cowbridge"
          ]
        },
        {
          "name": "Penarth",
          "slug": "penarth",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Dinas Powys",
            "Barry",
            "Rhoose",
            "Caerphilly",
            "Cowbridge",
            "Llantrisant"
          ]
        }
      ]
    },
    {
      "name": "Carmarthenshire",
      "slug": "carmarthenshire",
      "region": "Wales",
      "council_name": "Carmarthenshire County Council",
      "council_url": "https://www.carmarthenshire.gov.wales/",
      "climate": "wet, mild and rural",
      "population": "190,000",
      "towns": [
        {
          "name": "Carmarthen",
          "slug": "carmarthen",
          "postcode": "SA31",
          "nearby_areas": [
            "Llanelli",
            "Ammanford",
            "Llandeilo",
            "Kidwelly",
            "Burry Port",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Llanelli",
          "slug": "llanelli",
          "postcode": "SA15",
          "nearby_areas": [
            "Llandeilo",
            "Burry Port",
            "Kidwelly",
            "Gorseinon",
            "Pontarddulais",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Ammanford",
          "slug": "ammanford",
          "postcode": "SA18",
          "nearby_areas": [
            "Kidwelly",
            "Llandeilo",
            "Burry Port",
            "Llanelli",
            "Cymmer",
            "Ystradgynlais",
            "Briton Ferry"
          ]
        },
        {
          "name": "Llandeilo",
          "slug": "llandeilo",
          "postcode": "SA19",
          "nearby_areas": [
            "Kidwelly",
            "Burry Port",
            "Llanelli",
            "Clydach",
            "Morriston",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Burry Port",
          "slug": "burry-port",
          "postcode": "SA16",
          "nearby_areas": [
            "Kidwelly",
            "Llandeilo",
            "Clydach",
            "Morriston",
            "Llanelli",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Kidwelly",
          "slug": "kidwelly",
          "postcode": "SA17",
          "nearby_areas": [
            "Llandeilo",
            "Burry Port",
            "Llanelli",
            "Clydach",
            "Morriston",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Newcastle Emlyn",
          "slug": "newcastle-emlyn",
          "postcode": "SA38",
          "nearby_areas": [
            "Fishguard",
            "Narberth",
            "Llanelli",
            "Lampeter",
            "Burry Port",
            "Llandeilo",
            "Tenby"
          ]
        }
      ]
    },
    {
      "name": "Ceredigion",
      "slug": "ceredigion",
      "region": "Wales",
      "council_name": "Ceredigion County Council",
      "council_url": "https://www.ceredigion.gov.uk/",
      "climate": "wet coastal and upland climate",
      "population": "72,000",
      "towns": [
        {
          "name": "Aberystwyth",
          "slug": "aberystwyth",
          "postcode": "SY23",
          "nearby_areas": [
            "Tregaron",
            "Llandrindod Wells",
            "Machynlleth",
            "Builth Wells",
            "Presteigne",
            "Carmarthen",
            "Newtown"
          ]
        },
        {
          "name": "Cardigan",
          "slug": "cardigan",
          "postcode": "SA43",
          "nearby_areas": [
            "Lampeter",
            "Aberaeron",
            "Bude",
            "Bideford",
            "Newcastle Emlyn",
            "Ilfracombe",
            "Barnstaple"
          ]
        },
        {
          "name": "Lampeter",
          "slug": "lampeter",
          "postcode": "SA48",
          "nearby_areas": [
            "Cardigan",
            "Aberaeron",
            "Newcastle Emlyn",
            "Bideford",
            "Bude",
            "Ilfracombe",
            "Fishguard"
          ]
        },
        {
          "name": "Aberaeron",
          "slug": "aberaeron",
          "postcode": "SA46",
          "nearby_areas": [
            "Cardigan",
            "Lampeter",
            "Bude",
            "Bideford",
            "Launceston",
            "Wadebridge",
            "New Quay"
          ]
        },
        {
          "name": "New Quay",
          "slug": "new-quay",
          "postcode": "SA45",
          "nearby_areas": [
            "Truro",
            "Wadebridge",
            "St Austell",
            "Redruth",
            "Bodmin",
            "Camborne",
            "Falmouth"
          ]
        },
        {
          "name": "Tregaron",
          "slug": "tregaron",
          "postcode": "SY25",
          "nearby_areas": [
            "Machynlleth",
            "Newtown",
            "Welshpool",
            "Llandrindod Wells",
            "Whitchurch",
            "Aberystwyth",
            "Rogerstone"
          ]
        }
      ]
    },
    {
      "name": "Cheshire",
      "slug": "cheshire",
      "region": "North West England",
      "council_name": "Cheshire (unitary authorities)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "damp Atlantic air and mild wet winters",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Chester",
          "slug": "chester",
          "postcode": "CH1",
          "nearby_areas": [
            "Ellesmere Port",
            "Bebington",
            "Buckley",
            "Connah's Quay",
            "Shotton",
            "Frodsham",
            "Holywell"
          ]
        },
        {
          "name": "Warrington",
          "slug": "warrington",
          "postcode": "WA1",
          "nearby_areas": [
            "St Helens",
            "Newton-le-Willows",
            "Widnes",
            "Runcorn",
            "Frodsham",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Crewe",
          "slug": "crewe",
          "postcode": "CW1",
          "nearby_areas": [
            "Nantwich",
            "Sandbach",
            "Middlewich",
            "Winsford",
            "Congleton",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Runcorn",
          "slug": "runcorn",
          "postcode": "WA7",
          "nearby_areas": [
            "Widnes",
            "Frodsham",
            "St Helens",
            "Warrington",
            "Prescot",
            "Ellesmere Port",
            "Newton-le-Willows"
          ]
        },
        {
          "name": "Widnes",
          "slug": "widnes",
          "postcode": "WA8",
          "nearby_areas": [
            "Runcorn",
            "Frodsham",
            "St Helens",
            "Prescot",
            "Warrington",
            "Newton-le-Willows",
            "Ellesmere Port"
          ]
        },
        {
          "name": "Macclesfield",
          "slug": "macclesfield",
          "postcode": "SK10",
          "nearby_areas": [
            "Cheadle",
            "Wilmslow",
            "Congleton",
            "Buxton",
            "Hyde",
            "Knutsford",
            "Stockport"
          ]
        },
        {
          "name": "Ellesmere Port",
          "slug": "ellesmere-port",
          "postcode": "CH65",
          "nearby_areas": [
            "Bebington",
            "Chester",
            "Frodsham",
            "Runcorn",
            "Widnes",
            "Birkenhead",
            "Liverpool"
          ]
        },
        {
          "name": "Northwich",
          "slug": "northwich",
          "postcode": "CW9",
          "nearby_areas": [
            "Winsford",
            "Middlewich",
            "Knutsford",
            "Frodsham",
            "Warrington",
            "St Helens",
            "Sandbach"
          ]
        },
        {
          "name": "Winsford",
          "slug": "winsford",
          "postcode": "CW7",
          "nearby_areas": [
            "Middlewich",
            "Northwich",
            "Crewe",
            "Sandbach",
            "Nantwich",
            "Knutsford",
            "Frodsham"
          ]
        },
        {
          "name": "Wilmslow",
          "slug": "wilmslow",
          "postcode": "SK9",
          "nearby_areas": [
            "Cheadle",
            "Knutsford",
            "Macclesfield",
            "Stockport",
            "Altrincham",
            "Buxton",
            "Sale"
          ]
        },
        {
          "name": "Congleton",
          "slug": "congleton",
          "postcode": "CW12",
          "nearby_areas": [
            "Sandbach",
            "Macclesfield",
            "Middlewich",
            "Crewe",
            "Leek",
            "Wilmslow",
            "Knutsford"
          ]
        },
        {
          "name": "Nantwich",
          "slug": "nantwich",
          "postcode": "CW5",
          "nearby_areas": [
            "Crewe",
            "Sandbach",
            "Winsford",
            "Middlewich",
            "Northwich",
            "Market Drayton",
            "Congleton"
          ]
        },
        {
          "name": "Knutsford",
          "slug": "knutsford",
          "postcode": "WA16",
          "nearby_areas": [
            "Wilmslow",
            "Northwich",
            "Altrincham",
            "Middlewich",
            "Winsford",
            "Sale",
            "Denton"
          ]
        },
        {
          "name": "Sandbach",
          "slug": "sandbach",
          "postcode": "CW11",
          "nearby_areas": [
            "Crewe",
            "Middlewich",
            "Congleton",
            "Winsford",
            "Nantwich",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Middlewich",
          "slug": "middlewich",
          "postcode": "CW10",
          "nearby_areas": [
            "Winsford",
            "Sandbach",
            "Northwich",
            "Crewe",
            "Knutsford",
            "Nantwich",
            "Congleton"
          ]
        },
        {
          "name": "Frodsham",
          "slug": "frodsham",
          "postcode": "WA6",
          "nearby_areas": [
            "Runcorn",
            "Widnes",
            "Ellesmere Port",
            "St Helens",
            "Warrington",
            "Northwich",
            "Chester"
          ]
        }
      ]
    },
    {
      "name": "City of Edinburgh",
      "slug": "city-of-edinburgh",
      "region": "Scotland",
      "council_name": "The City of Edinburgh Council",
      "council_url": "https://www.edinburgh.gov.uk/",
      "climate": "cool, windy and relatively dry for Scotland",
      "population": "520,000",
      "towns": [
        {
          "name": "Edinburgh",
          "slug": "edinburgh",
          "postcode": "EH1",
          "nearby_areas": [
            "Leith",
            "Newington",
            "Morningside",
            "Corstorphine",
            "Portobello",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Leith",
          "slug": "leith",
          "postcode": "EH6",
          "nearby_areas": [
            "Newington",
            "Morningside",
            "Corstorphine",
            "Portobello",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Portobello",
          "slug": "portobello",
          "postcode": "EH15",
          "nearby_areas": [
            "Corstorphine",
            "Bonnyrigg",
            "Morningside",
            "Loanhead",
            "Newington",
            "Musselburgh",
            "Dalkeith"
          ]
        },
        {
          "name": "Corstorphine",
          "slug": "corstorphine",
          "postcode": "EH12",
          "nearby_areas": [
            "Morningside",
            "Portobello",
            "Newington",
            "Bonnyrigg",
            "Leith",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Morningside",
          "slug": "morningside",
          "postcode": "EH10",
          "nearby_areas": [
            "Newington",
            "Corstorphine",
            "Portobello",
            "Leith",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Newington",
          "slug": "newington",
          "postcode": "EH9",
          "nearby_areas": [
            "Morningside",
            "Corstorphine",
            "Leith",
            "Portobello",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        }
      ]
    },
    {
      "name": "Clackmannanshire",
      "slug": "clackmannanshire",
      "region": "Scotland",
      "council_name": "Clackmannanshire Council",
      "council_url": "https://www.clacks.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "52,000",
      "towns": [
        {
          "name": "Alloa",
          "slug": "alloa",
          "postcode": "FK10",
          "nearby_areas": [
            "Clackmannan",
            "Bridge of Allan",
            "Alva",
            "Denny",
            "Dollar",
            "Callander",
            "Larbert"
          ]
        },
        {
          "name": "Tillicoultry",
          "slug": "tillicoultry",
          "postcode": "FK13",
          "nearby_areas": [
            "Alva",
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Bridge of Allan",
            "Denny"
          ]
        },
        {
          "name": "Alva",
          "slug": "alva",
          "postcode": "FK12",
          "nearby_areas": [
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Bridge of Allan",
            "Denny",
            "Larbert"
          ]
        },
        {
          "name": "Clackmannan",
          "slug": "clackmannan",
          "postcode": "FK10",
          "nearby_areas": [
            "Alloa",
            "Bridge of Allan",
            "Alva",
            "Denny",
            "Dollar",
            "Callander",
            "Larbert"
          ]
        },
        {
          "name": "Dollar",
          "slug": "dollar",
          "postcode": "FK14",
          "nearby_areas": [
            "Callander",
            "Alva",
            "Alloa",
            "Clackmannan",
            "Bridge of Allan",
            "Denny",
            "Larbert"
          ]
        }
      ]
    },
    {
      "name": "Conwy",
      "slug": "conwy",
      "region": "Wales",
      "council_name": "Conwy County Borough Council",
      "council_url": "https://www.conwy.gov.uk/",
      "climate": "wet coastal and mountain weather",
      "population": "115,000",
      "towns": [
        {
          "name": "Colwyn Bay",
          "slug": "colwyn-bay",
          "postcode": "LL29",
          "nearby_areas": [
            "Llanrwst",
            "Dolgellau",
            "Conwy",
            "Llandudno",
            "Blaenau Ffestiniog",
            "Barmouth",
            "Betws-y-Coed"
          ]
        },
        {
          "name": "Llandudno",
          "slug": "llandudno",
          "postcode": "LL30",
          "nearby_areas": [
            "Conwy",
            "Colwyn Bay",
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Barmouth",
            "Llanrwst",
            "Porthmadog"
          ]
        },
        {
          "name": "Conwy",
          "slug": "conwy",
          "postcode": "LL32",
          "nearby_areas": [
            "Barmouth",
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Llandudno",
            "Colwyn Bay",
            "Porthmadog",
            "Llanrwst"
          ]
        },
        {
          "name": "Abergele",
          "slug": "abergele",
          "postcode": "LL22",
          "nearby_areas": [
            "Betws-y-Coed",
            "Corwen",
            "Llanrwst",
            "Llangollen",
            "Rhyl",
            "Colwyn Bay",
            "Prestatyn"
          ]
        },
        {
          "name": "Llanrwst",
          "slug": "llanrwst",
          "postcode": "LL26",
          "nearby_areas": [
            "Betws-y-Coed",
            "Abergele",
            "Colwyn Bay",
            "Corwen",
            "Llangollen",
            "Dolgellau",
            "Blaenau Ffestiniog"
          ]
        },
        {
          "name": "Betws-y-Coed",
          "slug": "betws-y-coed",
          "postcode": "LL24",
          "nearby_areas": [
            "Abergele",
            "Llanrwst",
            "Corwen",
            "Llangollen",
            "Colwyn Bay",
            "Rhyl",
            "Dolgellau"
          ]
        }
      ]
    },
    {
      "name": "Cornwall",
      "slug": "cornwall",
      "region": "South West England",
      "council_name": "Cornwall Council",
      "council_url": "https://www.cornwall.gov.uk/",
      "climate": "mild, exposed coastal climate with high rainfall",
      "population": "580,000",
      "towns": [
        {
          "name": "Truro",
          "slug": "truro",
          "postcode": "TR1",
          "nearby_areas": [
            "Falmouth",
            "Redruth",
            "Newquay",
            "Camborne",
            "St Austell",
            "St Ives",
            "Helston"
          ]
        },
        {
          "name": "Falmouth",
          "slug": "falmouth",
          "postcode": "TR11",
          "nearby_areas": [
            "Truro",
            "Redruth",
            "Helston",
            "Camborne",
            "St Ives",
            "Hayle",
            "St Austell"
          ]
        },
        {
          "name": "St Austell",
          "slug": "st-austell",
          "postcode": "PL25",
          "nearby_areas": [
            "Bodmin",
            "Padstow",
            "Truro",
            "Wadebridge",
            "Newquay",
            "Looe",
            "Liskeard"
          ]
        },
        {
          "name": "Camborne",
          "slug": "camborne",
          "postcode": "TR14",
          "nearby_areas": [
            "St Ives",
            "Redruth",
            "Hayle",
            "Helston",
            "Falmouth",
            "Truro",
            "Penzance"
          ]
        },
        {
          "name": "Redruth",
          "slug": "redruth",
          "postcode": "TR15",
          "nearby_areas": [
            "Camborne",
            "St Ives",
            "Truro",
            "Falmouth",
            "Hayle",
            "Helston",
            "Newquay"
          ]
        },
        {
          "name": "Penzance",
          "slug": "penzance",
          "postcode": "TR18",
          "nearby_areas": [
            "Hayle",
            "St Ives",
            "Helston",
            "Camborne",
            "Redruth",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "Newquay",
          "slug": "newquay",
          "postcode": "TR7",
          "nearby_areas": [
            "Truro",
            "Wadebridge",
            "St Austell",
            "Redruth",
            "Bodmin",
            "Camborne",
            "Falmouth"
          ]
        },
        {
          "name": "Bodmin",
          "slug": "bodmin",
          "postcode": "PL31",
          "nearby_areas": [
            "Wadebridge",
            "Padstow",
            "St Austell",
            "Liskeard",
            "Fowey",
            "Looe",
            "Newquay"
          ]
        },
        {
          "name": "Saltash",
          "slug": "saltash",
          "postcode": "PL12",
          "nearby_areas": [
            "Torpoint",
            "Plymouth",
            "Fowey",
            "Looe",
            "Liskeard",
            "Tavistock",
            "Ivybridge"
          ]
        },
        {
          "name": "Helston",
          "slug": "helston",
          "postcode": "TR13",
          "nearby_areas": [
            "St Ives",
            "Camborne",
            "Hayle",
            "Redruth",
            "Falmouth",
            "Penzance",
            "Truro"
          ]
        },
        {
          "name": "Launceston",
          "slug": "launceston",
          "postcode": "PL15",
          "nearby_areas": [
            "Tavistock",
            "Liskeard",
            "Fowey",
            "Bude",
            "Padstow",
            "Saltash",
            "Okehampton"
          ]
        },
        {
          "name": "Liskeard",
          "slug": "liskeard",
          "postcode": "PL14",
          "nearby_areas": [
            "Fowey",
            "Padstow",
            "Looe",
            "Bodmin",
            "Saltash",
            "Torpoint",
            "Launceston"
          ]
        },
        {
          "name": "Hayle",
          "slug": "hayle",
          "postcode": "TR27",
          "nearby_areas": [
            "St Ives",
            "Camborne",
            "Penzance",
            "Helston",
            "Redruth",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "St Ives",
          "slug": "st-ives",
          "postcode": "TR26",
          "nearby_areas": [
            "Camborne",
            "Hayle",
            "Redruth",
            "Helston",
            "Penzance",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "Bude",
          "slug": "bude",
          "postcode": "EX23",
          "nearby_areas": [
            "Launceston",
            "Aberaeron",
            "Bideford",
            "Cardigan",
            "Wadebridge",
            "Padstow",
            "Bodmin"
          ]
        },
        {
          "name": "Wadebridge",
          "slug": "wadebridge",
          "postcode": "PL27",
          "nearby_areas": [
            "Bodmin",
            "Padstow",
            "St Austell",
            "Newquay",
            "Liskeard",
            "Fowey",
            "Truro"
          ]
        },
        {
          "name": "Fowey",
          "slug": "fowey",
          "postcode": "PL23",
          "nearby_areas": [
            "Liskeard",
            "Looe",
            "Padstow",
            "Saltash",
            "Torpoint",
            "Plymouth",
            "Launceston"
          ]
        },
        {
          "name": "Padstow",
          "slug": "padstow",
          "postcode": "PL28",
          "nearby_areas": [
            "Liskeard",
            "Bodmin",
            "Fowey",
            "Looe",
            "Wadebridge",
            "St Austell",
            "Launceston"
          ]
        },
        {
          "name": "Looe",
          "slug": "looe",
          "postcode": "PL13",
          "nearby_areas": [
            "Fowey",
            "Liskeard",
            "Padstow",
            "Saltash",
            "Torpoint",
            "Bodmin",
            "St Austell"
          ]
        },
        {
          "name": "Torpoint",
          "slug": "torpoint",
          "postcode": "PL11",
          "nearby_areas": [
            "Saltash",
            "Plymouth",
            "Fowey",
            "Looe",
            "Liskeard",
            "Ivybridge",
            "Tavistock"
          ]
        }
      ]
    },
    {
      "name": "County Antrim",
      "slug": "county-antrim",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet and coastal",
      "population": "620,000",
      "towns": [
        {
          "name": "Belfast",
          "slug": "belfast",
          "postcode": "BT1",
          "nearby_areas": [
            "Newtownabbey",
            "Antrim",
            "Lisburn",
            "Randalstown",
            "Warrenpoint",
            "Carrickfergus",
            "Holywood"
          ]
        },
        {
          "name": "Lisburn",
          "slug": "lisburn",
          "postcode": "BT28",
          "nearby_areas": [
            "Newtownabbey",
            "Belfast",
            "Warrenpoint",
            "Holywood",
            "Antrim",
            "Comber",
            "Carrickfergus"
          ]
        },
        {
          "name": "Antrim",
          "slug": "antrim",
          "postcode": "BT41",
          "nearby_areas": [
            "Randalstown",
            "Belfast",
            "Newtownabbey",
            "Ballymena",
            "Maghera",
            "Lisburn",
            "Dungiven"
          ]
        },
        {
          "name": "Ballymena",
          "slug": "ballymena",
          "postcode": "BT43",
          "nearby_areas": [
            "Randalstown",
            "Dungiven",
            "Maghera",
            "Derry",
            "Antrim",
            "Belfast",
            "Newtownabbey"
          ]
        },
        {
          "name": "Carrickfergus",
          "slug": "carrickfergus",
          "postcode": "BT38",
          "nearby_areas": [
            "Holywood",
            "Bangor",
            "Larne",
            "Newtownards",
            "Comber",
            "Donaghadee",
            "Lisburn"
          ]
        },
        {
          "name": "Larne",
          "slug": "larne",
          "postcode": "BT40",
          "nearby_areas": [
            "Carrickfergus",
            "Holywood",
            "Bangor",
            "Antrim",
            "Ballymena",
            "Belfast",
            "Donaghadee"
          ]
        },
        {
          "name": "Newtownabbey",
          "slug": "newtownabbey",
          "postcode": "BT36",
          "nearby_areas": [
            "Belfast",
            "Antrim",
            "Lisburn",
            "Randalstown",
            "Warrenpoint",
            "Carrickfergus",
            "Holywood"
          ]
        },
        {
          "name": "Ballymoney",
          "slug": "ballymoney",
          "postcode": "BT53",
          "nearby_areas": [
            "Coleraine",
            "Portrush",
            "Portstewart",
            "Ballymena",
            "Derry",
            "Limavady",
            "Dungiven"
          ]
        },
        {
          "name": "Portrush",
          "slug": "portrush",
          "postcode": "BT56",
          "nearby_areas": [
            "Portstewart",
            "Coleraine",
            "Ballymoney",
            "Limavady",
            "Ballymena",
            "Derry",
            "Dungiven"
          ]
        },
        {
          "name": "Randalstown",
          "slug": "randalstown",
          "postcode": "BT41",
          "nearby_areas": [
            "Antrim",
            "Maghera",
            "Dungiven",
            "Ballymena",
            "Belfast",
            "Newtownabbey",
            "Derry"
          ]
        }
      ]
    },
    {
      "name": "County Armagh",
      "slug": "county-armagh",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "mild, damp and rural",
      "population": "175,000",
      "towns": [
        {
          "name": "Armagh",
          "slug": "armagh",
          "postcode": "BT60",
          "nearby_areas": [
            "Dungannon",
            "Coalisland",
            "Banbridge",
            "Newry",
            "Keady",
            "Markethill",
            "Cookstown"
          ]
        },
        {
          "name": "Craigavon",
          "slug": "craigavon",
          "postcode": "BT64",
          "nearby_areas": [
            "Portadown",
            "Tandragee",
            "Ballinamallard",
            "Irvinestown",
            "Lurgan",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Portadown",
          "slug": "portadown",
          "postcode": "BT62",
          "nearby_areas": [
            "Tandragee",
            "Craigavon",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Lurgan",
          "slug": "lurgan",
          "postcode": "BT66",
          "nearby_areas": [
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Keady",
          "slug": "keady",
          "postcode": "BT60",
          "nearby_areas": [
            "Markethill",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Craigavon",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Tandragee",
          "slug": "tandragee",
          "postcode": "BT62",
          "nearby_areas": [
            "Portadown",
            "Craigavon",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Markethill",
          "slug": "markethill",
          "postcode": "BT60",
          "nearby_areas": [
            "Keady",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Craigavon",
            "Belleek",
            "Lisnaskea"
          ]
        }
      ]
    },
    {
      "name": "County Down",
      "slug": "county-down",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "mild, wet and coastal",
      "population": "540,000",
      "towns": [
        {
          "name": "Newry",
          "slug": "newry",
          "postcode": "BT34",
          "nearby_areas": [
            "Banbridge",
            "Armagh",
            "Warrenpoint",
            "Ballynahinch",
            "Downpatrick",
            "Dungannon",
            "Coalisland"
          ]
        },
        {
          "name": "Bangor",
          "slug": "bangor",
          "postcode": "BT20",
          "nearby_areas": [
            "Newtownards",
            "Donaghadee",
            "Holywood",
            "Comber",
            "Carrickfergus",
            "Larne",
            "Lisburn"
          ]
        },
        {
          "name": "Newtownards",
          "slug": "newtownards",
          "postcode": "BT23",
          "nearby_areas": [
            "Comber",
            "Bangor",
            "Holywood",
            "Donaghadee",
            "Carrickfergus",
            "Ballynahinch",
            "Lisburn"
          ]
        },
        {
          "name": "Downpatrick",
          "slug": "downpatrick",
          "postcode": "BT30",
          "nearby_areas": [
            "Ballynahinch",
            "Comber",
            "Newtownards",
            "Holywood",
            "Bangor",
            "Banbridge",
            "Donaghadee"
          ]
        },
        {
          "name": "Banbridge",
          "slug": "banbridge",
          "postcode": "BT32",
          "nearby_areas": [
            "Warrenpoint",
            "Newry",
            "Ballynahinch",
            "Armagh",
            "Lisburn",
            "Newtownabbey",
            "Downpatrick"
          ]
        },
        {
          "name": "Holywood",
          "slug": "holywood",
          "postcode": "BT18",
          "nearby_areas": [
            "Carrickfergus",
            "Newtownards",
            "Bangor",
            "Comber",
            "Donaghadee",
            "Lisburn",
            "Belfast"
          ]
        },
        {
          "name": "Comber",
          "slug": "comber",
          "postcode": "BT23",
          "nearby_areas": [
            "Newtownards",
            "Holywood",
            "Bangor",
            "Donaghadee",
            "Ballynahinch",
            "Carrickfergus",
            "Lisburn"
          ]
        },
        {
          "name": "Donaghadee",
          "slug": "donaghadee",
          "postcode": "BT21",
          "nearby_areas": [
            "Bangor",
            "Newtownards",
            "Comber",
            "Holywood",
            "Carrickfergus",
            "Larne",
            "Ballynahinch"
          ]
        },
        {
          "name": "Warrenpoint",
          "slug": "warrenpoint",
          "postcode": "BT34",
          "nearby_areas": [
            "Lisburn",
            "Newtownabbey",
            "Banbridge",
            "Belfast",
            "Ballynahinch",
            "Antrim",
            "Holywood"
          ]
        },
        {
          "name": "Ballynahinch",
          "slug": "ballynahinch",
          "postcode": "BT24",
          "nearby_areas": [
            "Downpatrick",
            "Comber",
            "Warrenpoint",
            "Lisburn",
            "Newtownards",
            "Banbridge",
            "Holywood"
          ]
        }
      ]
    },
    {
      "name": "County Durham",
      "slug": "county-durham",
      "region": "North East England",
      "council_name": "Durham County Council",
      "council_url": "https://www.durham.gov.uk/",
      "climate": "cold winters with wet upland conditions",
      "population": "870,000",
      "towns": [
        {
          "name": "Durham",
          "slug": "durham",
          "postcode": "DH1",
          "nearby_areas": [
            "Chester-le-Street",
            "Spennymoor",
            "Houghton-le-Spring",
            "Crook",
            "Bishop Auckland",
            "Stanley",
            "Peterlee"
          ]
        },
        {
          "name": "Darlington",
          "slug": "darlington",
          "postcode": "DL1",
          "nearby_areas": [
            "Newton Aycliffe",
            "Shildon",
            "Stockton-on-Tees",
            "Bishop Auckland",
            "Spennymoor",
            "Richmond",
            "Barnard Castle"
          ]
        },
        {
          "name": "Hartlepool",
          "slug": "hartlepool",
          "postcode": "TS24",
          "nearby_areas": [
            "Peterlee",
            "Stokesley",
            "Stockton-on-Tees",
            "Redcar",
            "Middlesbrough",
            "Seaham",
            "Newton Aycliffe"
          ]
        },
        {
          "name": "Stockton-on-Tees",
          "slug": "stockton-on-tees",
          "postcode": "TS18",
          "nearby_areas": [
            "Middlesbrough",
            "Hartlepool",
            "Stokesley",
            "Darlington",
            "Newton Aycliffe",
            "Redcar",
            "Peterlee"
          ]
        },
        {
          "name": "Chester-le-Street",
          "slug": "chester-le-street",
          "postcode": "DH3",
          "nearby_areas": [
            "Houghton-le-Spring",
            "Durham",
            "Stanley",
            "Crook",
            "Spennymoor",
            "Consett",
            "Washington"
          ]
        },
        {
          "name": "Bishop Auckland",
          "slug": "bishop-auckland",
          "postcode": "DL14",
          "nearby_areas": [
            "Shildon",
            "Spennymoor",
            "Crook",
            "Newton Aycliffe",
            "Durham",
            "Chester-le-Street",
            "Darlington"
          ]
        },
        {
          "name": "Consett",
          "slug": "consett",
          "postcode": "DH8",
          "nearby_areas": [
            "Stanley",
            "Houghton-le-Spring",
            "Chester-le-Street",
            "Prudhoe",
            "Crook",
            "Durham",
            "Corbridge"
          ]
        },
        {
          "name": "Peterlee",
          "slug": "peterlee",
          "postcode": "SR8",
          "nearby_areas": [
            "Seaham",
            "Hartlepool",
            "Durham",
            "Spennymoor",
            "Sunderland",
            "Chester-le-Street",
            "Stockton-on-Tees"
          ]
        },
        {
          "name": "Seaham",
          "slug": "seaham",
          "postcode": "SR7",
          "nearby_areas": [
            "Peterlee",
            "Sunderland",
            "Washington",
            "Durham",
            "Hartlepool",
            "Jarrow",
            "Chester-le-Street"
          ]
        },
        {
          "name": "Spennymoor",
          "slug": "spennymoor",
          "postcode": "DL16",
          "nearby_areas": [
            "Bishop Auckland",
            "Shildon",
            "Durham",
            "Crook",
            "Newton Aycliffe",
            "Chester-le-Street",
            "Houghton-le-Spring"
          ]
        },
        {
          "name": "Newton Aycliffe",
          "slug": "newton-aycliffe",
          "postcode": "DL5",
          "nearby_areas": [
            "Shildon",
            "Bishop Auckland",
            "Spennymoor",
            "Darlington",
            "Crook",
            "Stockton-on-Tees",
            "Durham"
          ]
        },
        {
          "name": "Barnard Castle",
          "slug": "barnard-castle",
          "postcode": "DL12",
          "nearby_areas": [
            "Bishop Auckland",
            "Shildon",
            "Crook",
            "Richmond",
            "Darlington",
            "Newton Aycliffe",
            "Spennymoor"
          ]
        },
        {
          "name": "Stanley",
          "slug": "stanley",
          "postcode": "DH9",
          "nearby_areas": [
            "Consett",
            "Houghton-le-Spring",
            "Chester-le-Street",
            "Crook",
            "Durham",
            "Prudhoe",
            "Gateshead"
          ]
        },
        {
          "name": "Shildon",
          "slug": "shildon",
          "postcode": "DL4",
          "nearby_areas": [
            "Bishop Auckland",
            "Newton Aycliffe",
            "Spennymoor",
            "Crook",
            "Darlington",
            "Durham",
            "Chester-le-Street"
          ]
        },
        {
          "name": "Crook",
          "slug": "crook",
          "postcode": "DL15",
          "nearby_areas": [
            "Bishop Auckland",
            "Spennymoor",
            "Shildon",
            "Chester-le-Street",
            "Durham",
            "Houghton-le-Spring",
            "Stanley"
          ]
        }
      ]
    },
    {
      "name": "County Fermanagh",
      "slug": "county-fermanagh",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "wet, mild and rural",
      "population": "65,000",
      "towns": [
        {
          "name": "Enniskillen",
          "slug": "enniskillen",
          "postcode": "BT74",
          "nearby_areas": [
            "Strabane",
            "Dungannon",
            "Castlederg",
            "Armagh",
            "Coalisland",
            "Fintona",
            "Omagh"
          ]
        },
        {
          "name": "Lisnaskea",
          "slug": "lisnaskea",
          "postcode": "BT92",
          "nearby_areas": [
            "Belleek",
            "Ballinamallard",
            "Irvinestown",
            "Lurgan",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Irvinestown",
          "slug": "irvinestown",
          "postcode": "BT94",
          "nearby_areas": [
            "Ballinamallard",
            "Belleek",
            "Lurgan",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Belleek",
          "slug": "belleek",
          "postcode": "BT93",
          "nearby_areas": [
            "Ballinamallard",
            "Irvinestown",
            "Lisnaskea",
            "Lurgan",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Ballinamallard",
          "slug": "ballinamallard",
          "postcode": "BT94",
          "nearby_areas": [
            "Irvinestown",
            "Belleek",
            "Lurgan",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        }
      ]
    },
    {
      "name": "County Londonderry",
      "slug": "county-londonderry",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet and coastal",
      "population": "250,000",
      "towns": [
        {
          "name": "Derry",
          "slug": "derry",
          "postcode": "BT48",
          "nearby_areas": [
            "Dungiven",
            "Maghera",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee",
            "Randalstown"
          ]
        },
        {
          "name": "Coleraine",
          "slug": "coleraine",
          "postcode": "BT52",
          "nearby_areas": [
            "Portstewart",
            "Portrush",
            "Ballymoney",
            "Limavady",
            "Derry",
            "Dungiven",
            "Maghera"
          ]
        },
        {
          "name": "Limavady",
          "slug": "limavady",
          "postcode": "BT49",
          "nearby_areas": [
            "Coleraine",
            "Portstewart",
            "Portrush",
            "Ballymoney",
            "Derry",
            "Magherafelt",
            "Dungiven"
          ]
        },
        {
          "name": "Magherafelt",
          "slug": "magherafelt",
          "postcode": "BT45",
          "nearby_areas": [
            "Portadown",
            "Tandragee",
            "Craigavon",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Portstewart",
          "slug": "portstewart",
          "postcode": "BT55",
          "nearby_areas": [
            "Portrush",
            "Coleraine",
            "Ballymoney",
            "Limavady",
            "Derry",
            "Dungiven",
            "Magherafelt"
          ]
        },
        {
          "name": "Maghera",
          "slug": "maghera",
          "postcode": "BT46",
          "nearby_areas": [
            "Dungiven",
            "Derry",
            "Randalstown",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Dungiven",
          "slug": "dungiven",
          "postcode": "BT47",
          "nearby_areas": [
            "Maghera",
            "Derry",
            "Randalstown",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee"
          ]
        }
      ]
    },
    {
      "name": "County Tyrone",
      "slug": "county-tyrone",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet inland climate",
      "population": "180,000",
      "towns": [
        {
          "name": "Omagh",
          "slug": "omagh",
          "postcode": "BT78",
          "nearby_areas": [
            "Fintona",
            "Cookstown",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Dungannon",
          "slug": "dungannon",
          "postcode": "BT70",
          "nearby_areas": [
            "Coalisland",
            "Cookstown",
            "Fintona",
            "Omagh",
            "Armagh",
            "Castlederg",
            "Keady"
          ]
        },
        {
          "name": "Cookstown",
          "slug": "cookstown",
          "postcode": "BT80",
          "nearby_areas": [
            "Fintona",
            "Omagh",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Strabane",
          "slug": "strabane",
          "postcode": "BT82",
          "nearby_areas": [
            "Castlederg",
            "Limavady",
            "Fintona",
            "Omagh",
            "Cookstown",
            "Dungannon",
            "Coalisland"
          ]
        },
        {
          "name": "Coalisland",
          "slug": "coalisland",
          "postcode": "BT71",
          "nearby_areas": [
            "Dungannon",
            "Cookstown",
            "Fintona",
            "Omagh",
            "Keady",
            "Markethill",
            "Lurgan"
          ]
        },
        {
          "name": "Fintona",
          "slug": "fintona",
          "postcode": "BT78",
          "nearby_areas": [
            "Omagh",
            "Cookstown",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Castlederg",
          "slug": "castlederg",
          "postcode": "BT81",
          "nearby_areas": [
            "Fintona",
            "Omagh",
            "Cookstown",
            "Lisnaskea",
            "Belleek",
            "Ballinamallard",
            "Irvinestown"
          ]
        }
      ]
    },
    {
      "name": "Cumbria",
      "slug": "cumbria",
      "region": "North West England",
      "council_name": "Cumberland/Westmorland & Furness (unitary)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "cool, wet and exposed in upland areas",
      "population": "500,000",
      "towns": [
        {
          "name": "Carlisle",
          "slug": "carlisle",
          "postcode": "CA1",
          "nearby_areas": [
            "Penrith",
            "Annan",
            "Keswick",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Barrow-in-Furness",
          "slug": "barrow-in-furness",
          "postcode": "LA14",
          "nearby_areas": [
            "Millom",
            "Ambleside",
            "Windermere",
            "Ulverston",
            "Grange-over-Sands",
            "Morecambe",
            "Fleetwood"
          ]
        },
        {
          "name": "Kendal",
          "slug": "kendal",
          "postcode": "LA9",
          "nearby_areas": [
            "Grange-over-Sands",
            "Ulverston",
            "Windermere",
            "Ambleside",
            "Morecambe",
            "Lancaster",
            "Millom"
          ]
        },
        {
          "name": "Workington",
          "slug": "workington",
          "postcode": "CA14",
          "nearby_areas": [
            "Maryport",
            "Whitehaven",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Keswick",
            "Carlisle",
            "Penrith"
          ]
        },
        {
          "name": "Whitehaven",
          "slug": "whitehaven",
          "postcode": "CA28",
          "nearby_areas": [
            "Workington",
            "Cockermouth",
            "Maryport",
            "Appleby-in-Westmorland",
            "Keswick",
            "Millom",
            "Ulverston"
          ]
        },
        {
          "name": "Penrith",
          "slug": "penrith",
          "postcode": "CA11",
          "nearby_areas": [
            "Carlisle",
            "Keswick",
            "Kendal",
            "Cockermouth",
            "Appleby-in-Westmorland",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Ulverston",
          "slug": "ulverston",
          "postcode": "LA12",
          "nearby_areas": [
            "Ambleside",
            "Windermere",
            "Grange-over-Sands",
            "Millom",
            "Barrow-in-Furness",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Windermere",
          "slug": "windermere",
          "postcode": "LA23",
          "nearby_areas": [
            "Ambleside",
            "Ulverston",
            "Grange-over-Sands",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Lancaster"
          ]
        },
        {
          "name": "Keswick",
          "slug": "keswick",
          "postcode": "CA12",
          "nearby_areas": [
            "Cockermouth",
            "Appleby-in-Westmorland",
            "Maryport",
            "Workington",
            "Whitehaven",
            "Penrith",
            "Carlisle"
          ]
        },
        {
          "name": "Cockermouth",
          "slug": "cockermouth",
          "postcode": "CA13",
          "nearby_areas": [
            "Appleby-in-Westmorland",
            "Keswick",
            "Maryport",
            "Workington",
            "Whitehaven",
            "Carlisle",
            "Penrith"
          ]
        },
        {
          "name": "Maryport",
          "slug": "maryport",
          "postcode": "CA15",
          "nearby_areas": [
            "Workington",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Keswick",
            "Whitehaven",
            "Carlisle",
            "Annan"
          ]
        },
        {
          "name": "Millom",
          "slug": "millom",
          "postcode": "LA18",
          "nearby_areas": [
            "Ulverston",
            "Barrow-in-Furness",
            "Ambleside",
            "Windermere",
            "Grange-over-Sands",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Ambleside",
          "slug": "ambleside",
          "postcode": "LA22",
          "nearby_areas": [
            "Windermere",
            "Ulverston",
            "Grange-over-Sands",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Lancaster"
          ]
        },
        {
          "name": "Grange-over-Sands",
          "slug": "grange-over-sands",
          "postcode": "LA11",
          "nearby_areas": [
            "Windermere",
            "Ulverston",
            "Ambleside",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Appleby-in-Westmorland",
          "slug": "appleby-in-westmorland",
          "postcode": "CA16",
          "nearby_areas": [
            "Cockermouth",
            "Maryport",
            "Keswick",
            "Workington",
            "Whitehaven",
            "Carlisle",
            "Penrith"
          ]
        }
      ]
    },
    {
      "name": "Denbighshire",
      "slug": "denbighshire",
      "region": "Wales",
      "council_name": "Denbighshire County Council",
      "council_url": "https://www.denbighshire.gov.uk/",
      "climate": "wet uplands with coastal influence",
      "population": "95,000",
      "towns": [
        {
          "name": "Rhyl",
          "slug": "rhyl",
          "postcode": "LL18",
          "nearby_areas": [
            "Llangollen",
            "Prestatyn",
            "Corwen",
            "Abergele",
            "Betws-y-Coed",
            "Llanrwst",
            "Denbigh"
          ]
        },
        {
          "name": "Denbigh",
          "slug": "denbigh",
          "postcode": "LL16",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Gresford",
            "Ruthin",
            "Llangollen"
          ]
        },
        {
          "name": "Prestatyn",
          "slug": "prestatyn",
          "postcode": "LL19",
          "nearby_areas": [
            "Rhyl",
            "Llangollen",
            "Corwen",
            "Abergele",
            "Denbigh",
            "Betws-y-Coed",
            "Cefn Mawr"
          ]
        },
        {
          "name": "Ruthin",
          "slug": "ruthin",
          "postcode": "LL15",
          "nearby_areas": [
            "Gresford",
            "Denbigh",
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Mold"
          ]
        },
        {
          "name": "Corwen",
          "slug": "corwen",
          "postcode": "LL21",
          "nearby_areas": [
            "Llangollen",
            "Abergele",
            "Betws-y-Coed",
            "Rhyl",
            "Llanrwst",
            "Denbigh",
            "Prestatyn"
          ]
        },
        {
          "name": "Llangollen",
          "slug": "llangollen",
          "postcode": "LL20",
          "nearby_areas": [
            "Corwen",
            "Abergele",
            "Rhyl",
            "Betws-y-Coed",
            "Llanrwst",
            "Prestatyn",
            "Denbigh"
          ]
        }
      ]
    },
    {
      "name": "Derbyshire",
      "slug": "derbyshire",
      "region": "East Midlands",
      "council_name": "Derbyshire County Council",
      "council_url": "https://www.derbyshire.gov.uk/",
      "climate": "high moorland moisture and cold winters",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Derby",
          "slug": "derby",
          "postcode": "DE1",
          "nearby_areas": [
            "Burton upon Trent",
            "Bakewell",
            "Ripley",
            "Belper",
            "Ilkeston",
            "Heanor",
            "Swadlincote"
          ]
        },
        {
          "name": "Chesterfield",
          "slug": "chesterfield",
          "postcode": "S40",
          "nearby_areas": [
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Matlock",
            "Alfreton",
            "Dinnington",
            "Mansfield"
          ]
        },
        {
          "name": "Swadlincote",
          "slug": "swadlincote",
          "postcode": "DE11",
          "nearby_areas": [
            "Ashby-de-la-Zouch",
            "Coalville",
            "Derby",
            "Burton upon Trent",
            "Tamworth",
            "Lichfield",
            "Loughborough"
          ]
        },
        {
          "name": "Ilkeston",
          "slug": "ilkeston",
          "postcode": "DE7",
          "nearby_areas": [
            "Heanor",
            "Bakewell",
            "Nottingham",
            "Derby",
            "Belper",
            "Alfreton",
            "West Bridgford"
          ]
        },
        {
          "name": "Long Eaton",
          "slug": "long-eaton",
          "postcode": "NG10",
          "nearby_areas": [
            "Beeston",
            "Bingham",
            "Arnold",
            "Hucknall",
            "Ollerton",
            "Carlton",
            "West Bridgford"
          ]
        },
        {
          "name": "Glossop",
          "slug": "glossop",
          "postcode": "SK13",
          "nearby_areas": [
            "Hyde",
            "Buxton",
            "Ashton-under-Lyne",
            "Stockport",
            "Oldham",
            "Cheadle",
            "Manchester"
          ]
        },
        {
          "name": "Buxton",
          "slug": "buxton",
          "postcode": "SK17",
          "nearby_areas": [
            "Hyde",
            "Cheadle",
            "Stockport",
            "Glossop",
            "Wilmslow",
            "Macclesfield",
            "Ashton-under-Lyne"
          ]
        },
        {
          "name": "Ripley",
          "slug": "ripley",
          "postcode": "DE5",
          "nearby_areas": [
            "Belper",
            "Bakewell",
            "Burton upon Trent",
            "Derby",
            "Ashbourne",
            "Heanor",
            "Matlock"
          ]
        },
        {
          "name": "Matlock",
          "slug": "matlock",
          "postcode": "DE4",
          "nearby_areas": [
            "Alfreton",
            "Belper",
            "Chesterfield",
            "Ripley",
            "Bakewell",
            "Ashbourne",
            "Heanor"
          ]
        },
        {
          "name": "Belper",
          "slug": "belper",
          "postcode": "DE56",
          "nearby_areas": [
            "Bakewell",
            "Ripley",
            "Heanor",
            "Alfreton",
            "Derby",
            "Burton upon Trent",
            "Ilkeston"
          ]
        },
        {
          "name": "Heanor",
          "slug": "heanor",
          "postcode": "DE75",
          "nearby_areas": [
            "Ilkeston",
            "Bakewell",
            "Belper",
            "Alfreton",
            "Ripley",
            "Derby",
            "Nottingham"
          ]
        },
        {
          "name": "Alfreton",
          "slug": "alfreton",
          "postcode": "DE55",
          "nearby_areas": [
            "Heanor",
            "Bakewell",
            "Belper",
            "Matlock",
            "Ripley",
            "Ilkeston",
            "Mansfield"
          ]
        },
        {
          "name": "Ashbourne",
          "slug": "ashbourne",
          "postcode": "DE6",
          "nearby_areas": [
            "Ripley",
            "Belper",
            "Matlock",
            "Bakewell",
            "Uttoxeter",
            "Derby",
            "Burton upon Trent"
          ]
        },
        {
          "name": "Bolsover",
          "slug": "bolsover",
          "postcode": "S44",
          "nearby_areas": [
            "Penistone",
            "Stocksbridge",
            "Dinnington",
            "Sheffield",
            "Chesterfield",
            "Rotherham",
            "Hoyland"
          ]
        },
        {
          "name": "Bakewell",
          "slug": "bakewell",
          "postcode": "DE45",
          "nearby_areas": [
            "Belper",
            "Ripley",
            "Heanor",
            "Alfreton",
            "Derby",
            "Ilkeston",
            "Burton upon Trent"
          ]
        }
      ]
    },
    {
      "name": "Devon",
      "slug": "devon",
      "region": "South West England",
      "council_name": "Devon County Council",
      "council_url": "https://www.devon.gov.uk/",
      "climate": "mild, wet and windy coastal climate",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Plymouth",
          "slug": "plymouth",
          "postcode": "PL1",
          "nearby_areas": [
            "Torpoint",
            "Saltash",
            "Ivybridge",
            "Tavistock",
            "Fowey",
            "Looe",
            "Liskeard"
          ]
        },
        {
          "name": "Exeter",
          "slug": "exeter",
          "postcode": "EX1",
          "nearby_areas": [
            "Crediton",
            "Exmouth",
            "Dawlish",
            "Teignmouth",
            "Tiverton",
            "Sidmouth",
            "Newton Abbot"
          ]
        },
        {
          "name": "Torquay",
          "slug": "torquay",
          "postcode": "TQ1",
          "nearby_areas": [
            "Paignton",
            "Newton Abbot",
            "Teignmouth",
            "Totnes",
            "Dawlish",
            "Exmouth",
            "Kingsbridge"
          ]
        },
        {
          "name": "Paignton",
          "slug": "paignton",
          "postcode": "TQ3",
          "nearby_areas": [
            "Torquay",
            "Totnes",
            "Newton Abbot",
            "Teignmouth",
            "Dawlish",
            "Kingsbridge",
            "Exmouth"
          ]
        },
        {
          "name": "Barnstaple",
          "slug": "barnstaple",
          "postcode": "EX31",
          "nearby_areas": [
            "Bideford",
            "Ilfracombe",
            "Okehampton",
            "Crediton",
            "Tiverton",
            "Minehead",
            "Bude"
          ]
        },
        {
          "name": "Newton Abbot",
          "slug": "newton-abbot",
          "postcode": "TQ12",
          "nearby_areas": [
            "Teignmouth",
            "Torquay",
            "Paignton",
            "Dawlish",
            "Totnes",
            "Exmouth",
            "Exeter"
          ]
        },
        {
          "name": "Tiverton",
          "slug": "tiverton",
          "postcode": "EX16",
          "nearby_areas": [
            "Crediton",
            "Exeter",
            "Honiton",
            "Sidmouth",
            "Exmouth",
            "Taunton",
            "Dawlish"
          ]
        },
        {
          "name": "Bideford",
          "slug": "bideford",
          "postcode": "EX39",
          "nearby_areas": [
            "Barnstaple",
            "Ilfracombe",
            "Okehampton",
            "Bude",
            "Cardigan",
            "Crediton",
            "Lampeter"
          ]
        },
        {
          "name": "Exmouth",
          "slug": "exmouth",
          "postcode": "EX8",
          "nearby_areas": [
            "Dawlish",
            "Teignmouth",
            "Exeter",
            "Sidmouth",
            "Newton Abbot",
            "Torquay",
            "Paignton"
          ]
        },
        {
          "name": "Totnes",
          "slug": "totnes",
          "postcode": "TQ9",
          "nearby_areas": [
            "Paignton",
            "Torquay",
            "Newton Abbot",
            "Ivybridge",
            "Kingsbridge",
            "Teignmouth",
            "Dawlish"
          ]
        },
        {
          "name": "Teignmouth",
          "slug": "teignmouth",
          "postcode": "TQ14",
          "nearby_areas": [
            "Dawlish",
            "Newton Abbot",
            "Exmouth",
            "Torquay",
            "Paignton",
            "Totnes",
            "Exeter"
          ]
        },
        {
          "name": "Crediton",
          "slug": "crediton",
          "postcode": "EX17",
          "nearby_areas": [
            "Exeter",
            "Tiverton",
            "Okehampton",
            "Exmouth",
            "Dawlish",
            "Teignmouth",
            "Newton Abbot"
          ]
        },
        {
          "name": "Dawlish",
          "slug": "dawlish",
          "postcode": "EX7",
          "nearby_areas": [
            "Teignmouth",
            "Exmouth",
            "Newton Abbot",
            "Torquay",
            "Exeter",
            "Paignton",
            "Sidmouth"
          ]
        },
        {
          "name": "Okehampton",
          "slug": "okehampton",
          "postcode": "EX20",
          "nearby_areas": [
            "Tavistock",
            "Crediton",
            "Launceston",
            "Exeter",
            "Bideford",
            "Newton Abbot",
            "Barnstaple"
          ]
        },
        {
          "name": "Sidmouth",
          "slug": "sidmouth",
          "postcode": "EX10",
          "nearby_areas": [
            "Honiton",
            "Exmouth",
            "Dawlish",
            "Exeter",
            "Teignmouth",
            "Tiverton",
            "Newton Abbot"
          ]
        },
        {
          "name": "Honiton",
          "slug": "honiton",
          "postcode": "EX14",
          "nearby_areas": [
            "Sidmouth",
            "Chard",
            "Tiverton",
            "Exmouth",
            "Exeter",
            "Taunton",
            "Dawlish"
          ]
        },
        {
          "name": "Ivybridge",
          "slug": "ivybridge",
          "postcode": "PL21",
          "nearby_areas": [
            "Kingsbridge",
            "Plymouth",
            "Totnes",
            "Torpoint",
            "Saltash",
            "Tavistock",
            "Paignton"
          ]
        },
        {
          "name": "Kingsbridge",
          "slug": "kingsbridge",
          "postcode": "TQ7",
          "nearby_areas": [
            "Ivybridge",
            "Totnes",
            "Paignton",
            "Torquay",
            "Plymouth",
            "Newton Abbot",
            "Torpoint"
          ]
        },
        {
          "name": "Ilfracombe",
          "slug": "ilfracombe",
          "postcode": "EX34",
          "nearby_areas": [
            "Barnstaple",
            "Bideford",
            "Newcastle Emlyn",
            "Minehead",
            "Lampeter",
            "Porthcawl",
            "Cardigan"
          ]
        },
        {
          "name": "Tavistock",
          "slug": "tavistock",
          "postcode": "PL19",
          "nearby_areas": [
            "Saltash",
            "Plymouth",
            "Launceston",
            "Torpoint",
            "Okehampton",
            "Ivybridge",
            "Fowey"
          ]
        }
      ]
    },
    {
      "name": "Dorset",
      "slug": "dorset",
      "region": "South West England",
      "council_name": "Dorset Council",
      "council_url": "https://www.dorsetcouncil.gov.uk/",
      "climate": "mild coastal winters and sea air",
      "population": "800,000",
      "towns": [
        {
          "name": "Bournemouth",
          "slug": "bournemouth",
          "postcode": "BH1",
          "nearby_areas": [
            "Wimborne Minster",
            "Christchurch",
            "Poole",
            "Ferndown",
            "Swanage",
            "Wareham",
            "Verwood"
          ]
        },
        {
          "name": "Poole",
          "slug": "poole",
          "postcode": "BH15",
          "nearby_areas": [
            "Wimborne Minster",
            "Bournemouth",
            "Wareham",
            "Christchurch",
            "Ferndown",
            "Swanage",
            "Verwood"
          ]
        },
        {
          "name": "Weymouth",
          "slug": "weymouth",
          "postcode": "DT4",
          "nearby_areas": [
            "Dorchester",
            "Lyme Regis",
            "Bridport",
            "Wareham",
            "Blandford Forum",
            "Swanage",
            "Poole"
          ]
        },
        {
          "name": "Dorchester",
          "slug": "dorchester",
          "postcode": "DT1",
          "nearby_areas": [
            "Lyme Regis",
            "Weymouth",
            "Bridport",
            "Sherborne",
            "Yeovil",
            "Blandford Forum",
            "Wareham"
          ]
        },
        {
          "name": "Christchurch",
          "slug": "christchurch",
          "postcode": "BH23",
          "nearby_areas": [
            "Ferndown",
            "Wimborne Minster",
            "Bournemouth",
            "Poole",
            "Ringwood",
            "Verwood",
            "New Milton"
          ]
        },
        {
          "name": "Ferndown",
          "slug": "ferndown",
          "postcode": "BH22",
          "nearby_areas": [
            "Christchurch",
            "Wimborne Minster",
            "Verwood",
            "Bournemouth",
            "Ringwood",
            "Poole",
            "Blandford Forum"
          ]
        },
        {
          "name": "Wimborne Minster",
          "slug": "wimborne-minster",
          "postcode": "BH21",
          "nearby_areas": [
            "Bournemouth",
            "Poole",
            "Christchurch",
            "Ferndown",
            "Wareham",
            "Swanage",
            "Verwood"
          ]
        },
        {
          "name": "Bridport",
          "slug": "bridport",
          "postcode": "DT6",
          "nearby_areas": [
            "Lyme Regis",
            "Dorchester",
            "Crewkerne",
            "Chard",
            "Weymouth",
            "Yeovil",
            "Sherborne"
          ]
        },
        {
          "name": "Swanage",
          "slug": "swanage",
          "postcode": "BH19",
          "nearby_areas": [
            "Poole",
            "Bournemouth",
            "Wareham",
            "Wimborne Minster",
            "Christchurch",
            "Ferndown",
            "Verwood"
          ]
        },
        {
          "name": "Blandford Forum",
          "slug": "blandford-forum",
          "postcode": "DT11",
          "nearby_areas": [
            "Wareham",
            "Ferndown",
            "Poole",
            "Verwood",
            "Wimborne Minster",
            "Christchurch",
            "Bournemouth"
          ]
        },
        {
          "name": "Sherborne",
          "slug": "sherborne",
          "postcode": "DT9",
          "nearby_areas": [
            "Yeovil",
            "Lyme Regis",
            "Dorchester",
            "Crewkerne",
            "Blandford Forum",
            "Bridport",
            "Glastonbury"
          ]
        },
        {
          "name": "Gillingham",
          "slug": "gillingham",
          "postcode": "SP8",
          "nearby_areas": [
            "Andover",
            "Amesbury",
            "Salisbury",
            "Romsey",
            "Winchester",
            "Eastleigh",
            "Hungerford"
          ]
        },
        {
          "name": "Wareham",
          "slug": "wareham",
          "postcode": "BH20",
          "nearby_areas": [
            "Poole",
            "Swanage",
            "Wimborne Minster",
            "Bournemouth",
            "Blandford Forum",
            "Christchurch",
            "Ferndown"
          ]
        },
        {
          "name": "Verwood",
          "slug": "verwood",
          "postcode": "BH31",
          "nearby_areas": [
            "Ferndown",
            "Ringwood",
            "Christchurch",
            "Wimborne Minster",
            "Bournemouth",
            "Poole",
            "Blandford Forum"
          ]
        },
        {
          "name": "Lyme Regis",
          "slug": "lyme-regis",
          "postcode": "DT7",
          "nearby_areas": [
            "Dorchester",
            "Bridport",
            "Sherborne",
            "Weymouth",
            "Yeovil",
            "Crewkerne",
            "Blandford Forum"
          ]
        }
      ]
    },
    {
      "name": "Dumfries and Galloway",
      "slug": "dumfries-and-galloway",
      "region": "Scotland",
      "council_name": "Dumfries and Galloway Council",
      "council_url": "https://www.dumgal.gov.uk/",
      "climate": "wet, mild and rural",
      "population": "145,000",
      "towns": [
        {
          "name": "Dumfries",
          "slug": "dumfries",
          "postcode": "DG1",
          "nearby_areas": [
            "Lockerbie",
            "Annan",
            "Kirkcudbright",
            "Castle Douglas",
            "Maryport",
            "Newton Stewart",
            "Appleby-in-Westmorland"
          ]
        },
        {
          "name": "Stranraer",
          "slug": "stranraer",
          "postcode": "DG9",
          "nearby_areas": [
            "Newton Stewart",
            "Girvan",
            "Castle Douglas",
            "Donaghadee",
            "Kirkcudbright",
            "Bangor",
            "Larne"
          ]
        },
        {
          "name": "Annan",
          "slug": "annan",
          "postcode": "DG12",
          "nearby_areas": [
            "Dumfries",
            "Carlisle",
            "Maryport",
            "Keswick",
            "Appleby-in-Westmorland",
            "Lockerbie",
            "Cockermouth"
          ]
        },
        {
          "name": "Lockerbie",
          "slug": "lockerbie",
          "postcode": "DG11",
          "nearby_areas": [
            "Kirkcudbright",
            "Castle Douglas",
            "Dumfries",
            "Newton Stewart",
            "Annan",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Castle Douglas",
          "slug": "castle-douglas",
          "postcode": "DG7",
          "nearby_areas": [
            "Kirkcudbright",
            "Newton Stewart",
            "Lockerbie",
            "Dumfries",
            "Stranraer",
            "Girvan",
            "Cumnock"
          ]
        },
        {
          "name": "Kirkcudbright",
          "slug": "kirkcudbright",
          "postcode": "DG6",
          "nearby_areas": [
            "Castle Douglas",
            "Lockerbie",
            "Newton Stewart",
            "Dumfries",
            "Stranraer",
            "Annan",
            "Girvan"
          ]
        },
        {
          "name": "Newton Stewart",
          "slug": "newton-stewart",
          "postcode": "DG8",
          "nearby_areas": [
            "Castle Douglas",
            "Kirkcudbright",
            "Lockerbie",
            "Stranraer",
            "Girvan",
            "Dumfries",
            "Cumnock"
          ]
        }
      ]
    },
    {
      "name": "Dundee City",
      "slug": "dundee-city",
      "region": "Scotland",
      "council_name": "Dundee City Council",
      "council_url": "https://www.dundeecity.gov.uk/",
      "climate": "cool east coast climate",
      "population": "145,000",
      "towns": [
        {
          "name": "Dundee",
          "slug": "dundee",
          "postcode": "DD1",
          "nearby_areas": [
            "Lochee",
            "Broughty Ferry",
            "Monifieth",
            "Carnoustie",
            "Cupar",
            "St Andrews",
            "Forfar"
          ]
        },
        {
          "name": "Broughty Ferry",
          "slug": "broughty-ferry",
          "postcode": "DD5",
          "nearby_areas": [
            "Monifieth",
            "Lochee",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Kirriemuir",
            "Arbroath"
          ]
        },
        {
          "name": "Lochee",
          "slug": "lochee",
          "postcode": "DD2",
          "nearby_areas": [
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Dundee",
            "Kirriemuir"
          ]
        },
        {
          "name": "Monifieth",
          "slug": "monifieth",
          "postcode": "DD5",
          "nearby_areas": [
            "Broughty Ferry",
            "Lochee",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Kirriemuir",
            "Arbroath"
          ]
        }
      ]
    },
    {
      "name": "East Ayrshire",
      "slug": "east-ayrshire",
      "region": "Scotland",
      "council_name": "East Ayrshire Council",
      "council_url": "https://www.east-ayrshire.gov.uk/",
      "climate": "wet west coast inland climate",
      "population": "120,000",
      "towns": [
        {
          "name": "Kilmarnock",
          "slug": "kilmarnock",
          "postcode": "KA1",
          "nearby_areas": [
            "Stewarton",
            "Auchinleck",
            "Mauchline",
            "Maybole",
            "Dalmellington",
            "Irvine",
            "Stevenston"
          ]
        },
        {
          "name": "Cumnock",
          "slug": "cumnock",
          "postcode": "KA18",
          "nearby_areas": [
            "Auchinleck",
            "Kilmarnock",
            "Stewarton",
            "Dalmellington",
            "Mauchline",
            "Maybole",
            "Ayr"
          ]
        },
        {
          "name": "Stewarton",
          "slug": "stewarton",
          "postcode": "KA3",
          "nearby_areas": [
            "Mauchline",
            "Stevenston",
            "Prestwick",
            "Maybole",
            "Dalmellington",
            "Troon",
            "Ardrossan"
          ]
        },
        {
          "name": "Auchinleck",
          "slug": "auchinleck",
          "postcode": "KA18",
          "nearby_areas": [
            "Maybole",
            "Stewarton",
            "Dalmellington",
            "Mauchline",
            "Kilmarnock",
            "Prestwick",
            "Stevenston"
          ]
        },
        {
          "name": "Mauchline",
          "slug": "mauchline",
          "postcode": "KA5",
          "nearby_areas": [
            "Dalmellington",
            "Prestwick",
            "Stevenston",
            "Stewarton",
            "Troon",
            "Maybole",
            "Ardrossan"
          ]
        },
        {
          "name": "Dalmellington",
          "slug": "dalmellington",
          "postcode": "KA6",
          "nearby_areas": [
            "Mauchline",
            "Prestwick",
            "Stevenston",
            "Troon",
            "Maybole",
            "Stewarton",
            "Ardrossan"
          ]
        }
      ]
    },
    {
      "name": "East Dunbartonshire",
      "slug": "east-dunbartonshire",
      "region": "Scotland",
      "council_name": "East Dunbartonshire Council",
      "council_url": "https://www.eastdunbarton.gov.uk/",
      "climate": "cool, damp west central climate",
      "population": "110,000",
      "towns": [
        {
          "name": "Bearsden",
          "slug": "bearsden",
          "postcode": "G61",
          "nearby_areas": [
            "Milngavie",
            "Balfron",
            "Bishopbriggs",
            "Kilsyth",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        },
        {
          "name": "Milngavie",
          "slug": "milngavie",
          "postcode": "G62",
          "nearby_areas": [
            "Bearsden",
            "Balfron",
            "Bishopbriggs",
            "Kilsyth",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        },
        {
          "name": "Kirkintilloch",
          "slug": "kirkintilloch",
          "postcode": "G66",
          "nearby_areas": [
            "Lennoxtown",
            "Cumbernauld",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        },
        {
          "name": "Bishopbriggs",
          "slug": "bishopbriggs",
          "postcode": "G64",
          "nearby_areas": [
            "Kilsyth",
            "Balfron",
            "Kirkintilloch",
            "Lennoxtown",
            "Milngavie",
            "Bearsden",
            "Cumbernauld"
          ]
        },
        {
          "name": "Lennoxtown",
          "slug": "lennoxtown",
          "postcode": "G66",
          "nearby_areas": [
            "Kirkintilloch",
            "Cumbernauld",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        }
      ]
    },
    {
      "name": "East Lothian",
      "slug": "east-lothian",
      "region": "Scotland",
      "council_name": "East Lothian Council",
      "council_url": "https://www.eastlothian.gov.uk/",
      "climate": "cool, breezy and relatively dry",
      "population": "110,000",
      "towns": [
        {
          "name": "Musselburgh",
          "slug": "musselburgh",
          "postcode": "EH21",
          "nearby_areas": [
            "Loanhead",
            "Dalkeith",
            "Bonnyrigg",
            "Gorebridge",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Haddington",
          "slug": "haddington",
          "postcode": "EH41",
          "nearby_areas": [
            "Tranent",
            "North Berwick",
            "Prestonpans",
            "Dunbar",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Tranent",
          "slug": "tranent",
          "postcode": "EH33",
          "nearby_areas": [
            "Prestonpans",
            "Musselburgh",
            "Haddington",
            "Bonnyrigg",
            "Loanhead",
            "Portobello",
            "Dalkeith"
          ]
        },
        {
          "name": "North Berwick",
          "slug": "north-berwick",
          "postcode": "EH39",
          "nearby_areas": [
            "Haddington",
            "Dunbar",
            "Tranent",
            "Prestonpans",
            "Musselburgh",
            "Bonnyrigg",
            "Portobello"
          ]
        },
        {
          "name": "Dunbar",
          "slug": "dunbar",
          "postcode": "EH42",
          "nearby_areas": [
            "North Berwick",
            "Haddington",
            "Tranent",
            "Prestonpans",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Prestonpans",
          "slug": "prestonpans",
          "postcode": "EH32",
          "nearby_areas": [
            "Tranent",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead",
            "Portobello",
            "Corstorphine",
            "Dalkeith"
          ]
        }
      ]
    },
    {
      "name": "East Renfrewshire",
      "slug": "east-renfrewshire",
      "region": "Scotland",
      "council_name": "East Renfrewshire Council",
      "council_url": "https://www.eastrenfrewshire.gov.uk/",
      "climate": "cool, wet west central climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Giffnock",
          "slug": "giffnock",
          "postcode": "G46",
          "nearby_areas": [
            "Govan",
            "Pollokshields",
            "Shawlands",
            "Johnstone",
            "Dumbarton",
            "Renfrew",
            "Linwood"
          ]
        },
        {
          "name": "Newton Mearns",
          "slug": "newton-mearns",
          "postcode": "G77",
          "nearby_areas": [
            "Barrhead",
            "Clarkston",
            "Eaglesham",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Barrhead",
          "slug": "barrhead",
          "postcode": "G78",
          "nearby_areas": [
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Clarkston",
          "slug": "clarkston",
          "postcode": "G76",
          "nearby_areas": [
            "Eaglesham",
            "Newton Mearns",
            "Barrhead",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Eaglesham",
          "slug": "eaglesham",
          "postcode": "G76",
          "nearby_areas": [
            "Clarkston",
            "Newton Mearns",
            "Barrhead",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        }
      ]
    },
    {
      "name": "East Riding of Yorkshire",
      "slug": "east-riding-of-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "East Riding of Yorkshire Council",
      "council_url": "https://www.eastriding.gov.uk/",
      "climate": "cool coastal winds and damp winters",
      "population": "600,000",
      "towns": [
        {
          "name": "Hull",
          "slug": "hull",
          "postcode": "HU1",
          "nearby_areas": [
            "Hedon",
            "Cottingham",
            "Beverley",
            "Hessle",
            "Hornsea",
            "Withernsea",
            "Driffield"
          ]
        },
        {
          "name": "Beverley",
          "slug": "beverley",
          "postcode": "HU17",
          "nearby_areas": [
            "Cottingham",
            "Hedon",
            "Hull",
            "Hessle",
            "Driffield",
            "Hornsea",
            "Bridlington"
          ]
        },
        {
          "name": "Bridlington",
          "slug": "bridlington",
          "postcode": "YO15",
          "nearby_areas": [
            "Filey",
            "Driffield",
            "Hornsea",
            "Scarborough",
            "Beverley",
            "Pocklington",
            "Market Weighton"
          ]
        },
        {
          "name": "Goole",
          "slug": "goole",
          "postcode": "DN14",
          "nearby_areas": [
            "Howden",
            "Snaith",
            "Selby",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Hessle"
          ]
        },
        {
          "name": "Driffield",
          "slug": "driffield",
          "postcode": "YO25",
          "nearby_areas": [
            "Beverley",
            "Bridlington",
            "Hornsea",
            "Pocklington",
            "Market Weighton",
            "Cottingham",
            "Hull"
          ]
        },
        {
          "name": "Hessle",
          "slug": "hessle",
          "postcode": "HU13",
          "nearby_areas": [
            "Cottingham",
            "Hedon",
            "Hull",
            "Beverley",
            "Immingham",
            "Brigg",
            "Howden"
          ]
        },
        {
          "name": "Cottingham",
          "slug": "cottingham",
          "postcode": "HU16",
          "nearby_areas": [
            "Hedon",
            "Hessle",
            "Beverley",
            "Hull",
            "Hornsea",
            "Driffield",
            "Immingham"
          ]
        },
        {
          "name": "Hornsea",
          "slug": "hornsea",
          "postcode": "HU18",
          "nearby_areas": [
            "Hull",
            "Beverley",
            "Hedon",
            "Bridlington",
            "Driffield",
            "Cottingham",
            "Withernsea"
          ]
        },
        {
          "name": "Withernsea",
          "slug": "withernsea",
          "postcode": "HU19",
          "nearby_areas": [
            "Hull",
            "Hornsea",
            "Grimsby",
            "Cleethorpes",
            "Hedon",
            "Immingham",
            "Cottingham"
          ]
        },
        {
          "name": "Market Weighton",
          "slug": "market-weighton",
          "postcode": "YO43",
          "nearby_areas": [
            "Pocklington",
            "Malton",
            "Pickering",
            "Driffield",
            "Scarborough",
            "Filey",
            "Bridlington"
          ]
        },
        {
          "name": "Pocklington",
          "slug": "pocklington",
          "postcode": "YO42",
          "nearby_areas": [
            "Market Weighton",
            "Malton",
            "Pickering",
            "Driffield",
            "Scarborough",
            "Filey",
            "Bridlington"
          ]
        },
        {
          "name": "Howden",
          "slug": "howden",
          "postcode": "DN14",
          "nearby_areas": [
            "Snaith",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Goole",
            "Brigg",
            "Hessle"
          ]
        },
        {
          "name": "Snaith",
          "slug": "snaith",
          "postcode": "DN14",
          "nearby_areas": [
            "Howden",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Goole",
            "Brigg",
            "Hessle"
          ]
        },
        {
          "name": "Hedon",
          "slug": "hedon",
          "postcode": "HU12",
          "nearby_areas": [
            "Hull",
            "Cottingham",
            "Hessle",
            "Beverley",
            "Hornsea",
            "Immingham",
            "Withernsea"
          ]
        }
      ]
    },
    {
      "name": "East Sussex",
      "slug": "east-sussex",
      "region": "South East England",
      "council_name": "East Sussex County Council",
      "council_url": "https://www.eastsussex.gov.uk/",
      "climate": "mild coastal conditions with sea winds",
      "population": "850,000",
      "towns": [
        {
          "name": "Brighton",
          "slug": "brighton",
          "postcode": "BN1",
          "nearby_areas": [
            "Hove",
            "Peacehaven",
            "Arundel",
            "Lewes",
            "Newhaven",
            "Seaford",
            "Shoreham-by-Sea"
          ]
        },
        {
          "name": "Hove",
          "slug": "hove",
          "postcode": "BN3",
          "nearby_areas": [
            "Brighton",
            "Peacehaven",
            "Arundel",
            "Lewes",
            "Newhaven",
            "Seaford",
            "Shoreham-by-Sea"
          ]
        },
        {
          "name": "Eastbourne",
          "slug": "eastbourne",
          "postcode": "BN21",
          "nearby_areas": [
            "Hailsham",
            "Seaford",
            "Bexhill-on-Sea",
            "Newhaven",
            "Peacehaven",
            "Rye",
            "Battle"
          ]
        },
        {
          "name": "Hastings",
          "slug": "hastings",
          "postcode": "TN34",
          "nearby_areas": [
            "Bexhill-on-Sea",
            "Battle",
            "Rye",
            "Eastbourne",
            "Hailsham",
            "Heathfield",
            "Ashford"
          ]
        },
        {
          "name": "Bexhill-on-Sea",
          "slug": "bexhill-on-sea",
          "postcode": "TN39",
          "nearby_areas": [
            "Hastings",
            "Battle",
            "Rye",
            "Hailsham",
            "Eastbourne",
            "Heathfield",
            "Ashford"
          ]
        },
        {
          "name": "Lewes",
          "slug": "lewes",
          "postcode": "BN7",
          "nearby_areas": [
            "Hove",
            "Brighton",
            "Peacehaven",
            "Newhaven",
            "Uckfield",
            "Seaford",
            "Burgess Hill"
          ]
        },
        {
          "name": "Uckfield",
          "slug": "uckfield",
          "postcode": "TN22",
          "nearby_areas": [
            "Heathfield",
            "Ashford",
            "Crowborough",
            "Lewes",
            "Hailsham",
            "Haywards Heath",
            "Burgess Hill"
          ]
        },
        {
          "name": "Crowborough",
          "slug": "crowborough",
          "postcode": "TN6",
          "nearby_areas": [
            "Heathfield",
            "Tunbridge Wells",
            "Ashford",
            "Uckfield",
            "East Grinstead",
            "Tonbridge",
            "Haywards Heath"
          ]
        },
        {
          "name": "Seaford",
          "slug": "seaford",
          "postcode": "BN25",
          "nearby_areas": [
            "Newhaven",
            "Peacehaven",
            "Hove",
            "Lewes",
            "Brighton",
            "Eastbourne",
            "Hailsham"
          ]
        },
        {
          "name": "Newhaven",
          "slug": "newhaven",
          "postcode": "BN9",
          "nearby_areas": [
            "Peacehaven",
            "Seaford",
            "Hove",
            "Brighton",
            "Lewes",
            "Hailsham",
            "Arundel"
          ]
        },
        {
          "name": "Rye",
          "slug": "rye",
          "postcode": "TN31",
          "nearby_areas": [
            "Battle",
            "Bexhill-on-Sea",
            "Hastings",
            "Hailsham",
            "Heathfield",
            "Ashford",
            "Eastbourne"
          ]
        },
        {
          "name": "Battle",
          "slug": "battle",
          "postcode": "TN33",
          "nearby_areas": [
            "Rye",
            "Bexhill-on-Sea",
            "Hastings",
            "Hailsham",
            "Heathfield",
            "Eastbourne",
            "Ashford"
          ]
        },
        {
          "name": "Heathfield",
          "slug": "heathfield",
          "postcode": "TN21",
          "nearby_areas": [
            "Ashford",
            "Crowborough",
            "Uckfield",
            "Tunbridge Wells",
            "Hailsham",
            "Rye",
            "Lewes"
          ]
        },
        {
          "name": "Hailsham",
          "slug": "hailsham",
          "postcode": "BN27",
          "nearby_areas": [
            "Eastbourne",
            "Rye",
            "Seaford",
            "Bexhill-on-Sea",
            "Uckfield",
            "Newhaven",
            "Heathfield"
          ]
        },
        {
          "name": "Peacehaven",
          "slug": "peacehaven",
          "postcode": "BN10",
          "nearby_areas": [
            "Newhaven",
            "Hove",
            "Brighton",
            "Seaford",
            "Lewes",
            "Arundel",
            "Hailsham"
          ]
        }
      ]
    },
    {
      "name": "Essex",
      "slug": "essex",
      "region": "East of England",
      "council_name": "Essex County Council",
      "council_url": "https://www.essex.gov.uk/",
      "climate": "cold easterly winds and high moisture",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Chelmsford",
          "slug": "chelmsford",
          "postcode": "CM1",
          "nearby_areas": [
            "Billericay",
            "Bishop's Stortford",
            "Witham",
            "Wickford",
            "Maldon",
            "Braintree",
            "Brentwood"
          ]
        },
        {
          "name": "Colchester",
          "slug": "colchester",
          "postcode": "CO1",
          "nearby_areas": [
            "Halstead",
            "Clacton-on-Sea",
            "Witham",
            "Sudbury",
            "Braintree",
            "Maldon",
            "Harwich"
          ]
        },
        {
          "name": "Southend-on-Sea",
          "slug": "southend-on-sea",
          "postcode": "SS1",
          "nearby_areas": [
            "Rayleigh",
            "Canvey Island",
            "Wickford",
            "Basildon",
            "Maldon",
            "Billericay",
            "Chelmsford"
          ]
        },
        {
          "name": "Basildon",
          "slug": "basildon",
          "postcode": "SS13",
          "nearby_areas": [
            "Wickford",
            "Billericay",
            "Rayleigh",
            "Canvey Island",
            "Brentwood",
            "Southend-on-Sea",
            "Grays"
          ]
        },
        {
          "name": "Harlow",
          "slug": "harlow",
          "postcode": "CM20",
          "nearby_areas": [
            "Epping",
            "Hertford",
            "Loughton",
            "Bishop's Stortford",
            "Ilford",
            "Brentwood",
            "Welwyn Garden City"
          ]
        },
        {
          "name": "Brentwood",
          "slug": "brentwood",
          "postcode": "CM14",
          "nearby_areas": [
            "Billericay",
            "Basildon",
            "Bishop's Stortford",
            "Wickford",
            "Epping",
            "Grays",
            "Loughton"
          ]
        },
        {
          "name": "Braintree",
          "slug": "braintree",
          "postcode": "CM7",
          "nearby_areas": [
            "Witham",
            "Chelmsford",
            "Maldon",
            "Sudbury",
            "Colchester",
            "Bishop's Stortford",
            "Saffron Walden"
          ]
        },
        {
          "name": "Clacton-on-Sea",
          "slug": "clacton-on-sea",
          "postcode": "CO15",
          "nearby_areas": [
            "Harwich",
            "Colchester",
            "Halstead",
            "Felixstowe",
            "Maldon",
            "Ipswich",
            "Witham"
          ]
        },
        {
          "name": "Witham",
          "slug": "witham",
          "postcode": "CM8",
          "nearby_areas": [
            "Maldon",
            "Braintree",
            "Chelmsford",
            "Colchester",
            "Wickford",
            "Rayleigh",
            "Billericay"
          ]
        },
        {
          "name": "Maldon",
          "slug": "maldon",
          "postcode": "CM9",
          "nearby_areas": [
            "Witham",
            "Chelmsford",
            "Rayleigh",
            "Wickford",
            "Braintree",
            "Southend-on-Sea",
            "Billericay"
          ]
        },
        {
          "name": "Grays",
          "slug": "grays",
          "postcode": "RM17",
          "nearby_areas": [
            "Romford",
            "Bexleyheath",
            "Gravesend",
            "Dartford",
            "Basildon",
            "Brentwood",
            "Billericay"
          ]
        },
        {
          "name": "Rayleigh",
          "slug": "rayleigh",
          "postcode": "SS6",
          "nearby_areas": [
            "Wickford",
            "Canvey Island",
            "Basildon",
            "Southend-on-Sea",
            "Billericay",
            "Maldon",
            "Chelmsford"
          ]
        },
        {
          "name": "Billericay",
          "slug": "billericay",
          "postcode": "CM12",
          "nearby_areas": [
            "Wickford",
            "Basildon",
            "Brentwood",
            "Chelmsford",
            "Rayleigh",
            "Bishop's Stortford",
            "Canvey Island"
          ]
        },
        {
          "name": "Wickford",
          "slug": "wickford",
          "postcode": "SS11",
          "nearby_areas": [
            "Basildon",
            "Rayleigh",
            "Billericay",
            "Canvey Island",
            "Chelmsford",
            "Brentwood",
            "Southend-on-Sea"
          ]
        },
        {
          "name": "Canvey Island",
          "slug": "canvey-island",
          "postcode": "SS8",
          "nearby_areas": [
            "Rayleigh",
            "Basildon",
            "Southend-on-Sea",
            "Wickford",
            "Billericay",
            "Grays",
            "Rochester"
          ]
        },
        {
          "name": "Loughton",
          "slug": "loughton",
          "postcode": "IG10",
          "nearby_areas": [
            "Ilford",
            "Epping",
            "Harlow",
            "Brentwood",
            "Bishop's Stortford",
            "Hertford",
            "Billericay"
          ]
        },
        {
          "name": "Epping",
          "slug": "epping",
          "postcode": "CM16",
          "nearby_areas": [
            "Loughton",
            "Harlow",
            "Ilford",
            "Bishop's Stortford",
            "Brentwood",
            "Hertford",
            "Billericay"
          ]
        },
        {
          "name": "Saffron Walden",
          "slug": "saffron-walden",
          "postcode": "CB10",
          "nearby_areas": [
            "Haverhill",
            "Sawston",
            "Histon",
            "Cambridge",
            "Braintree",
            "Harlow",
            "Newmarket"
          ]
        },
        {
          "name": "Halstead",
          "slug": "halstead",
          "postcode": "CO9",
          "nearby_areas": [
            "Colchester",
            "Sudbury",
            "Ipswich",
            "Clacton-on-Sea",
            "Harwich",
            "Hadleigh",
            "Witham"
          ]
        },
        {
          "name": "Harwich",
          "slug": "harwich",
          "postcode": "CO12",
          "nearby_areas": [
            "Felixstowe",
            "Ipswich",
            "Woodbridge",
            "Clacton-on-Sea",
            "Halstead",
            "Hadleigh",
            "Colchester"
          ]
        }
      ]
    },
    {
      "name": "Falkirk",
      "slug": "falkirk",
      "region": "Scotland",
      "council_name": "Falkirk Council",
      "council_url": "https://www.falkirk.gov.uk/",
      "climate": "cool, damp central belt climate",
      "population": "160,000",
      "towns": [
        {
          "name": "Falkirk",
          "slug": "falkirk",
          "postcode": "FK1",
          "nearby_areas": [
            "Grangemouth",
            "Larbert",
            "Stenhousemuir",
            "Denny",
            "Linlithgow",
            "Bathgate",
            "Bridge of Allan"
          ]
        },
        {
          "name": "Grangemouth",
          "slug": "grangemouth",
          "postcode": "FK3",
          "nearby_areas": [
            "Larbert",
            "Stenhousemuir",
            "Denny",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Falkirk"
          ]
        },
        {
          "name": "Bo'ness",
          "slug": "bo-ness",
          "postcode": "EH51",
          "nearby_areas": [
            "Armadale",
            "Whitburn",
            "Newbridge",
            "Broxburn",
            "Livingston",
            "Edinburgh",
            "Penicuik"
          ]
        },
        {
          "name": "Denny",
          "slug": "denny",
          "postcode": "FK6",
          "nearby_areas": [
            "Larbert",
            "Stenhousemuir",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Grangemouth",
            "Stirling"
          ]
        },
        {
          "name": "Larbert",
          "slug": "larbert",
          "postcode": "FK5",
          "nearby_areas": [
            "Stenhousemuir",
            "Denny",
            "Grangemouth",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Stirling"
          ]
        },
        {
          "name": "Stenhousemuir",
          "slug": "stenhousemuir",
          "postcode": "FK5",
          "nearby_areas": [
            "Larbert",
            "Denny",
            "Grangemouth",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Stirling"
          ]
        }
      ]
    },
    {
      "name": "Fife",
      "slug": "fife",
      "region": "Scotland",
      "council_name": "Fife Council",
      "council_url": "https://www.fife.gov.uk/",
      "climate": "cool coastal climate with damp winters",
      "population": "375,000",
      "towns": [
        {
          "name": "Dunfermline",
          "slug": "dunfermline",
          "postcode": "KY12",
          "nearby_areas": [
            "Linlithgow",
            "Kinross",
            "Broxburn",
            "Inverkeithing",
            "Rosyth",
            "Newbridge",
            "Anstruther"
          ]
        },
        {
          "name": "Kirkcaldy",
          "slug": "kirkcaldy",
          "postcode": "KY1",
          "nearby_areas": [
            "Cowdenbeath",
            "Leven",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Cupar"
          ]
        },
        {
          "name": "Glenrothes",
          "slug": "glenrothes",
          "postcode": "KY7",
          "nearby_areas": [
            "Cowdenbeath",
            "Leven",
            "Kirkcaldy",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Cupar"
          ]
        },
        {
          "name": "St Andrews",
          "slug": "st-andrews",
          "postcode": "KY16",
          "nearby_areas": [
            "Cupar",
            "Dundee",
            "Carnoustie",
            "Lochee",
            "Glenrothes",
            "Kirkcaldy",
            "Cowdenbeath"
          ]
        },
        {
          "name": "Cowdenbeath",
          "slug": "cowdenbeath",
          "postcode": "KY4",
          "nearby_areas": [
            "Kirkcaldy",
            "Leven",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Kinross"
          ]
        },
        {
          "name": "Leven",
          "slug": "leven",
          "postcode": "KY8",
          "nearby_areas": [
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Kinross"
          ]
        },
        {
          "name": "Cupar",
          "slug": "cupar",
          "postcode": "KY15",
          "nearby_areas": [
            "St Andrews",
            "Kirkcaldy",
            "Cowdenbeath",
            "Glenrothes",
            "Leven",
            "Dundee",
            "Anstruther"
          ]
        },
        {
          "name": "Rosyth",
          "slug": "rosyth",
          "postcode": "KY11",
          "nearby_areas": [
            "Inverkeithing",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        },
        {
          "name": "Inverkeithing",
          "slug": "inverkeithing",
          "postcode": "KY11",
          "nearby_areas": [
            "Rosyth",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        },
        {
          "name": "Anstruther",
          "slug": "anstruther",
          "postcode": "KY10",
          "nearby_areas": [
            "Inverkeithing",
            "Rosyth",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        }
      ]
    },
    {
      "name": "Flintshire",
      "slug": "flintshire",
      "region": "Wales",
      "council_name": "Flintshire County Council",
      "council_url": "https://www.flintshire.gov.uk/",
      "climate": "mild, damp and coastal",
      "population": "160,000",
      "towns": [
        {
          "name": "Mold",
          "slug": "mold",
          "postcode": "CH7",
          "nearby_areas": [
            "Buckley",
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Flint",
            "Risca",
            "Ruthin"
          ]
        },
        {
          "name": "Flint",
          "slug": "flint",
          "postcode": "CH6",
          "nearby_areas": [
            "Risca",
            "Connah's Quay",
            "Shotton",
            "Holywell",
            "Mold",
            "Buckley",
            "Bebington"
          ]
        },
        {
          "name": "Connah's Quay",
          "slug": "connah-s-quay",
          "postcode": "CH5",
          "nearby_areas": [
            "Shotton",
            "Holywell",
            "Buckley",
            "Flint",
            "Mold",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Buckley",
          "slug": "buckley",
          "postcode": "CH7",
          "nearby_areas": [
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Mold",
            "Flint",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Holywell",
          "slug": "holywell",
          "postcode": "CH8",
          "nearby_areas": [
            "Connah's Quay",
            "Shotton",
            "Buckley",
            "Mold",
            "Flint",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Shotton",
          "slug": "shotton",
          "postcode": "CH5",
          "nearby_areas": [
            "Connah's Quay",
            "Holywell",
            "Buckley",
            "Flint",
            "Mold",
            "Risca",
            "Chester"
          ]
        }
      ]
    },
    {
      "name": "Glasgow City",
      "slug": "glasgow-city",
      "region": "Scotland",
      "council_name": "Glasgow City Council",
      "council_url": "https://www.glasgow.gov.uk/",
      "climate": "wet west coast urban climate",
      "population": "635,000",
      "towns": [
        {
          "name": "Glasgow",
          "slug": "glasgow",
          "postcode": "G1",
          "nearby_areas": [
            "Partick",
            "Maryhill",
            "Erskine",
            "Dennistoun",
            "Pollokshields",
            "Shawlands",
            "Bishopton"
          ]
        },
        {
          "name": "Partick",
          "slug": "partick",
          "postcode": "G11",
          "nearby_areas": [
            "Maryhill",
            "Glasgow",
            "Erskine",
            "Dennistoun",
            "Bishopton",
            "Pollokshields",
            "Shawlands"
          ]
        },
        {
          "name": "Shawlands",
          "slug": "shawlands",
          "postcode": "G41",
          "nearby_areas": [
            "Pollokshields",
            "Giffnock",
            "Govan",
            "Dennistoun",
            "Johnstone",
            "Dumbarton",
            "Bishopton"
          ]
        },
        {
          "name": "Pollokshields",
          "slug": "pollokshields",
          "postcode": "G41",
          "nearby_areas": [
            "Shawlands",
            "Giffnock",
            "Govan",
            "Dennistoun",
            "Johnstone",
            "Dumbarton",
            "Bishopton"
          ]
        },
        {
          "name": "Maryhill",
          "slug": "maryhill",
          "postcode": "G20",
          "nearby_areas": [
            "Erskine",
            "Partick",
            "Dennistoun",
            "Bishopton",
            "Pollokshields",
            "Shawlands",
            "Giffnock"
          ]
        },
        {
          "name": "Dennistoun",
          "slug": "dennistoun",
          "postcode": "G31",
          "nearby_areas": [
            "Erskine",
            "Pollokshields",
            "Shawlands",
            "Bishopton",
            "Maryhill",
            "Giffnock",
            "Govan"
          ]
        },
        {
          "name": "Govan",
          "slug": "govan",
          "postcode": "G51",
          "nearby_areas": [
            "Dumbarton",
            "Giffnock",
            "Johnstone",
            "Renfrew",
            "Bearsden",
            "Linwood",
            "Pollokshields"
          ]
        }
      ]
    },
    {
      "name": "Gloucestershire",
      "slug": "gloucestershire",
      "region": "South West England",
      "council_name": "Gloucestershire County Council",
      "council_url": "https://www.gloucestershire.gov.uk/",
      "climate": "mild, damp winters with Cotswold exposure",
      "population": "950,000",
      "towns": [
        {
          "name": "Gloucester",
          "slug": "gloucester",
          "postcode": "GL1",
          "nearby_areas": [
            "Cheltenham",
            "Coleford",
            "Stroud",
            "Bishop's Cleeve",
            "Tewkesbury",
            "Cinderford",
            "Dursley"
          ]
        },
        {
          "name": "Cheltenham",
          "slug": "cheltenham",
          "postcode": "GL50",
          "nearby_areas": [
            "Bishop's Cleeve",
            "Tewkesbury",
            "Gloucester",
            "Chipping Campden",
            "Stroud",
            "Cirencester",
            "Coleford"
          ]
        },
        {
          "name": "Stroud",
          "slug": "stroud",
          "postcode": "GL5",
          "nearby_areas": [
            "Coleford",
            "Dursley",
            "Tetbury",
            "Gloucester",
            "Cirencester",
            "Cheltenham",
            "Bishop's Cleeve"
          ]
        },
        {
          "name": "Tewkesbury",
          "slug": "tewkesbury",
          "postcode": "GL20",
          "nearby_areas": [
            "Cheltenham",
            "Bishop's Cleeve",
            "Gloucester",
            "Pershore",
            "Droitwich Spa",
            "Chipping Campden",
            "Upton-upon-Severn"
          ]
        },
        {
          "name": "Cirencester",
          "slug": "cirencester",
          "postcode": "GL7",
          "nearby_areas": [
            "Tetbury",
            "Stroud",
            "Bishop's Cleeve",
            "Cheltenham",
            "Chipping Campden",
            "Gloucester",
            "Dursley"
          ]
        },
        {
          "name": "Dursley",
          "slug": "dursley",
          "postcode": "GL11",
          "nearby_areas": [
            "Coleford",
            "Stroud",
            "Lydney",
            "Tetbury",
            "Cinderford",
            "Gloucester",
            "Cirencester"
          ]
        },
        {
          "name": "Cinderford",
          "slug": "cinderford",
          "postcode": "GL14",
          "nearby_areas": [
            "Lydney",
            "Coleford",
            "Ross-on-Wye",
            "Monmouth",
            "Gloucester",
            "Dursley",
            "Stroud"
          ]
        },
        {
          "name": "Lydney",
          "slug": "lydney",
          "postcode": "GL15",
          "nearby_areas": [
            "Cinderford",
            "Dursley",
            "Coleford",
            "Chepstow",
            "Monmouth",
            "Stroud",
            "Gloucester"
          ]
        },
        {
          "name": "Coleford",
          "slug": "coleford",
          "postcode": "GL16",
          "nearby_areas": [
            "Stroud",
            "Dursley",
            "Cinderford",
            "Gloucester",
            "Lydney",
            "Tetbury",
            "Cheltenham"
          ]
        },
        {
          "name": "Bishop's Cleeve",
          "slug": "bishop-s-cleeve",
          "postcode": "GL52",
          "nearby_areas": [
            "Cheltenham",
            "Chipping Campden",
            "Tewkesbury",
            "Gloucester",
            "Cirencester",
            "Stroud",
            "Moreton-in-Marsh"
          ]
        },
        {
          "name": "Yate",
          "slug": "yate",
          "postcode": "BS37",
          "nearby_areas": [
            "Thornbury",
            "Filton",
            "Fishponds",
            "Nailsea",
            "Keynsham",
            "Portishead",
            "Kingswood"
          ]
        },
        {
          "name": "Thornbury",
          "slug": "thornbury",
          "postcode": "BS35",
          "nearby_areas": [
            "Filton",
            "Yate",
            "Keynsham",
            "Portishead",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Chipping Campden",
          "slug": "chipping-campden",
          "postcode": "GL55",
          "nearby_areas": [
            "Bishop's Cleeve",
            "Cheltenham",
            "Moreton-in-Marsh",
            "Tewkesbury",
            "Evesham",
            "Cirencester",
            "Gloucester"
          ]
        },
        {
          "name": "Moreton-in-Marsh",
          "slug": "moreton-in-marsh",
          "postcode": "GL56",
          "nearby_areas": [
            "Shipston-on-Stour",
            "Chipping Norton",
            "Chipping Campden",
            "Bishop's Cleeve",
            "Evesham",
            "Stratford-upon-Avon",
            "Cheltenham"
          ]
        },
        {
          "name": "Tetbury",
          "slug": "tetbury",
          "postcode": "GL8",
          "nearby_areas": [
            "Stroud",
            "Dursley",
            "Cirencester",
            "Coleford",
            "Gloucester",
            "Corsham",
            "Lydney"
          ]
        }
      ]
    },
    {
      "name": "Greater London",
      "slug": "greater-london",
      "region": "London",
      "council_name": "Greater London Authority",
      "council_url": "https://www.london.gov.uk/",
      "climate": "urban heat island with damp winters",
      "population": "9.1 million",
      "towns": [
        {
          "name": "Central London",
          "slug": "central-london",
          "postcode": "WC2N",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Westminster",
          "slug": "westminster",
          "postcode": "SW1A",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Camden",
          "slug": "camden",
          "postcode": "NW1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Islington",
          "slug": "islington",
          "postcode": "N1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hackney",
          "slug": "hackney",
          "postcode": "E8",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hammersmith",
          "slug": "hammersmith",
          "postcode": "W6",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Croydon",
          "slug": "croydon",
          "postcode": "CR0",
          "nearby_areas": [
            "Caterham",
            "Banstead",
            "Reigate",
            "Epsom",
            "Redhill",
            "Ashtead",
            "Leatherhead"
          ]
        },
        {
          "name": "Wimbledon",
          "slug": "wimbledon",
          "postcode": "SW19",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Ealing",
          "slug": "ealing",
          "postcode": "W5",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Harrow",
          "slug": "harrow",
          "postcode": "HA1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Ilford",
          "slug": "ilford",
          "postcode": "IG1",
          "nearby_areas": [
            "Loughton",
            "Epping",
            "Harlow",
            "Brentwood",
            "Bishop's Stortford",
            "Hertford",
            "Romford"
          ]
        },
        {
          "name": "Romford",
          "slug": "romford",
          "postcode": "RM1",
          "nearby_areas": [
            "Grays",
            "Bexleyheath",
            "Gravesend",
            "Dartford",
            "Basildon",
            "Rochester",
            "Brentwood"
          ]
        },
        {
          "name": "Bromley",
          "slug": "bromley",
          "postcode": "BR1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Kingston upon Thames",
          "slug": "kingston-upon-thames",
          "postcode": "KT1",
          "nearby_areas": [
            "Esher",
            "Walton-on-Thames",
            "Weybridge",
            "Addlestone",
            "Leatherhead",
            "Ashtead",
            "Epsom"
          ]
        },
        {
          "name": "Richmond",
          "slug": "richmond",
          "postcode": "TW9",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Enfield",
          "slug": "enfield",
          "postcode": "EN1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Barnet",
          "slug": "barnet",
          "postcode": "EN5",
          "nearby_areas": [
            "Acton",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Walthamstow",
          "slug": "walthamstow",
          "postcode": "E17",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Lewisham",
          "slug": "lewisham",
          "postcode": "SE13",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Greenwich",
          "slug": "greenwich",
          "postcode": "SE10",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Peckham",
          "slug": "peckham",
          "postcode": "SE15",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Clapham",
          "slug": "clapham",
          "postcode": "SW4",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Ealing"
          ]
        },
        {
          "name": "Uxbridge",
          "slug": "uxbridge",
          "postcode": "UB8",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hounslow",
          "slug": "hounslow",
          "postcode": "TW3",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Bexleyheath",
          "slug": "bexleyheath",
          "postcode": "DA6",
          "nearby_areas": [
            "Romford",
            "Grays",
            "Dartford",
            "Gravesend",
            "Rochester",
            "Chatham",
            "Brentwood"
          ]
        },
        {
          "name": "Woolwich",
          "slug": "woolwich",
          "postcode": "SE18",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Tottenham",
          "slug": "tottenham",
          "postcode": "N17",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Streatham",
          "slug": "streatham",
          "postcode": "SW16",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Acton",
          "slug": "acton",
          "postcode": "W3",
          "nearby_areas": [
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Chiswick",
          "slug": "chiswick",
          "postcode": "W4",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Clapham",
            "Ealing"
          ]
        }
      ]
    },
    {
      "name": "Greater Manchester",
      "slug": "greater-manchester",
      "region": "North West England",
      "council_name": "Greater Manchester Combined Authority",
      "council_url": "https://www.greatermanchester-ca.gov.uk/",
      "climate": "wet Atlantic weather and cool winters",
      "population": "2.9 million",
      "towns": [
        {
          "name": "Manchester",
          "slug": "manchester",
          "postcode": "M1",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Bolton",
          "slug": "bolton",
          "postcode": "BL1",
          "nearby_areas": [
            "Bury",
            "Ramsbottom",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Stockport",
          "slug": "stockport",
          "postcode": "SK1",
          "nearby_areas": [
            "Hyde",
            "Cheadle",
            "Buxton",
            "Ashton-under-Lyne",
            "Manchester",
            "Middleton",
            "Prestwich"
          ]
        },
        {
          "name": "Oldham",
          "slug": "oldham",
          "postcode": "OL1",
          "nearby_areas": [
            "Ashton-under-Lyne",
            "Rochdale",
            "Manchester",
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Salford"
          ]
        },
        {
          "name": "Rochdale",
          "slug": "rochdale",
          "postcode": "OL16",
          "nearby_areas": [
            "Oldham",
            "Bacup",
            "Todmorden",
            "Ashton-under-Lyne",
            "Bolton",
            "Bury",
            "Ramsbottom"
          ]
        },
        {
          "name": "Bury",
          "slug": "bury",
          "postcode": "BL9",
          "nearby_areas": [
            "Bolton",
            "Ramsbottom",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Wigan",
          "slug": "wigan",
          "postcode": "WN1",
          "nearby_areas": [
            "Leigh",
            "Skelmersdale",
            "Newton-le-Willows",
            "Chorley",
            "Formby",
            "Huyton",
            "Garstang"
          ]
        },
        {
          "name": "Salford",
          "slug": "salford",
          "postcode": "M5",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Manchester",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Altrincham",
          "slug": "altrincham",
          "postcode": "WA14",
          "nearby_areas": [
            "Sale",
            "Denton",
            "Stretford",
            "Eccles",
            "Prestwich",
            "Middleton",
            "Knutsford"
          ]
        },
        {
          "name": "Sale",
          "slug": "sale",
          "postcode": "M33",
          "nearby_areas": [
            "Denton",
            "Stretford",
            "Eccles",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Ashton-under-Lyne",
          "slug": "ashton-under-lyne",
          "postcode": "OL6",
          "nearby_areas": [
            "Oldham",
            "Manchester",
            "Stockport",
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Hyde"
          ]
        },
        {
          "name": "Leigh",
          "slug": "leigh",
          "postcode": "WN7",
          "nearby_areas": [
            "Skelmersdale",
            "Wigan",
            "Formby",
            "Ormskirk",
            "Huyton",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "Stretford",
          "slug": "stretford",
          "postcode": "M32",
          "nearby_areas": [
            "Denton",
            "Eccles",
            "Sale",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Eccles",
          "slug": "eccles",
          "postcode": "M30",
          "nearby_areas": [
            "Stretford",
            "Denton",
            "Prestwich",
            "Sale",
            "Middleton",
            "Salford",
            "Altrincham"
          ]
        },
        {
          "name": "Prestwich",
          "slug": "prestwich",
          "postcode": "M25",
          "nearby_areas": [
            "Middleton",
            "Eccles",
            "Stretford",
            "Denton",
            "Sale",
            "Salford",
            "Bolton"
          ]
        },
        {
          "name": "Hyde",
          "slug": "hyde",
          "postcode": "SK14",
          "nearby_areas": [
            "Buxton",
            "Stockport",
            "Cheadle",
            "Glossop",
            "Ashton-under-Lyne",
            "Wilmslow",
            "Macclesfield"
          ]
        },
        {
          "name": "Denton",
          "slug": "denton",
          "postcode": "M34",
          "nearby_areas": [
            "Stretford",
            "Eccles",
            "Sale",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Cheadle",
          "slug": "cheadle",
          "postcode": "SK8",
          "nearby_areas": [
            "Wilmslow",
            "Buxton",
            "Hyde",
            "Stockport",
            "Macclesfield",
            "Altrincham",
            "Sale"
          ]
        },
        {
          "name": "Ramsbottom",
          "slug": "ramsbottom",
          "postcode": "BL0",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Middleton",
          "slug": "middleton",
          "postcode": "M24",
          "nearby_areas": [
            "Prestwich",
            "Eccles",
            "Stretford",
            "Denton",
            "Sale",
            "Salford",
            "Bolton"
          ]
        }
      ]
    },
    {
      "name": "Gwynedd",
      "slug": "gwynedd",
      "region": "Wales",
      "council_name": "Cyngor Gwynedd",
      "council_url": "https://www.gwynedd.llyw.cymru/",
      "climate": "mountain rainfall and exposed coastal weather",
      "population": "120,000",
      "towns": [
        {
          "name": "Bangor",
          "slug": "bangor",
          "postcode": "LL57",
          "nearby_areas": [
            "Menai Bridge",
            "Beaumaris",
            "Benllech",
            "Pwllheli",
            "Amlwch",
            "Rhosneigr",
            "Porthmadog"
          ]
        },
        {
          "name": "Caernarfon",
          "slug": "caernarfon",
          "postcode": "LL55",
          "nearby_areas": [
            "Bangor",
            "Llangefni",
            "Rhosneigr",
            "Amlwch",
            "Pwllheli",
            "Beaumaris",
            "Menai Bridge"
          ]
        },
        {
          "name": "Porthmadog",
          "slug": "porthmadog",
          "postcode": "LL49",
          "nearby_areas": [
            "Pwllheli",
            "Barmouth",
            "Blaenau Ffestiniog",
            "Conwy",
            "Dolgellau",
            "Menai Bridge",
            "Beaumaris"
          ]
        },
        {
          "name": "Pwllheli",
          "slug": "pwllheli",
          "postcode": "LL53",
          "nearby_areas": [
            "Beaumaris",
            "Menai Bridge",
            "Bangor",
            "Benllech",
            "Porthmadog",
            "Amlwch",
            "Caernarfon"
          ]
        },
        {
          "name": "Blaenau Ffestiniog",
          "slug": "blaenau-ffestiniog",
          "postcode": "LL41",
          "nearby_areas": [
            "Dolgellau",
            "Barmouth",
            "Conwy",
            "Colwyn Bay",
            "Llandudno",
            "Porthmadog",
            "Llanrwst"
          ]
        },
        {
          "name": "Dolgellau",
          "slug": "dolgellau",
          "postcode": "LL40",
          "nearby_areas": [
            "Blaenau Ffestiniog",
            "Barmouth",
            "Conwy",
            "Colwyn Bay",
            "Llandudno",
            "Llanrwst",
            "Porthmadog"
          ]
        },
        {
          "name": "Barmouth",
          "slug": "barmouth",
          "postcode": "LL42",
          "nearby_areas": [
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Conwy",
            "Colwyn Bay",
            "Porthmadog",
            "Llandudno",
            "Llanrwst"
          ]
        }
      ]
    },
    {
      "name": "Hampshire",
      "slug": "hampshire",
      "region": "South East England",
      "council_name": "Hampshire County Council",
      "council_url": "https://www.hants.gov.uk/",
      "climate": "mild coastal air with damp winters",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Southampton",
          "slug": "southampton",
          "postcode": "SO14",
          "nearby_areas": [
            "Eastleigh",
            "Romsey",
            "Fareham",
            "Winchester",
            "Lymington",
            "Cowes",
            "East Cowes"
          ]
        },
        {
          "name": "Portsmouth",
          "slug": "portsmouth",
          "postcode": "PO1",
          "nearby_areas": [
            "Gosport",
            "Waterlooville",
            "Fareham",
            "Havant",
            "Newport",
            "Emsworth",
            "Selsey"
          ]
        },
        {
          "name": "Basingstoke",
          "slug": "basingstoke",
          "postcode": "RG21",
          "nearby_areas": [
            "Fleet",
            "Thatcham",
            "Twyford",
            "Aldershot",
            "Farnborough",
            "Farnham",
            "Pangbourne"
          ]
        },
        {
          "name": "Winchester",
          "slug": "winchester",
          "postcode": "SO23",
          "nearby_areas": [
            "Eastleigh",
            "Romsey",
            "Southampton",
            "Andover",
            "Fareham",
            "Gillingham",
            "Basingstoke"
          ]
        },
        {
          "name": "Andover",
          "slug": "andover",
          "postcode": "SP10",
          "nearby_areas": [
            "Gillingham",
            "Winchester",
            "Amesbury",
            "Romsey",
            "Hungerford",
            "Newbury",
            "Eastleigh"
          ]
        },
        {
          "name": "Aldershot",
          "slug": "aldershot",
          "postcode": "GU11",
          "nearby_areas": [
            "Farnborough",
            "Farnham",
            "Sandhurst",
            "Fleet",
            "Camberley",
            "Godalming",
            "Guildford"
          ]
        },
        {
          "name": "Farnborough",
          "slug": "farnborough",
          "postcode": "GU14",
          "nearby_areas": [
            "Aldershot",
            "Fleet",
            "Camberley",
            "Farnham",
            "Sandhurst",
            "Crowthorne",
            "Guildford"
          ]
        },
        {
          "name": "Eastleigh",
          "slug": "eastleigh",
          "postcode": "SO50",
          "nearby_areas": [
            "Southampton",
            "Romsey",
            "Winchester",
            "Fareham",
            "Gosport",
            "Waterlooville",
            "Lymington"
          ]
        },
        {
          "name": "Fareham",
          "slug": "fareham",
          "postcode": "PO16",
          "nearby_areas": [
            "Gosport",
            "Portsmouth",
            "Waterlooville",
            "Newport",
            "Havant",
            "East Cowes",
            "Cowes"
          ]
        },
        {
          "name": "Gosport",
          "slug": "gosport",
          "postcode": "PO12",
          "nearby_areas": [
            "Portsmouth",
            "Newport",
            "Fareham",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Waterlooville"
          ]
        },
        {
          "name": "Havant",
          "slug": "havant",
          "postcode": "PO9",
          "nearby_areas": [
            "Emsworth",
            "Waterlooville",
            "Selsey",
            "Portsmouth",
            "Gosport",
            "Fareham",
            "Chichester"
          ]
        },
        {
          "name": "Waterlooville",
          "slug": "waterlooville",
          "postcode": "PO7",
          "nearby_areas": [
            "Havant",
            "Emsworth",
            "Portsmouth",
            "Fareham",
            "Gosport",
            "Selsey",
            "Petersfield"
          ]
        },
        {
          "name": "Fleet",
          "slug": "fleet",
          "postcode": "GU51",
          "nearby_areas": [
            "Farnborough",
            "Aldershot",
            "Farnham",
            "Camberley",
            "Sandhurst",
            "Crowthorne",
            "Wokingham"
          ]
        },
        {
          "name": "Petersfield",
          "slug": "petersfield",
          "postcode": "GU32",
          "nearby_areas": [
            "Waterlooville",
            "Midhurst",
            "Alton",
            "Havant",
            "Emsworth",
            "Petworth",
            "Haslemere"
          ]
        },
        {
          "name": "Lymington",
          "slug": "lymington",
          "postcode": "SO41",
          "nearby_areas": [
            "New Milton",
            "Cowes",
            "Southampton",
            "Ringwood",
            "East Cowes",
            "Romsey",
            "Eastleigh"
          ]
        },
        {
          "name": "Romsey",
          "slug": "romsey",
          "postcode": "SO51",
          "nearby_areas": [
            "Eastleigh",
            "Southampton",
            "Winchester",
            "Amesbury",
            "Andover",
            "Gillingham",
            "Lymington"
          ]
        },
        {
          "name": "Ringwood",
          "slug": "ringwood",
          "postcode": "BH24",
          "nearby_areas": [
            "Verwood",
            "Ferndown",
            "Christchurch",
            "New Milton",
            "Wimborne Minster",
            "Bournemouth",
            "Lymington"
          ]
        },
        {
          "name": "Alton",
          "slug": "alton",
          "postcode": "GU34",
          "nearby_areas": [
            "Petworth",
            "Haslemere",
            "Sandhurst",
            "Farnham",
            "Aldershot",
            "Petersfield",
            "Midhurst"
          ]
        },
        {
          "name": "New Milton",
          "slug": "new-milton",
          "postcode": "BH25",
          "nearby_areas": [
            "Lymington",
            "Ringwood",
            "Christchurch",
            "Bournemouth",
            "Ferndown",
            "Wimborne Minster",
            "Southampton"
          ]
        },
        {
          "name": "Emsworth",
          "slug": "emsworth",
          "postcode": "PO10",
          "nearby_areas": [
            "Havant",
            "Selsey",
            "Waterlooville",
            "Portsmouth",
            "Chichester",
            "Gosport",
            "Petersfield"
          ]
        }
      ]
    },
    {
      "name": "Herefordshire",
      "slug": "herefordshire",
      "region": "West Midlands",
      "council_name": "Herefordshire Council",
      "council_url": "https://www.herefordshire.gov.uk/",
      "climate": "rural damp winters and cool valleys",
      "population": "190,000",
      "towns": [
        {
          "name": "Hereford",
          "slug": "hereford",
          "postcode": "HR1",
          "nearby_areas": [
            "Hay-on-Wye",
            "Weobley",
            "Kington",
            "Bromyard",
            "Pembridge",
            "Ross-on-Wye",
            "Leominster"
          ]
        },
        {
          "name": "Leominster",
          "slug": "leominster",
          "postcode": "HR6",
          "nearby_areas": [
            "Pembridge",
            "Kington",
            "Weobley",
            "Ludlow",
            "Hay-on-Wye",
            "Hereford",
            "Bromyard"
          ]
        },
        {
          "name": "Ross-on-Wye",
          "slug": "ross-on-wye",
          "postcode": "HR9",
          "nearby_areas": [
            "Cinderford",
            "Ledbury",
            "Monmouth",
            "Bromyard",
            "Hereford",
            "Hay-on-Wye",
            "Weobley"
          ]
        },
        {
          "name": "Ledbury",
          "slug": "ledbury",
          "postcode": "HR8",
          "nearby_areas": [
            "Bromyard",
            "Weobley",
            "Hay-on-Wye",
            "Kington",
            "Ross-on-Wye",
            "Pembridge",
            "Hereford"
          ]
        },
        {
          "name": "Bromyard",
          "slug": "bromyard",
          "postcode": "HR7",
          "nearby_areas": [
            "Weobley",
            "Hay-on-Wye",
            "Kington",
            "Pembridge",
            "Hereford",
            "Ledbury",
            "Ross-on-Wye"
          ]
        },
        {
          "name": "Kington",
          "slug": "kington",
          "postcode": "HR5",
          "nearby_areas": [
            "Weobley",
            "Hay-on-Wye",
            "Pembridge",
            "Bromyard",
            "Hereford",
            "Leominster",
            "Ledbury"
          ]
        },
        {
          "name": "Hay-on-Wye",
          "slug": "hay-on-wye",
          "postcode": "HR3",
          "nearby_areas": [
            "Weobley",
            "Kington",
            "Bromyard",
            "Hereford",
            "Pembridge",
            "Ledbury",
            "Leominster"
          ]
        },
        {
          "name": "Pembridge",
          "slug": "pembridge",
          "postcode": "HR6",
          "nearby_areas": [
            "Kington",
            "Weobley",
            "Hay-on-Wye",
            "Bromyard",
            "Hereford",
            "Leominster",
            "Ledbury"
          ]
        },
        {
          "name": "Weobley",
          "slug": "weobley",
          "postcode": "HR4",
          "nearby_areas": [
            "Hay-on-Wye",
            "Kington",
            "Bromyard",
            "Pembridge",
            "Hereford",
            "Ledbury",
            "Leominster"
          ]
        },
        {
          "name": "Colwall",
          "slug": "colwall",
          "postcode": "WR13",
          "nearby_areas": [
            "Malvern",
            "Broadway",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        }
      ]
    },
    {
      "name": "Hertfordshire",
      "slug": "hertfordshire",
      "region": "East of England",
      "council_name": "Hertfordshire County Council",
      "council_url": "https://www.hertfordshire.gov.uk/",
      "climate": "mild, fairly dry with winter damp",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Watford",
          "slug": "watford",
          "postcode": "WD17",
          "nearby_areas": [
            "Borehamwood",
            "Rickmansworth",
            "St Albans",
            "Hemel Hempstead",
            "Cheshunt",
            "Hatfield",
            "Gerrards Cross"
          ]
        },
        {
          "name": "St Albans",
          "slug": "st-albans",
          "postcode": "AL1",
          "nearby_areas": [
            "Cheshunt",
            "Harpenden",
            "Hatfield",
            "Hemel Hempstead",
            "Welwyn Garden City",
            "Borehamwood",
            "Watford"
          ]
        },
        {
          "name": "Hemel Hempstead",
          "slug": "hemel-hempstead",
          "postcode": "HP1",
          "nearby_areas": [
            "Berkhamsted",
            "St Albans",
            "Harpenden",
            "Cheshunt",
            "Rickmansworth",
            "Chesham",
            "Watford"
          ]
        },
        {
          "name": "Stevenage",
          "slug": "stevenage",
          "postcode": "SG1",
          "nearby_areas": [
            "Letchworth Garden City",
            "Hitchin",
            "Royston",
            "Stotfold",
            "Welwyn Garden City",
            "Harpenden",
            "Hertford"
          ]
        },
        {
          "name": "Hertford",
          "slug": "hertford",
          "postcode": "SG14",
          "nearby_areas": [
            "Welwyn Garden City",
            "Hatfield",
            "Harlow",
            "Stevenage",
            "Cheshunt",
            "St Albans",
            "Epping"
          ]
        },
        {
          "name": "Hatfield",
          "slug": "hatfield",
          "postcode": "AL10",
          "nearby_areas": [
            "Welwyn Garden City",
            "Cheshunt",
            "St Albans",
            "Hertford",
            "Harpenden",
            "Borehamwood",
            "Stevenage"
          ]
        },
        {
          "name": "Welwyn Garden City",
          "slug": "welwyn-garden-city",
          "postcode": "AL8",
          "nearby_areas": [
            "Hatfield",
            "Cheshunt",
            "Hertford",
            "Harpenden",
            "St Albans",
            "Stevenage",
            "Hitchin"
          ]
        },
        {
          "name": "Bishop's Stortford",
          "slug": "bishop-s-stortford",
          "postcode": "CM23",
          "nearby_areas": [
            "Chelmsford",
            "Brentwood",
            "Billericay",
            "Epping",
            "Harlow",
            "Loughton",
            "Wickford"
          ]
        },
        {
          "name": "Hitchin",
          "slug": "hitchin",
          "postcode": "SG5",
          "nearby_areas": [
            "Stotfold",
            "Letchworth Garden City",
            "Royston",
            "Stevenage",
            "Arlesey",
            "Shefford",
            "Luton"
          ]
        },
        {
          "name": "Letchworth Garden City",
          "slug": "letchworth-garden-city",
          "postcode": "SG6",
          "nearby_areas": [
            "Stotfold",
            "Royston",
            "Hitchin",
            "Stevenage",
            "Arlesey",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Borehamwood",
          "slug": "borehamwood",
          "postcode": "WD6",
          "nearby_areas": [
            "Watford",
            "St Albans",
            "Hatfield",
            "Rickmansworth",
            "Cheshunt",
            "Welwyn Garden City",
            "Hemel Hempstead"
          ]
        },
        {
          "name": "Cheshunt",
          "slug": "cheshunt",
          "postcode": "EN8",
          "nearby_areas": [
            "St Albans",
            "Harpenden",
            "Hatfield",
            "Welwyn Garden City",
            "Hemel Hempstead",
            "Borehamwood",
            "Luton"
          ]
        },
        {
          "name": "Harpenden",
          "slug": "harpenden",
          "postcode": "AL5",
          "nearby_areas": [
            "Cheshunt",
            "St Albans",
            "Luton",
            "Welwyn Garden City",
            "Hatfield",
            "Hemel Hempstead",
            "Stevenage"
          ]
        },
        {
          "name": "Royston",
          "slug": "royston",
          "postcode": "SG8",
          "nearby_areas": [
            "Letchworth Garden City",
            "Stotfold",
            "Hitchin",
            "Arlesey",
            "Stevenage",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Rickmansworth",
          "slug": "rickmansworth",
          "postcode": "WD3",
          "nearby_areas": [
            "Watford",
            "Gerrards Cross",
            "Amersham",
            "Hemel Hempstead",
            "Borehamwood",
            "Chesham",
            "Berkhamsted"
          ]
        },
        {
          "name": "Berkhamsted",
          "slug": "berkhamsted",
          "postcode": "HP4",
          "nearby_areas": [
            "Hemel Hempstead",
            "Chesham",
            "Amersham",
            "Wendover",
            "Rickmansworth",
            "Harpenden",
            "St Albans"
          ]
        }
      ]
    },
    {
      "name": "Highland",
      "slug": "highland",
      "region": "Scotland",
      "council_name": "Highland Council",
      "council_url": "https://www.highland.gov.uk/",
      "climate": "cool, wet, mountainous and exposed",
      "population": "240,000",
      "towns": [
        {
          "name": "Inverness",
          "slug": "inverness",
          "postcode": "IV1",
          "nearby_areas": [
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Alness",
            "Fochabers",
            "Dingwall"
          ]
        },
        {
          "name": "Fort William",
          "slug": "fort-william",
          "postcode": "PH33",
          "nearby_areas": [
            "Oban",
            "Lochgilphead",
            "Aviemore",
            "Campbeltown",
            "Dingwall",
            "Dunoon",
            "Pitlochry"
          ]
        },
        {
          "name": "Nairn",
          "slug": "nairn",
          "postcode": "IV12",
          "nearby_areas": [
            "Inverness",
            "Portree",
            "Ullapool",
            "Forres",
            "Alness",
            "Fochabers",
            "Dingwall"
          ]
        },
        {
          "name": "Thurso",
          "slug": "thurso",
          "postcode": "KW14",
          "nearby_areas": [
            "Wick",
            "Dounby",
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Ullapool",
            "Portree"
          ]
        },
        {
          "name": "Wick",
          "slug": "wick",
          "postcode": "KW1",
          "nearby_areas": [
            "Thurso",
            "Dounby",
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Lossiemouth",
            "Ullapool"
          ]
        },
        {
          "name": "Aviemore",
          "slug": "aviemore",
          "postcode": "PH22",
          "nearby_areas": [
            "Pitlochry",
            "Aberfeldy",
            "Crieff",
            "Auchterarder",
            "Benbecula",
            "Brae",
            "Castlebay"
          ]
        },
        {
          "name": "Dingwall",
          "slug": "dingwall",
          "postcode": "IV15",
          "nearby_areas": [
            "Alness",
            "Inverness",
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Fochabers"
          ]
        },
        {
          "name": "Alness",
          "slug": "alness",
          "postcode": "IV17",
          "nearby_areas": [
            "Dingwall",
            "Inverness",
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Fochabers"
          ]
        },
        {
          "name": "Ullapool",
          "slug": "ullapool",
          "postcode": "IV26",
          "nearby_areas": [
            "Portree",
            "Forres",
            "Fochabers",
            "Nairn",
            "Inverness",
            "Elgin",
            "Lossiemouth"
          ]
        },
        {
          "name": "Portree",
          "slug": "portree",
          "postcode": "IV51",
          "nearby_areas": [
            "Ullapool",
            "Forres",
            "Nairn",
            "Inverness",
            "Fochabers",
            "Elgin",
            "Lossiemouth"
          ]
        }
      ]
    },
    {
      "name": "Inverclyde",
      "slug": "inverclyde",
      "region": "Scotland",
      "council_name": "Inverclyde Council",
      "council_url": "https://www.inverclyde.gov.uk/",
      "climate": "wet west coast climate",
      "population": "78,000",
      "towns": [
        {
          "name": "Greenock",
          "slug": "greenock",
          "postcode": "PA15",
          "nearby_areas": [
            "Inverkip",
            "Port Glasgow",
            "Kilmacolm",
            "Gourock",
            "Helensburgh",
            "Rothesay",
            "Alexandria"
          ]
        },
        {
          "name": "Port Glasgow",
          "slug": "port-glasgow",
          "postcode": "PA14",
          "nearby_areas": [
            "Inverkip",
            "Kilmacolm",
            "Greenock",
            "Alexandria",
            "Balloch",
            "Gourock",
            "Barrhead"
          ]
        },
        {
          "name": "Gourock",
          "slug": "gourock",
          "postcode": "PA19",
          "nearby_areas": [
            "Helensburgh",
            "Rothesay",
            "Inverkip",
            "Port Glasgow",
            "Greenock",
            "Kilmacolm",
            "Alexandria"
          ]
        },
        {
          "name": "Kilmacolm",
          "slug": "kilmacolm",
          "postcode": "PA13",
          "nearby_areas": [
            "Port Glasgow",
            "Alexandria",
            "Balloch",
            "Inverkip",
            "Barrhead",
            "Newton Mearns",
            "Clarkston"
          ]
        },
        {
          "name": "Inverkip",
          "slug": "inverkip",
          "postcode": "PA16",
          "nearby_areas": [
            "Port Glasgow",
            "Greenock",
            "Kilmacolm",
            "Gourock",
            "Helensburgh",
            "Alexandria",
            "Balloch"
          ]
        }
      ]
    },
    {
      "name": "Isle of Wight",
      "slug": "isle-of-wight",
      "region": "South East England",
      "council_name": "Isle of Wight Council",
      "council_url": "https://www.iow.gov.uk/",
      "climate": "mild maritime climate and coastal winds",
      "population": "140,000",
      "towns": [
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "PO30",
          "nearby_areas": [
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport",
            "East Cowes",
            "Cowes"
          ]
        },
        {
          "name": "Ryde",
          "slug": "ryde",
          "postcode": "PO33",
          "nearby_areas": [
            "Newport",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Sandown",
            "Gosport",
            "East Cowes"
          ]
        },
        {
          "name": "Cowes",
          "slug": "cowes",
          "postcode": "PO31",
          "nearby_areas": [
            "East Cowes",
            "Newport",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport"
          ]
        },
        {
          "name": "East Cowes",
          "slug": "east-cowes",
          "postcode": "PO32",
          "nearby_areas": [
            "Cowes",
            "Newport",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport"
          ]
        },
        {
          "name": "Sandown",
          "slug": "sandown",
          "postcode": "PO36",
          "nearby_areas": [
            "Shanklin",
            "Freshwater",
            "Yarmouth",
            "Bembridge",
            "Ventnor",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Shanklin",
          "slug": "shanklin",
          "postcode": "PO37",
          "nearby_areas": [
            "Sandown",
            "Ventnor",
            "Freshwater",
            "Yarmouth",
            "Bembridge",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Ventnor",
          "slug": "ventnor",
          "postcode": "PO38",
          "nearby_areas": [
            "Shanklin",
            "Sandown",
            "Freshwater",
            "Bembridge",
            "Yarmouth",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Freshwater",
          "slug": "freshwater",
          "postcode": "PO40",
          "nearby_areas": [
            "Yarmouth",
            "Bembridge",
            "Ryde",
            "Sandown",
            "Newport",
            "Shanklin",
            "Ventnor"
          ]
        },
        {
          "name": "Yarmouth",
          "slug": "yarmouth",
          "postcode": "PO41",
          "nearby_areas": [
            "Freshwater",
            "Bembridge",
            "Ryde",
            "Newport",
            "Sandown",
            "Shanklin",
            "Gosport"
          ]
        },
        {
          "name": "Bembridge",
          "slug": "bembridge",
          "postcode": "PO35",
          "nearby_areas": [
            "Yarmouth",
            "Freshwater",
            "Ryde",
            "Newport",
            "Sandown",
            "Shanklin",
            "East Cowes"
          ]
        }
      ]
    },
    {
      "name": "Kent",
      "slug": "kent",
      "region": "South East England",
      "council_name": "Kent County Council",
      "council_url": "https://www.kent.gov.uk/",
      "climate": "coastal damp and sea winds",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Maidstone",
          "slug": "maidstone",
          "postcode": "ME14",
          "nearby_areas": [
            "Gillingham",
            "Chatham",
            "Rochester",
            "Sittingbourne",
            "Tonbridge",
            "Gravesend",
            "Sevenoaks"
          ]
        },
        {
          "name": "Canterbury",
          "slug": "canterbury",
          "postcode": "CT1",
          "nearby_areas": [
            "Whitstable",
            "Herne Bay",
            "Faversham",
            "Deal",
            "Folkestone",
            "Dover",
            "Margate"
          ]
        },
        {
          "name": "Tunbridge Wells",
          "slug": "tunbridge-wells",
          "postcode": "TN1",
          "nearby_areas": [
            "Crowborough",
            "Heathfield",
            "Ashford",
            "Tonbridge",
            "Uckfield",
            "East Grinstead",
            "Sevenoaks"
          ]
        },
        {
          "name": "Ashford",
          "slug": "ashford",
          "postcode": "TN23",
          "nearby_areas": [
            "Heathfield",
            "Crowborough",
            "Tunbridge Wells",
            "Uckfield",
            "Hailsham",
            "Rye",
            "Tonbridge"
          ]
        },
        {
          "name": "Dartford",
          "slug": "dartford",
          "postcode": "DA1",
          "nearby_areas": [
            "Bexleyheath",
            "Grays",
            "Romford",
            "Gravesend",
            "Sevenoaks",
            "Rochester",
            "Chatham"
          ]
        },
        {
          "name": "Gravesend",
          "slug": "gravesend",
          "postcode": "DA11",
          "nearby_areas": [
            "Grays",
            "Romford",
            "Bexleyheath",
            "Dartford",
            "Rochester",
            "Chatham",
            "Basildon"
          ]
        },
        {
          "name": "Gillingham",
          "slug": "gillingham",
          "postcode": "ME7",
          "nearby_areas": [
            "Sittingbourne",
            "Chatham",
            "Rochester",
            "Maidstone",
            "Faversham",
            "Gravesend",
            "Canvey Island"
          ]
        },
        {
          "name": "Chatham",
          "slug": "chatham",
          "postcode": "ME4",
          "nearby_areas": [
            "Rochester",
            "Gillingham",
            "Maidstone",
            "Gravesend",
            "Sittingbourne",
            "Canvey Island",
            "Bexleyheath"
          ]
        },
        {
          "name": "Rochester",
          "slug": "rochester",
          "postcode": "ME1",
          "nearby_areas": [
            "Chatham",
            "Gillingham",
            "Gravesend",
            "Maidstone",
            "Sittingbourne",
            "Canvey Island",
            "Bexleyheath"
          ]
        },
        {
          "name": "Folkestone",
          "slug": "folkestone",
          "postcode": "CT20",
          "nearby_areas": [
            "Dover",
            "Deal",
            "Canterbury",
            "Faversham",
            "Herne Bay",
            "Whitstable",
            "Ramsgate"
          ]
        },
        {
          "name": "Dover",
          "slug": "dover",
          "postcode": "CT16",
          "nearby_areas": [
            "Folkestone",
            "Deal",
            "Canterbury",
            "Ramsgate",
            "Margate",
            "Herne Bay",
            "Whitstable"
          ]
        },
        {
          "name": "Margate",
          "slug": "margate",
          "postcode": "CT9",
          "nearby_areas": [
            "Ramsgate",
            "Deal",
            "Herne Bay",
            "Canterbury",
            "Whitstable",
            "Dover",
            "Faversham"
          ]
        },
        {
          "name": "Ramsgate",
          "slug": "ramsgate",
          "postcode": "CT11",
          "nearby_areas": [
            "Margate",
            "Deal",
            "Herne Bay",
            "Dover",
            "Canterbury",
            "Whitstable",
            "Folkestone"
          ]
        },
        {
          "name": "Sevenoaks",
          "slug": "sevenoaks",
          "postcode": "TN13",
          "nearby_areas": [
            "Tonbridge",
            "Dartford",
            "Tunbridge Wells",
            "Caterham",
            "Gravesend",
            "Maidstone",
            "Croydon"
          ]
        },
        {
          "name": "Tonbridge",
          "slug": "tonbridge",
          "postcode": "TN9",
          "nearby_areas": [
            "Sevenoaks",
            "Tunbridge Wells",
            "Crowborough",
            "Maidstone",
            "Ashford",
            "Heathfield",
            "East Grinstead"
          ]
        },
        {
          "name": "Sittingbourne",
          "slug": "sittingbourne",
          "postcode": "ME10",
          "nearby_areas": [
            "Gillingham",
            "Faversham",
            "Chatham",
            "Maidstone",
            "Rochester",
            "Whitstable",
            "Canterbury"
          ]
        },
        {
          "name": "Faversham",
          "slug": "faversham",
          "postcode": "ME13",
          "nearby_areas": [
            "Whitstable",
            "Sittingbourne",
            "Canterbury",
            "Herne Bay",
            "Gillingham",
            "Maidstone",
            "Chatham"
          ]
        },
        {
          "name": "Deal",
          "slug": "deal",
          "postcode": "CT14",
          "nearby_areas": [
            "Dover",
            "Ramsgate",
            "Margate",
            "Folkestone",
            "Canterbury",
            "Herne Bay",
            "Whitstable"
          ]
        },
        {
          "name": "Whitstable",
          "slug": "whitstable",
          "postcode": "CT5",
          "nearby_areas": [
            "Herne Bay",
            "Canterbury",
            "Faversham",
            "Sittingbourne",
            "Margate",
            "Gillingham",
            "Ramsgate"
          ]
        },
        {
          "name": "Herne Bay",
          "slug": "herne-bay",
          "postcode": "CT6",
          "nearby_areas": [
            "Whitstable",
            "Canterbury",
            "Faversham",
            "Margate",
            "Ramsgate",
            "Deal",
            "Sittingbourne"
          ]
        }
      ]
    },
    {
      "name": "Lancashire",
      "slug": "lancashire",
      "region": "North West England",
      "council_name": "Lancashire County Council",
      "council_url": "https://www.lancashire.gov.uk/",
      "climate": "persistent rain and high annual rainfall",
      "population": "1.5 million",
      "towns": [
        {
          "name": "Preston",
          "slug": "preston",
          "postcode": "PR1",
          "nearby_areas": [
            "Garstang",
            "Leyland",
            "Chorley",
            "Ormskirk",
            "Skelmersdale",
            "Leigh",
            "Southport"
          ]
        },
        {
          "name": "Blackpool",
          "slug": "blackpool",
          "postcode": "FY1",
          "nearby_areas": [
            "Lytham St Annes",
            "Fleetwood",
            "Southport",
            "Preston",
            "Garstang",
            "Leyland",
            "Ormskirk"
          ]
        },
        {
          "name": "Blackburn",
          "slug": "blackburn",
          "postcode": "BB1",
          "nearby_areas": [
            "Rawtenstall",
            "Accrington",
            "Nelson",
            "Burnley",
            "Darwen",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Burnley",
          "slug": "burnley",
          "postcode": "BB11",
          "nearby_areas": [
            "Nelson",
            "Rawtenstall",
            "Blackburn",
            "Colne",
            "Accrington",
            "Bacup",
            "Clitheroe"
          ]
        },
        {
          "name": "Lancaster",
          "slug": "lancaster",
          "postcode": "LA1",
          "nearby_areas": [
            "Morecambe",
            "Fleetwood",
            "Lytham St Annes",
            "Grange-over-Sands",
            "Windermere",
            "Ambleside",
            "Ulverston"
          ]
        },
        {
          "name": "Accrington",
          "slug": "accrington",
          "postcode": "BB5",
          "nearby_areas": [
            "Blackburn",
            "Rawtenstall",
            "Darwen",
            "Nelson",
            "Burnley",
            "Bacup",
            "Clitheroe"
          ]
        },
        {
          "name": "Chorley",
          "slug": "chorley",
          "postcode": "PR7",
          "nearby_areas": [
            "Leyland",
            "Garstang",
            "Preston",
            "Darwen",
            "Wigan",
            "Skelmersdale",
            "Leigh"
          ]
        },
        {
          "name": "Nelson",
          "slug": "nelson",
          "postcode": "BB9",
          "nearby_areas": [
            "Burnley",
            "Rawtenstall",
            "Blackburn",
            "Accrington",
            "Colne",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Morecambe",
          "slug": "morecambe",
          "postcode": "LA4",
          "nearby_areas": [
            "Lancaster",
            "Grange-over-Sands",
            "Fleetwood",
            "Windermere",
            "Ambleside",
            "Lytham St Annes",
            "Ulverston"
          ]
        },
        {
          "name": "Clitheroe",
          "slug": "clitheroe",
          "postcode": "BB7",
          "nearby_areas": [
            "Nelson",
            "Rawtenstall",
            "Blackburn",
            "Accrington",
            "Burnley",
            "Colne",
            "Darwen"
          ]
        },
        {
          "name": "Fleetwood",
          "slug": "fleetwood",
          "postcode": "FY7",
          "nearby_areas": [
            "Lytham St Annes",
            "Blackpool",
            "Morecambe",
            "Lancaster",
            "Barrow-in-Furness",
            "Windermere",
            "Ambleside"
          ]
        },
        {
          "name": "Leyland",
          "slug": "leyland",
          "postcode": "PR25",
          "nearby_areas": [
            "Chorley",
            "Garstang",
            "Preston",
            "Darwen",
            "Skelmersdale",
            "Leigh",
            "Ormskirk"
          ]
        },
        {
          "name": "Skelmersdale",
          "slug": "skelmersdale",
          "postcode": "WN8",
          "nearby_areas": [
            "Leigh",
            "Ormskirk",
            "Formby",
            "Huyton",
            "Wigan",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "Ormskirk",
          "slug": "ormskirk",
          "postcode": "L39",
          "nearby_areas": [
            "Skelmersdale",
            "Formby",
            "Huyton",
            "Leigh",
            "Garstang",
            "Preston",
            "Crosby"
          ]
        },
        {
          "name": "Colne",
          "slug": "colne",
          "postcode": "BB8",
          "nearby_areas": [
            "Burnley",
            "Nelson",
            "Clitheroe",
            "Rawtenstall",
            "Blackburn",
            "Bacup",
            "Accrington"
          ]
        },
        {
          "name": "Rawtenstall",
          "slug": "rawtenstall",
          "postcode": "BB4",
          "nearby_areas": [
            "Blackburn",
            "Accrington",
            "Nelson",
            "Burnley",
            "Darwen",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Lytham St Annes",
          "slug": "lytham-st-annes",
          "postcode": "FY8",
          "nearby_areas": [
            "Fleetwood",
            "Blackpool",
            "Morecambe",
            "Lancaster",
            "Barrow-in-Furness",
            "Leyland",
            "Preston"
          ]
        },
        {
          "name": "Garstang",
          "slug": "garstang",
          "postcode": "PR3",
          "nearby_areas": [
            "Preston",
            "Leyland",
            "Chorley",
            "Ormskirk",
            "Skelmersdale",
            "Leigh",
            "Southport"
          ]
        },
        {
          "name": "Darwen",
          "slug": "darwen",
          "postcode": "BB3",
          "nearby_areas": [
            "Accrington",
            "Blackburn",
            "Rawtenstall",
            "Chorley",
            "Leyland",
            "Bacup",
            "Nelson"
          ]
        },
        {
          "name": "Bacup",
          "slug": "bacup",
          "postcode": "OL13",
          "nearby_areas": [
            "Todmorden",
            "Burnley",
            "Rochdale",
            "Accrington",
            "Blackburn",
            "Rawtenstall",
            "Nelson"
          ]
        }
      ]
    },
    {
      "name": "Leicestershire",
      "slug": "leicestershire",
      "region": "East Midlands",
      "council_name": "Leicestershire County Council",
      "council_url": "https://www.leicestershire.gov.uk/",
      "climate": "cool winters with moderate rainfall",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Leicester",
          "slug": "leicester",
          "postcode": "LE1",
          "nearby_areas": [
            "Blaby",
            "Broughton Astley",
            "Earl Shilton",
            "Syston",
            "Oadby",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Loughborough",
          "slug": "loughborough",
          "postcode": "LE11",
          "nearby_areas": [
            "Coalville",
            "Shepshed",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Blaby",
            "Oadby"
          ]
        },
        {
          "name": "Hinckley",
          "slug": "hinckley",
          "postcode": "LE10",
          "nearby_areas": [
            "Nuneaton",
            "Bedworth",
            "Atherstone",
            "Lutterworth",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester"
          ]
        },
        {
          "name": "Coalville",
          "slug": "coalville",
          "postcode": "LE67",
          "nearby_areas": [
            "Ashby-de-la-Zouch",
            "Loughborough",
            "Swadlincote",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester",
            "Blaby"
          ]
        },
        {
          "name": "Melton Mowbray",
          "slug": "melton-mowbray",
          "postcode": "LE13",
          "nearby_areas": [
            "Oakham",
            "Shepshed",
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham"
          ]
        },
        {
          "name": "Market Harborough",
          "slug": "market-harborough",
          "postcode": "LE16",
          "nearby_areas": [
            "Wigston",
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham"
          ]
        },
        {
          "name": "Wigston",
          "slug": "wigston",
          "postcode": "LE18",
          "nearby_areas": [
            "Syston",
            "Oadby",
            "Blaby",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester",
            "Shepshed"
          ]
        },
        {
          "name": "Oadby",
          "slug": "oadby",
          "postcode": "LE2",
          "nearby_areas": [
            "Syston",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Ashby-de-la-Zouch",
          "slug": "ashby-de-la-zouch",
          "postcode": "LE65",
          "nearby_areas": [
            "Swadlincote",
            "Coalville",
            "Loughborough",
            "Derby",
            "Hinckley",
            "Tamworth",
            "Atherstone"
          ]
        },
        {
          "name": "Lutterworth",
          "slug": "lutterworth",
          "postcode": "LE17",
          "nearby_areas": [
            "Rugby",
            "Hinckley",
            "Wigston",
            "Market Harborough",
            "Broughton Astley",
            "Earl Shilton",
            "Blaby"
          ]
        },
        {
          "name": "Blaby",
          "slug": "blaby",
          "postcode": "LE8",
          "nearby_areas": [
            "Syston",
            "Oadby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Syston",
          "slug": "syston",
          "postcode": "LE7",
          "nearby_areas": [
            "Oadby",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Earl Shilton",
          "slug": "earl-shilton",
          "postcode": "LE9",
          "nearby_areas": [
            "Broughton Astley",
            "Leicester",
            "Blaby",
            "Syston",
            "Oadby",
            "Wigston",
            "Shepshed"
          ]
        },
        {
          "name": "Shepshed",
          "slug": "shepshed",
          "postcode": "LE12",
          "nearby_areas": [
            "Oadby",
            "Syston",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Wigston"
          ]
        },
        {
          "name": "Broughton Astley",
          "slug": "broughton-astley",
          "postcode": "LE9",
          "nearby_areas": [
            "Earl Shilton",
            "Leicester",
            "Blaby",
            "Syston",
            "Oadby",
            "Wigston",
            "Shepshed"
          ]
        }
      ]
    },
    {
      "name": "Lincolnshire",
      "slug": "lincolnshire",
      "region": "East Midlands",
      "council_name": "Lincolnshire County Council",
      "council_url": "https://www.lincolnshire.gov.uk/",
      "climate": "dry eastern climate with cold winds",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Lincoln",
          "slug": "lincoln",
          "postcode": "LN1",
          "nearby_areas": [
            "Gainsborough",
            "Sleaford",
            "Horncastle",
            "Market Rasen",
            "Retford",
            "Southwell",
            "Newark-on-Trent"
          ]
        },
        {
          "name": "Grimsby",
          "slug": "grimsby",
          "postcode": "DN31",
          "nearby_areas": [
            "Cleethorpes",
            "Immingham",
            "Louth",
            "Withernsea",
            "Brigg",
            "Market Rasen",
            "Mablethorpe"
          ]
        },
        {
          "name": "Scunthorpe",
          "slug": "scunthorpe",
          "postcode": "DN15",
          "nearby_areas": [
            "Conisbrough",
            "Thorne",
            "Howden",
            "Snaith",
            "Brigg",
            "Gainsborough",
            "Goole"
          ]
        },
        {
          "name": "Boston",
          "slug": "boston",
          "postcode": "PE21",
          "nearby_areas": [
            "Spalding",
            "Sleaford",
            "Horncastle",
            "Skegness",
            "Market Rasen",
            "Ramsey",
            "Bourne"
          ]
        },
        {
          "name": "Grantham",
          "slug": "grantham",
          "postcode": "NG31",
          "nearby_areas": [
            "Southwell",
            "Sleaford",
            "Newark-on-Trent",
            "Bourne",
            "Melton Mowbray",
            "Ollerton",
            "Beeston"
          ]
        },
        {
          "name": "Spalding",
          "slug": "spalding",
          "postcode": "PE11",
          "nearby_areas": [
            "Bourne",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Whittlesey",
            "Yaxley",
            "Ramsey"
          ]
        },
        {
          "name": "Skegness",
          "slug": "skegness",
          "postcode": "PE25",
          "nearby_areas": [
            "Mablethorpe",
            "Boston",
            "Market Rasen",
            "Horncastle",
            "Louth",
            "Cleethorpes",
            "Spalding"
          ]
        },
        {
          "name": "Louth",
          "slug": "louth",
          "postcode": "LN11",
          "nearby_areas": [
            "Market Rasen",
            "Mablethorpe",
            "Horncastle",
            "Cleethorpes",
            "Grimsby",
            "Immingham",
            "Skegness"
          ]
        },
        {
          "name": "Stamford",
          "slug": "stamford",
          "postcode": "PE9",
          "nearby_areas": [
            "Bourne",
            "Ketton",
            "Ryhall",
            "Oakham",
            "Oundle",
            "Peterborough",
            "Corby"
          ]
        },
        {
          "name": "Sleaford",
          "slug": "sleaford",
          "postcode": "NG34",
          "nearby_areas": [
            "Grantham",
            "Bourne",
            "Boston",
            "Lincoln",
            "Spalding",
            "Southwell",
            "Horncastle"
          ]
        },
        {
          "name": "Gainsborough",
          "slug": "gainsborough",
          "postcode": "DN21",
          "nearby_areas": [
            "Retford",
            "Thorne",
            "Scunthorpe",
            "Conisbrough",
            "Lincoln",
            "Brigg",
            "Worksop"
          ]
        },
        {
          "name": "Bourne",
          "slug": "bourne",
          "postcode": "PE10",
          "nearby_areas": [
            "Stamford",
            "Spalding",
            "Ketton",
            "Ryhall",
            "Oundle",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "Mablethorpe",
          "slug": "mablethorpe",
          "postcode": "LN12",
          "nearby_areas": [
            "Louth",
            "Skegness",
            "Market Rasen",
            "Horncastle",
            "Cleethorpes",
            "Grimsby",
            "Immingham"
          ]
        },
        {
          "name": "Market Rasen",
          "slug": "market-rasen",
          "postcode": "LN8",
          "nearby_areas": [
            "Horncastle",
            "Louth",
            "Mablethorpe",
            "Skegness",
            "Cleethorpes",
            "Lincoln",
            "Grimsby"
          ]
        },
        {
          "name": "Horncastle",
          "slug": "horncastle",
          "postcode": "LN9",
          "nearby_areas": [
            "Market Rasen",
            "Louth",
            "Boston",
            "Lincoln",
            "Mablethorpe",
            "Sleaford",
            "Skegness"
          ]
        },
        {
          "name": "Brigg",
          "slug": "brigg",
          "postcode": "DN20",
          "nearby_areas": [
            "Scunthorpe",
            "Conisbrough",
            "Thorne",
            "Immingham",
            "Howden",
            "Snaith",
            "Hessle"
          ]
        },
        {
          "name": "Immingham",
          "slug": "immingham",
          "postcode": "DN40",
          "nearby_areas": [
            "Grimsby",
            "Cleethorpes",
            "Brigg",
            "Hessle",
            "Hedon",
            "Hull",
            "Withernsea"
          ]
        },
        {
          "name": "Cleethorpes",
          "slug": "cleethorpes",
          "postcode": "DN35",
          "nearby_areas": [
            "Grimsby",
            "Immingham",
            "Louth",
            "Withernsea",
            "Mablethorpe",
            "Brigg",
            "Market Rasen"
          ]
        }
      ]
    },
    {
      "name": "Merseyside",
      "slug": "merseyside",
      "region": "North West England",
      "council_name": "Liverpool City Region Combined Authority (boroughs)",
      "council_url": "https://www.liverpoolcityregion-ca.gov.uk/",
      "climate": "coastal rain and mild winters",
      "population": "1.4 million",
      "towns": [
        {
          "name": "Liverpool",
          "slug": "liverpool",
          "postcode": "L1",
          "nearby_areas": [
            "Birkenhead",
            "Wallasey",
            "Bootle",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Prescot"
          ]
        },
        {
          "name": "Birkenhead",
          "slug": "birkenhead",
          "postcode": "CH41",
          "nearby_areas": [
            "Liverpool",
            "Wallasey",
            "Bootle",
            "Bebington",
            "Crosby",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "St Helens",
          "slug": "st-helens",
          "postcode": "WA10",
          "nearby_areas": [
            "Warrington",
            "Widnes",
            "Runcorn",
            "Newton-le-Willows",
            "Frodsham",
            "Prescot",
            "Northwich"
          ]
        },
        {
          "name": "Southport",
          "slug": "southport",
          "postcode": "PR8",
          "nearby_areas": [
            "Ormskirk",
            "Preston",
            "Garstang",
            "Formby",
            "Huyton",
            "Skelmersdale",
            "Blackpool"
          ]
        },
        {
          "name": "Wallasey",
          "slug": "wallasey",
          "postcode": "CH44",
          "nearby_areas": [
            "Birkenhead",
            "Liverpool",
            "Bootle",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Huyton"
          ]
        },
        {
          "name": "Bootle",
          "slug": "bootle",
          "postcode": "L20",
          "nearby_areas": [
            "Crosby",
            "Maghull",
            "Kirkby",
            "Huyton",
            "Formby",
            "Prescot",
            "Liverpool"
          ]
        },
        {
          "name": "Crosby",
          "slug": "crosby",
          "postcode": "L23",
          "nearby_areas": [
            "Bootle",
            "Maghull",
            "Kirkby",
            "Huyton",
            "Formby",
            "Prescot",
            "Liverpool"
          ]
        },
        {
          "name": "Formby",
          "slug": "formby",
          "postcode": "L37",
          "nearby_areas": [
            "Huyton",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Bootle",
            "Ormskirk",
            "Skelmersdale"
          ]
        },
        {
          "name": "Prescot",
          "slug": "prescot",
          "postcode": "L34",
          "nearby_areas": [
            "Kirkby",
            "Maghull",
            "Crosby",
            "Bootle",
            "Huyton",
            "Formby",
            "Widnes"
          ]
        },
        {
          "name": "Kirkby",
          "slug": "kirkby",
          "postcode": "L32",
          "nearby_areas": [
            "Maghull",
            "Huyton",
            "Crosby",
            "Bootle",
            "Prescot",
            "Formby",
            "Skelmersdale"
          ]
        },
        {
          "name": "Huyton",
          "slug": "huyton",
          "postcode": "L36",
          "nearby_areas": [
            "Maghull",
            "Formby",
            "Kirkby",
            "Crosby",
            "Bootle",
            "Prescot",
            "Skelmersdale"
          ]
        },
        {
          "name": "Maghull",
          "slug": "maghull",
          "postcode": "L31",
          "nearby_areas": [
            "Kirkby",
            "Huyton",
            "Crosby",
            "Bootle",
            "Formby",
            "Prescot",
            "Skelmersdale"
          ]
        },
        {
          "name": "Bebington",
          "slug": "bebington",
          "postcode": "CH63",
          "nearby_areas": [
            "Ellesmere Port",
            "Birkenhead",
            "Chester",
            "Liverpool",
            "Connah's Quay",
            "Shotton",
            "Flint"
          ]
        },
        {
          "name": "Newton-le-Willows",
          "slug": "newton-le-willows",
          "postcode": "WA12",
          "nearby_areas": [
            "Warrington",
            "St Helens",
            "Wigan",
            "Prescot",
            "Widnes",
            "Kirkby",
            "Maghull"
          ]
        }
      ]
    },
    {
      "name": "Merthyr Tydfil",
      "slug": "merthyr-tydfil",
      "region": "Wales",
      "council_name": "Merthyr Tydfil County Borough Council",
      "council_url": "https://www.merthyr.gov.uk/",
      "climate": "cool, wet valleys climate",
      "population": "58,000",
      "towns": [
        {
          "name": "Merthyr Tydfil",
          "slug": "merthyr-tydfil",
          "postcode": "CF47",
          "nearby_areas": [
            "Aberdare",
            "Mountain Ash",
            "Tredegar",
            "Treharris",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw"
          ]
        },
        {
          "name": "Treharris",
          "slug": "treharris",
          "postcode": "CF46",
          "nearby_areas": [
            "Mountain Ash",
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Pontypridd",
            "Blackwood"
          ]
        },
        {
          "name": "Dowlais",
          "slug": "dowlais",
          "postcode": "CF48",
          "nearby_areas": [
            "Aberfan",
            "Troedyrhiw",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        },
        {
          "name": "Aberfan",
          "slug": "aberfan",
          "postcode": "CF48",
          "nearby_areas": [
            "Dowlais",
            "Troedyrhiw",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        },
        {
          "name": "Troedyrhiw",
          "slug": "troedyrhiw",
          "postcode": "CF48",
          "nearby_areas": [
            "Aberfan",
            "Dowlais",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        }
      ]
    },
    {
      "name": "Midlothian",
      "slug": "midlothian",
      "region": "Scotland",
      "council_name": "Midlothian Council",
      "council_url": "https://www.midlothian.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Dalkeith",
          "slug": "dalkeith",
          "postcode": "EH22",
          "nearby_areas": [
            "Musselburgh",
            "Gorebridge",
            "Loanhead",
            "Bonnyrigg",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Bonnyrigg",
          "slug": "bonnyrigg",
          "postcode": "EH19",
          "nearby_areas": [
            "Loanhead",
            "Musselburgh",
            "Portobello",
            "Dalkeith",
            "Gorebridge",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Penicuik",
          "slug": "penicuik",
          "postcode": "EH26",
          "nearby_areas": [
            "Whitburn",
            "Gorebridge",
            "Dalkeith",
            "Loanhead",
            "Bonnyrigg",
            "Musselburgh",
            "Portobello"
          ]
        },
        {
          "name": "Loanhead",
          "slug": "loanhead",
          "postcode": "EH20",
          "nearby_areas": [
            "Bonnyrigg",
            "Musselburgh",
            "Dalkeith",
            "Portobello",
            "Gorebridge",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Gorebridge",
          "slug": "gorebridge",
          "postcode": "EH23",
          "nearby_areas": [
            "Dalkeith",
            "Musselburgh",
            "Loanhead",
            "Bonnyrigg",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        }
      ]
    },
    {
      "name": "Monmouthshire",
      "slug": "monmouthshire",
      "region": "Wales",
      "council_name": "Monmouthshire County Council",
      "council_url": "https://www.monmouthshire.gov.uk/",
      "climate": "mild, damp rural climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Abergavenny",
          "slug": "abergavenny",
          "postcode": "NP7",
          "nearby_areas": [
            "Brynmawr",
            "Nantyglo",
            "Blaenavon",
            "New Inn",
            "Abersychan",
            "Abertillery",
            "Pontypool"
          ]
        },
        {
          "name": "Chepstow",
          "slug": "chepstow",
          "postcode": "NP16",
          "nearby_areas": [
            "Caldicot",
            "Lydney",
            "Monmouth",
            "Bristol",
            "Bedminster",
            "Knowle",
            "Dursley"
          ]
        },
        {
          "name": "Monmouth",
          "slug": "monmouth",
          "postcode": "NP25",
          "nearby_areas": [
            "Ross-on-Wye",
            "Cinderford",
            "Chepstow",
            "Lydney",
            "Abergavenny",
            "Caldicot",
            "Abersychan"
          ]
        },
        {
          "name": "Caldicot",
          "slug": "caldicot",
          "postcode": "NP26",
          "nearby_areas": [
            "Chepstow",
            "Knowle",
            "Bedminster",
            "St George",
            "Redland",
            "Bishopston",
            "Horfield"
          ]
        },
        {
          "name": "Usk",
          "slug": "usk",
          "postcode": "NP15",
          "nearby_areas": [
            "Raglan",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Blaina",
            "Malpas",
            "Newport"
          ]
        },
        {
          "name": "Raglan",
          "slug": "raglan",
          "postcode": "NP15",
          "nearby_areas": [
            "Usk",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Blaina",
            "Malpas",
            "Newport"
          ]
        }
      ]
    },
    {
      "name": "Moray",
      "slug": "moray",
      "region": "Scotland",
      "council_name": "Moray Council",
      "council_url": "https://www.moray.gov.uk/",
      "climate": "cool north-east climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Elgin",
          "slug": "elgin",
          "postcode": "IV30",
          "nearby_areas": [
            "Lossiemouth",
            "Fochabers",
            "Forres",
            "Ullapool",
            "Buckie",
            "Portree",
            "Nairn"
          ]
        },
        {
          "name": "Forres",
          "slug": "forres",
          "postcode": "IV36",
          "nearby_areas": [
            "Ullapool",
            "Portree",
            "Fochabers",
            "Nairn",
            "Elgin",
            "Inverness",
            "Lossiemouth"
          ]
        },
        {
          "name": "Buckie",
          "slug": "buckie",
          "postcode": "AB56",
          "nearby_areas": [
            "Lossiemouth",
            "Elgin",
            "Keith",
            "Fochabers",
            "Forres",
            "Huntly",
            "Ullapool"
          ]
        },
        {
          "name": "Lossiemouth",
          "slug": "lossiemouth",
          "postcode": "IV31",
          "nearby_areas": [
            "Elgin",
            "Fochabers",
            "Buckie",
            "Forres",
            "Ullapool",
            "Portree",
            "Nairn"
          ]
        },
        {
          "name": "Keith",
          "slug": "keith",
          "postcode": "AB55",
          "nearby_areas": [
            "Huntly",
            "Turriff",
            "Inverurie",
            "Buckie",
            "Banff",
            "Aberdeen",
            "Cove Bay"
          ]
        },
        {
          "name": "Fochabers",
          "slug": "fochabers",
          "postcode": "IV32",
          "nearby_areas": [
            "Elgin",
            "Forres",
            "Ullapool",
            "Lossiemouth",
            "Portree",
            "Nairn",
            "Inverness"
          ]
        }
      ]
    },
    {
      "name": "Na h-Eileanan Siar",
      "slug": "na-h-eileanan-siar",
      "region": "Scotland",
      "council_name": "Comhairle nan Eilean Siar",
      "council_url": "https://www.cne-siar.gov.uk/",
      "climate": "very windy Atlantic island climate",
      "population": "27,000",
      "towns": [
        {
          "name": "Stornoway",
          "slug": "stornoway",
          "postcode": "HS1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Tarbert",
          "slug": "tarbert",
          "postcode": "HS3",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Benbecula",
          "slug": "benbecula",
          "postcode": "HS7",
          "nearby_areas": [
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Lochboisdale",
          "slug": "lochboisdale",
          "postcode": "HS8",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Castlebay",
          "slug": "castlebay",
          "postcode": "HS9",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        }
      ]
    },
    {
      "name": "Neath Port Talbot",
      "slug": "neath-port-talbot",
      "region": "Wales",
      "council_name": "Neath Port Talbot Council",
      "council_url": "https://www.npt.gov.uk/",
      "climate": "wet coastal and valleys climate",
      "population": "140,000",
      "towns": [
        {
          "name": "Neath",
          "slug": "neath",
          "postcode": "SA11",
          "nearby_areas": [
            "Briton Ferry",
            "Glynneath",
            "Port Talbot",
            "Swansea",
            "Cymmer",
            "Maesteg",
            "Pontardawe"
          ]
        },
        {
          "name": "Port Talbot",
          "slug": "port-talbot",
          "postcode": "SA12",
          "nearby_areas": [
            "Neath",
            "Maesteg",
            "Briton Ferry",
            "Glynneath",
            "Swansea",
            "Cymmer",
            "Porthcawl"
          ]
        },
        {
          "name": "Pontardawe",
          "slug": "pontardawe",
          "postcode": "SA8",
          "nearby_areas": [
            "Ystradgynlais",
            "Cymmer",
            "Clydach",
            "Morriston",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Glynneath",
          "slug": "glynneath",
          "postcode": "SA11",
          "nearby_areas": [
            "Briton Ferry",
            "Swansea",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Neath",
            "Clydach"
          ]
        },
        {
          "name": "Briton Ferry",
          "slug": "briton-ferry",
          "postcode": "SA11",
          "nearby_areas": [
            "Glynneath",
            "Swansea",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Neath",
            "Clydach"
          ]
        },
        {
          "name": "Cymmer",
          "slug": "cymmer",
          "postcode": "SA13",
          "nearby_areas": [
            "Ystradgynlais",
            "Pontardawe",
            "Swansea",
            "Clydach",
            "Morriston",
            "Mumbles",
            "Gorseinon"
          ]
        }
      ]
    },
    {
      "name": "Newport",
      "slug": "newport",
      "region": "Wales",
      "council_name": "Newport City Council",
      "council_url": "https://www.newport.gov.uk/",
      "climate": "mild damp estuary climate",
      "population": "160,000",
      "towns": [
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "NP20",
          "nearby_areas": [
            "Malpas",
            "Cwmbran",
            "Caerleon",
            "Langstone",
            "Blaenavon",
            "New Inn",
            "Brynmawr"
          ]
        },
        {
          "name": "Caerleon",
          "slug": "caerleon",
          "postcode": "NP18",
          "nearby_areas": [
            "Langstone",
            "Cwmbran",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        },
        {
          "name": "Rogerstone",
          "slug": "rogerstone",
          "postcode": "NP10",
          "nearby_areas": [
            "Ellesmere",
            "Welshpool",
            "Whitchurch",
            "Oswestry",
            "Newtown",
            "Machynlleth",
            "Church Stretton"
          ]
        },
        {
          "name": "Malpas",
          "slug": "malpas",
          "postcode": "NP20",
          "nearby_areas": [
            "Newport",
            "Cwmbran",
            "Caerleon",
            "Langstone",
            "Blaenavon",
            "New Inn",
            "Brynmawr"
          ]
        },
        {
          "name": "Marshfield",
          "slug": "marshfield",
          "postcode": "CF3",
          "nearby_areas": [
            "Whitchurch",
            "Radyr",
            "Canton",
            "Llandaff",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Langstone",
          "slug": "langstone",
          "postcode": "NP18",
          "nearby_areas": [
            "Caerleon",
            "Cwmbran",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        }
      ]
    },
    {
      "name": "Norfolk",
      "slug": "norfolk",
      "region": "East of England",
      "council_name": "Norfolk County Council",
      "council_url": "https://www.norfolk.gov.uk/",
      "climate": "dry eastern weather with coastal winds",
      "population": "920,000",
      "towns": [
        {
          "name": "Norwich",
          "slug": "norwich",
          "postcode": "NR1",
          "nearby_areas": [
            "Aylsham",
            "Wymondham",
            "Holt",
            "North Walsham",
            "Attleborough",
            "Dereham",
            "Great Yarmouth"
          ]
        },
        {
          "name": "King's Lynn",
          "slug": "king-s-lynn",
          "postcode": "PE30",
          "nearby_areas": [
            "March",
            "St Ives",
            "Wisbech",
            "Chatteris",
            "Whittlesey",
            "Yaxley",
            "Peterborough"
          ]
        },
        {
          "name": "Great Yarmouth",
          "slug": "great-yarmouth",
          "postcode": "NR30",
          "nearby_areas": [
            "Lowestoft",
            "Beccles",
            "Norwich",
            "North Walsham",
            "Holt",
            "Aylsham",
            "Wymondham"
          ]
        },
        {
          "name": "Thetford",
          "slug": "thetford",
          "postcode": "IP24",
          "nearby_areas": [
            "Eye",
            "Bury St Edmunds",
            "Attleborough",
            "Mildenhall",
            "Diss",
            "Swaffham",
            "Dereham"
          ]
        },
        {
          "name": "Dereham",
          "slug": "dereham",
          "postcode": "NR19",
          "nearby_areas": [
            "Wymondham",
            "Swaffham",
            "Fakenham",
            "Aylsham",
            "Attleborough",
            "Norwich",
            "Holt"
          ]
        },
        {
          "name": "Wymondham",
          "slug": "wymondham",
          "postcode": "NR18",
          "nearby_areas": [
            "Aylsham",
            "Dereham",
            "Norwich",
            "Holt",
            "Attleborough",
            "Fakenham",
            "North Walsham"
          ]
        },
        {
          "name": "North Walsham",
          "slug": "north-walsham",
          "postcode": "NR28",
          "nearby_areas": [
            "Holt",
            "Cromer",
            "Sheringham",
            "Aylsham",
            "Norwich",
            "Wymondham",
            "Great Yarmouth"
          ]
        },
        {
          "name": "Attleborough",
          "slug": "attleborough",
          "postcode": "NR17",
          "nearby_areas": [
            "Diss",
            "Wymondham",
            "Dereham",
            "Thetford",
            "Aylsham",
            "Norwich",
            "Eye"
          ]
        },
        {
          "name": "Diss",
          "slug": "diss",
          "postcode": "IP22",
          "nearby_areas": [
            "Eye",
            "Attleborough",
            "Mildenhall",
            "Saxmundham",
            "Thetford",
            "Stowmarket",
            "Aldeburgh"
          ]
        },
        {
          "name": "Fakenham",
          "slug": "fakenham",
          "postcode": "NR21",
          "nearby_areas": [
            "Dereham",
            "Swaffham",
            "Wymondham",
            "Sheringham",
            "Aylsham",
            "Holt",
            "Cromer"
          ]
        },
        {
          "name": "Cromer",
          "slug": "cromer",
          "postcode": "NR27",
          "nearby_areas": [
            "Sheringham",
            "North Walsham",
            "Holt",
            "Aylsham",
            "Wymondham",
            "Fakenham",
            "Norwich"
          ]
        },
        {
          "name": "Downham Market",
          "slug": "downham-market",
          "postcode": "PE38",
          "nearby_areas": [
            "Wisbech",
            "Swaffham",
            "March",
            "King's Lynn",
            "St Ives",
            "Ely",
            "Ramsey"
          ]
        },
        {
          "name": "Swaffham",
          "slug": "swaffham",
          "postcode": "PE37",
          "nearby_areas": [
            "Dereham",
            "Downham Market",
            "Fakenham",
            "Thetford",
            "Attleborough",
            "Wymondham",
            "Aylsham"
          ]
        },
        {
          "name": "Sheringham",
          "slug": "sheringham",
          "postcode": "NR26",
          "nearby_areas": [
            "Cromer",
            "North Walsham",
            "Holt",
            "Fakenham",
            "Aylsham",
            "Wymondham",
            "Dereham"
          ]
        },
        {
          "name": "Holt",
          "slug": "holt",
          "postcode": "NR25",
          "nearby_areas": [
            "North Walsham",
            "Aylsham",
            "Cromer",
            "Norwich",
            "Wymondham",
            "Sheringham",
            "Dereham"
          ]
        },
        {
          "name": "Aylsham",
          "slug": "aylsham",
          "postcode": "NR11",
          "nearby_areas": [
            "Wymondham",
            "Norwich",
            "Holt",
            "Dereham",
            "North Walsham",
            "Attleborough",
            "Cromer"
          ]
        }
      ]
    },
    {
      "name": "North Ayrshire",
      "slug": "north-ayrshire",
      "region": "Scotland",
      "council_name": "North Ayrshire Council",
      "council_url": "https://www.north-ayrshire.gov.uk/",
      "climate": "wet west coast climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Irvine",
          "slug": "irvine",
          "postcode": "KA12",
          "nearby_areas": [
            "Kilwinning",
            "Stevenston",
            "Ardrossan",
            "Saltcoats",
            "Stewarton",
            "Prestwick",
            "Troon"
          ]
        },
        {
          "name": "Kilwinning",
          "slug": "kilwinning",
          "postcode": "KA13",
          "nearby_areas": [
            "Irvine",
            "Saltcoats",
            "Ardrossan",
            "Stevenston",
            "Stewarton",
            "Prestwick",
            "Troon"
          ]
        },
        {
          "name": "Saltcoats",
          "slug": "saltcoats",
          "postcode": "KA21",
          "nearby_areas": [
            "Kilwinning",
            "Irvine",
            "Ardrossan",
            "Stevenston",
            "Troon",
            "Prestwick",
            "Stewarton"
          ]
        },
        {
          "name": "Ardrossan",
          "slug": "ardrossan",
          "postcode": "KA22",
          "nearby_areas": [
            "Troon",
            "Stevenston",
            "Prestwick",
            "Mauchline",
            "Dalmellington",
            "Stewarton",
            "Irvine"
          ]
        },
        {
          "name": "Largs",
          "slug": "largs",
          "postcode": "KA30",
          "nearby_areas": [
            "Saltcoats",
            "Kilwinning",
            "Greenock",
            "Port Glasgow",
            "Inverkip",
            "Irvine",
            "Kilmacolm"
          ]
        },
        {
          "name": "Stevenston",
          "slug": "stevenston",
          "postcode": "KA20",
          "nearby_areas": [
            "Prestwick",
            "Mauchline",
            "Troon",
            "Dalmellington",
            "Stewarton",
            "Ardrossan",
            "Maybole"
          ]
        }
      ]
    },
    {
      "name": "North Lanarkshire",
      "slug": "north-lanarkshire",
      "region": "Scotland",
      "council_name": "North Lanarkshire Council",
      "council_url": "https://www.northlanarkshire.gov.uk/",
      "climate": "cool, wet central belt climate",
      "population": "340,000",
      "towns": [
        {
          "name": "Motherwell",
          "slug": "motherwell",
          "postcode": "ML1",
          "nearby_areas": [
            "Bellshill",
            "Wishaw",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "Coatbridge",
          "slug": "coatbridge",
          "postcode": "ML5",
          "nearby_areas": [
            "Airdrie",
            "Bellshill",
            "Motherwell",
            "Biggar",
            "Lanark",
            "Wishaw",
            "Larkhall"
          ]
        },
        {
          "name": "Airdrie",
          "slug": "airdrie",
          "postcode": "ML6",
          "nearby_areas": [
            "Biggar",
            "Lanark",
            "Coatbridge",
            "Bellshill",
            "Motherwell",
            "Larkhall",
            "Wishaw"
          ]
        },
        {
          "name": "Cumbernauld",
          "slug": "cumbernauld",
          "postcode": "G67",
          "nearby_areas": [
            "Kirkintilloch",
            "Lennoxtown",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Cambuslang",
            "Clydebank"
          ]
        },
        {
          "name": "Wishaw",
          "slug": "wishaw",
          "postcode": "ML2",
          "nearby_areas": [
            "Motherwell",
            "Bellshill",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Hamilton",
            "Biggar"
          ]
        },
        {
          "name": "Bellshill",
          "slug": "bellshill",
          "postcode": "ML4",
          "nearby_areas": [
            "Motherwell",
            "Wishaw",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "Kilsyth",
          "slug": "kilsyth",
          "postcode": "G65",
          "nearby_areas": [
            "Kirkintilloch",
            "Lennoxtown",
            "Bishopbriggs",
            "Cumbernauld",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        }
      ]
    },
    {
      "name": "North Yorkshire",
      "slug": "north-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "North Yorkshire Council",
      "council_url": "https://www.northyorkshire.gov.uk/",
      "climate": "upland rainfall, cold winters and coastal winds",
      "population": "1.2 million",
      "towns": [
        {
          "name": "York",
          "slug": "york",
          "postcode": "YO1",
          "nearby_areas": [
            "Selby",
            "Knaresborough",
            "Malton",
            "Harrogate",
            "Ripon",
            "Thirsk",
            "Goole"
          ]
        },
        {
          "name": "Middlesbrough",
          "slug": "middlesbrough",
          "postcode": "TS1",
          "nearby_areas": [
            "Stockton-on-Tees",
            "Stokesley",
            "Redcar",
            "Hartlepool",
            "Darlington",
            "Peterlee",
            "Newton Aycliffe"
          ]
        },
        {
          "name": "Harrogate",
          "slug": "harrogate",
          "postcode": "HG1",
          "nearby_areas": [
            "Knaresborough",
            "Ripon",
            "Otley",
            "Morley",
            "Ilkley",
            "Leeds",
            "Settle"
          ]
        },
        {
          "name": "Scarborough",
          "slug": "scarborough",
          "postcode": "YO11",
          "nearby_areas": [
            "Filey",
            "Pocklington",
            "Market Weighton",
            "Pickering",
            "Whitby",
            "Bridlington",
            "Malton"
          ]
        },
        {
          "name": "Redcar",
          "slug": "redcar",
          "postcode": "TS10",
          "nearby_areas": [
            "Stokesley",
            "Middlesbrough",
            "Hartlepool",
            "Stockton-on-Tees",
            "Peterlee",
            "Whitby",
            "Seaham"
          ]
        },
        {
          "name": "Northallerton",
          "slug": "northallerton",
          "postcode": "DL7",
          "nearby_areas": [
            "Thirsk",
            "Richmond",
            "Ripon",
            "Darlington",
            "Middlesbrough",
            "Stockton-on-Tees",
            "Stokesley"
          ]
        },
        {
          "name": "Skipton",
          "slug": "skipton",
          "postcode": "BD23",
          "nearby_areas": [
            "Settle",
            "Keighley",
            "Ilkley",
            "Morley",
            "Colne",
            "Otley",
            "Shipley"
          ]
        },
        {
          "name": "Richmond",
          "slug": "richmond",
          "postcode": "DL10",
          "nearby_areas": [
            "Northallerton",
            "Darlington",
            "Barnard Castle",
            "Shildon",
            "Thirsk",
            "Newton Aycliffe",
            "Ripon"
          ]
        },
        {
          "name": "Ripon",
          "slug": "ripon",
          "postcode": "HG4",
          "nearby_areas": [
            "Knaresborough",
            "Harrogate",
            "Thirsk",
            "Northallerton",
            "Richmond",
            "Morley",
            "Ilkley"
          ]
        },
        {
          "name": "Whitby",
          "slug": "whitby",
          "postcode": "YO21",
          "nearby_areas": [
            "Scarborough",
            "Pickering",
            "Redcar",
            "Stokesley",
            "Filey",
            "Malton",
            "Middlesbrough"
          ]
        },
        {
          "name": "Selby",
          "slug": "selby",
          "postcode": "YO8",
          "nearby_areas": [
            "Goole",
            "York",
            "Pontefract",
            "Castleford",
            "Howden",
            "Snaith",
            "Doncaster"
          ]
        },
        {
          "name": "Malton",
          "slug": "malton",
          "postcode": "YO17",
          "nearby_areas": [
            "Market Weighton",
            "Pocklington",
            "Pickering",
            "York",
            "Scarborough",
            "Driffield",
            "Filey"
          ]
        },
        {
          "name": "Thirsk",
          "slug": "thirsk",
          "postcode": "YO7",
          "nearby_areas": [
            "Northallerton",
            "Ripon",
            "Knaresborough",
            "Harrogate",
            "Richmond",
            "York",
            "Pickering"
          ]
        },
        {
          "name": "Knaresborough",
          "slug": "knaresborough",
          "postcode": "HG5",
          "nearby_areas": [
            "Harrogate",
            "Ripon",
            "Otley",
            "York",
            "Thirsk",
            "Leeds",
            "Morley"
          ]
        },
        {
          "name": "Filey",
          "slug": "filey",
          "postcode": "YO14",
          "nearby_areas": [
            "Scarborough",
            "Bridlington",
            "Driffield",
            "Pocklington",
            "Market Weighton",
            "Pickering",
            "Malton"
          ]
        },
        {
          "name": "Pickering",
          "slug": "pickering",
          "postcode": "YO18",
          "nearby_areas": [
            "Malton",
            "Market Weighton",
            "Pocklington",
            "Scarborough",
            "Whitby",
            "Filey",
            "Thirsk"
          ]
        },
        {
          "name": "Settle",
          "slug": "settle",
          "postcode": "BD24",
          "nearby_areas": [
            "Keighley",
            "Ilkley",
            "Morley",
            "Skipton",
            "Shipley",
            "Otley",
            "Bradford"
          ]
        },
        {
          "name": "Stokesley",
          "slug": "stokesley",
          "postcode": "TS9",
          "nearby_areas": [
            "Redcar",
            "Middlesbrough",
            "Hartlepool",
            "Stockton-on-Tees",
            "Peterlee",
            "Newton Aycliffe",
            "Darlington"
          ]
        }
      ]
    },
    {
      "name": "Northamptonshire",
      "slug": "northamptonshire",
      "region": "East Midlands",
      "council_name": "North Northamptonshire/West Northamptonshire",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "cool winters with moderate rainfall",
      "population": "790,000",
      "towns": [
        {
          "name": "Northampton",
          "slug": "northampton",
          "postcode": "NN1",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Kettering",
          "slug": "kettering",
          "postcode": "NN16",
          "nearby_areas": [
            "Wellingborough",
            "Corby",
            "Rushden",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Market Harborough"
          ]
        },
        {
          "name": "Corby",
          "slug": "corby",
          "postcode": "NN17",
          "nearby_areas": [
            "Kettering",
            "Market Harborough",
            "Wellingborough",
            "Oakham",
            "Rushden",
            "Stamford",
            "Cottesmore"
          ]
        },
        {
          "name": "Wellingborough",
          "slug": "wellingborough",
          "postcode": "NN8",
          "nearby_areas": [
            "Rushden",
            "Higham Ferrers",
            "Irthlingborough",
            "Raunds",
            "Kettering",
            "Moulton",
            "Northampton"
          ]
        },
        {
          "name": "Rushden",
          "slug": "rushden",
          "postcode": "NN10",
          "nearby_areas": [
            "Wellingborough",
            "Kettering",
            "Higham Ferrers",
            "Irthlingborough",
            "Raunds",
            "Moulton",
            "Olney"
          ]
        },
        {
          "name": "Daventry",
          "slug": "daventry",
          "postcode": "NN11",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Rugby",
            "Northampton",
            "Towcester",
            "Moulton",
            "Irthlingborough"
          ]
        },
        {
          "name": "Towcester",
          "slug": "towcester",
          "postcode": "NN12",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Northampton",
            "Brackley",
            "Moulton",
            "Winslow",
            "Irthlingborough"
          ]
        },
        {
          "name": "Brackley",
          "slug": "brackley",
          "postcode": "NN13",
          "nearby_areas": [
            "Buckingham",
            "Towcester",
            "Banbury",
            "Bicester",
            "Winslow",
            "Daventry",
            "Woburn"
          ]
        },
        {
          "name": "Desborough",
          "slug": "desborough",
          "postcode": "NN14",
          "nearby_areas": [
            "Thrapston",
            "Northampton",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Raunds",
          "slug": "raunds",
          "postcode": "NN9",
          "nearby_areas": [
            "Irthlingborough",
            "Higham Ferrers",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Higham Ferrers",
          "slug": "higham-ferrers",
          "postcode": "NN10",
          "nearby_areas": [
            "Irthlingborough",
            "Raunds",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Irthlingborough",
          "slug": "irthlingborough",
          "postcode": "NN9",
          "nearby_areas": [
            "Raunds",
            "Higham Ferrers",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Oundle",
          "slug": "oundle",
          "postcode": "PE8",
          "nearby_areas": [
            "Whittlesey",
            "Yaxley",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "Spalding",
            "Bourne"
          ]
        },
        {
          "name": "Thrapston",
          "slug": "thrapston",
          "postcode": "NN14",
          "nearby_areas": [
            "Desborough",
            "Northampton",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Moulton",
          "slug": "moulton",
          "postcode": "NN3",
          "nearby_areas": [
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        }
      ]
    },
    {
      "name": "Northumberland",
      "slug": "northumberland",
      "region": "North East England",
      "council_name": "Northumberland Council",
      "council_url": "https://www.northumberland.gov.uk/",
      "climate": "cool, exposed and wet in upland areas",
      "population": "320,000",
      "towns": [
        {
          "name": "Blyth",
          "slug": "blyth",
          "postcode": "NE24",
          "nearby_areas": [
            "Ponteland",
            "Blaydon",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Whitley Bay"
          ]
        },
        {
          "name": "Cramlington",
          "slug": "cramlington",
          "postcode": "NE23",
          "nearby_areas": [
            "Blaydon",
            "Ponteland",
            "Blyth",
            "Bedlington",
            "Ashington",
            "North Shields",
            "Tynemouth"
          ]
        },
        {
          "name": "Ashington",
          "slug": "ashington",
          "postcode": "NE63",
          "nearby_areas": [
            "Morpeth",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Newbiggin-by-the-Sea",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Hexham",
          "slug": "hexham",
          "postcode": "NE46",
          "nearby_areas": [
            "Prudhoe",
            "Corbridge",
            "Consett",
            "Haltwhistle",
            "Stanley",
            "Morpeth",
            "Ponteland"
          ]
        },
        {
          "name": "Morpeth",
          "slug": "morpeth",
          "postcode": "NE61",
          "nearby_areas": [
            "Ashington",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Cramlington",
            "Newbiggin-by-the-Sea",
            "Ponteland"
          ]
        },
        {
          "name": "Berwick-upon-Tweed",
          "slug": "berwick-upon-tweed",
          "postcode": "TD15",
          "nearby_areas": [
            "Eyemouth",
            "Kelso",
            "Alnwick",
            "Melrose",
            "Dunbar",
            "Jedburgh",
            "Haddington"
          ]
        },
        {
          "name": "Alnwick",
          "slug": "alnwick",
          "postcode": "NE66",
          "nearby_areas": [
            "Amble",
            "Rothbury",
            "Morpeth",
            "Ashington",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington"
          ]
        },
        {
          "name": "Prudhoe",
          "slug": "prudhoe",
          "postcode": "NE42",
          "nearby_areas": [
            "Corbridge",
            "Haltwhistle",
            "Consett",
            "Stanley",
            "Hexham",
            "Gateshead",
            "Newcastle upon Tyne"
          ]
        },
        {
          "name": "Ponteland",
          "slug": "ponteland",
          "postcode": "NE20",
          "nearby_areas": [
            "Blyth",
            "Blaydon",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Bedlington"
          ]
        },
        {
          "name": "Bedlington",
          "slug": "bedlington",
          "postcode": "NE22",
          "nearby_areas": [
            "Ashington",
            "Cramlington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Ponteland",
            "Blaydon",
            "Amble"
          ]
        },
        {
          "name": "Amble",
          "slug": "amble",
          "postcode": "NE65",
          "nearby_areas": [
            "Rothbury",
            "Ashington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Haltwhistle",
          "slug": "haltwhistle",
          "postcode": "NE49",
          "nearby_areas": [
            "Corbridge",
            "Ponteland",
            "Newcastle upon Tyne",
            "Blyth",
            "Cramlington",
            "Prudhoe",
            "Blaydon"
          ]
        },
        {
          "name": "Rothbury",
          "slug": "rothbury",
          "postcode": "NE65",
          "nearby_areas": [
            "Amble",
            "Ashington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Corbridge",
          "slug": "corbridge",
          "postcode": "NE45",
          "nearby_areas": [
            "Haltwhistle",
            "Prudhoe",
            "Newcastle upon Tyne",
            "Gateshead",
            "Ponteland",
            "Blyth",
            "Cramlington"
          ]
        },
        {
          "name": "Newbiggin-by-the-Sea",
          "slug": "newbiggin-by-the-sea",
          "postcode": "NE64",
          "nearby_areas": [
            "Ashington",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Morpeth",
            "Cramlington",
            "Ponteland"
          ]
        }
      ]
    },
    {
      "name": "Nottinghamshire",
      "slug": "nottinghamshire",
      "region": "East Midlands",
      "council_name": "Nottinghamshire County Council",
      "council_url": "https://www.nottinghamshire.gov.uk/",
      "climate": "cool damp winters and moderate rainfall",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Nottingham",
          "slug": "nottingham",
          "postcode": "NG1",
          "nearby_areas": [
            "West Bridgford",
            "Carlton",
            "Arnold",
            "Ilkeston",
            "Beeston",
            "Bingham",
            "Long Eaton"
          ]
        },
        {
          "name": "Mansfield",
          "slug": "mansfield",
          "postcode": "NG18",
          "nearby_areas": [
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Hucknall",
            "Alfreton",
            "Bingham",
            "Worksop",
            "Beeston"
          ]
        },
        {
          "name": "Worksop",
          "slug": "worksop",
          "postcode": "S80",
          "nearby_areas": [
            "Retford",
            "Mansfield",
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Dinnington",
            "Chesterfield"
          ]
        },
        {
          "name": "Newark-on-Trent",
          "slug": "newark-on-trent",
          "postcode": "NG24",
          "nearby_areas": [
            "Southwell",
            "Ollerton",
            "Beeston",
            "Bingham",
            "Long Eaton",
            "Hucknall",
            "Arnold"
          ]
        },
        {
          "name": "Sutton-in-Ashfield",
          "slug": "sutton-in-ashfield",
          "postcode": "NG17",
          "nearby_areas": [
            "Kirkby-in-Ashfield",
            "Hucknall",
            "Bingham",
            "Beeston",
            "Mansfield",
            "Long Eaton",
            "Arnold"
          ]
        },
        {
          "name": "Beeston",
          "slug": "beeston",
          "postcode": "NG9",
          "nearby_areas": [
            "Long Eaton",
            "Bingham",
            "Arnold",
            "Carlton",
            "Hucknall",
            "Ollerton",
            "West Bridgford"
          ]
        },
        {
          "name": "Arnold",
          "slug": "arnold",
          "postcode": "NG5",
          "nearby_areas": [
            "Carlton",
            "Beeston",
            "West Bridgford",
            "Long Eaton",
            "Bingham",
            "Hucknall",
            "Nottingham"
          ]
        },
        {
          "name": "Retford",
          "slug": "retford",
          "postcode": "DN22",
          "nearby_areas": [
            "Worksop",
            "Gainsborough",
            "Mansfield",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Hucknall",
            "Bingham"
          ]
        },
        {
          "name": "West Bridgford",
          "slug": "west-bridgford",
          "postcode": "NG2",
          "nearby_areas": [
            "Carlton",
            "Nottingham",
            "Arnold",
            "Beeston",
            "Long Eaton",
            "Bingham",
            "Hucknall"
          ]
        },
        {
          "name": "Hucknall",
          "slug": "hucknall",
          "postcode": "NG15",
          "nearby_areas": [
            "Bingham",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Beeston",
            "Long Eaton",
            "Ollerton",
            "Arnold"
          ]
        },
        {
          "name": "Kirkby-in-Ashfield",
          "slug": "kirkby-in-ashfield",
          "postcode": "NG17",
          "nearby_areas": [
            "Sutton-in-Ashfield",
            "Hucknall",
            "Bingham",
            "Beeston",
            "Mansfield",
            "Long Eaton",
            "Arnold"
          ]
        },
        {
          "name": "Carlton",
          "slug": "carlton",
          "postcode": "NG4",
          "nearby_areas": [
            "Arnold",
            "West Bridgford",
            "Beeston",
            "Long Eaton",
            "Bingham",
            "Nottingham",
            "Hucknall"
          ]
        },
        {
          "name": "Southwell",
          "slug": "southwell",
          "postcode": "NG25",
          "nearby_areas": [
            "Newark-on-Trent",
            "Ollerton",
            "Beeston",
            "Bingham",
            "Long Eaton",
            "Arnold",
            "Hucknall"
          ]
        },
        {
          "name": "Bingham",
          "slug": "bingham",
          "postcode": "NG13",
          "nearby_areas": [
            "Hucknall",
            "Long Eaton",
            "Beeston",
            "Ollerton",
            "Arnold",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield"
          ]
        },
        {
          "name": "Ollerton",
          "slug": "ollerton",
          "postcode": "NG22",
          "nearby_areas": [
            "Bingham",
            "Newark-on-Trent",
            "Beeston",
            "Long Eaton",
            "Hucknall",
            "Southwell",
            "Arnold"
          ]
        }
      ]
    },
    {
      "name": "Orkney Islands",
      "slug": "orkney-islands",
      "region": "Scotland",
      "council_name": "Orkney Islands Council",
      "council_url": "https://www.orkney.gov.uk/",
      "climate": "cool, windy maritime island climate",
      "population": "22,000",
      "towns": [
        {
          "name": "Kirkwall",
          "slug": "kirkwall",
          "postcode": "KW15",
          "nearby_areas": [
            "Stromness",
            "Dounby",
            "Finstown",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Stromness",
          "slug": "stromness",
          "postcode": "KW16",
          "nearby_areas": [
            "Dounby",
            "Finstown",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Dounby",
          "slug": "dounby",
          "postcode": "KW17",
          "nearby_areas": [
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Finstown",
          "slug": "finstown",
          "postcode": "KW17",
          "nearby_areas": [
            "Dounby",
            "Stromness",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        }
      ]
    },
    {
      "name": "Oxfordshire",
      "slug": "oxfordshire",
      "region": "South East England",
      "council_name": "Oxfordshire County Council",
      "council_url": "https://www.oxfordshire.gov.uk/",
      "climate": "mild, inland climate with winter damp",
      "population": "750,000",
      "towns": [
        {
          "name": "Oxford",
          "slug": "oxford",
          "postcode": "OX1",
          "nearby_areas": [
            "Abingdon",
            "Kidlington",
            "Woodstock",
            "Witney",
            "Didcot",
            "Bicester",
            "Wallingford"
          ]
        },
        {
          "name": "Banbury",
          "slug": "banbury",
          "postcode": "OX16",
          "nearby_areas": [
            "Brackley",
            "Chipping Norton",
            "Bicester",
            "Shipston-on-Stour",
            "Kidlington",
            "Buckingham",
            "Woodstock"
          ]
        },
        {
          "name": "Bicester",
          "slug": "bicester",
          "postcode": "OX26",
          "nearby_areas": [
            "Kidlington",
            "Buckingham",
            "Brackley",
            "Oxford",
            "Woodstock",
            "Abingdon",
            "Thame"
          ]
        },
        {
          "name": "Abingdon",
          "slug": "abingdon",
          "postcode": "OX14",
          "nearby_areas": [
            "Woodstock",
            "Oxford",
            "Kidlington",
            "Witney",
            "Didcot",
            "Bicester",
            "Carterton"
          ]
        },
        {
          "name": "Didcot",
          "slug": "didcot",
          "postcode": "OX11",
          "nearby_areas": [
            "Wallingford",
            "Wantage",
            "Oxford",
            "Abingdon",
            "Woodstock",
            "Kidlington",
            "Thame"
          ]
        },
        {
          "name": "Witney",
          "slug": "witney",
          "postcode": "OX28",
          "nearby_areas": [
            "Carterton",
            "Woodstock",
            "Abingdon",
            "Kidlington",
            "Faringdon",
            "Oxford",
            "Chipping Norton"
          ]
        },
        {
          "name": "Kidlington",
          "slug": "kidlington",
          "postcode": "OX5",
          "nearby_areas": [
            "Woodstock",
            "Abingdon",
            "Oxford",
            "Bicester",
            "Witney",
            "Carterton",
            "Chipping Norton"
          ]
        },
        {
          "name": "Henley-on-Thames",
          "slug": "henley-on-thames",
          "postcode": "RG9",
          "nearby_areas": [
            "Marlow",
            "Reading",
            "Pangbourne",
            "Twyford",
            "Maidenhead",
            "High Wycombe",
            "Wallingford"
          ]
        },
        {
          "name": "Thame",
          "slug": "thame",
          "postcode": "OX9",
          "nearby_areas": [
            "Princes Risborough",
            "Aylesbury",
            "Wendover",
            "Wallingford",
            "Oxford",
            "Bicester",
            "Kidlington"
          ]
        },
        {
          "name": "Wallingford",
          "slug": "wallingford",
          "postcode": "OX10",
          "nearby_areas": [
            "Didcot",
            "Henley-on-Thames",
            "Oxford",
            "Thame",
            "Pangbourne",
            "Wantage",
            "Twyford"
          ]
        },
        {
          "name": "Carterton",
          "slug": "carterton",
          "postcode": "OX18",
          "nearby_areas": [
            "Witney",
            "Faringdon",
            "Woodstock",
            "Abingdon",
            "Chipping Norton",
            "Kidlington",
            "Wantage"
          ]
        },
        {
          "name": "Chipping Norton",
          "slug": "chipping-norton",
          "postcode": "OX7",
          "nearby_areas": [
            "Moreton-in-Marsh",
            "Witney",
            "Shipston-on-Stour",
            "Banbury",
            "Carterton",
            "Woodstock",
            "Kidlington"
          ]
        },
        {
          "name": "Faringdon",
          "slug": "faringdon",
          "postcode": "SN7",
          "nearby_areas": [
            "Carterton",
            "Wantage",
            "Witney",
            "Woodstock",
            "Abingdon",
            "Didcot",
            "Oxford"
          ]
        },
        {
          "name": "Wantage",
          "slug": "wantage",
          "postcode": "OX12",
          "nearby_areas": [
            "Didcot",
            "Faringdon",
            "Wallingford",
            "Abingdon",
            "Oxford",
            "Witney",
            "Carterton"
          ]
        },
        {
          "name": "Woodstock",
          "slug": "woodstock",
          "postcode": "OX20",
          "nearby_areas": [
            "Abingdon",
            "Kidlington",
            "Witney",
            "Oxford",
            "Carterton",
            "Bicester",
            "Chipping Norton"
          ]
        }
      ]
    },
    {
      "name": "Pembrokeshire",
      "slug": "pembrokeshire",
      "region": "Wales",
      "council_name": "Pembrokeshire County Council",
      "council_url": "https://www.pembrokeshire.gov.uk/",
      "climate": "mild, wet and coastal",
      "population": "125,000",
      "towns": [
        {
          "name": "Haverfordwest",
          "slug": "haverfordwest",
          "postcode": "SA61",
          "nearby_areas": [
            "Milford Haven",
            "Pembroke",
            "St Davids",
            "Tenby",
            "Narberth",
            "Fishguard",
            "Carmarthen"
          ]
        },
        {
          "name": "Milford Haven",
          "slug": "milford-haven",
          "postcode": "SA73",
          "nearby_areas": [
            "Pembroke",
            "Haverfordwest",
            "Tenby",
            "St Davids",
            "Narberth",
            "Fishguard",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Pembroke",
          "slug": "pembroke",
          "postcode": "SA71",
          "nearby_areas": [
            "Tenby",
            "St Davids",
            "Narberth",
            "Milford Haven",
            "Fishguard",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Tenby",
          "slug": "tenby",
          "postcode": "SA70",
          "nearby_areas": [
            "St Davids",
            "Narberth",
            "Pembroke",
            "Fishguard",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Fishguard",
          "slug": "fishguard",
          "postcode": "SA65",
          "nearby_areas": [
            "Narberth",
            "Tenby",
            "St Davids",
            "Pembroke",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Narberth",
          "slug": "narberth",
          "postcode": "SA67",
          "nearby_areas": [
            "Fishguard",
            "Tenby",
            "St Davids",
            "Pembroke",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "St Davids",
          "slug": "st-davids",
          "postcode": "SA62",
          "nearby_areas": [
            "Tenby",
            "Narberth",
            "Pembroke",
            "Fishguard",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        }
      ]
    },
    {
      "name": "Perth and Kinross",
      "slug": "perth-and-kinross",
      "region": "Scotland",
      "council_name": "Perth and Kinross Council",
      "council_url": "https://www.pkc.gov.uk/",
      "climate": "cool, damp with upland rainfall",
      "population": "150,000",
      "towns": [
        {
          "name": "Perth",
          "slug": "perth",
          "postcode": "PH1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Blairgowrie",
          "slug": "blairgowrie",
          "postcode": "PH10",
          "nearby_areas": [
            "Perth",
            "Kirriemuir",
            "Aberfeldy",
            "Pitlochry",
            "Dundee",
            "Forfar",
            "Lochee"
          ]
        },
        {
          "name": "Crieff",
          "slug": "crieff",
          "postcode": "PH7",
          "nearby_areas": [
            "Auchterarder",
            "Pitlochry",
            "Aberfeldy",
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick"
          ]
        },
        {
          "name": "Pitlochry",
          "slug": "pitlochry",
          "postcode": "PH16",
          "nearby_areas": [
            "Aberfeldy",
            "Crieff",
            "Aviemore",
            "Auchterarder",
            "Perth",
            "Benbecula",
            "Brae"
          ]
        },
        {
          "name": "Kinross",
          "slug": "kinross",
          "postcode": "KY13",
          "nearby_areas": [
            "Inverkeithing",
            "Rosyth",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Dunfermline"
          ]
        },
        {
          "name": "Auchterarder",
          "slug": "auchterarder",
          "postcode": "PH3",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Aberfeldy",
          "slug": "aberfeldy",
          "postcode": "PH15",
          "nearby_areas": [
            "Pitlochry",
            "Crieff",
            "Aviemore",
            "Perth",
            "Benbecula",
            "Brae",
            "Castlebay"
          ]
        }
      ]
    },
    {
      "name": "Powys",
      "slug": "powys",
      "region": "Wales",
      "council_name": "Powys County Council",
      "council_url": "https://en.powys.gov.uk/",
      "climate": "upland rainfall and cold rural winters",
      "population": "135,000",
      "towns": [
        {
          "name": "Llandrindod Wells",
          "slug": "llandrindod-wells",
          "postcode": "LD1",
          "nearby_areas": [
            "Builth Wells",
            "Presteigne",
            "Blaina",
            "Raglan",
            "Usk",
            "Brecon",
            "Caerleon"
          ]
        },
        {
          "name": "Newtown",
          "slug": "newtown",
          "postcode": "SY16",
          "nearby_areas": [
            "Welshpool",
            "Machynlleth",
            "Whitchurch",
            "Ellesmere",
            "Rogerstone",
            "Church Stretton",
            "Craven Arms"
          ]
        },
        {
          "name": "Brecon",
          "slug": "brecon",
          "postcode": "LD3",
          "nearby_areas": [
            "Presteigne",
            "Builth Wells",
            "Tredegar",
            "Merthyr Tydfil",
            "Ebbw Vale",
            "Brynmawr",
            "Nantyglo"
          ]
        },
        {
          "name": "Welshpool",
          "slug": "welshpool",
          "postcode": "SY21",
          "nearby_areas": [
            "Whitchurch",
            "Newtown",
            "Ellesmere",
            "Rogerstone",
            "Machynlleth",
            "Church Stretton",
            "Craven Arms"
          ]
        },
        {
          "name": "Ystradgynlais",
          "slug": "ystradgynlais",
          "postcode": "SA9",
          "nearby_areas": [
            "Cymmer",
            "Pontardawe",
            "Clydach",
            "Morriston",
            "Swansea",
            "Mumbles",
            "Gorseinon"
          ]
        },
        {
          "name": "Machynlleth",
          "slug": "machynlleth",
          "postcode": "SY20",
          "nearby_areas": [
            "Newtown",
            "Welshpool",
            "Tregaron",
            "Whitchurch",
            "Rogerstone",
            "Ellesmere",
            "Church Stretton"
          ]
        },
        {
          "name": "Builth Wells",
          "slug": "builth-wells",
          "postcode": "LD2",
          "nearby_areas": [
            "Presteigne",
            "Llandrindod Wells",
            "Brecon",
            "Blaina",
            "Raglan",
            "Usk",
            "Cwmbran"
          ]
        },
        {
          "name": "Presteigne",
          "slug": "presteigne",
          "postcode": "LD8",
          "nearby_areas": [
            "Builth Wells",
            "Brecon",
            "Llandrindod Wells",
            "Blaina",
            "Malpas",
            "Newport",
            "Cwmbran"
          ]
        }
      ]
    },
    {
      "name": "Renfrewshire",
      "slug": "renfrewshire",
      "region": "Scotland",
      "council_name": "Renfrewshire Council",
      "council_url": "https://www.renfrewshire.gov.uk/",
      "climate": "wet west central climate",
      "population": "180,000",
      "towns": [
        {
          "name": "Paisley",
          "slug": "paisley",
          "postcode": "PA1",
          "nearby_areas": [
            "Cumbernauld",
            "Kirkintilloch",
            "Lennoxtown",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Clydebank"
          ]
        },
        {
          "name": "Renfrew",
          "slug": "renfrew",
          "postcode": "PA4",
          "nearby_areas": [
            "Linwood",
            "Johnstone",
            "Dumbarton",
            "Govan",
            "Bearsden",
            "Milngavie",
            "Paisley"
          ]
        },
        {
          "name": "Johnstone",
          "slug": "johnstone",
          "postcode": "PA5",
          "nearby_areas": [
            "Renfrew",
            "Dumbarton",
            "Govan",
            "Linwood",
            "Giffnock",
            "Bearsden",
            "Pollokshields"
          ]
        },
        {
          "name": "Linwood",
          "slug": "linwood",
          "postcode": "PA3",
          "nearby_areas": [
            "Renfrew",
            "Paisley",
            "Bearsden",
            "Dumbarton",
            "Milngavie",
            "Balfron",
            "Bishopbriggs"
          ]
        },
        {
          "name": "Erskine",
          "slug": "erskine",
          "postcode": "PA8",
          "nearby_areas": [
            "Bishopton",
            "Dennistoun",
            "Maryhill",
            "Pollokshields",
            "Shawlands",
            "Partick",
            "Giffnock"
          ]
        },
        {
          "name": "Bishopton",
          "slug": "bishopton",
          "postcode": "PA7",
          "nearby_areas": [
            "Erskine",
            "Dennistoun",
            "Pollokshields",
            "Shawlands",
            "Johnstone",
            "Giffnock",
            "Renfrew"
          ]
        }
      ]
    },
    {
      "name": "Rhondda Cynon Taf",
      "slug": "rhondda-cynon-taf",
      "region": "Wales",
      "council_name": "Rhondda Cynon Taf County Borough Council",
      "council_url": "https://www.rctcbc.gov.uk/",
      "climate": "wet valleys climate and cool winters",
      "population": "240,000",
      "towns": [
        {
          "name": "Pontypridd",
          "slug": "pontypridd",
          "postcode": "CF37",
          "nearby_areas": [
            "Porth",
            "Bargoed",
            "Marshfield",
            "Ystrad Mynach",
            "Canton",
            "Llandaff",
            "Radyr"
          ]
        },
        {
          "name": "Aberdare",
          "slug": "aberdare",
          "postcode": "CF44",
          "nearby_areas": [
            "Mountain Ash",
            "Merthyr Tydfil",
            "Treorchy",
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw"
          ]
        },
        {
          "name": "Tonypandy",
          "slug": "tonypandy",
          "postcode": "CF40",
          "nearby_areas": [
            "Porth",
            "Roath",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Treorchy",
            "Pyle"
          ]
        },
        {
          "name": "Porth",
          "slug": "porth",
          "postcode": "CF39",
          "nearby_areas": [
            "Tonypandy",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Pontypridd",
            "Roath",
            "Nelson"
          ]
        },
        {
          "name": "Mountain Ash",
          "slug": "mountain-ash",
          "postcode": "CF45",
          "nearby_areas": [
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Aberdare",
            "Treharris",
            "Merthyr Tydfil"
          ]
        },
        {
          "name": "Treorchy",
          "slug": "treorchy",
          "postcode": "CF42",
          "nearby_areas": [
            "Tonypandy",
            "Aberdare",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Porth",
            "Mountain Ash"
          ]
        },
        {
          "name": "Llantrisant",
          "slug": "llantrisant",
          "postcode": "CF72",
          "nearby_areas": [
            "Cowbridge",
            "Canton",
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Bargoed",
            "Radyr"
          ]
        }
      ]
    },
    {
      "name": "Rutland",
      "slug": "rutland",
      "region": "East Midlands",
      "council_name": "Rutland County Council",
      "council_url": "https://www.rutland.gov.uk/",
      "climate": "cool, rural and fairly dry",
      "population": "40,000",
      "towns": [
        {
          "name": "Oakham",
          "slug": "oakham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine"
          ]
        },
        {
          "name": "Uppingham",
          "slug": "uppingham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Ketton",
          "slug": "ketton",
          "postcode": "PE9",
          "nearby_areas": [
            "Ryhall",
            "Oundle",
            "Whittlesey",
            "Yaxley",
            "Peterborough",
            "Bourne",
            "Spalding"
          ]
        },
        {
          "name": "Cottesmore",
          "slug": "cottesmore",
          "postcode": "LE15",
          "nearby_areas": [
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Ryhall",
          "slug": "ryhall",
          "postcode": "PE9",
          "nearby_areas": [
            "Ketton",
            "Oundle",
            "Whittlesey",
            "Yaxley",
            "Peterborough",
            "Bourne",
            "Spalding"
          ]
        },
        {
          "name": "Empingham",
          "slug": "empingham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Whissendine",
          "slug": "whissendine",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Shepshed"
          ]
        },
        {
          "name": "Greetham",
          "slug": "greetham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Exton",
          "slug": "exton",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Edith Weston",
          "slug": "edith-weston",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        }
      ]
    },
    {
      "name": "Scottish Borders",
      "slug": "scottish-borders",
      "region": "Scotland",
      "council_name": "Scottish Borders Council",
      "council_url": "https://www.scotborders.gov.uk/",
      "climate": "cool upland climate with wet winters",
      "population": "115,000",
      "towns": [
        {
          "name": "Galashiels",
          "slug": "galashiels",
          "postcode": "TD1",
          "nearby_areas": [
            "Jedburgh",
            "Melrose",
            "Hawick",
            "Kelso",
            "Peebles",
            "Eyemouth",
            "Penicuik"
          ]
        },
        {
          "name": "Hawick",
          "slug": "hawick",
          "postcode": "TD9",
          "nearby_areas": [
            "Jedburgh",
            "Galashiels",
            "Melrose",
            "Kelso",
            "Peebles",
            "Eyemouth",
            "Penicuik"
          ]
        },
        {
          "name": "Peebles",
          "slug": "peebles",
          "postcode": "EH45",
          "nearby_areas": [
            "Penicuik",
            "Galashiels",
            "Whitburn",
            "Gorebridge",
            "Dalkeith",
            "Musselburgh",
            "Loanhead"
          ]
        },
        {
          "name": "Kelso",
          "slug": "kelso",
          "postcode": "TD5",
          "nearby_areas": [
            "Melrose",
            "Eyemouth",
            "Jedburgh",
            "Galashiels",
            "Hawick",
            "Berwick-upon-Tweed",
            "Peebles"
          ]
        },
        {
          "name": "Jedburgh",
          "slug": "jedburgh",
          "postcode": "TD8",
          "nearby_areas": [
            "Melrose",
            "Kelso",
            "Galashiels",
            "Hawick",
            "Eyemouth",
            "Peebles",
            "Haddington"
          ]
        },
        {
          "name": "Melrose",
          "slug": "melrose",
          "postcode": "TD6",
          "nearby_areas": [
            "Jedburgh",
            "Kelso",
            "Galashiels",
            "Eyemouth",
            "Hawick",
            "Peebles",
            "Berwick-upon-Tweed"
          ]
        },
        {
          "name": "Eyemouth",
          "slug": "eyemouth",
          "postcode": "TD14",
          "nearby_areas": [
            "Kelso",
            "Melrose",
            "Jedburgh",
            "Berwick-upon-Tweed",
            "Galashiels",
            "Hawick",
            "Dunbar"
          ]
        }
      ]
    },
    {
      "name": "Shetland Islands",
      "slug": "shetland-islands",
      "region": "Scotland",
      "council_name": "Shetland Islands Council",
      "council_url": "https://www.shetland.gov.uk/",
      "climate": "cool, very windy maritime climate",
      "population": "23,000",
      "towns": [
        {
          "name": "Lerwick",
          "slug": "lerwick",
          "postcode": "ZE1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Scalloway",
          "slug": "scalloway",
          "postcode": "ZE1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Brae",
          "slug": "brae",
          "postcode": "ZE2",
          "nearby_areas": [
            "Benbecula",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Sullom Voe",
          "slug": "sullom-voe",
          "postcode": "ZE2",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        }
      ]
    },
    {
      "name": "Shropshire",
      "slug": "shropshire",
      "region": "West Midlands",
      "council_name": "Shropshire Council",
      "council_url": "https://www.shropshire.gov.uk/",
      "climate": "rural rainfall and cool upland winters",
      "population": "500,000",
      "towns": [
        {
          "name": "Shrewsbury",
          "slug": "shrewsbury",
          "postcode": "SY1",
          "nearby_areas": [
            "Much Wenlock",
            "Church Stretton",
            "Wellington",
            "Newport",
            "Ellesmere",
            "Craven Arms",
            "Telford"
          ]
        },
        {
          "name": "Telford",
          "slug": "telford",
          "postcode": "TF3",
          "nearby_areas": [
            "Much Wenlock",
            "Wellington",
            "Broseley",
            "Newport",
            "Bridgnorth",
            "Shrewsbury",
            "Bilston"
          ]
        },
        {
          "name": "Oswestry",
          "slug": "oswestry",
          "postcode": "SY11",
          "nearby_areas": [
            "Rogerstone",
            "Ellesmere",
            "Whitchurch",
            "Wrexham",
            "Shrewsbury",
            "Welshpool",
            "Church Stretton"
          ]
        },
        {
          "name": "Ludlow",
          "slug": "ludlow",
          "postcode": "SY8",
          "nearby_areas": [
            "Leominster",
            "Craven Arms",
            "Church Stretton",
            "Bridgnorth",
            "Pembridge",
            "Bewdley",
            "Broseley"
          ]
        },
        {
          "name": "Bridgnorth",
          "slug": "bridgnorth",
          "postcode": "WV16",
          "nearby_areas": [
            "Broseley",
            "Bilston",
            "Telford",
            "Much Wenlock",
            "Cleobury Mortimer",
            "Kingswinford",
            "Wellington"
          ]
        },
        {
          "name": "Market Drayton",
          "slug": "market-drayton",
          "postcode": "TF9",
          "nearby_areas": [
            "Newport",
            "Wellington",
            "Nantwich",
            "Much Wenlock",
            "Telford",
            "Stoke-on-Trent",
            "Crewe"
          ]
        },
        {
          "name": "Whitchurch",
          "slug": "whitchurch",
          "postcode": "SY13",
          "nearby_areas": [
            "Ellesmere",
            "Welshpool",
            "Newtown",
            "Rogerstone",
            "Church Stretton",
            "Craven Arms",
            "Machynlleth"
          ]
        },
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "TF10",
          "nearby_areas": [
            "Wellington",
            "Much Wenlock",
            "Telford",
            "Market Drayton",
            "Broseley",
            "Shrewsbury",
            "Bridgnorth"
          ]
        },
        {
          "name": "Wellington",
          "slug": "wellington",
          "postcode": "TF1",
          "nearby_areas": [
            "Much Wenlock",
            "Telford",
            "Newport",
            "Broseley",
            "Shrewsbury",
            "Bridgnorth",
            "Market Drayton"
          ]
        },
        {
          "name": "Ellesmere",
          "slug": "ellesmere",
          "postcode": "SY12",
          "nearby_areas": [
            "Whitchurch",
            "Welshpool",
            "Rogerstone",
            "Newtown",
            "Church Stretton",
            "Craven Arms",
            "Oswestry"
          ]
        },
        {
          "name": "Church Stretton",
          "slug": "church-stretton",
          "postcode": "SY6",
          "nearby_areas": [
            "Craven Arms",
            "Whitchurch",
            "Ellesmere",
            "Shrewsbury",
            "Welshpool",
            "Newtown",
            "Ludlow"
          ]
        },
        {
          "name": "Much Wenlock",
          "slug": "much-wenlock",
          "postcode": "TF13",
          "nearby_areas": [
            "Wellington",
            "Telford",
            "Newport",
            "Broseley",
            "Bridgnorth",
            "Shrewsbury",
            "Market Drayton"
          ]
        },
        {
          "name": "Cleobury Mortimer",
          "slug": "cleobury-mortimer",
          "postcode": "DY14",
          "nearby_areas": [
            "Kidderminster",
            "Bewdley",
            "Stourport-on-Severn",
            "Dudley",
            "Stourbridge",
            "Kingswinford",
            "Brierley Hill"
          ]
        },
        {
          "name": "Craven Arms",
          "slug": "craven-arms",
          "postcode": "SY7",
          "nearby_areas": [
            "Church Stretton",
            "Whitchurch",
            "Ellesmere",
            "Shrewsbury",
            "Ludlow",
            "Welshpool",
            "Newtown"
          ]
        },
        {
          "name": "Broseley",
          "slug": "broseley",
          "postcode": "TF12",
          "nearby_areas": [
            "Telford",
            "Much Wenlock",
            "Bridgnorth",
            "Wellington",
            "Newport",
            "Bilston",
            "Shrewsbury"
          ]
        }
      ]
    },
    {
      "name": "Somerset",
      "slug": "somerset",
      "region": "South West England",
      "council_name": "Somerset Council",
      "council_url": "https://www.somerset.gov.uk/",
      "climate": "mild, damp winters with coastal exposure",
      "population": "980,000",
      "towns": [
        {
          "name": "Bath",
          "slug": "bath",
          "postcode": "BA1",
          "nearby_areas": [
            "Bradford-on-Avon",
            "Radstock",
            "Trowbridge",
            "Corsham",
            "Frome",
            "Westbury",
            "Melksham"
          ]
        },
        {
          "name": "Weston-super-Mare",
          "slug": "weston-super-mare",
          "postcode": "BS23",
          "nearby_areas": [
            "Keynsham",
            "Portishead",
            "Filton",
            "Thornbury",
            "Nailsea",
            "Yate",
            "Fishponds"
          ]
        },
        {
          "name": "Taunton",
          "slug": "taunton",
          "postcode": "TA1",
          "nearby_areas": [
            "Bridgwater",
            "Chard",
            "Burnham-on-Sea",
            "Crewkerne",
            "Honiton",
            "Glastonbury",
            "Tiverton"
          ]
        },
        {
          "name": "Yeovil",
          "slug": "yeovil",
          "postcode": "BA20",
          "nearby_areas": [
            "Sherborne",
            "Crewkerne",
            "Lyme Regis",
            "Glastonbury",
            "Chard",
            "Dorchester",
            "Bridport"
          ]
        },
        {
          "name": "Bridgwater",
          "slug": "bridgwater",
          "postcode": "TA6",
          "nearby_areas": [
            "Burnham-on-Sea",
            "Taunton",
            "Glastonbury",
            "Weston-super-Mare",
            "Wells",
            "Chard",
            "Crewkerne"
          ]
        },
        {
          "name": "Frome",
          "slug": "frome",
          "postcode": "BA11",
          "nearby_areas": [
            "Westbury",
            "Radstock",
            "Warminster",
            "Trowbridge",
            "Bradford-on-Avon",
            "Shepton Mallet",
            "Bath"
          ]
        },
        {
          "name": "Wells",
          "slug": "wells",
          "postcode": "BA5",
          "nearby_areas": [
            "Shepton Mallet",
            "Glastonbury",
            "Radstock",
            "Frome",
            "Burnham-on-Sea",
            "Westbury",
            "Nailsea"
          ]
        },
        {
          "name": "Burnham-on-Sea",
          "slug": "burnham-on-sea",
          "postcode": "TA8",
          "nearby_areas": [
            "Bridgwater",
            "Weston-super-Mare",
            "Keynsham",
            "Portishead",
            "Nailsea",
            "Glastonbury",
            "Filton"
          ]
        },
        {
          "name": "Chard",
          "slug": "chard",
          "postcode": "TA20",
          "nearby_areas": [
            "Crewkerne",
            "Taunton",
            "Honiton",
            "Bridport",
            "Yeovil",
            "Bridgwater",
            "Sidmouth"
          ]
        },
        {
          "name": "Minehead",
          "slug": "minehead",
          "postcode": "TA24",
          "nearby_areas": [
            "Llantwit Major",
            "Taunton",
            "Burnham-on-Sea",
            "Bridgwater",
            "Tiverton",
            "Weston-super-Mare",
            "Barry"
          ]
        },
        {
          "name": "Glastonbury",
          "slug": "glastonbury",
          "postcode": "BA6",
          "nearby_areas": [
            "Wells",
            "Shepton Mallet",
            "Bridgwater",
            "Burnham-on-Sea",
            "Yeovil",
            "Radstock",
            "Frome"
          ]
        },
        {
          "name": "Shepton Mallet",
          "slug": "shepton-mallet",
          "postcode": "BA4",
          "nearby_areas": [
            "Wells",
            "Glastonbury",
            "Radstock",
            "Frome",
            "Westbury",
            "Bath",
            "Yeovil"
          ]
        },
        {
          "name": "Radstock",
          "slug": "radstock",
          "postcode": "BA3",
          "nearby_areas": [
            "Frome",
            "Westbury",
            "Bath",
            "Shepton Mallet",
            "Wells",
            "Bradford-on-Avon",
            "Trowbridge"
          ]
        },
        {
          "name": "Nailsea",
          "slug": "nailsea",
          "postcode": "BS48",
          "nearby_areas": [
            "Fishponds",
            "Kingswood",
            "Yate",
            "Thornbury",
            "Filton",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Portishead",
          "slug": "portishead",
          "postcode": "BS20",
          "nearby_areas": [
            "Keynsham",
            "Filton",
            "Thornbury",
            "Yate",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Clevedon",
          "slug": "clevedon",
          "postcode": "BS21",
          "nearby_areas": [
            "Portishead",
            "Kingswood",
            "Fishponds",
            "Nailsea",
            "Yate",
            "Thornbury",
            "Keynsham"
          ]
        },
        {
          "name": "Keynsham",
          "slug": "keynsham",
          "postcode": "BS31",
          "nearby_areas": [
            "Filton",
            "Thornbury",
            "Yate",
            "Portishead",
            "Nailsea",
            "Fishponds",
            "Kingswood"
          ]
        },
        {
          "name": "Crewkerne",
          "slug": "crewkerne",
          "postcode": "TA18",
          "nearby_areas": [
            "Chard",
            "Yeovil",
            "Bridport",
            "Sherborne",
            "Lyme Regis",
            "Taunton",
            "Dorchester"
          ]
        }
      ]
    },
    {
      "name": "South Ayrshire",
      "slug": "south-ayrshire",
      "region": "Scotland",
      "council_name": "South Ayrshire Council",
      "council_url": "https://www.south-ayrshire.gov.uk/",
      "climate": "wet, mild west coast climate",
      "population": "112,000",
      "towns": [
        {
          "name": "Ayr",
          "slug": "ayr",
          "postcode": "KA7",
          "nearby_areas": [
            "Maybole",
            "Dalmellington",
            "Troon",
            "Prestwick",
            "Mauchline",
            "Auchinleck",
            "Stevenston"
          ]
        },
        {
          "name": "Prestwick",
          "slug": "prestwick",
          "postcode": "KA9",
          "nearby_areas": [
            "Stevenston",
            "Troon",
            "Mauchline",
            "Dalmellington",
            "Ardrossan",
            "Stewarton",
            "Maybole"
          ]
        },
        {
          "name": "Troon",
          "slug": "troon",
          "postcode": "KA10",
          "nearby_areas": [
            "Prestwick",
            "Stevenston",
            "Ardrossan",
            "Dalmellington",
            "Mauchline",
            "Stewarton",
            "Maybole"
          ]
        },
        {
          "name": "Girvan",
          "slug": "girvan",
          "postcode": "KA26",
          "nearby_areas": [
            "Ayr",
            "Troon",
            "Prestwick",
            "Maybole",
            "Dalmellington",
            "Ardrossan",
            "Mauchline"
          ]
        },
        {
          "name": "Maybole",
          "slug": "maybole",
          "postcode": "KA19",
          "nearby_areas": [
            "Mauchline",
            "Stewarton",
            "Dalmellington",
            "Prestwick",
            "Stevenston",
            "Troon",
            "Auchinleck"
          ]
        }
      ]
    },
    {
      "name": "South Lanarkshire",
      "slug": "south-lanarkshire",
      "region": "Scotland",
      "council_name": "South Lanarkshire Council",
      "council_url": "https://www.southlanarkshire.gov.uk/",
      "climate": "cool, wet central belt and upland climate",
      "population": "320,000",
      "towns": [
        {
          "name": "Hamilton",
          "slug": "hamilton",
          "postcode": "ML3",
          "nearby_areas": [
            "Wishaw",
            "Motherwell",
            "Bellshill",
            "Larkhall",
            "Coatbridge",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "East Kilbride",
          "slug": "east-kilbride",
          "postcode": "G74",
          "nearby_areas": [
            "Rutherglen",
            "Clydebank",
            "Clarkston",
            "Eaglesham",
            "Cambuslang",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Rutherglen",
          "slug": "rutherglen",
          "postcode": "G73",
          "nearby_areas": [
            "East Kilbride",
            "Cambuslang",
            "Clydebank",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Cambuslang",
          "slug": "cambuslang",
          "postcode": "G72",
          "nearby_areas": [
            "Rutherglen",
            "Clydebank",
            "East Kilbride",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Lanark",
          "slug": "lanark",
          "postcode": "ML11",
          "nearby_areas": [
            "Biggar",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell",
            "Wishaw"
          ]
        },
        {
          "name": "Carluke",
          "slug": "carluke",
          "postcode": "ML8",
          "nearby_areas": [
            "Lanark",
            "Biggar",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell"
          ]
        },
        {
          "name": "Larkhall",
          "slug": "larkhall",
          "postcode": "ML9",
          "nearby_areas": [
            "Bellshill",
            "Motherwell",
            "Coatbridge",
            "Wishaw",
            "Biggar",
            "Lanark",
            "Airdrie"
          ]
        },
        {
          "name": "Biggar",
          "slug": "biggar",
          "postcode": "ML12",
          "nearby_areas": [
            "Lanark",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell",
            "Wishaw"
          ]
        }
      ]
    },
    {
      "name": "South Yorkshire",
      "slug": "south-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "South Yorkshire Council",
      "council_url": "https://www.southyorkshire.gov.uk/",
      "climate": "cool, wet winters and upland rain",
      "population": "1.4 million",
      "towns": [
        {
          "name": "Sheffield",
          "slug": "sheffield",
          "postcode": "S1",
          "nearby_areas": [
            "Dinnington",
            "Penistone",
            "Stocksbridge",
            "Bolsover",
            "Rotherham",
            "Hoyland",
            "Wombwell"
          ]
        },
        {
          "name": "Doncaster",
          "slug": "doncaster",
          "postcode": "DN1",
          "nearby_areas": [
            "Mexborough",
            "Wath upon Dearne",
            "Maltby",
            "Hoyland",
            "Wombwell",
            "Rotherham",
            "Barnsley"
          ]
        },
        {
          "name": "Rotherham",
          "slug": "rotherham",
          "postcode": "S60",
          "nearby_areas": [
            "Hoyland",
            "Wombwell",
            "Wath upon Dearne",
            "Maltby",
            "Dinnington",
            "Mexborough",
            "Sheffield"
          ]
        },
        {
          "name": "Barnsley",
          "slug": "barnsley",
          "postcode": "S70",
          "nearby_areas": [
            "Maltby",
            "Wombwell",
            "Wath upon Dearne",
            "Mexborough",
            "Rotherham",
            "Hoyland",
            "Wakefield"
          ]
        },
        {
          "name": "Mexborough",
          "slug": "mexborough",
          "postcode": "S64",
          "nearby_areas": [
            "Wath upon Dearne",
            "Maltby",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Doncaster",
            "Barnsley"
          ]
        },
        {
          "name": "Wombwell",
          "slug": "wombwell",
          "postcode": "S73",
          "nearby_areas": [
            "Maltby",
            "Wath upon Dearne",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Penistone",
          "slug": "penistone",
          "postcode": "S36",
          "nearby_areas": [
            "Stocksbridge",
            "Bolsover",
            "Dinnington",
            "Sheffield",
            "Rotherham",
            "Chesterfield",
            "Hoyland"
          ]
        },
        {
          "name": "Maltby",
          "slug": "maltby",
          "postcode": "S66",
          "nearby_areas": [
            "Wath upon Dearne",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Dinnington",
          "slug": "dinnington",
          "postcode": "S25",
          "nearby_areas": [
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Sheffield",
            "Rotherham",
            "Hoyland",
            "Wombwell"
          ]
        },
        {
          "name": "Stocksbridge",
          "slug": "stocksbridge",
          "postcode": "S36",
          "nearby_areas": [
            "Penistone",
            "Bolsover",
            "Dinnington",
            "Sheffield",
            "Rotherham",
            "Chesterfield",
            "Hoyland"
          ]
        },
        {
          "name": "Hoyland",
          "slug": "hoyland",
          "postcode": "S74",
          "nearby_areas": [
            "Wombwell",
            "Rotherham",
            "Wath upon Dearne",
            "Maltby",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Thorne",
          "slug": "thorne",
          "postcode": "DN8",
          "nearby_areas": [
            "Conisbrough",
            "Scunthorpe",
            "Howden",
            "Snaith",
            "Brigg",
            "Gainsborough",
            "Goole"
          ]
        },
        {
          "name": "Wath upon Dearne",
          "slug": "wath-upon-dearne",
          "postcode": "S63",
          "nearby_areas": [
            "Maltby",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Conisbrough",
          "slug": "conisbrough",
          "postcode": "DN12",
          "nearby_areas": [
            "Thorne",
            "Scunthorpe",
            "Howden",
            "Snaith",
            "Brigg",
            "Goole",
            "Gainsborough"
          ]
        }
      ]
    },
    {
      "name": "Staffordshire",
      "slug": "staffordshire",
      "region": "West Midlands",
      "council_name": "Staffordshire County Council",
      "council_url": "https://www.staffordshire.gov.uk/",
      "climate": "cool winters and steady rainfall",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Stoke-on-Trent",
          "slug": "stoke-on-trent",
          "postcode": "ST1",
          "nearby_areas": [
            "Newcastle-under-Lyme",
            "Biddulph",
            "Cheadle",
            "Penkridge",
            "Stone",
            "Leek",
            "Congleton"
          ]
        },
        {
          "name": "Stafford",
          "slug": "stafford",
          "postcode": "ST16",
          "nearby_areas": [
            "Rugeley",
            "Penkridge",
            "Cannock",
            "Stone",
            "Burntwood",
            "Biddulph",
            "Newcastle-under-Lyme"
          ]
        },
        {
          "name": "Burton upon Trent",
          "slug": "burton-upon-trent",
          "postcode": "DE14",
          "nearby_areas": [
            "Derby",
            "Ripley",
            "Bakewell",
            "Belper",
            "Heanor",
            "Ilkeston",
            "Ashbourne"
          ]
        },
        {
          "name": "Cannock",
          "slug": "cannock",
          "postcode": "WS11",
          "nearby_areas": [
            "Burntwood",
            "Rugeley",
            "Willenhall",
            "Walsall",
            "Lichfield",
            "Stafford",
            "Wolverhampton"
          ]
        },
        {
          "name": "Tamworth",
          "slug": "tamworth",
          "postcode": "B79",
          "nearby_areas": [
            "Lichfield",
            "Atherstone",
            "Polesworth",
            "Burntwood",
            "Rugeley",
            "Swadlincote",
            "Nuneaton"
          ]
        },
        {
          "name": "Lichfield",
          "slug": "lichfield",
          "postcode": "WS13",
          "nearby_areas": [
            "Burntwood",
            "Tamworth",
            "Rugeley",
            "Cannock",
            "Walsall",
            "Polesworth",
            "Willenhall"
          ]
        },
        {
          "name": "Leek",
          "slug": "leek",
          "postcode": "ST13",
          "nearby_areas": [
            "Cheadle",
            "Newcastle-under-Lyme",
            "Biddulph",
            "Stoke-on-Trent",
            "Congleton",
            "Stone",
            "Penkridge"
          ]
        },
        {
          "name": "Newcastle-under-Lyme",
          "slug": "newcastle-under-lyme",
          "postcode": "ST5",
          "nearby_areas": [
            "Biddulph",
            "Cheadle",
            "Penkridge",
            "Stone",
            "Stoke-on-Trent",
            "Leek",
            "Uttoxeter"
          ]
        },
        {
          "name": "Rugeley",
          "slug": "rugeley",
          "postcode": "WS15",
          "nearby_areas": [
            "Burntwood",
            "Cannock",
            "Lichfield",
            "Stafford",
            "Uttoxeter",
            "Stone",
            "Penkridge"
          ]
        },
        {
          "name": "Uttoxeter",
          "slug": "uttoxeter",
          "postcode": "ST14",
          "nearby_areas": [
            "Stone",
            "Penkridge",
            "Cheadle",
            "Biddulph",
            "Rugeley",
            "Newcastle-under-Lyme",
            "Ashbourne"
          ]
        },
        {
          "name": "Stone",
          "slug": "stone",
          "postcode": "ST15",
          "nearby_areas": [
            "Penkridge",
            "Cheadle",
            "Biddulph",
            "Newcastle-under-Lyme",
            "Uttoxeter",
            "Stafford",
            "Stoke-on-Trent"
          ]
        },
        {
          "name": "Burntwood",
          "slug": "burntwood",
          "postcode": "WS7",
          "nearby_areas": [
            "Cannock",
            "Lichfield",
            "Rugeley",
            "Walsall",
            "Willenhall",
            "Tamworth",
            "Wednesbury"
          ]
        },
        {
          "name": "Cheadle",
          "slug": "cheadle",
          "postcode": "ST10",
          "nearby_areas": [
            "Biddulph",
            "Newcastle-under-Lyme",
            "Stone",
            "Penkridge",
            "Stoke-on-Trent",
            "Uttoxeter",
            "Leek"
          ]
        },
        {
          "name": "Penkridge",
          "slug": "penkridge",
          "postcode": "ST19",
          "nearby_areas": [
            "Stone",
            "Biddulph",
            "Cheadle",
            "Newcastle-under-Lyme",
            "Uttoxeter",
            "Stafford",
            "Stoke-on-Trent"
          ]
        },
        {
          "name": "Biddulph",
          "slug": "biddulph",
          "postcode": "ST8",
          "nearby_areas": [
            "Cheadle",
            "Newcastle-under-Lyme",
            "Penkridge",
            "Stone",
            "Stoke-on-Trent",
            "Uttoxeter",
            "Leek"
          ]
        }
      ]
    },
    {
      "name": "Stirling",
      "slug": "stirling",
      "region": "Scotland",
      "council_name": "Stirling Council",
      "council_url": "https://www.stirling.gov.uk/",
      "climate": "cool, wet and upland influenced",
      "population": "95,000",
      "towns": [
        {
          "name": "Stirling",
          "slug": "stirling",
          "postcode": "FK8",
          "nearby_areas": [
            "Bridge of Allan",
            "Denny",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Larbert",
            "Stenhousemuir"
          ]
        },
        {
          "name": "Bridge of Allan",
          "slug": "bridge-of-allan",
          "postcode": "FK9",
          "nearby_areas": [
            "Alloa",
            "Clackmannan",
            "Denny",
            "Larbert",
            "Stenhousemuir",
            "Stirling",
            "Callander"
          ]
        },
        {
          "name": "Dunblane",
          "slug": "dunblane",
          "postcode": "FK15",
          "nearby_areas": [
            "Callander",
            "Stirling",
            "Dollar",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Alva"
          ]
        },
        {
          "name": "Callander",
          "slug": "callander",
          "postcode": "FK17",
          "nearby_areas": [
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Alva",
            "Bridge of Allan",
            "Stirling",
            "Denny"
          ]
        },
        {
          "name": "Balfron",
          "slug": "balfron",
          "postcode": "G63",
          "nearby_areas": [
            "Bishopbriggs",
            "Milngavie",
            "Kilsyth",
            "Bearsden",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        }
      ]
    },
    {
      "name": "Suffolk",
      "slug": "suffolk",
      "region": "East of England",
      "council_name": "Suffolk County Council",
      "council_url": "https://www.suffolk.gov.uk/",
      "climate": "dry eastern climate with coastal winds",
      "population": "760,000",
      "towns": [
        {
          "name": "Ipswich",
          "slug": "ipswich",
          "postcode": "IP1",
          "nearby_areas": [
            "Hadleigh",
            "Woodbridge",
            "Aldeburgh",
            "Saxmundham",
            "Felixstowe",
            "Stowmarket",
            "Harwich"
          ]
        },
        {
          "name": "Lowestoft",
          "slug": "lowestoft",
          "postcode": "NR32",
          "nearby_areas": [
            "Beccles",
            "Great Yarmouth",
            "Norwich",
            "Aylsham",
            "North Walsham",
            "Diss",
            "Holt"
          ]
        },
        {
          "name": "Bury St Edmunds",
          "slug": "bury-st-edmunds",
          "postcode": "IP33",
          "nearby_areas": [
            "Mildenhall",
            "Eye",
            "Stowmarket",
            "Newmarket",
            "Thetford",
            "Sudbury",
            "Haverhill"
          ]
        },
        {
          "name": "Felixstowe",
          "slug": "felixstowe",
          "postcode": "IP11",
          "nearby_areas": [
            "Harwich",
            "Woodbridge",
            "Ipswich",
            "Hadleigh",
            "Clacton-on-Sea",
            "Aldeburgh",
            "Halstead"
          ]
        },
        {
          "name": "Haverhill",
          "slug": "haverhill",
          "postcode": "CB9",
          "nearby_areas": [
            "Sawston",
            "Histon",
            "Saffron Walden",
            "Cambridge",
            "Newmarket",
            "Sudbury",
            "Soham"
          ]
        },
        {
          "name": "Stowmarket",
          "slug": "stowmarket",
          "postcode": "IP14",
          "nearby_areas": [
            "Saxmundham",
            "Aldeburgh",
            "Mildenhall",
            "Hadleigh",
            "Eye",
            "Ipswich",
            "Bury St Edmunds"
          ]
        },
        {
          "name": "Newmarket",
          "slug": "newmarket",
          "postcode": "CB8",
          "nearby_areas": [
            "Cambridge",
            "Soham",
            "Histon",
            "Sawston",
            "Haverhill",
            "Bury St Edmunds",
            "Ely"
          ]
        },
        {
          "name": "Sudbury",
          "slug": "sudbury",
          "postcode": "CO10",
          "nearby_areas": [
            "Halstead",
            "Haverhill",
            "Colchester",
            "Bury St Edmunds",
            "Braintree",
            "Stowmarket",
            "Ipswich"
          ]
        },
        {
          "name": "Woodbridge",
          "slug": "woodbridge",
          "postcode": "IP12",
          "nearby_areas": [
            "Hadleigh",
            "Ipswich",
            "Felixstowe",
            "Aldeburgh",
            "Harwich",
            "Saxmundham",
            "Stowmarket"
          ]
        },
        {
          "name": "Beccles",
          "slug": "beccles",
          "postcode": "NR34",
          "nearby_areas": [
            "Lowestoft",
            "Great Yarmouth",
            "Norwich",
            "Diss",
            "Aylsham",
            "Attleborough",
            "Eye"
          ]
        },
        {
          "name": "Saxmundham",
          "slug": "saxmundham",
          "postcode": "IP17",
          "nearby_areas": [
            "Aldeburgh",
            "Stowmarket",
            "Hadleigh",
            "Mildenhall",
            "Eye",
            "Ipswich",
            "Woodbridge"
          ]
        },
        {
          "name": "Aldeburgh",
          "slug": "aldeburgh",
          "postcode": "IP15",
          "nearby_areas": [
            "Saxmundham",
            "Hadleigh",
            "Stowmarket",
            "Ipswich",
            "Mildenhall",
            "Woodbridge",
            "Eye"
          ]
        },
        {
          "name": "Mildenhall",
          "slug": "mildenhall",
          "postcode": "IP28",
          "nearby_areas": [
            "Eye",
            "Stowmarket",
            "Saxmundham",
            "Aldeburgh",
            "Bury St Edmunds",
            "Diss",
            "Hadleigh"
          ]
        },
        {
          "name": "Hadleigh",
          "slug": "hadleigh",
          "postcode": "IP7",
          "nearby_areas": [
            "Aldeburgh",
            "Ipswich",
            "Saxmundham",
            "Woodbridge",
            "Stowmarket",
            "Felixstowe",
            "Mildenhall"
          ]
        },
        {
          "name": "Eye",
          "slug": "eye",
          "postcode": "IP23",
          "nearby_areas": [
            "Mildenhall",
            "Diss",
            "Stowmarket",
            "Saxmundham",
            "Aldeburgh",
            "Bury St Edmunds",
            "Thetford"
          ]
        }
      ]
    },
    {
      "name": "Surrey",
      "slug": "surrey",
      "region": "South East England",
      "council_name": "Surrey County Council",
      "council_url": "https://www.surreycc.gov.uk/",
      "climate": "mild and damp winters",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Guildford",
          "slug": "guildford",
          "postcode": "GU1",
          "nearby_areas": [
            "Godalming",
            "Woking",
            "Aldershot",
            "Farnborough",
            "Farnham",
            "Addlestone",
            "Dorking"
          ]
        },
        {
          "name": "Woking",
          "slug": "woking",
          "postcode": "GU21",
          "nearby_areas": [
            "Addlestone",
            "Guildford",
            "Weybridge",
            "Walton-on-Thames",
            "Egham",
            "Camberley",
            "Staines-upon-Thames"
          ]
        },
        {
          "name": "Redhill",
          "slug": "redhill",
          "postcode": "RH1",
          "nearby_areas": [
            "Reigate",
            "Dorking",
            "Crawley",
            "Leatherhead",
            "Ashtead",
            "Caterham",
            "Banstead"
          ]
        },
        {
          "name": "Reigate",
          "slug": "reigate",
          "postcode": "RH2",
          "nearby_areas": [
            "Redhill",
            "Dorking",
            "Banstead",
            "Caterham",
            "Ashtead",
            "Leatherhead",
            "Epsom"
          ]
        },
        {
          "name": "Epsom",
          "slug": "epsom",
          "postcode": "KT18",
          "nearby_areas": [
            "Ashtead",
            "Banstead",
            "Leatherhead",
            "Esher",
            "Kingston upon Thames",
            "Reigate",
            "Dorking"
          ]
        },
        {
          "name": "Camberley",
          "slug": "camberley",
          "postcode": "GU15",
          "nearby_areas": [
            "Crowthorne",
            "Farnborough",
            "Bracknell",
            "Ascot",
            "Fleet",
            "Wokingham",
            "Aldershot"
          ]
        },
        {
          "name": "Farnham",
          "slug": "farnham",
          "postcode": "GU9",
          "nearby_areas": [
            "Sandhurst",
            "Aldershot",
            "Fleet",
            "Farnborough",
            "Alton",
            "Godalming",
            "Camberley"
          ]
        },
        {
          "name": "Leatherhead",
          "slug": "leatherhead",
          "postcode": "KT22",
          "nearby_areas": [
            "Ashtead",
            "Epsom",
            "Dorking",
            "Esher",
            "Banstead",
            "Kingston upon Thames",
            "Reigate"
          ]
        },
        {
          "name": "Dorking",
          "slug": "dorking",
          "postcode": "RH4",
          "nearby_areas": [
            "Leatherhead",
            "Ashtead",
            "Reigate",
            "Redhill",
            "Epsom",
            "Banstead",
            "Esher"
          ]
        },
        {
          "name": "Staines-upon-Thames",
          "slug": "staines-upon-thames",
          "postcode": "TW18",
          "nearby_areas": [
            "Egham",
            "Addlestone",
            "Weybridge",
            "Walton-on-Thames",
            "Hounslow",
            "Windsor",
            "Slough"
          ]
        },
        {
          "name": "Walton-on-Thames",
          "slug": "walton-on-thames",
          "postcode": "KT12",
          "nearby_areas": [
            "Weybridge",
            "Esher",
            "Kingston upon Thames",
            "Addlestone",
            "Staines-upon-Thames",
            "Hounslow",
            "Egham"
          ]
        },
        {
          "name": "Esher",
          "slug": "esher",
          "postcode": "KT10",
          "nearby_areas": [
            "Kingston upon Thames",
            "Walton-on-Thames",
            "Weybridge",
            "Epsom",
            "Ashtead",
            "Leatherhead",
            "Addlestone"
          ]
        },
        {
          "name": "Weybridge",
          "slug": "weybridge",
          "postcode": "KT13",
          "nearby_areas": [
            "Addlestone",
            "Walton-on-Thames",
            "Esher",
            "Kingston upon Thames",
            "Staines-upon-Thames",
            "Egham",
            "Woking"
          ]
        },
        {
          "name": "Godalming",
          "slug": "godalming",
          "postcode": "GU7",
          "nearby_areas": [
            "Guildford",
            "Haslemere",
            "Sandhurst",
            "Farnham",
            "Aldershot",
            "Petworth",
            "Woking"
          ]
        },
        {
          "name": "Egham",
          "slug": "egham",
          "postcode": "TW20",
          "nearby_areas": [
            "Staines-upon-Thames",
            "Windsor",
            "Addlestone",
            "Weybridge",
            "Ascot",
            "Walton-on-Thames",
            "Slough"
          ]
        },
        {
          "name": "Addlestone",
          "slug": "addlestone",
          "postcode": "KT15",
          "nearby_areas": [
            "Weybridge",
            "Walton-on-Thames",
            "Staines-upon-Thames",
            "Woking",
            "Egham",
            "Esher",
            "Kingston upon Thames"
          ]
        },
        {
          "name": "Caterham",
          "slug": "caterham",
          "postcode": "CR3",
          "nearby_areas": [
            "Croydon",
            "Banstead",
            "Reigate",
            "Epsom",
            "Redhill",
            "Ashtead",
            "Leatherhead"
          ]
        },
        {
          "name": "Haslemere",
          "slug": "haslemere",
          "postcode": "GU27",
          "nearby_areas": [
            "Petworth",
            "Alton",
            "Godalming",
            "Midhurst",
            "Sandhurst",
            "Farnham",
            "Guildford"
          ]
        },
        {
          "name": "Ashtead",
          "slug": "ashtead",
          "postcode": "KT21",
          "nearby_areas": [
            "Leatherhead",
            "Epsom",
            "Banstead",
            "Esher",
            "Dorking",
            "Kingston upon Thames",
            "Reigate"
          ]
        },
        {
          "name": "Banstead",
          "slug": "banstead",
          "postcode": "SM7",
          "nearby_areas": [
            "Epsom",
            "Ashtead",
            "Leatherhead",
            "Reigate",
            "Caterham",
            "Croydon",
            "Esher"
          ]
        }
      ]
    },
    {
      "name": "Swansea",
      "slug": "swansea",
      "region": "Wales",
      "council_name": "Swansea Council",
      "council_url": "https://www.swansea.gov.uk/",
      "climate": "mild, wet and coastal",
      "population": "245,000",
      "towns": [
        {
          "name": "Swansea",
          "slug": "swansea",
          "postcode": "SA1",
          "nearby_areas": [
            "Briton Ferry",
            "Glynneath",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Mumbles",
          "slug": "mumbles",
          "postcode": "SA3",
          "nearby_areas": [
            "Gorseinon",
            "Pontarddulais",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Gorseinon",
          "slug": "gorseinon",
          "postcode": "SA4",
          "nearby_areas": [
            "Pontarddulais",
            "Mumbles",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Morriston",
          "slug": "morriston",
          "postcode": "SA6",
          "nearby_areas": [
            "Clydach",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Pontarddulais",
          "slug": "pontarddulais",
          "postcode": "SA4",
          "nearby_areas": [
            "Gorseinon",
            "Mumbles",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Clydach",
          "slug": "clydach",
          "postcode": "SA6",
          "nearby_areas": [
            "Morriston",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        }
      ]
    },
    {
      "name": "Torfaen",
      "slug": "torfaen",
      "region": "Wales",
      "council_name": "Torfaen County Borough Council",
      "council_url": "https://www.torfaen.gov.uk/",
      "climate": "wet valleys climate",
      "population": "92,000",
      "towns": [
        {
          "name": "Cwmbran",
          "slug": "cwmbran",
          "postcode": "NP44",
          "nearby_areas": [
            "Caerleon",
            "Langstone",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        },
        {
          "name": "Pontypool",
          "slug": "pontypool",
          "postcode": "NP4",
          "nearby_areas": [
            "Abersychan",
            "Abertillery",
            "Blackwood",
            "Abergavenny",
            "Ebbw Vale",
            "Tredegar",
            "Caerphilly"
          ]
        },
        {
          "name": "Blaenavon",
          "slug": "blaenavon",
          "postcode": "NP4",
          "nearby_areas": [
            "New Inn",
            "Brynmawr",
            "Nantyglo",
            "Malpas",
            "Newport",
            "Abergavenny",
            "Cwmbran"
          ]
        },
        {
          "name": "Abersychan",
          "slug": "abersychan",
          "postcode": "NP4",
          "nearby_areas": [
            "Pontypool",
            "Abertillery",
            "Abergavenny",
            "Blackwood",
            "Ebbw Vale",
            "Tredegar",
            "Brynmawr"
          ]
        },
        {
          "name": "New Inn",
          "slug": "new-inn",
          "postcode": "NP4",
          "nearby_areas": [
            "Blaenavon",
            "Brynmawr",
            "Nantyglo",
            "Malpas",
            "Newport",
            "Abergavenny",
            "Cwmbran"
          ]
        }
      ]
    },
    {
      "name": "Tyne and Wear",
      "slug": "tyne-and-wear",
      "region": "North East England",
      "council_name": "Tyne and Wear Council",
      "council_url": "https://www.tyneandwear.gov.uk/",
      "climate": "cool, coastal and windy",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Newcastle upon Tyne",
          "slug": "newcastle-upon-tyne",
          "postcode": "NE1",
          "nearby_areas": [
            "Gateshead",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Hebburn",
            "Jarrow",
            "Blaydon"
          ]
        },
        {
          "name": "Sunderland",
          "slug": "sunderland",
          "postcode": "SR1",
          "nearby_areas": [
            "Washington",
            "Seaham",
            "Jarrow",
            "South Shields",
            "Hebburn",
            "Wallsend",
            "Tynemouth"
          ]
        },
        {
          "name": "Gateshead",
          "slug": "gateshead",
          "postcode": "NE8",
          "nearby_areas": [
            "Newcastle upon Tyne",
            "Hebburn",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Washington",
            "Jarrow"
          ]
        },
        {
          "name": "South Shields",
          "slug": "south-shields",
          "postcode": "NE33",
          "nearby_areas": [
            "Jarrow",
            "Whitley Bay",
            "Hebburn",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Sunderland"
          ]
        },
        {
          "name": "North Shields",
          "slug": "north-shields",
          "postcode": "NE29",
          "nearby_areas": [
            "Tynemouth",
            "Wallsend",
            "Hebburn",
            "Blyth",
            "Jarrow",
            "Ponteland",
            "Blaydon"
          ]
        },
        {
          "name": "Tynemouth",
          "slug": "tynemouth",
          "postcode": "NE30",
          "nearby_areas": [
            "North Shields",
            "Wallsend",
            "Hebburn",
            "Jarrow",
            "Blyth",
            "Newcastle upon Tyne",
            "Ponteland"
          ]
        },
        {
          "name": "Washington",
          "slug": "washington",
          "postcode": "NE37",
          "nearby_areas": [
            "Hebburn",
            "Gateshead",
            "Sunderland",
            "Jarrow",
            "Wallsend",
            "Newcastle upon Tyne",
            "Tynemouth"
          ]
        },
        {
          "name": "Wallsend",
          "slug": "wallsend",
          "postcode": "NE28",
          "nearby_areas": [
            "Tynemouth",
            "Hebburn",
            "North Shields",
            "Jarrow",
            "Newcastle upon Tyne",
            "South Shields",
            "Gateshead"
          ]
        },
        {
          "name": "Whitley Bay",
          "slug": "whitley-bay",
          "postcode": "NE26",
          "nearby_areas": [
            "South Shields",
            "North Shields",
            "Jarrow",
            "Tynemouth",
            "Wallsend",
            "Blyth",
            "Blaydon"
          ]
        },
        {
          "name": "Jarrow",
          "slug": "jarrow",
          "postcode": "NE32",
          "nearby_areas": [
            "Hebburn",
            "Wallsend",
            "South Shields",
            "Tynemouth",
            "North Shields",
            "Whitley Bay",
            "Newcastle upon Tyne"
          ]
        },
        {
          "name": "Blaydon",
          "slug": "blaydon",
          "postcode": "NE21",
          "nearby_areas": [
            "Ponteland",
            "Blyth",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Whitley Bay"
          ]
        },
        {
          "name": "Hebburn",
          "slug": "hebburn",
          "postcode": "NE31",
          "nearby_areas": [
            "Jarrow",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "South Shields",
            "Newcastle upon Tyne",
            "Gateshead"
          ]
        },
        {
          "name": "Houghton-le-Spring",
          "slug": "houghton-le-spring",
          "postcode": "DH4",
          "nearby_areas": [
            "Chester-le-Street",
            "Stanley",
            "Durham",
            "Consett",
            "Crook",
            "Washington",
            "Spennymoor"
          ]
        }
      ]
    },
    {
      "name": "Vale of Glamorgan",
      "slug": "vale-of-glamorgan",
      "region": "Wales",
      "council_name": "Vale of Glamorgan Council",
      "council_url": "https://www.valeofglamorgan.gov.uk/",
      "climate": "mild coastal climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Barry",
          "slug": "barry",
          "postcode": "CF62",
          "nearby_areas": [
            "Rhoose",
            "Cowbridge",
            "Llantrisant",
            "Dinas Powys",
            "Canton",
            "Llandaff",
            "Whitchurch"
          ]
        },
        {
          "name": "Penarth",
          "slug": "penarth",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Dinas Powys",
            "Barry",
            "Rhoose",
            "Cowbridge",
            "Caerphilly",
            "Llantrisant"
          ]
        },
        {
          "name": "Cowbridge",
          "slug": "cowbridge",
          "postcode": "CF71",
          "nearby_areas": [
            "Llantrisant",
            "Canton",
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Bargoed",
            "Radyr"
          ]
        },
        {
          "name": "Llantwit Major",
          "slug": "llantwit-major",
          "postcode": "CF61",
          "nearby_areas": [
            "Barry",
            "Rhoose",
            "Bridgend",
            "Cowbridge",
            "Dinas Powys",
            "Porthcawl",
            "Llantrisant"
          ]
        },
        {
          "name": "Dinas Powys",
          "slug": "dinas-powys",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Penarth",
            "Barry",
            "Rhoose",
            "Cowbridge",
            "Llantrisant",
            "Ystrad Mynach"
          ]
        },
        {
          "name": "Rhoose",
          "slug": "rhoose",
          "postcode": "CF62",
          "nearby_areas": [
            "Barry",
            "Cowbridge",
            "Llantrisant",
            "Dinas Powys",
            "Canton",
            "Llandaff",
            "Whitchurch"
          ]
        }
      ]
    },
    {
      "name": "Warwickshire",
      "slug": "warwickshire",
      "region": "West Midlands",
      "council_name": "Warwickshire County Council",
      "council_url": "https://www.warwickshire.gov.uk/",
      "climate": "mild inland climate with winter damp",
      "population": "600,000",
      "towns": [
        {
          "name": "Warwick",
          "slug": "warwick",
          "postcode": "CV34",
          "nearby_areas": [
            "Southam",
            "Leamington Spa",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Solihull"
          ]
        },
        {
          "name": "Nuneaton",
          "slug": "nuneaton",
          "postcode": "CV11",
          "nearby_areas": [
            "Bedworth",
            "Atherstone",
            "Hinckley",
            "Coventry",
            "Kenilworth",
            "Rugby",
            "Tamworth"
          ]
        },
        {
          "name": "Rugby",
          "slug": "rugby",
          "postcode": "CV21",
          "nearby_areas": [
            "Lutterworth",
            "Daventry",
            "Bedworth",
            "Coventry",
            "Kenilworth",
            "Nuneaton",
            "Southam"
          ]
        },
        {
          "name": "Leamington Spa",
          "slug": "leamington-spa",
          "postcode": "CV32",
          "nearby_areas": [
            "Southam",
            "Warwick",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Shipston-on-Stour"
          ]
        },
        {
          "name": "Stratford-upon-Avon",
          "slug": "stratford-upon-avon",
          "postcode": "CV37",
          "nearby_areas": [
            "Alcester",
            "Leamington Spa",
            "Warwick",
            "Southam",
            "Shipston-on-Stour",
            "Kenilworth",
            "Evesham"
          ]
        },
        {
          "name": "Bedworth",
          "slug": "bedworth",
          "postcode": "CV12",
          "nearby_areas": [
            "Nuneaton",
            "Coventry",
            "Hinckley",
            "Atherstone",
            "Kenilworth",
            "Rugby",
            "Lutterworth"
          ]
        },
        {
          "name": "Atherstone",
          "slug": "atherstone",
          "postcode": "CV9",
          "nearby_areas": [
            "Nuneaton",
            "Bedworth",
            "Tamworth",
            "Hinckley",
            "Polesworth",
            "Coventry",
            "Ashby-de-la-Zouch"
          ]
        },
        {
          "name": "Kenilworth",
          "slug": "kenilworth",
          "postcode": "CV8",
          "nearby_areas": [
            "Southam",
            "Warwick",
            "Coventry",
            "Leamington Spa",
            "Bedworth",
            "Solihull",
            "Stratford-upon-Avon"
          ]
        },
        {
          "name": "Alcester",
          "slug": "alcester",
          "postcode": "B49",
          "nearby_areas": [
            "Stratford-upon-Avon",
            "Redditch",
            "Coleshill",
            "Evesham",
            "Broadway",
            "Colwall",
            "Malvern"
          ]
        },
        {
          "name": "Shipston-on-Stour",
          "slug": "shipston-on-stour",
          "postcode": "CV36",
          "nearby_areas": [
            "Moreton-in-Marsh",
            "Stratford-upon-Avon",
            "Chipping Norton",
            "Leamington Spa",
            "Alcester",
            "Banbury",
            "Warwick"
          ]
        },
        {
          "name": "Southam",
          "slug": "southam",
          "postcode": "CV47",
          "nearby_areas": [
            "Warwick",
            "Leamington Spa",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Solihull"
          ]
        },
        {
          "name": "Coleshill",
          "slug": "coleshill",
          "postcode": "B46",
          "nearby_areas": [
            "Redditch",
            "Bromsgrove",
            "Solihull",
            "Alcester",
            "Oldbury",
            "Halesowen",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Polesworth",
          "slug": "polesworth",
          "postcode": "B78",
          "nearby_areas": [
            "Birmingham",
            "Sutton Coldfield",
            "Smethwick",
            "West Bromwich",
            "Oldbury",
            "Walsall",
            "Wednesbury"
          ]
        }
      ]
    },
    {
      "name": "West Dunbartonshire",
      "slug": "west-dunbartonshire",
      "region": "Scotland",
      "council_name": "West Dunbartonshire Council",
      "council_url": "https://www.west-dunbarton.gov.uk/",
      "climate": "wet west central climate",
      "population": "88,000",
      "towns": [
        {
          "name": "Clydebank",
          "slug": "clydebank",
          "postcode": "G81",
          "nearby_areas": [
            "Rutherglen",
            "Cambuslang",
            "East Kilbride",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Dumbarton",
          "slug": "dumbarton",
          "postcode": "G82",
          "nearby_areas": [
            "Govan",
            "Renfrew",
            "Linwood",
            "Johnstone",
            "Bearsden",
            "Milngavie",
            "Balfron"
          ]
        },
        {
          "name": "Alexandria",
          "slug": "alexandria",
          "postcode": "G83",
          "nearby_areas": [
            "Balloch",
            "Barrhead",
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "Clydebank",
            "East Kilbride"
          ]
        },
        {
          "name": "Balloch",
          "slug": "balloch",
          "postcode": "G83",
          "nearby_areas": [
            "Alexandria",
            "Barrhead",
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "Clydebank",
            "East Kilbride"
          ]
        }
      ]
    },
    {
      "name": "West Lothian",
      "slug": "west-lothian",
      "region": "Scotland",
      "council_name": "West Lothian Council",
      "council_url": "https://www.westlothian.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "185,000",
      "towns": [
        {
          "name": "Livingston",
          "slug": "livingston",
          "postcode": "EH54",
          "nearby_areas": [
            "Broxburn",
            "Armadale",
            "Bathgate",
            "Newbridge",
            "Linlithgow",
            "Bo'ness",
            "Whitburn"
          ]
        },
        {
          "name": "Bathgate",
          "slug": "bathgate",
          "postcode": "EH48",
          "nearby_areas": [
            "Livingston",
            "Linlithgow",
            "Broxburn",
            "Armadale",
            "Falkirk",
            "Newbridge",
            "Bo'ness"
          ]
        },
        {
          "name": "Linlithgow",
          "slug": "linlithgow",
          "postcode": "EH49",
          "nearby_areas": [
            "Bathgate",
            "Broxburn",
            "Livingston",
            "Falkirk",
            "Armadale",
            "Newbridge",
            "Dunfermline"
          ]
        },
        {
          "name": "Broxburn",
          "slug": "broxburn",
          "postcode": "EH52",
          "nearby_areas": [
            "Newbridge",
            "Armadale",
            "Livingston",
            "Bo'ness",
            "Linlithgow",
            "Bathgate",
            "Whitburn"
          ]
        },
        {
          "name": "Whitburn",
          "slug": "whitburn",
          "postcode": "EH47",
          "nearby_areas": [
            "Bo'ness",
            "Armadale",
            "Penicuik",
            "Edinburgh",
            "Leith",
            "Newbridge",
            "Newington"
          ]
        },
        {
          "name": "Armadale",
          "slug": "armadale",
          "postcode": "EH48",
          "nearby_areas": [
            "Bo'ness",
            "Newbridge",
            "Broxburn",
            "Whitburn",
            "Livingston",
            "Linlithgow",
            "Edinburgh"
          ]
        }
      ]
    },
    {
      "name": "West Midlands",
      "slug": "west-midlands",
      "region": "West Midlands",
      "council_name": "West Midlands Combined Authority (area)",
      "council_url": "https://www.wmca.org.uk/",
      "climate": "urban climate with damp winters",
      "population": "2.9 million",
      "towns": [
        {
          "name": "Birmingham",
          "slug": "birmingham",
          "postcode": "B1",
          "nearby_areas": [
            "Sutton Coldfield",
            "Oldbury",
            "Smethwick",
            "Polesworth",
            "West Bromwich",
            "Solihull",
            "Wednesbury"
          ]
        },
        {
          "name": "Coventry",
          "slug": "coventry",
          "postcode": "CV1",
          "nearby_areas": [
            "Kenilworth",
            "Bedworth",
            "Nuneaton",
            "Southam",
            "Warwick",
            "Solihull",
            "Leamington Spa"
          ]
        },
        {
          "name": "Wolverhampton",
          "slug": "wolverhampton",
          "postcode": "WV1",
          "nearby_areas": [
            "Willenhall",
            "Bilston",
            "Tipton",
            "Wednesbury",
            "Walsall",
            "Kingswinford",
            "Brierley Hill"
          ]
        },
        {
          "name": "Dudley",
          "slug": "dudley",
          "postcode": "DY1",
          "nearby_areas": [
            "Stourbridge",
            "Brierley Hill",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "Cleobury Mortimer",
            "Bilston"
          ]
        },
        {
          "name": "Walsall",
          "slug": "walsall",
          "postcode": "WS1",
          "nearby_areas": [
            "Wednesbury",
            "Willenhall",
            "West Bromwich",
            "Tipton",
            "Wolverhampton",
            "Smethwick",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Solihull",
          "slug": "solihull",
          "postcode": "B91",
          "nearby_areas": [
            "Birmingham",
            "Sutton Coldfield",
            "Coleshill",
            "Oldbury",
            "Polesworth",
            "Smethwick",
            "Kenilworth"
          ]
        },
        {
          "name": "West Bromwich",
          "slug": "west-bromwich",
          "postcode": "B70",
          "nearby_areas": [
            "Smethwick",
            "Wednesbury",
            "Tipton",
            "Sutton Coldfield",
            "Oldbury",
            "Walsall",
            "Birmingham"
          ]
        },
        {
          "name": "Sutton Coldfield",
          "slug": "sutton-coldfield",
          "postcode": "B72",
          "nearby_areas": [
            "Oldbury",
            "Smethwick",
            "Birmingham",
            "West Bromwich",
            "Halesowen",
            "Wednesbury",
            "Tipton"
          ]
        },
        {
          "name": "Stourbridge",
          "slug": "stourbridge",
          "postcode": "DY8",
          "nearby_areas": [
            "Dudley",
            "Brierley Hill",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "Cleobury Mortimer",
            "Oldbury"
          ]
        },
        {
          "name": "Halesowen",
          "slug": "halesowen",
          "postcode": "B63",
          "nearby_areas": [
            "Brierley Hill",
            "Oldbury",
            "Stourbridge",
            "Smethwick",
            "Dudley",
            "Sutton Coldfield",
            "West Bromwich"
          ]
        },
        {
          "name": "Brierley Hill",
          "slug": "brierley-hill",
          "postcode": "DY5",
          "nearby_areas": [
            "Stourbridge",
            "Dudley",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "West Bromwich",
            "Smethwick"
          ]
        },
        {
          "name": "Smethwick",
          "slug": "smethwick",
          "postcode": "B66",
          "nearby_areas": [
            "Sutton Coldfield",
            "Oldbury",
            "West Bromwich",
            "Birmingham",
            "Wednesbury",
            "Halesowen",
            "Tipton"
          ]
        },
        {
          "name": "Oldbury",
          "slug": "oldbury",
          "postcode": "B68",
          "nearby_areas": [
            "Sutton Coldfield",
            "Smethwick",
            "Birmingham",
            "West Bromwich",
            "Halesowen",
            "Tipton",
            "Wednesbury"
          ]
        },
        {
          "name": "Tipton",
          "slug": "tipton",
          "postcode": "DY4",
          "nearby_areas": [
            "Wednesbury",
            "West Bromwich",
            "Willenhall",
            "Brierley Hill",
            "Wolverhampton",
            "Kingswinford",
            "Smethwick"
          ]
        },
        {
          "name": "Willenhall",
          "slug": "willenhall",
          "postcode": "WV12",
          "nearby_areas": [
            "Wednesbury",
            "Wolverhampton",
            "Walsall",
            "Tipton",
            "West Bromwich",
            "Bilston",
            "Smethwick"
          ]
        },
        {
          "name": "Bilston",
          "slug": "bilston",
          "postcode": "WV14",
          "nearby_areas": [
            "Wolverhampton",
            "Kingswinford",
            "Tipton",
            "Brierley Hill",
            "Willenhall",
            "Dudley",
            "Stourbridge"
          ]
        },
        {
          "name": "Kingswinford",
          "slug": "kingswinford",
          "postcode": "DY6",
          "nearby_areas": [
            "Brierley Hill",
            "Dudley",
            "Stourbridge",
            "Tipton",
            "Bilston",
            "Halesowen",
            "Wolverhampton"
          ]
        },
        {
          "name": "Wednesbury",
          "slug": "wednesbury",
          "postcode": "WS10",
          "nearby_areas": [
            "Tipton",
            "West Bromwich",
            "Willenhall",
            "Walsall",
            "Smethwick",
            "Wolverhampton",
            "Sutton Coldfield"
          ]
        }
      ]
    },
    {
      "name": "West Sussex",
      "slug": "west-sussex",
      "region": "South East England",
      "council_name": "West Sussex County Council",
      "council_url": "https://www.westsussex.gov.uk/",
      "climate": "mild coastal conditions and damp winters",
      "population": "900,000",
      "towns": [
        {
          "name": "Crawley",
          "slug": "crawley",
          "postcode": "RH10",
          "nearby_areas": [
            "Horsham",
            "Redhill",
            "Haywards Heath",
            "East Grinstead",
            "Burgess Hill",
            "Reigate",
            "Dorking"
          ]
        },
        {
          "name": "Worthing",
          "slug": "worthing",
          "postcode": "BN11",
          "nearby_areas": [
            "Shoreham-by-Sea",
            "Steyning",
            "Littlehampton",
            "Arundel",
            "Bognor Regis",
            "Burgess Hill",
            "Brighton"
          ]
        },
        {
          "name": "Chichester",
          "slug": "chichester",
          "postcode": "PO19",
          "nearby_areas": [
            "Bognor Regis",
            "Selsey",
            "Emsworth",
            "Havant",
            "Midhurst",
            "Littlehampton",
            "Waterlooville"
          ]
        },
        {
          "name": "Horsham",
          "slug": "horsham",
          "postcode": "RH12",
          "nearby_areas": [
            "Crawley",
            "Redhill",
            "Haywards Heath",
            "Burgess Hill",
            "Steyning",
            "Dorking",
            "East Grinstead"
          ]
        },
        {
          "name": "Bognor Regis",
          "slug": "bognor-regis",
          "postcode": "PO21",
          "nearby_areas": [
            "Chichester",
            "Littlehampton",
            "Selsey",
            "Worthing",
            "Emsworth",
            "Midhurst",
            "Havant"
          ]
        },
        {
          "name": "Littlehampton",
          "slug": "littlehampton",
          "postcode": "BN17",
          "nearby_areas": [
            "Bognor Regis",
            "Worthing",
            "Chichester",
            "Steyning",
            "Shoreham-by-Sea",
            "Midhurst",
            "Arundel"
          ]
        },
        {
          "name": "Haywards Heath",
          "slug": "haywards-heath",
          "postcode": "RH16",
          "nearby_areas": [
            "Burgess Hill",
            "Crawley",
            "East Grinstead",
            "Uckfield",
            "Horsham",
            "Lewes",
            "Steyning"
          ]
        },
        {
          "name": "Burgess Hill",
          "slug": "burgess-hill",
          "postcode": "RH15",
          "nearby_areas": [
            "Haywards Heath",
            "Lewes",
            "Steyning",
            "Crawley",
            "Arundel",
            "Shoreham-by-Sea",
            "Hove"
          ]
        },
        {
          "name": "East Grinstead",
          "slug": "east-grinstead",
          "postcode": "RH19",
          "nearby_areas": [
            "Haywards Heath",
            "Crawley",
            "Crowborough",
            "Redhill",
            "Caterham",
            "Tunbridge Wells",
            "Burgess Hill"
          ]
        },
        {
          "name": "Shoreham-by-Sea",
          "slug": "shoreham-by-sea",
          "postcode": "BN43",
          "nearby_areas": [
            "Steyning",
            "Worthing",
            "Arundel",
            "Brighton",
            "Hove",
            "Burgess Hill",
            "Littlehampton"
          ]
        },
        {
          "name": "Midhurst",
          "slug": "midhurst",
          "postcode": "GU29",
          "nearby_areas": [
            "Petworth",
            "Haslemere",
            "Petersfield",
            "Alton",
            "Chichester",
            "Bognor Regis",
            "Emsworth"
          ]
        },
        {
          "name": "Petworth",
          "slug": "petworth",
          "postcode": "GU28",
          "nearby_areas": [
            "Haslemere",
            "Alton",
            "Sandhurst",
            "Midhurst",
            "Godalming",
            "Farnham",
            "Aldershot"
          ]
        },
        {
          "name": "Arundel",
          "slug": "arundel",
          "postcode": "BN18",
          "nearby_areas": [
            "Brighton",
            "Hove",
            "Shoreham-by-Sea",
            "Peacehaven",
            "Lewes",
            "Steyning",
            "Worthing"
          ]
        },
        {
          "name": "Steyning",
          "slug": "steyning",
          "postcode": "BN44",
          "nearby_areas": [
            "Shoreham-by-Sea",
            "Worthing",
            "Arundel",
            "Burgess Hill",
            "Littlehampton",
            "Horsham",
            "Haywards Heath"
          ]
        },
        {
          "name": "Selsey",
          "slug": "selsey",
          "postcode": "PO20",
          "nearby_areas": [
            "Emsworth",
            "Havant",
            "Chichester",
            "Portsmouth",
            "Waterlooville",
            "Gosport",
            "Bognor Regis"
          ]
        }
      ]
    },
    {
      "name": "West Yorkshire",
      "slug": "west-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "West Yorkshire Council",
      "council_url": "https://www.westyorkshire.gov.uk/",
      "climate": "wet winters and Pennine rainfall",
      "population": "2.4 million",
      "towns": [
        {
          "name": "Leeds",
          "slug": "leeds",
          "postcode": "LS1",
          "nearby_areas": [
            "Batley",
            "Dewsbury",
            "Wakefield",
            "Cleckheaton",
            "Bradford",
            "Castleford",
            "Otley"
          ]
        },
        {
          "name": "Bradford",
          "slug": "bradford",
          "postcode": "BD1",
          "nearby_areas": [
            "Shipley",
            "Cleckheaton",
            "Halifax",
            "Otley",
            "Brighouse",
            "Batley",
            "Keighley"
          ]
        },
        {
          "name": "Wakefield",
          "slug": "wakefield",
          "postcode": "WF1",
          "nearby_areas": [
            "Dewsbury",
            "Batley",
            "Castleford",
            "Pontefract",
            "Leeds",
            "Cleckheaton",
            "Barnsley"
          ]
        },
        {
          "name": "Huddersfield",
          "slug": "huddersfield",
          "postcode": "HD1",
          "nearby_areas": [
            "Brighouse",
            "Cleckheaton",
            "Halifax",
            "Dewsbury",
            "Batley",
            "Bradford",
            "Shipley"
          ]
        },
        {
          "name": "Halifax",
          "slug": "halifax",
          "postcode": "HX1",
          "nearby_areas": [
            "Brighouse",
            "Shipley",
            "Cleckheaton",
            "Huddersfield",
            "Bradford",
            "Hebden Bridge",
            "Batley"
          ]
        },
        {
          "name": "Keighley",
          "slug": "keighley",
          "postcode": "BD21",
          "nearby_areas": [
            "Settle",
            "Ilkley",
            "Morley",
            "Shipley",
            "Otley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Dewsbury",
          "slug": "dewsbury",
          "postcode": "WF12",
          "nearby_areas": [
            "Batley",
            "Cleckheaton",
            "Wakefield",
            "Brighouse",
            "Huddersfield",
            "Leeds",
            "Bradford"
          ]
        },
        {
          "name": "Batley",
          "slug": "batley",
          "postcode": "WF17",
          "nearby_areas": [
            "Dewsbury",
            "Cleckheaton",
            "Wakefield",
            "Brighouse",
            "Leeds",
            "Bradford",
            "Huddersfield"
          ]
        },
        {
          "name": "Castleford",
          "slug": "castleford",
          "postcode": "WF10",
          "nearby_areas": [
            "Pontefract",
            "Wakefield",
            "Leeds",
            "Batley",
            "Dewsbury",
            "Selby",
            "Barnsley"
          ]
        },
        {
          "name": "Pontefract",
          "slug": "pontefract",
          "postcode": "WF8",
          "nearby_areas": [
            "Castleford",
            "Wakefield",
            "Leeds",
            "Selby",
            "Dewsbury",
            "Batley",
            "Barnsley"
          ]
        },
        {
          "name": "Brighouse",
          "slug": "brighouse",
          "postcode": "HD6",
          "nearby_areas": [
            "Cleckheaton",
            "Halifax",
            "Huddersfield",
            "Dewsbury",
            "Batley",
            "Bradford",
            "Shipley"
          ]
        },
        {
          "name": "Morley",
          "slug": "morley",
          "postcode": "LS27",
          "nearby_areas": [
            "Ilkley",
            "Otley",
            "Keighley",
            "Settle",
            "Shipley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Shipley",
          "slug": "shipley",
          "postcode": "BD18",
          "nearby_areas": [
            "Bradford",
            "Keighley",
            "Halifax",
            "Otley",
            "Cleckheaton",
            "Brighouse",
            "Morley"
          ]
        },
        {
          "name": "Ilkley",
          "slug": "ilkley",
          "postcode": "LS29",
          "nearby_areas": [
            "Morley",
            "Otley",
            "Keighley",
            "Settle",
            "Shipley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Otley",
          "slug": "otley",
          "postcode": "LS21",
          "nearby_areas": [
            "Morley",
            "Ilkley",
            "Bradford",
            "Shipley",
            "Keighley",
            "Settle",
            "Leeds"
          ]
        },
        {
          "name": "Cleckheaton",
          "slug": "cleckheaton",
          "postcode": "BD19",
          "nearby_areas": [
            "Brighouse",
            "Batley",
            "Dewsbury",
            "Bradford",
            "Halifax",
            "Huddersfield",
            "Shipley"
          ]
        },
        {
          "name": "Todmorden",
          "slug": "todmorden",
          "postcode": "OL14",
          "nearby_areas": [
            "Hebden Bridge",
            "Bacup",
            "Rochdale",
            "Burnley",
            "Halifax",
            "Colne",
            "Brighouse"
          ]
        },
        {
          "name": "Hebden Bridge",
          "slug": "hebden-bridge",
          "postcode": "HX7",
          "nearby_areas": [
            "Todmorden",
            "Halifax",
            "Shipley",
            "Keighley",
            "Brighouse",
            "Bacup",
            "Bradford"
          ]
        }
      ]
    },
    {
      "name": "Wiltshire",
      "slug": "wiltshire",
      "region": "South West England",
      "council_name": "Wiltshire Council",
      "council_url": "https://www.wiltshire.gov.uk/",
      "climate": "mild, inland with damp winters",
      "population": "750,000",
      "towns": [
        {
          "name": "Swindon",
          "slug": "swindon",
          "postcode": "SN1",
          "nearby_areas": [
            "Royal Wootton Bassett",
            "Pewsey",
            "Calne",
            "Chippenham",
            "Marlborough",
            "Devizes",
            "Melksham"
          ]
        },
        {
          "name": "Salisbury",
          "slug": "salisbury",
          "postcode": "SP1",
          "nearby_areas": [
            "Amesbury",
            "Gillingham",
            "Verwood",
            "Romsey",
            "Ringwood",
            "Warminster",
            "Andover"
          ]
        },
        {
          "name": "Trowbridge",
          "slug": "trowbridge",
          "postcode": "BA14",
          "nearby_areas": [
            "Bradford-on-Avon",
            "Melksham",
            "Westbury",
            "Warminster",
            "Corsham",
            "Frome",
            "Bath"
          ]
        },
        {
          "name": "Chippenham",
          "slug": "chippenham",
          "postcode": "SN15",
          "nearby_areas": [
            "Calne",
            "Pewsey",
            "Devizes",
            "Swindon",
            "Melksham",
            "Royal Wootton Bassett",
            "Corsham"
          ]
        },
        {
          "name": "Warminster",
          "slug": "warminster",
          "postcode": "BA12",
          "nearby_areas": [
            "Westbury",
            "Frome",
            "Trowbridge",
            "Bradford-on-Avon",
            "Melksham",
            "Devizes",
            "Radstock"
          ]
        },
        {
          "name": "Melksham",
          "slug": "melksham",
          "postcode": "SN12",
          "nearby_areas": [
            "Corsham",
            "Trowbridge",
            "Bradford-on-Avon",
            "Devizes",
            "Chippenham",
            "Calne",
            "Bath"
          ]
        },
        {
          "name": "Devizes",
          "slug": "devizes",
          "postcode": "SN10",
          "nearby_areas": [
            "Chippenham",
            "Calne",
            "Melksham",
            "Pewsey",
            "Swindon",
            "Trowbridge",
            "Corsham"
          ]
        },
        {
          "name": "Calne",
          "slug": "calne",
          "postcode": "SN11",
          "nearby_areas": [
            "Chippenham",
            "Pewsey",
            "Swindon",
            "Devizes",
            "Royal Wootton Bassett",
            "Melksham",
            "Corsham"
          ]
        },
        {
          "name": "Marlborough",
          "slug": "marlborough",
          "postcode": "SN8",
          "nearby_areas": [
            "Royal Wootton Bassett",
            "Swindon",
            "Pewsey",
            "Hungerford",
            "Calne",
            "Chippenham",
            "Devizes"
          ]
        },
        {
          "name": "Corsham",
          "slug": "corsham",
          "postcode": "SN13",
          "nearby_areas": [
            "Melksham",
            "Bradford-on-Avon",
            "Chippenham",
            "Calne",
            "Trowbridge",
            "Bath",
            "Devizes"
          ]
        },
        {
          "name": "Westbury",
          "slug": "westbury",
          "postcode": "BA13",
          "nearby_areas": [
            "Frome",
            "Warminster",
            "Radstock",
            "Trowbridge",
            "Bradford-on-Avon",
            "Bath",
            "Shepton Mallet"
          ]
        },
        {
          "name": "Amesbury",
          "slug": "amesbury",
          "postcode": "SP4",
          "nearby_areas": [
            "Salisbury",
            "Gillingham",
            "Andover",
            "Romsey",
            "Winchester",
            "Eastleigh",
            "Verwood"
          ]
        },
        {
          "name": "Royal Wootton Bassett",
          "slug": "royal-wootton-bassett",
          "postcode": "SN4",
          "nearby_areas": [
            "Swindon",
            "Pewsey",
            "Calne",
            "Marlborough",
            "Chippenham",
            "Devizes",
            "Melksham"
          ]
        },
        {
          "name": "Bradford-on-Avon",
          "slug": "bradford-on-avon",
          "postcode": "BA15",
          "nearby_areas": [
            "Trowbridge",
            "Melksham",
            "Bath",
            "Corsham",
            "Westbury",
            "Frome",
            "Warminster"
          ]
        },
        {
          "name": "Pewsey",
          "slug": "pewsey",
          "postcode": "SN9",
          "nearby_areas": [
            "Swindon",
            "Royal Wootton Bassett",
            "Calne",
            "Chippenham",
            "Devizes",
            "Marlborough",
            "Melksham"
          ]
        }
      ]
    },
    {
      "name": "Worcestershire",
      "slug": "worcestershire",
      "region": "West Midlands",
      "council_name": "Worcestershire Council",
      "council_url": "https://www.worcestershire.gov.uk/",
      "climate": "mild damp winters and river valley mist",
      "population": "600,000",
      "towns": [
        {
          "name": "Worcester",
          "slug": "worcester",
          "postcode": "WR1",
          "nearby_areas": [
            "Pershore",
            "Upton-upon-Severn",
            "Droitwich Spa",
            "Tenbury Wells",
            "Malvern",
            "Broadway",
            "Stourport-on-Severn"
          ]
        },
        {
          "name": "Redditch",
          "slug": "redditch",
          "postcode": "B97",
          "nearby_areas": [
            "Coleshill",
            "Bromsgrove",
            "Alcester",
            "Solihull",
            "Halesowen",
            "Oldbury",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Kidderminster",
          "slug": "kidderminster",
          "postcode": "DY10",
          "nearby_areas": [
            "Cleobury Mortimer",
            "Bewdley",
            "Stourport-on-Severn",
            "Stourbridge",
            "Dudley",
            "Bromsgrove",
            "Kingswinford"
          ]
        },
        {
          "name": "Bromsgrove",
          "slug": "bromsgrove",
          "postcode": "B60",
          "nearby_areas": [
            "Redditch",
            "Coleshill",
            "Kidderminster",
            "Halesowen",
            "Stourport-on-Severn",
            "Cleobury Mortimer",
            "Stourbridge"
          ]
        },
        {
          "name": "Malvern",
          "slug": "malvern",
          "postcode": "WR14",
          "nearby_areas": [
            "Tenbury Wells",
            "Colwall",
            "Droitwich Spa",
            "Broadway",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        },
        {
          "name": "Evesham",
          "slug": "evesham",
          "postcode": "WR11",
          "nearby_areas": [
            "Broadway",
            "Malvern",
            "Colwall",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore"
          ]
        },
        {
          "name": "Droitwich Spa",
          "slug": "droitwich-spa",
          "postcode": "WR9",
          "nearby_areas": [
            "Tenbury Wells",
            "Upton-upon-Severn",
            "Malvern",
            "Colwall",
            "Pershore",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Stourport-on-Severn",
          "slug": "stourport-on-severn",
          "postcode": "DY13",
          "nearby_areas": [
            "Bewdley",
            "Kidderminster",
            "Cleobury Mortimer",
            "Bromsgrove",
            "Worcester",
            "Stourbridge",
            "Dudley"
          ]
        },
        {
          "name": "Pershore",
          "slug": "pershore",
          "postcode": "WR10",
          "nearby_areas": [
            "Upton-upon-Severn",
            "Droitwich Spa",
            "Tenbury Wells",
            "Malvern",
            "Colwall",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Bewdley",
          "slug": "bewdley",
          "postcode": "DY12",
          "nearby_areas": [
            "Stourport-on-Severn",
            "Kidderminster",
            "Cleobury Mortimer",
            "Dudley",
            "Stourbridge",
            "Bromsgrove",
            "Kingswinford"
          ]
        },
        {
          "name": "Upton-upon-Severn",
          "slug": "upton-upon-severn",
          "postcode": "WR8",
          "nearby_areas": [
            "Droitwich Spa",
            "Tenbury Wells",
            "Pershore",
            "Malvern",
            "Colwall",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Tenbury Wells",
          "slug": "tenbury-wells",
          "postcode": "WR15",
          "nearby_areas": [
            "Malvern",
            "Droitwich Spa",
            "Colwall",
            "Upton-upon-Severn",
            "Broadway",
            "Pershore",
            "Evesham"
          ]
        },
        {
          "name": "Broadway",
          "slug": "broadway",
          "postcode": "WR12",
          "nearby_areas": [
            "Colwall",
            "Malvern",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        }
      ]
    },
    {
      "name": "Wrexham",
      "slug": "wrexham",
      "region": "Wales",
      "council_name": "Wrexham County Borough Council",
      "council_url": "https://www.wrexham.gov.uk/",
      "climate": "cool, damp border climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Wrexham",
          "slug": "wrexham",
          "postcode": "LL11",
          "nearby_areas": [
            "Buckley",
            "Mold",
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Chester",
            "Ruthin"
          ]
        },
        {
          "name": "Chirk",
          "slug": "chirk",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Rhosllanerchrugog",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Ruabon",
          "slug": "ruabon",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Gresford",
          "slug": "gresford",
          "postcode": "LL12",
          "nearby_areas": [
            "Denbigh",
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Ruthin",
            "Llangollen"
          ]
        },
        {
          "name": "Rhosllanerchrugog",
          "slug": "rhosllanerchrugog",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Cefn Mawr",
          "slug": "cefn-mawr",
          "postcode": "LL14",
          "nearby_areas": [
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        }
      ]
    }
  ],
  "guides": [],
  "youtube": [
    "https://www.youtube.com/watch?v=Er2rDo4dnyk",
    "https://www.youtube.com/watch?v=crPrYdsvWm8",
    "https://www.youtube.com/watch?v=ycA3e8sf5zc",
    "https://www.youtube.com/watch?v=xDUc-_IXTvo",
    "https://www.youtube.com/watch?v=ncPiBShvONM",
    "https://www.youtube.com/watch?v=VYjGkRCX7wI",
    "https://www.youtube.com/watch?v=1jGfbbstZCA",
    "https://www.youtube.com/watch?v=4zvajRuJtyA",
    "https://www.youtube.com/watch?v=wjMqhgvWmW8",
    "https://www.youtube.com/watch?v=SENrtb7pcEU",
    "https://www.youtube.com/watch?v=V9jncUzOL8I",
    "https://www.youtube.com/watch?v=jnmL23mw4Io",
    "https://www.youtube.com/watch?v=punN-FDDyLc",
    "https://www.youtube.com/watch?v=MQ0YTMqVutA",
    "https://www.youtube.com/watch?v=a1ZAJHUvs9k",
    "https://www.youtube.com/watch?v=01wpIAO1R70",
    "https://www.youtube.com/watch?v=DepMDFO7lu0",
    "https://www.youtube.com/watch?v=4ApQzHkKv0s",
    "https://www.youtube.com/watch?v=on9ZrGId1bg",
    "https://www.youtube.com/watch?v=B77p6gRgJoQ",
    "https://www.youtube.com/watch?v=2xRV4KNAHZY",
    "https://www.youtube.com/watch?v=APLRc0ULdyk",
    "https://www.youtube.com/watch?v=l7Esn4EeK3w",
    "https://www.youtube.com/watch?v=rVkhSD17GoI",
    "https://www.youtube.com/watch?v=q7GFweDlqCA"
  ],
  "templates": {
    "about": "<article class=\"about-content\">\n<h2>A simpler starting point for sun tunnel enquiries</h2>\n\n<p>Sun-Tunnel.co.uk helps people find quotations for daylight tubes, often called sun pipes or tubular skylights. A request might be as small as a cracked diffuser or as involved as planning a rigid tube through a deep loft. Explaining that difference at the start helps the enquiry reach a suitable business.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-home-survey-uk.jpg\" alt=\"Homeowner and installer inspecting a ceiling sun tunnel diffuser in a bungalow hallway\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<h2>What we help you compare</h2>\n\n<ul><li><a href=\"/sun-tunnel-installation/\">Sun Tunnel Installation</a>: Supply and fitting of new sun tunnels, sun pipes and tubular skylights to bring natural daylight into dark rooms, landings and corridors.</li>\n<li><a href=\"/sun-tunnel-replacement/\">Sun Tunnel Replacement</a>: Removal of old, yellowed or underperforming sun tunnels and light pipes and fitting of a modern, better-insulated replacement through the same roof opening.</li>\n<li><a href=\"/sun-tunnel-repairs/\">Sun Tunnel Repairs</a>: Repairs to leaking, dripping or misted sun tunnels, including flashing reseals, cracked dome replacement, tube joint taping and new diffusers.</li>\n<li><a href=\"/rigid-sun-tunnel-installation/\">Rigid Sun Tunnel Installation</a>: High-output rigid sun tunnels with mirror-finish aluminium tubes, extensions and angled elbows for long loft runs and larger rooms.</li>\n<li><a href=\"/flexible-sun-tunnel-installation/\">Flexible Sun Tunnel Installation</a>: Budget-friendly flexible sun tunnels with a foil-lined concertina tube for short runs and awkward routes around purlins, pipes and ceiling joists.</li>\n<li><a href=\"/bathroom-hallway-sun-tunnels/\">Sun Tunnels for Bathrooms and Hallways</a>: Sun tunnels for windowless bathrooms, en-suites, WCs, hallways and landings, with insulated tubes, condensation-resistant diffusers and optional ventilation.</li></ul>\n\n<h2>Who does the survey and the work?</h2>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<p>We do not install sun tunnels or employ the businesses that respond. Their survey should establish whether the roof collector can receive useful daylight, how the tube will pass through the void and whether the ceiling position is practical. They are responsible for their own advice, quotation and workmanship.</p>\n\n<h2>Why details make a difference</h2>\n\n<p>Two homes with equally dark hallways may need quite different systems. A shallow bungalow loft can offer a short route, while a pitched roof above an upstairs landing may need extensions or an elbow. A replacement also depends on the old opening and compatible parts. We encourage you to describe the room and roof rather than guess which kit to order.</p>\n\n<p>For repair enquiries, note whether water appears during rain, on cold mornings or after showering. That gives the specialist a useful starting point without assuming the cause. For installations, mention loft tanks, any known roof problems and whether you want a separate electric light accessory.</p>\n\n<h2>A written quote you can understand</h2>\n\n<ul><li>The manufacturer, tube type and diameter, with the proposed route and any elbows or extensions.</li>\n<li>The correct roof collector and flashing for tiles, slates or the flat roof covering.</li>\n<li>How insulation, tube seals and the ceiling air seal will be handled.</li>\n<li>Safe roof access, waste removal, ceiling repairs and decorating, with exclusions stated.</li>\n<li>Whether VAT is included, payment stages, a realistic start date and written warranty terms.</li></ul>\n\n<p>A warranty may cover the product, installation or both, on different terms. Ask who you would contact about a roof leak or diffuser fault, and keep the quotation and completion paperwork. Do not rely on the number of quotes alone when choosing a firm.</p>\n\n<h2>Working on an existing roof</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<p>The survey should also consider safe access and any materials that should not be disturbed without assessment. A small fitting still involves the roof covering and ceiling. Ask about dust protection, insulation reinstatement and what condition the room will be left in.</p>\n\n<h2>Your decision, at your pace</h2>\n\n<p>You can ask questions, compare the scope of each offer and decide whether to proceed. We cannot guarantee four responses or that a particular product will suit your home. Start with an <a href=\"/free-quotes/\">online enquiry</a> and let the independent installers explain the available options.</p>\n</article>\n",
    "bathroom-hallway-sun-tunnels-county": "<article class=\"bathroom-hallway-sun-tunnels-county-content\">\n<h2>{Sun Tunnels for Bathrooms and Hallways in [COUNTY]|Compare bathroom and hallway sun tunnel installation quotes in [COUNTY]|Local help with bathroom and hallway sun tunnel installation in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For bathroom and hallway sun tunnel installation in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Sun tunnels can bring daylight to windowless bathrooms, en-suites, WCs, hallways and landings when there is a suitable route above. Bathroom work needs attention to moisture and the ceiling seal; a hallway installation needs a diffuser position that spreads light where people actually walk.|In an internal bathroom or hallway, a ceiling diffuser can introduce daylight where a wall window is impractical. The installation needs a suitable roof route, with moisture management in bathrooms and useful diffuser positioning in circulation spaces.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>A bathroom relies on electric light throughout the day.</li>\n<li>An en-suite feels enclosed despite a recent refit.</li>\n<li>A long landing or internal hallway has a particularly dark central section.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Assess the room layout, roof exposure and route before selecting the diffuser position.|Plan the diffuser position around the room’s layout and the route available above it.}</li>\n<li>{Check the existing bathroom extraction and discuss moisture management separately from daylight.|Discuss how the bathroom currently removes moisture and what separate ventilation work is needed.}</li>\n<li>{Specify a compatible insulated arrangement and seals for the chosen system.|Choose insulation and sealing details suited to the selected daylighting system.}</li>\n<li>{Check ceiling cables and pipework, protect bathroom fittings and install the roof and tube components.|Protect sanitaryware and check concealed services before forming the ceiling opening.}</li>\n<li>{Finish the ceiling connection, reinstate insulation and agree any electrical work or decorating.|Complete the weatherproofing and ceiling seals, then confirm any finishing or electrical tasks.}</li></ul>\n\n<p>A standard sun tunnel is not an extractor fan. Optional ventilation or electric light kits are product-specific and need separate specification. Electrical additions should be handled by a competent person, with the applicable bathroom and building requirements checked.</p>\n\n<h2>{Guide costs for bathroom and hallway sun tunnel installation|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £550–£1,600. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for bathroom and hallway sun tunnel installation}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request bathroom and hallway sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], will a bathroom sun tunnel replace an extractor fan?</h3>\n\n<p>No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.</p>\n<h3>What affects bathroom and hallway sun tunnel installation costs in [COUNTY]?</h3>\n\n<p>The guide range is £550–£1,600. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], will a bathroom sun tunnel replace an extractor fan?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects bathroom and hallway sun tunnel installation costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £550–£1,600. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "bathroom-hallway-sun-tunnels-town": "<article class=\"bathroom-hallway-sun-tunnels-town-content\">\n<h2>{Sun Tunnels for Bathrooms and Hallways in [TOWN]|Compare bathroom and hallway sun tunnel installation quotes in [TOWN]|Local help with bathroom and hallway sun tunnel installation in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For bathroom and hallway sun tunnel installation in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Sun tunnels can bring daylight to windowless bathrooms, en-suites, WCs, hallways and landings when there is a suitable route above. Bathroom work needs attention to moisture and the ceiling seal; a hallway installation needs a diffuser position that spreads light where people actually walk.|In an internal bathroom or hallway, a ceiling diffuser can introduce daylight where a wall window is impractical. The installation needs a suitable roof route, with moisture management in bathrooms and useful diffuser positioning in circulation spaces.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>A bathroom relies on electric light throughout the day.</li>\n<li>An en-suite feels enclosed despite a recent refit.</li>\n<li>A long landing or internal hallway has a particularly dark central section.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Assess the room layout, roof exposure and route before selecting the diffuser position.|Plan the diffuser position around the room’s layout and the route available above it.}</li>\n<li>{Check the existing bathroom extraction and discuss moisture management separately from daylight.|Discuss how the bathroom currently removes moisture and what separate ventilation work is needed.}</li>\n<li>{Specify a compatible insulated arrangement and seals for the chosen system.|Choose insulation and sealing details suited to the selected daylighting system.}</li>\n<li>{Check ceiling cables and pipework, protect bathroom fittings and install the roof and tube components.|Protect sanitaryware and check concealed services before forming the ceiling opening.}</li>\n<li>{Finish the ceiling connection, reinstate insulation and agree any electrical work or decorating.|Complete the weatherproofing and ceiling seals, then confirm any finishing or electrical tasks.}</li></ul>\n\n<p>A standard sun tunnel is not an extractor fan. Optional ventilation or electric light kits are product-specific and need separate specification. Electrical additions should be handled by a competent person, with the applicable bathroom and building requirements checked.</p>\n\n<h2>{Guide costs for bathroom and hallway sun tunnel installation|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £550–£1,600. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for bathroom and hallway sun tunnel installation}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request bathroom and hallway sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], will a bathroom sun tunnel replace an extractor fan?</h3>\n\n<p>No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.</p>\n<h3>What affects bathroom and hallway sun tunnel installation costs in [TOWN]?</h3>\n\n<p>The guide range is £550–£1,600. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], will a bathroom sun tunnel replace an extractor fan?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects bathroom and hallway sun tunnel installation costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £550–£1,600. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "bathroom-hallway-sun-tunnels": "<article class=\"bathroom-hallway-sun-tunnels-content\">\n<h2>What is bathroom and hallway sun tunnel installation?</h2>\n\n<p>Sun tunnels can bring daylight to windowless bathrooms, en-suites, WCs, hallways and landings when there is a suitable route above. Bathroom work needs attention to moisture and the ceiling seal; a hallway installation needs a diffuser position that spreads light where people actually walk.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/bathroom-sun-tunnel-ceiling-daylight.jpg\" alt=\"Ceiling sun tunnel diffuser lighting a small bathroom with a separate extractor\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need bathroom and hallway sun tunnel installation</h2>\n\n<ul><li>A bathroom relies on electric light throughout the day.</li>\n<li>An en-suite feels enclosed despite a recent refit.</li>\n<li>A long landing or internal hallway has a particularly dark central section.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Assess the room layout, roof exposure and route before selecting the diffuser position.</li>\n<li>Check the existing bathroom extraction and discuss moisture management separately from daylight.</li>\n<li>Specify a compatible insulated arrangement and seals for the chosen system.</li>\n<li>Check ceiling cables and pipework, protect bathroom fittings and install the roof and tube components.</li>\n<li>Finish the ceiling connection, reinstate insulation and agree any electrical work or decorating.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>A standard sun tunnel is not an extractor fan. Optional ventilation or electric light kits are product-specific and need separate specification. Electrical additions should be handled by a competent person, with the applicable bathroom and building requirements checked.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for bathroom and hallway sun tunnel installation is £550–£1,600. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Will a bathroom sun tunnel replace an extractor fan?</h3>\n\n<p>No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For bathroom and hallway sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will a bathroom sun tunnel replace an extractor fan?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A standard sun tunnel supplies daylight rather than extraction. Keep suitable bathroom ventilation, and discuss any compatible ventilation accessory and electrical work separately with the installer.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For bathroom and hallway sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "flexible-sun-tunnel-installation-county": "<article class=\"flexible-sun-tunnel-installation-county-content\">\n<h2>{Flexible Sun Tunnel Installation in [COUNTY]|Compare flexible sun tunnel installation quotes in [COUNTY]|Local help with flexible sun tunnel installation in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For flexible sun tunnel installation in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{A flexible sun tunnel uses a reflective concertina tube between the roof collector and ceiling diffuser. It can suit a short route with a modest offset, where a rigid assembly is difficult to position. The flexible tube must still be supported and fitted within its manufacturer’s length and bend limits.|Flexible daylight tubes have a reflective concertina lining that can follow a short, gently offset route. A survey should check whether the available path falls within the chosen product’s limits rather than relying on the tube’s flexibility alone.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>A small hallway has a short roof-to-ceiling distance.</li>\n<li>Minor loft obstructions make a straight connection awkward.</li>\n<li>You want to compare a lower-cost flexible option with a rigid system.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Check the measured route against the product’s limits and assess likely daylight.|Confirm that the proposed flexible run is short enough for the selected product.}</li>\n<li>{Plan gentle curves around obstructions without crushing the tube or using unnecessary length.|Avoid tight bends, sagging sections and squeezed tube walls when planning the route.}</li>\n<li>{Fit the roof collector with flashing made for the roof covering.|Weatherproof the roof opening with the correct collector and flashing kit.}</li>\n<li>{Attach and support the tube at both ends using the specified connections and seals.|Fix and support the flexible tube so that its connections remain secure.}</li>\n<li>{Reinstate insulation, seal the ceiling fitting and remove installation debris.|Complete the diffuser seal, reinstate insulation and clear cut materials from the room.}</li></ul>\n\n<p>The corrugated lining and bends generally transmit less light than an equivalent smooth rigid route. A flexible system is not a solution for every long or complicated loft run. Compare the likely result as well as the initial cost.</p>\n\n<h2>{Guide costs for flexible sun tunnel installation|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £400–£950. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for flexible sun tunnel installation}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request flexible sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], is a flexible tube suitable for a long loft route?</h3>\n\n<p>Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.</p>\n<h3>What affects flexible sun tunnel installation costs in [COUNTY]?</h3>\n\n<p>The guide range is £400–£950. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], is a flexible tube suitable for a long loft route?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects flexible sun tunnel installation costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £400–£950. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "flexible-sun-tunnel-installation-town": "<article class=\"flexible-sun-tunnel-installation-town-content\">\n<h2>{Flexible Sun Tunnel Installation in [TOWN]|Compare flexible sun tunnel installation quotes in [TOWN]|Local help with flexible sun tunnel installation in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For flexible sun tunnel installation in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{A flexible sun tunnel uses a reflective concertina tube between the roof collector and ceiling diffuser. It can suit a short route with a modest offset, where a rigid assembly is difficult to position. The flexible tube must still be supported and fitted within its manufacturer’s length and bend limits.|Flexible daylight tubes have a reflective concertina lining that can follow a short, gently offset route. A survey should check whether the available path falls within the chosen product’s limits rather than relying on the tube’s flexibility alone.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>A small hallway has a short roof-to-ceiling distance.</li>\n<li>Minor loft obstructions make a straight connection awkward.</li>\n<li>You want to compare a lower-cost flexible option with a rigid system.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Check the measured route against the product’s limits and assess likely daylight.|Confirm that the proposed flexible run is short enough for the selected product.}</li>\n<li>{Plan gentle curves around obstructions without crushing the tube or using unnecessary length.|Avoid tight bends, sagging sections and squeezed tube walls when planning the route.}</li>\n<li>{Fit the roof collector with flashing made for the roof covering.|Weatherproof the roof opening with the correct collector and flashing kit.}</li>\n<li>{Attach and support the tube at both ends using the specified connections and seals.|Fix and support the flexible tube so that its connections remain secure.}</li>\n<li>{Reinstate insulation, seal the ceiling fitting and remove installation debris.|Complete the diffuser seal, reinstate insulation and clear cut materials from the room.}</li></ul>\n\n<p>The corrugated lining and bends generally transmit less light than an equivalent smooth rigid route. A flexible system is not a solution for every long or complicated loft run. Compare the likely result as well as the initial cost.</p>\n\n<h2>{Guide costs for flexible sun tunnel installation|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £400–£950. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for flexible sun tunnel installation}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request flexible sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], is a flexible tube suitable for a long loft route?</h3>\n\n<p>Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.</p>\n<h3>What affects flexible sun tunnel installation costs in [TOWN]?</h3>\n\n<p>The guide range is £400–£950. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], is a flexible tube suitable for a long loft route?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects flexible sun tunnel installation costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £400–£950. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "flexible-sun-tunnel-installation": "<article class=\"flexible-sun-tunnel-installation-content\">\n<h2>What is flexible sun tunnel installation?</h2>\n\n<p>A flexible sun tunnel uses a reflective concertina tube between the roof collector and ceiling diffuser. It can suit a short route with a modest offset, where a rigid assembly is difficult to position. The flexible tube must still be supported and fitted within its manufacturer’s length and bend limits.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/flexible-foil-sun-tunnel-short-loft-route.jpg\" alt=\"Short flexible foil tube gently curved through a loft\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need flexible sun tunnel installation</h2>\n\n<ul><li>A small hallway has a short roof-to-ceiling distance.</li>\n<li>Minor loft obstructions make a straight connection awkward.</li>\n<li>You want to compare a lower-cost flexible option with a rigid system.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Check the measured route against the product’s limits and assess likely daylight.</li>\n<li>Plan gentle curves around obstructions without crushing the tube or using unnecessary length.</li>\n<li>Fit the roof collector with flashing made for the roof covering.</li>\n<li>Attach and support the tube at both ends using the specified connections and seals.</li>\n<li>Reinstate insulation, seal the ceiling fitting and remove installation debris.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>The corrugated lining and bends generally transmit less light than an equivalent smooth rigid route. A flexible system is not a solution for every long or complicated loft run. Compare the likely result as well as the initial cost.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for flexible sun tunnel installation is £400–£950. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Is a flexible tube suitable for a long loft route?</h3>\n\n<p>Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For flexible sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is a flexible tube suitable for a long loft route?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not necessarily. Flexible tubes have product-specific length limits and lose light through bends and their corrugated lining. Ask an installer whether a rigid system would perform better for the measured route.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For flexible sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "free-quotes": "<article class=\"free-quotes-content\">\n<h2>Tell us about the room, roof or repair</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-components-quote-comparison.jpg\" alt=\"Rigid tube sections, a ceiling diffuser and tape measure laid out on a table\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Information that helps an installer quote</h2>\n\n<ul><li>Your postcode, the room to be lit and its approximate size.</li>\n<li>Whether the roof is pitched or flat, tiled or slated, if known.</li>\n<li>The approximate roof-to-ceiling distance and any known loft obstructions.</li>\n<li>For replacements or repairs, the existing make, age and symptoms if known.</li>\n<li>Access restrictions, property height, planned roofing work and your preferred timing.</li></ul>\n\n<p>Photographs can help a firm give an initial indication. Take them from a safe position; a site visit may still be needed to measure the route and inspect the roof. You do not need to remove a diffuser or enter an unboarded loft to complete the form.</p>\n\n<h2>Indicative UK sun tunnel costs</h2>\n\n<p>These are budgeting ranges from our service guide, not guaranteed quotations. The six main rows reproduce the figures in our service listings. They describe different project types and should not be added together. A straightforward job may sit near the lower end; difficult access, premium products or additional repairs can take it above the range.</p>\n\n<div role=\"region\" aria-label=\"Sun tunnel guide costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;\"><table><caption>Indicative UK costs for one sun tunnel or related task</caption><thead><tr><th scope=\"col\">Work</th><th scope=\"col\">Guide range</th><th scope=\"col\">Scope to confirm</th></tr></thead><tbody><tr><th scope=\"row\">Sun Tunnel Installation</th><td>£500–£1,400</td><td>Supply and fitting of one unit; specification and access vary</td></tr>\n<tr><th scope=\"row\">Sun Tunnel Replacement</th><td>£450–£1,300</td><td>Supply and fitting of one unit; specification and access vary</td></tr>\n<tr><th scope=\"row\">Sun Tunnel Repairs</th><td>£120–£450</td><td>Diagnosis and agreed repair; parts and access vary</td></tr>\n<tr><th scope=\"row\">Rigid Sun Tunnel Installation</th><td>£650–£1,800</td><td>Supply and fitting of one unit; specification and access vary</td></tr>\n<tr><th scope=\"row\">Flexible Sun Tunnel Installation</th><td>£400–£950</td><td>Supply and fitting of one unit; specification and access vary</td></tr>\n<tr><th scope=\"row\">Sun Tunnels for Bathrooms and Hallways</th><td>£550–£1,600</td><td>Supply and fitting of one unit; specification and access vary</td></tr><tr><th scope=\"row\">Diffuser cleaning and resealing</th><td>£120–£180</td><td>Accessible fitting, no major roof repair; overlaps the repair range</td></tr><tr><th scope=\"row\">Compatible rigid extension section</th><td>£60–£165</td><td>Supply only per section; installation is additional</td></tr></tbody></table>\n\n</div>\n\n<p>Material-only prices and installation prices are different. The <a href=\"https://www.checkatrade.com/blog/cost-guides/sun-tunnel-installation-cost/\" target=\"_blank\" rel=\"nofollow noopener\">Checkatrade cost guide</a> discusses kit, labour and access separately. Our figures are broad allowances for comparing the site’s services, rather than a fixed tariff. Confirm VAT, scaffolding, waste removal and making-good in each written offer. For extension sections, compare the length and diameter: <a href=\"https://www.myjobquote.co.uk/costs/installing-a-sun-tunnel\" target=\"_blank\" rel=\"nofollow noopener\">MyJobQuote’s cost guide</a> gives a £60–£165 supply-only range. The small maintenance allowance is for a simple accessible job; a roof fault or unavailable part may need a different scope.</p>\n\n<h2>What changes the price?</h2>\n\n<p>Tube diameter, length and the number of bends affect materials and fitting time. A flat roof needs a collector and weatherproofing detail suited to that roof system. Roof height, fragile surfaces and restricted access can require scaffolding or other protection. Rotten timber, damaged tiles, damp insulation and repairs to the ceiling are additional work unless included. Local labour rates and the number of units also matter.</p>\n\n<h2>Compare the proposed result as well as the total</h2>\n\n<ul><li>The manufacturer, tube type and diameter, with the proposed route and any elbows or extensions.</li>\n<li>The correct roof collector and flashing for tiles, slates or the flat roof covering.</li>\n<li>How insulation, tube seals and the ceiling air seal will be handled.</li>\n<li>Safe roof access, waste removal, ceiling repairs and decorating, with exclusions stated.</li>\n<li>Whether VAT is included, payment stages, a realistic start date and written warranty terms.</li></ul>\n\n<p>Ask why the proposed tube type suits the route and what daylight you can reasonably expect. A cheaper flexible kit may be poor value on an unsuitable long run. A like-for-like replacement may be enough where the current tube is sound, while repeated condensation needs diagnosis before another diffuser is fitted.</p>\n\n<h2>Permissions and safe fitting</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Will I receive four sun tunnel quotes?</h3>\n\n<p>You may receive up to four quotations. The number depends on the work, location and availability of suitable independent installers.</p>\n<h3>Can I get a firm price from photographs?</h3>\n\n<p>Photos may support an initial estimate, but a firm may need to inspect the roof, measure the tube route and confirm access before giving a written quotation.</p>\n<h3>Is there a charge to send an enquiry?</h3>\n\n<p>The homeowner enquiry is free and there is no obligation to accept a quotation. Agree any separate survey or diagnostic charge with the installer before booking.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I receive four sun tunnel quotes?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations. The number depends on the work, location and availability of suitable independent installers.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I get a firm price from photographs?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Photos may support an initial estimate, but a firm may need to inspect the roof, measure the tube route and confirm access before giving a written quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is there a charge to send an enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The homeowner enquiry is free and there is no obligation to accept a quotation. Agree any separate survey or diagnostic charge with the installer before booking.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "home": "<article class=\"home-content\">\n<h2>Bring daylight into the middle of your home</h2>\n\n<p>A gloomy landing or windowless bathroom does not always need a major alteration. A sun tunnel collects daylight at the roof and carries it down a reflective tube to a ceiling diffuser. In a bungalow or a room beneath a usable roof void, it may offer a practical way to make everyday spaces lighter.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-daylit-bungalow-hallway.jpg\" alt=\"Circular ceiling diffuser bringing daylight into a bungalow hallway\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<h2>Which sun tunnel job do you have in mind?</h2>\n\n<ul><li><a href=\"/sun-tunnel-installation/\">Sun Tunnel Installation</a>: Supply and fitting of new sun tunnels, sun pipes and tubular skylights to bring natural daylight into dark rooms, landings and corridors.</li>\n<li><a href=\"/sun-tunnel-replacement/\">Sun Tunnel Replacement</a>: Removal of old, yellowed or underperforming sun tunnels and light pipes and fitting of a modern, better-insulated replacement through the same roof opening.</li>\n<li><a href=\"/sun-tunnel-repairs/\">Sun Tunnel Repairs</a>: Repairs to leaking, dripping or misted sun tunnels, including flashing reseals, cracked dome replacement, tube joint taping and new diffusers.</li>\n<li><a href=\"/rigid-sun-tunnel-installation/\">Rigid Sun Tunnel Installation</a>: High-output rigid sun tunnels with mirror-finish aluminium tubes, extensions and angled elbows for long loft runs and larger rooms.</li>\n<li><a href=\"/flexible-sun-tunnel-installation/\">Flexible Sun Tunnel Installation</a>: Budget-friendly flexible sun tunnels with a foil-lined concertina tube for short runs and awkward routes around purlins, pipes and ceiling joists.</li>\n<li><a href=\"/bathroom-hallway-sun-tunnels/\">Sun Tunnels for Bathrooms and Hallways</a>: Sun tunnels for windowless bathrooms, en-suites, WCs, hallways and landings, with insulated tubes, condensation-resistant diffusers and optional ventilation.</li></ul>\n\n<h2>Start with the route, not just the room</h2>\n\n<p>Tell an installer which room needs light, roughly how large it is and what sits above it. A water tank, purlin or long offset can change the choice of tube. Nearby trees and buildings can shade the collector. Photos taken safely from ground level and from an accessible loft hatch can help, but there is no need to climb onto a roof for an enquiry.</p>\n\n<p>Rigid tubes use smooth reflective sections and approved elbows. Flexible tubes can accommodate a short offset but need gentle curves and a suitable length. The <a href=\"https://www.velux.co.uk/products/sun-tunnels\" target=\"_blank\" rel=\"nofollow noopener\">VELUX sun tunnel range</a> illustrates these product choices; other manufacturers have their own fittings and installation limits.</p>\n\n<h2>What happens during fitting?</h2>\n\n<ul><li>Survey the roof slope or flat roof and check the covering, daylight exposure and safe access.</li>\n<li>Measure the roof-to-ceiling route, checking rafters, joists, pipes and cables before marking openings.</li>\n<li>Specify a collector, compatible flashing, tube diameter and diffuser that suit the room and route.</li>\n<li>Protect the room, form the openings without unapproved timber alterations, fit the flashing and secure the tube.</li>\n<li>Seal joints and the ceiling connection, reinstate insulation and agree plastering, decorating and waste removal.</li></ul>\n\n<p>Many straightforward installations take part of a day, but roof access, weather, longer routes and ceiling repairs can extend the job. Confirm the expected disruption and who will repair or decorate the ceiling. A daylight tube is not normally ventilation and it will not replace lighting at night.</p>\n\n<h2>Choosing your installer</h2>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<ul><li>The manufacturer, tube type and diameter, with the proposed route and any elbows or extensions.</li>\n<li>The correct roof collector and flashing for tiles, slates or the flat roof covering.</li>\n<li>How insulation, tube seals and the ceiling air seal will be handled.</li>\n<li>Safe roof access, waste removal, ceiling repairs and decorating, with exclusions stated.</li>\n<li>Whether VAT is included, payment stages, a realistic start date and written warranty terms.</li></ul>\n\n<h2>Check the property requirements</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Request quotes for your postcode</h2>\n\n<p>Use the <a href=\"/free-quotes/\">free quotation enquiry</a> to describe a new installation, upgrade or fault. Include your roof type if you know it and mention any planned roof replacement so the installer can consider doing the work together.</p>[YOUTUBE]\n</article>\n",
    "job-leads": "<article class=\"job-leads-content\">\n<h2>Sun tunnel enquiries for installers and roofing businesses</h2>\n\n<p>A homeowner looking to brighten an internal bathroom may know the room but have little idea about the roof route. Sun-Tunnel.co.uk introduces these enquiries to independent businesses through Leads Do Work, giving you an opportunity to assess the project and offer your own solution.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-installer-checking-mobile-lead.jpg\" alt=\"Installer checking a mobile phone beside a brick bungalow\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Set up an account around the work you actually offer</h2>\n\n<p>Create a free contractor account, select your relevant services and choose the towns or postcode areas you cover. Companies joining the network are asked for relevant insurance details and references. If your team fits new daylight tubes but does not diagnose leaks in older systems, make your service selection reflect that.</p>\n\n<ul><li>New sun tunnel and tubular skylight supply and fitting.</li>\n<li>Replacement collectors, tubes and ceiling diffusers.</li>\n<li>Leak investigation, flashing repairs and condensation-related work.</li>\n<li>Rigid tubes with extensions and elbows, or short flexible systems.</li>\n<li>Bathroom, en-suite, hallway and landing installations.</li></ul>\n\n<h2>From enquiry to your own quotation</h2>\n\n<ol><li>Create your account and check local opportunities in the app.</li><li>Choose the available paid lead pack when you want to receive customer contact details.</li><li>Contact the homeowner, establish the roof and room details and arrange a survey where needed.</li><li>Specify the system, access arrangements and finishing work, then provide your own written price.</li></ol>\n\n<p>The homeowner deals with your business for appointments, contracts, payment and installation. You set your prices and decide whether a project fits your skills, equipment and schedule.</p>\n\n<h2>Check new opportunities on your phone</h2>\n\n<p>Use the Leads Do Work app to browse enquiries between visits and respond when you can give the customer proper attention. Download the app and create a free account to see whether the local work fits your business before choosing a paid option.</p>\n\n<p><a href=\"https://apps.apple.com/gb/app/leadsdowork-for-tradespeople/id1018239423\" target=\"_blank\" rel=\"nofollow noopener\">Download Leads Do Work for iPhone and iPad</a></p>\n\n<p><a href=\"https://play.google.com/store/apps/details?id=uk.co.quotatis.quotatisapp\" target=\"_blank\" rel=\"nofollow noopener\">Download Leads Do Work for Android</a></p>\n\n<h2>Choose a lead pack that fits your quoting capacity</h2>\n\n<p>Available packs include 5, 10 or 20 leads. Check current prices and terms in your account before buying. A small team might want only a handful of surveys alongside existing work; a larger business needs enough survey and fitting capacity to follow up a bigger pack. Buying more contact details does not guarantee more installations.</p>\n\n<h2>Make coverage practical for roof surveys</h2>\n\n<p>Set an area that makes sense for travel, small repair visits and return trips with parts. A low-value diffuser repair far from your base may be less suitable than a planned multi-unit installation nearby. Demand varies by area and season, so lead volumes and particular job types are not guaranteed.</p>\n\n<h2>Useful questions for the first call</h2>\n\n<ul><li>Which room needs daylight, and what is immediately above it?</li>\n<li>Is the roof pitched or flat, and is the covering known?</li>\n<li>Is there an existing unit, and can the homeowner identify its make safely?</li>\n<li>For drips, when do they happen and is there visible ceiling staining?</li>\n<li>Are there loft obstructions, restricted access or upcoming roof works?</li>\n<li>Does the customer expect ceiling decorating, an electric light kit or ventilation work?</li></ul>\n\n<p>Explain which details need a visit rather than offering a fixed price for an unseen roof. Request useful photographs only where they can be taken safely. If the customer is unavailable, leave a brief message identifying your business and the sun tunnel enquiry, then follow up at a reasonable time.</p>\n\n<h2>Turn a survey into a clear offer</h2>\n\n<p>State the collector, flashing, tube diameter, extensions and diffuser. Explain why the chosen route works, how insulation and air seals will be reinstated, and whether scaffold access or ceiling repairs are included. Give a realistic lead time and explain warranty terms. Specific answers about their roof are more useful to a homeowner than a list of product features.</p>\n\n<h2>Shared enquiries are opportunities to quote</h2>\n\n<p>An enquiry may be matched with up to four suitable businesses. Leads are not exclusive and do not guarantee an appointment, accepted quotation or paid job. The customer may postpone the work or choose another firm. Use the service alongside referrals and your own marketing, with a budget that allows for enquiries that do not convert.</p>\n\n<h2>Start with local availability</h2>\n\n<p>Download the app, create your account and check the services and areas available to you. More contractor information is available at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"nofollow noopener\">Leads Do Work</a>.</p>[YOUTUBE]<h2>Frequently asked questions</h2>\n\n<h3>Are sun tunnel leads guaranteed jobs?</h3>\n\n<p>No. A lead gives your business an opportunity to contact a homeowner and quote. It does not guarantee a visit, accepted quotation or completed installation.</p>\n<h3>Can I select the services and areas I cover?</h3>\n\n<p>Set your relevant services and geographical coverage in your contractor account. Matching and lead availability depend on customer enquiries and the options available in the account.</p>\n<h3>What lead packs are available?</h3>\n\n<p>Leads Do Work offers packs of 5, 10 or 20 leads. Check the current prices and purchase terms in your account before choosing a pack.</p>\n<h3>Do I set the installation price?</h3>\n\n<p>Yes. Your business assesses the roof and tube route, prepares its own quotation and agrees any work directly with the homeowner.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Are sun tunnel leads guaranteed jobs?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A lead gives your business an opportunity to contact a homeowner and quote. It does not guarantee a visit, accepted quotation or completed installation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I select the services and areas I cover?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Set your relevant services and geographical coverage in your contractor account. Matching and lead availability depend on customer enquiries and the options available in the account.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What lead packs are available?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Leads Do Work offers packs of 5, 10 or 20 leads. Check the current prices and purchase terms in your account before choosing a pack.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Do I set the installation price?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Your business assesses the roof and tube route, prepares its own quotation and agrees any work directly with the homeowner.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "privacy": "<article class=\"privacy-content\">\n\n    <p>This privacy policy explains how personal information is collected, used and shared when you visit sun-tunnel.co.uk, request sun tunnel quotes or contact us.</p>\n\n    <p>The sun-tunnel.co.uk quote-matching service is provided by <strong>Leads Do Work Ltd</strong>. References in this policy to “we”, “us” or “our” mean Leads Do Work Ltd.</p>\n\n    <p>For questions about this privacy policy, the way we use your personal information or your data protection rights, please contact Leads Do Work Ltd through its website at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>About Our Quote-Matching Service</h2>\n\n    <p>sun-tunnel.co.uk helps homeowners, landlords, property buyers and property managers find independent sun tunnel and tubular skylight installers who may be interested in providing a site visit or quotation.</p>\n\n    <p>When you submit a quote request, we use the information you provide to identify contractors who may be suitable for the type of work and location you have entered. We may then share your enquiry with one or more relevant contractors so they can contact you directly.</p>\n\n    <p>Our role is to introduce you to independent contractors. We do not normally carry out the sun tunnel work ourselves, supervise the project or enter into the contract for work. Any agreement you make for a site visit, installation, repair or other service will be directly between you and the contractor you appoint.</p>\n\n    <h2>Information We Collect</h2>\n\n    <p>The information we collect depends on how you use the website and the details you choose to provide.</p>\n\n    <h3>Information provided with a quote request</h3>\n\n    <p>When you request sun tunnel quotes, we may collect:</p>\n\n    <ul>\n        <li>Your name.</li>\n        <li>Your email address.</li>\n        <li>Your telephone or mobile number.</li>\n        <li>Your postcode and property address.</li>\n        <li>The type of property concerned.</li>\n        <li>Whether you own, rent, manage or are buying the property.</li>\n        <li>Details of the roof, ceiling and room where the sun tunnel is needed.</li>\n        <li>The type of installation, replacement or repair you require.</li>\n        <li>Your preferred timescale for the work.</li>\n        <li>Photographs or documents you choose to upload.</li>\n        <li>Any other information you include in the enquiry.</li>\n    </ul>\n\n    <p>Please avoid including unnecessary sensitive personal information in your description or uploaded files.</p>\n\n    <h3>Information collected when you contact us</h3>\n\n    <p>If you contact us by telephone, email, online form, text message or another channel, we may retain:</p>\n\n    <ul>\n        <li>Your contact details.</li>\n        <li>The date and time of the communication.</li>\n        <li>The content of your message.</li>\n        <li>Notes made by our customer service team.</li>\n        <li>Information about your enquiry or complaint.</li>\n    </ul>\n\n    <p>Telephone calls to or from Leads Do Work Ltd may be recorded or monitored for quality, training, fraud prevention and dispute-resolution purposes.</p>\n\n    <h3>Information collected automatically</h3>\n\n    <p>When you use the website, we may automatically collect technical and usage information, including:</p>\n\n    <ul>\n        <li>Your Internet Protocol address.</li>\n        <li>Your browser type and version.</li>\n        <li>Your device type and operating system.</li>\n        <li>The pages you visit.</li>\n        <li>The date, time and length of your visit.</li>\n        <li>The website, advertisement or search result that referred you to us.</li>\n        <li>Information about how you use the quote form.</li>\n        <li>Cookie identifiers and similar technical information.</li>\n    </ul>\n\n    <h3>Information received from other sources</h3>\n\n    <p>We may receive your information through another website, advertising platform, social media form, affiliate, publisher or business partner where you have requested sun tunnel quotes or asked to be contacted.</p>\n\n    <p>Where another organisation collects your details before passing them to us, it should provide its own privacy information explaining how your data will be used.</p>\n\n    <h2>How We Use Your Information</h2>\n\n    <p>We may use your personal information to:</p>\n\n    <ul>\n        <li>Process your request for sun tunnel quotes.</li>\n        <li>Identify contractors who provide the service you require.</li>\n        <li>Match your enquiry according to the work type, location and contractor availability.</li>\n        <li>Share your enquiry with suitable independent contractors.</li>\n        <li>Contact you to confirm or clarify the details of your request.</li>\n        <li>Help contractors contact you about a survey or quotation.</li>\n        <li>Provide customer service and respond to questions or complaints.</li>\n        <li>Check whether contractors have responded to your enquiry.</li>\n        <li>Invite you to review the service or a contractor.</li>\n        <li>Prevent fraud, misuse and unauthorised access.</li>\n        <li>Maintain records of enquiries, introductions and communications.</li>\n        <li>Improve our websites, forms, matching systems and services.</li>\n        <li>Measure the performance of our advertising and marketing campaigns.</li>\n        <li>Comply with legal, regulatory, tax, accounting and reporting duties.</li>\n        <li>Establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <h2>Published Examples of Enquiries</h2>\n\n    <p>To help homeowners see the kind of sun tunnel work being requested near them, we publish anonymised examples of past enquiries on trade- and location-specific pages of sun-tunnel.co.uk (and any other website operated by Leads Do Work Ltd).</p>\n\n    <p>Before an example is published we remove or mask anything that could reasonably identify you or your home. Your name is reduced to an initial, your exact address is not shown (only a generic street name where one applies, never a house or unit number or a named property), your email address is partially masked, and we remove anything resembling a phone number, email address or postcode from your enquiry description.</p>\n\n    <p>If you have opted out of further contact from us, your enquiry is never used in this way. If you would rather your enquiry is never published as an example, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a> and we will exclude it.</p>\n\n    <p>Our lawful basis for this is legitimate interests — showing genuine local examples helps homeowners trust the quote-matching service. You have the right to object to this processing at any time; see \"Your Data Protection Rights\" below.</p>\n\n    <h2>How We Match Your Enquiry</h2>\n\n    <p>Our technology may automatically assess the information you submit, including your postcode, property type and the sun tunnel work required.</p>\n\n    <p>This information may be compared with contractor service areas, selected trades, availability and account settings. The system can then identify which contractors may be suitable to receive the enquiry.</p>\n\n    <p>This automated matching helps us process enquiries efficiently. It does not decide whether you may obtain sun tunnel services, and you remain free to accept or reject any quotation.</p>\n\n    <h2>Who We Share Your Information With</h2>\n\n    <h3>Sun tunnel installers</h3>\n\n    <p>To provide the quote-matching service, we may share your enquiry with one or more independent sun tunnel installers who appear relevant to your location and requested work.</p>\n\n    <p>The information shared may include your:</p>\n\n    <ul>\n        <li>Name.</li>\n        <li>Telephone number.</li>\n        <li>Email address.</li>\n        <li>Address or postcode.</li>\n        <li>Property details.</li>\n        <li>Description of the problem.</li>\n        <li>Preferred timescale.</li>\n        <li>Uploaded photographs or supporting information.</li>\n    </ul>\n\n    <p>Contractors may contact you by telephone, email or text message to discuss the enquiry, arrange an inspection or provide a quotation.</p>\n\n    <p>Each contractor receiving your personal information will normally act as an independent data controller. This means the contractor is responsible for its own use, storage and protection of your data after receiving it.</p>\n\n    <p>If you provide further information directly to a contractor or appoint that contractor, the use of your information will also be governed by the contractor’s own privacy policy. You should contact the contractor directly if you wish to exercise your rights regarding information held in its own systems.</p>\n\n    <h3>Companies providing services to us</h3>\n\n    <p>We may share personal information with trusted suppliers that help us operate the website and quote service, including providers of:</p>\n\n    <ul>\n        <li>Website hosting and cloud storage.</li>\n        <li>Email, telephone and text-message services.</li>\n        <li>Customer relationship management systems.</li>\n        <li>Analytics and website-performance tools.</li>\n        <li>Security, fraud prevention and technical support.</li>\n        <li>Customer service and communication systems.</li>\n        <li>Data backup and disaster recovery.</li>\n        <li>Professional legal, accounting and compliance services.</li>\n    </ul>\n\n    <p>These organisations may process information on our behalf and are required to handle it according to their contracts and applicable data protection law.</p>\n\n    <h3>Advertising and analytics providers</h3>\n\n    <p>Subject to your cookie choices and where required by law, information about your use of the website may be shared with analytics and advertising providers. This may include Google, Meta and other platforms used to measure website traffic or advertising performance.</p>\n\n    <p>These providers may use cookies or similar technologies. More information should be available through the cookie settings displayed on the website.</p>\n\n    <h3>Legal and business disclosures</h3>\n\n    <p>We may also disclose information:</p>\n\n    <ul>\n        <li>Where required by law, a court or regulatory authority.</li>\n        <li>To investigate fraud, security incidents or misuse of our services.</li>\n        <li>To protect our rights, property, users or contractors.</li>\n        <li>In connection with a sale, merger, restructuring or transfer of all or part of our business.</li>\n        <li>To establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <h2>We Do Not Sell Your Details for Unrelated Marketing</h2>\n\n    <p>We do not sell, rent or trade the personal information submitted with a sun tunnel quote request to unrelated organisations for their own marketing without an appropriate lawful basis.</p>\n\n    <p>Sharing your enquiry with relevant contractors is an essential part of the quote service you have requested. This is different from selling your information for unrelated marketing.</p>\n\n    <h2>Our Lawful Bases for Processing</h2>\n\n    <p>Under UK data protection law, we must have a lawful basis for using personal information. The bases we may rely on include:</p>\n\n    <h3>Taking steps at your request or performing a contract</h3>\n\n    <p>We use this basis where processing is necessary to provide the quote-matching service you have requested, including receiving your enquiry, matching it with contractors and helping those contractors contact you.</p>\n\n    <h3>Legitimate interests</h3>\n\n    <p>We may process information where it is necessary for our legitimate business interests, provided those interests are not overridden by your rights. These interests may include:</p>\n\n    <ul>\n        <li>Operating and improving the quote service.</li>\n        <li>Managing our relationship with users and contractors.</li>\n        <li>Checking the quality and effectiveness of introductions.</li>\n        <li>Preventing fraud and protecting the security of our systems.</li>\n        <li>Understanding how our website is used.</li>\n        <li>Handling complaints and resolving disputes.</li>\n        <li>Promoting similar services where permitted by law.</li>\n    </ul>\n\n    <p>We also publish anonymised examples of enquiries on our website, as described under \"Published Examples of Enquiries\" above; our lawful basis for that is legitimate interests.</p>\n\n    <h3>Consent</h3>\n\n    <p>We may rely on your consent for certain marketing communications, non-essential cookies or other processing where consent is legally required. You may withdraw your consent at any time.</p>\n\n    <h3>Legal obligation</h3>\n\n    <p>We may process personal information where necessary to comply with a legal or regulatory requirement.</p>\n\n    <h2>Contacting You About Your Enquiry</h2>\n\n    <p>After you submit an enquiry, Leads Do Work Ltd and relevant contractors may contact you to help process your request and provide quotations.</p>\n\n    <p>Contact may be made by:</p>\n\n    <ul>\n        <li>Telephone.</li>\n        <li>Automated telephone call.</li>\n        <li>Text message or SMS.</li>\n        <li>Email.</li>\n    </ul>\n\n    <p>These communications relate to the sun tunnel service you requested and may include confirming your details, arranging an inspection, providing a quotation or checking the progress of the enquiry.</p>\n\n    <h2>Marketing Communications</h2>\n\n    <p>We may occasionally contact you about similar home improvement services where we have your consent or where applicable marketing law allows us to do so.</p>\n\n    <p>You can stop receiving marketing messages from Leads Do Work Ltd by:</p>\n\n    <ul>\n        <li>Using the unsubscribe link in an email.</li>\n        <li>Following the opt-out instructions in a text message.</li>\n        <li>Contacting Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</li>\n    </ul>\n\n    <p>Opting out of marketing will not stop service messages that are necessary to process an active enquiry.</p>\n\n    <p>Contractors are independent organisations. If you wish to stop communications from a particular contractor, you should also contact that contractor directly.</p>\n\n    <h2>Uploaded Photographs and Documents</h2>\n\n    <p>You may have the option to upload photographs or other information showing the roof, ceiling or existing sun tunnel. These files may be shared with relevant contractors to help them understand your enquiry.</p>\n\n    <p>By uploading a file, you confirm that:</p>\n\n    <ul>\n        <li>You are entitled to share it.</li>\n        <li>It does not unlawfully contain another person’s private information.</li>\n        <li>It may be used and shared as reasonably necessary to operate the quote service.</li>\n    </ul>\n\n    <p>Uploaded files may remain in backups, audit records and contractor systems for a reasonable period after the enquiry has ended.</p>\n\n    <h2>Cookies and Similar Technologies</h2>\n\n    <p>We use cookies and similar technologies to operate the website, remember preferences, measure performance and understand how visitors use the service.</p>\n\n    <p>Cookies used on the website may include:</p>\n\n    <ul>\n        <li><strong>Strictly necessary cookies</strong> – required for essential website and form functions.</li>\n        <li><strong>Preference cookies</strong> – used to remember choices and settings.</li>\n        <li><strong>Analytics cookies</strong> – used to understand website traffic and user behaviour.</li>\n        <li><strong>Advertising cookies</strong> – used to measure advertising and, where permitted, deliver more relevant advertising.</li>\n    </ul>\n\n    <p>Non-essential cookies should only be used where permitted by applicable law and in accordance with the choices available through the website’s cookie banner or settings.</p>\n\n    <p>You can also control cookies through your browser. Blocking some cookies may affect the way the website or quote form works.</p>\n\n    <h2>Google AdSense Advertising</h2>\n\n    <p>This website displays advertisements served by Google AdSense, an advertising service provided by Google. For visitors in the UK, the European Economic Area and Switzerland, the service is provided by Google Ireland Limited; elsewhere it is provided by Google LLC. Adverts appear in fixed positions on our pages and help to keep the quotation service free to use. We do not choose the individual adverts shown, and an advert appearing on this website does not mean we recommend or endorse the advertiser.</p>\n\n    <h3>How Google's advertising cookies work</h3>\n\n    <ul>\n        <li>Third-party vendors, including Google, use cookies to serve adverts based on your previous visits to this website or to other websites.</li>\n        <li>Google's use of advertising cookies enables it and its partners to serve adverts to you based on your visits to this website and/or other sites on the internet.</li>\n        <li>Google and its partners may also use cookies and similar technologies, such as device identifiers and local storage, to limit how many times you see the same advert, measure how adverts perform, produce aggregated reports for advertisers and publishers, and detect and prevent fraudulent or invalid advertising activity.</li>\n        <li>Cookies used for these purposes may be set on this website's domain (for example <code>__gads</code>, <code>__gpi</code> and <code>__eoi</code>) and on Google-operated domains such as doubleclick.net (for example <code>IDE</code>). Google may change the names and lifespans of these cookies at any time.</li>\n    </ul>\n\n    <p>Information collected through these technologies may include your IP address, browser and device details, the pages you view, the adverts you see and interact with, and your approximate location. Google and its partners use this information in accordance with their own privacy policies. You can learn more in <a href=\"https://policies.google.com/technologies/partner-sites\" target=\"_blank\" rel=\"noopener noreferrer\">How Google uses information from sites or apps that use its services</a>, <a href=\"https://policies.google.com/technologies/ads\" target=\"_blank\" rel=\"noopener noreferrer\">how Google uses cookies in advertising</a> and the <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Google Privacy Policy</a>. Google may process this information outside the UK, including in the United States, subject to the safeguards described in its own policies.</p>\n\n    <h3>Your consent choices</h3>\n\n    <p>When you visit this website from the UK, the European Economic Area or Switzerland, a consent message provided by Google is displayed. Google's consent management platform is certified under the IAB Transparency and Consent Framework. The message explains how cookies and personal data are used for advertising, lists Google and the other advertising partners involved, and lets you accept, reject or manage your choices for each purpose and each partner.</p>\n\n    <ul>\n        <li><strong>If you consent</strong>, Google and its partners may use cookies and similar technologies to show you personalised adverts based on your interests and browsing activity.</li>\n        <li><strong>If you do not consent to personalised advertising</strong>, Google may show non-personalised adverts, which are selected using contextual information such as the content of the page you are viewing and your general location rather than your browsing history. Where you have agreed to information being stored on your device, these adverts may still use cookies for frequency capping, aggregated reporting and fraud prevention.</li>\n        <li><strong>If you do not agree to information being stored on your device</strong>, Google may show limited adverts that do not use cookies or other device identifiers for advertising purposes.</li>\n    </ul>\n\n    <p>You can change or withdraw your consent at any time using the privacy and cookie settings option displayed on the website, usually a small link or button at the bottom of the page, which reopens the consent message. Withdrawing consent does not affect processing that took place before you withdrew it.</p>\n\n    <p>You can also manage personalised advertising by Google through <a href=\"https://myadcenter.google.com/\" target=\"_blank\" rel=\"noopener noreferrer\">My Ad Center</a>, opt out of personalised advertising by many third-party vendors at <a href=\"https://www.youronlinechoices.com/uk/\" target=\"_blank\" rel=\"noopener noreferrer\">youronlinechoices.com</a> or <a href=\"https://optout.aboutads.info/\" target=\"_blank\" rel=\"noopener noreferrer\">aboutads.info</a>, and block or delete cookies through your browser settings.</p>\n\n    <p>We rely on your consent to store and access information on your device for advertising purposes and to use personal data for personalised advertising. Where Google uses information for its own purposes, it does so as an independent controller.</p>\n\n    <h2>Google Maps</h2>\n\n    <p>Some of our location pages include a small embedded map provided by Google Maps, a service of Google LLC (or Google Ireland Limited for visitors in the UK, the European Economic Area and Switzerland), to show the area the page covers. The map is loaded only when you scroll to the part of the page where it appears.</p>\n\n    <p>When the map loads, your browser connects directly to Google's servers. Google may receive your IP address, browser and device details and the address of the page you are viewing, and may set or read cookies on Google-operated domains, particularly if you are signed in to a Google account. We do not receive any information from Google about your use of the map, and we do not send Google any details you enter in our quote form.</p>\n\n    <p>Google uses this information in accordance with the <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Google Privacy Policy</a> and the <a href=\"https://cloud.google.com/maps-platform/terms\" target=\"_blank\" rel=\"noopener noreferrer\">Google Maps Platform Terms</a>. If you prefer that Google does not receive this information, you can block third-party content or cookies in your browser; the rest of the page will continue to work normally.</p>\n\n    <h2>Data Retention</h2>\n\n    <p>We keep personal information only for as long as reasonably necessary for the purposes for which it was collected.</p>\n\n    <p>The length of time information is retained may depend on:</p>\n\n    <ul>\n        <li>How long it is needed to provide and administer the quote service.</li>\n        <li>Whether the enquiry remains active.</li>\n        <li>Whether you continue to interact with us.</li>\n        <li>Customer service, complaint or dispute requirements.</li>\n        <li>Fraud prevention and system security.</li>\n        <li>Legal, regulatory, tax, accounting and audit obligations.</li>\n        <li>The need to establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <p>Some information may be retained for longer where there is a legal, compliance, security or dispute-resolution reason to do so.</p>\n\n    <p>Contractors receiving your enquiry will apply their own retention policies to the copies of your information held in their systems.</p>\n\n    <h2>International Transfers</h2>\n\n    <p>Some of the technology and service providers used to operate our websites may process information outside the United Kingdom.</p>\n\n    <p>Where personal information is transferred internationally, we will take appropriate steps required by UK data protection law. These may include using an adequacy regulation, approved contractual safeguards or another lawful transfer mechanism.</p>\n\n    <h2>How We Protect Your Information</h2>\n\n    <p>We use reasonable technical and organisational measures designed to protect personal information from loss, misuse, alteration, unauthorised access or disclosure.</p>\n\n    <p>These measures may include encrypted website connections, access controls, monitoring, backups and security procedures. However, no internet service or storage system can be guaranteed to be completely secure.</p>\n\n    <p>If you believe your personal information may have been compromised, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>Your Data Protection Rights</h2>\n\n    <p>Depending on the circumstances, UK data protection law may give you the right to:</p>\n\n    <ul>\n        <li><strong>Request access</strong> to the personal information we hold about you.</li>\n        <li><strong>Request correction</strong> of inaccurate or incomplete information.</li>\n        <li><strong>Request erasure</strong> of your personal information where there is no lawful reason for us to continue using it.</li>\n        <li><strong>Request restriction</strong> of the way your information is processed.</li>\n        <li><strong>Object to processing</strong> based on legitimate interests.</li>\n        <li><strong>Object to direct marketing</strong> at any time.</li>\n        <li><strong>Request data portability</strong> in certain circumstances.</li>\n        <li><strong>Withdraw consent</strong> where processing is based on consent.</li>\n        <li><strong>Ask for information about automated processing</strong> where applicable.</li>\n        <li><strong>Complain to the Information Commissioner’s Office</strong>.</li>\n    </ul>\n\n    <p>These rights are not absolute, and there may be circumstances in which we are legally permitted or required to retain or continue processing some information.</p>\n\n    <p>We may ask for information to confirm your identity before responding to a request. This helps prevent personal information from being disclosed to someone who is not entitled to receive it.</p>\n\n    <p>We normally aim to respond to a valid data protection request within one month. More time may be required for particularly complex requests, in which case we will explain the reason for the delay.</p>\n\n    <p>To exercise any of these rights, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>Complaints</h2>\n\n    <p>Please contact Leads Do Work Ltd first if you have concerns about the way your personal information has been handled. You can find the appropriate contact options at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <p>You also have the right to complain to the UK Information Commissioner’s Office. Information about making a complaint is available on the Information Commissioner’s Office website.</p>\n\n    <h2>Links to Other Websites</h2>\n\n    <p>This website may contain links to contractor websites, social media platforms or other third-party services. We are not responsible for the content, security or privacy practices of websites operated by other organisations.</p>\n\n    <p>You should read the privacy policy of any external website before providing personal information to it.</p>\n\n    <h2>Children’s Information</h2>\n\n    <p>This quote service is intended for adults seeking services for a property. It is not intended for children, and we do not knowingly collect personal information from anyone under the age of 18.</p>\n\n    <h2>Changes to This Privacy Policy</h2>\n\n    <p>We may update this privacy policy from time to time to reflect changes to the website, our services, technology or legal requirements.</p>\n\n    <p>The latest version will be published on this page, and the date at the top will show when it was last updated.</p>\n\n    <h2>Contact Leads Do Work Ltd</h2>\n\n    <p>For privacy questions, complaints or requests concerning your personal information, please visit <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a> and use the contact details or contact options provided there.</p>\n\n    <p><strong>Last updated: 27 September 2026</strong></p>\n\n</article>\n",
    "rigid-sun-tunnel-installation-county": "<article class=\"rigid-sun-tunnel-installation-county-content\">\n<h2>{Rigid Sun Tunnel Installation in [COUNTY]|Compare rigid sun tunnel installation quotes in [COUNTY]|Local help with rigid sun tunnel installation in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For rigid sun tunnel installation in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Rigid sun tunnels use smooth reflective aluminium sections to carry daylight through the roof void. Straight sections, approved extensions and angled elbows allow a planned route to the ceiling. They are often chosen where light output matters or the route is longer than a short flexible connection.|Smooth aluminium tube sections form a rigid route from the roof to the ceiling. Compatible elbows and extensions help an installer plan the connection, while the system’s reflective lining carries daylight along the measured run.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>A deeper loft needs a carefully specified tube run.</li>\n<li>An existing flexible system provides disappointing daylight.</li>\n<li>A larger landing or room needs an assessment of tube diameter and output.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Measure the full route and compare it with the chosen manufacturer’s permitted lengths.|Check the measured tube length against the manufacturer’s guidance.}</li>\n<li>{Plan the fewest practical bends without cutting or weakening roof timbers.|Lay out a direct route with approved elbows while preserving the roof structure.}</li>\n<li>{Specify tube sections, extensions, elbows and compatible roof flashing.|Allow for each extension, support and roof flashing component in the specification.}</li>\n<li>{Secure the assembly and seal each joint without damaging the reflective lining.|Assemble supported tube sections and carefully close the connections with suitable seals.}</li>\n<li>{Maintain insulation continuity and fit the ceiling diffuser with a sound air seal.|Restore insulation around the fitting and complete the ceiling air seal.}</li></ul>\n\n<p>A rigid tube is not a promise of a particular brightness. Tube length, bends, diameter, roof orientation and shading still matter. Ask the installer to explain expected performance for your route rather than selecting on price alone.</p>\n\n<h2>{Guide costs for rigid sun tunnel installation|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £650–£1,800. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for rigid sun tunnel installation}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request rigid sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], can a rigid sun tunnel have bends?</h3>\n\n<p>Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.</p>\n<h3>What affects rigid sun tunnel installation costs in [COUNTY]?</h3>\n\n<p>The guide range is £650–£1,800. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], can a rigid sun tunnel have bends?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects rigid sun tunnel installation costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £650–£1,800. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "rigid-sun-tunnel-installation-town": "<article class=\"rigid-sun-tunnel-installation-town-content\">\n<h2>{Rigid Sun Tunnel Installation in [TOWN]|Compare rigid sun tunnel installation quotes in [TOWN]|Local help with rigid sun tunnel installation in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For rigid sun tunnel installation in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Rigid sun tunnels use smooth reflective aluminium sections to carry daylight through the roof void. Straight sections, approved extensions and angled elbows allow a planned route to the ceiling. They are often chosen where light output matters or the route is longer than a short flexible connection.|Smooth aluminium tube sections form a rigid route from the roof to the ceiling. Compatible elbows and extensions help an installer plan the connection, while the system’s reflective lining carries daylight along the measured run.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>A deeper loft needs a carefully specified tube run.</li>\n<li>An existing flexible system provides disappointing daylight.</li>\n<li>A larger landing or room needs an assessment of tube diameter and output.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Measure the full route and compare it with the chosen manufacturer’s permitted lengths.|Check the measured tube length against the manufacturer’s guidance.}</li>\n<li>{Plan the fewest practical bends without cutting or weakening roof timbers.|Lay out a direct route with approved elbows while preserving the roof structure.}</li>\n<li>{Specify tube sections, extensions, elbows and compatible roof flashing.|Allow for each extension, support and roof flashing component in the specification.}</li>\n<li>{Secure the assembly and seal each joint without damaging the reflective lining.|Assemble supported tube sections and carefully close the connections with suitable seals.}</li>\n<li>{Maintain insulation continuity and fit the ceiling diffuser with a sound air seal.|Restore insulation around the fitting and complete the ceiling air seal.}</li></ul>\n\n<p>A rigid tube is not a promise of a particular brightness. Tube length, bends, diameter, roof orientation and shading still matter. Ask the installer to explain expected performance for your route rather than selecting on price alone.</p>\n\n<h2>{Guide costs for rigid sun tunnel installation|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £650–£1,800. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for rigid sun tunnel installation}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request rigid sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], can a rigid sun tunnel have bends?</h3>\n\n<p>Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.</p>\n<h3>What affects rigid sun tunnel installation costs in [TOWN]?</h3>\n\n<p>The guide range is £650–£1,800. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], can a rigid sun tunnel have bends?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects rigid sun tunnel installation costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £650–£1,800. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "rigid-sun-tunnel-installation": "<article class=\"rigid-sun-tunnel-installation-content\">\n<h2>What is rigid sun tunnel installation?</h2>\n\n<p>Rigid sun tunnels use smooth reflective aluminium sections to carry daylight through the roof void. Straight sections, approved extensions and angled elbows allow a planned route to the ceiling. They are often chosen where light output matters or the route is longer than a short flexible connection.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/rigid-aluminium-sun-tunnel-loft-route.jpg\" alt=\"Rigid aluminium tube sections and an angled elbow inside a timber loft\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need rigid sun tunnel installation</h2>\n\n<ul><li>A deeper loft needs a carefully specified tube run.</li>\n<li>An existing flexible system provides disappointing daylight.</li>\n<li>A larger landing or room needs an assessment of tube diameter and output.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Measure the full route and compare it with the chosen manufacturer’s permitted lengths.</li>\n<li>Plan the fewest practical bends without cutting or weakening roof timbers.</li>\n<li>Specify tube sections, extensions, elbows and compatible roof flashing.</li>\n<li>Secure the assembly and seal each joint without damaging the reflective lining.</li>\n<li>Maintain insulation continuity and fit the ceiling diffuser with a sound air seal.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>A rigid tube is not a promise of a particular brightness. Tube length, bends, diameter, roof orientation and shading still matter. Ask the installer to explain expected performance for your route rather than selecting on price alone.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for rigid sun tunnel installation is £650–£1,800. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Can a rigid sun tunnel have bends?</h3>\n\n<p>Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For rigid sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can a rigid sun tunnel have bends?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes, suitable systems use compatible angled elbows. Extra bends can reduce light transmission, so the route should stay as direct as the structure allows and follow the manufacturer’s limits.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For rigid sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-installation-county": "<article class=\"sun-tunnel-installation-county-content\">\n<h2>{Sun Tunnel Installation in [COUNTY]|Compare sun tunnel installation quotes in [COUNTY]|Local help with sun tunnel installation in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel installation in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{A sun tunnel brings daylight from a roof collector through a reflective tube to a diffuser in the ceiling. It can brighten an internal room below a loft or suitable flat roof without a full roof window. The route still needs a survey: roof shading, available space and obstructions all affect the result.|A roof collector, reflective light tube and ceiling diffuser work together to bring daylight into a room below. This can suit a space beneath a loft or compatible flat roof, provided a survey finds a viable route and useful roof exposure.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>A landing needs artificial light even on bright days.</li>\n<li>An internal WC or corridor has no external wall for a window.</li>\n<li>You want to assess a small roof opening before considering larger alterations.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Survey the roof slope or flat roof and check the covering, daylight exposure and safe access.|Check the roof covering, shading and working access during the first survey.}</li>\n<li>{Measure the roof-to-ceiling route, checking rafters, joists, pipes and cables before marking openings.|Measure the intended tube run and locate structural timbers, services and other obstructions.}</li>\n<li>{Specify a collector, compatible flashing, tube diameter and diffuser that suit the room and route.|Choose the diameter, roof kit and ceiling fitting for the room rather than ordering a generic kit.}</li>\n<li>{Protect the room, form the openings without unapproved timber alterations, fit the flashing and secure the tube.|Protect surfaces and install the collector and tube without unauthorised structural changes.}</li>\n<li>{Seal joints and the ceiling connection, reinstate insulation and agree plastering, decorating and waste removal.|Finish the seals, restore displaced insulation and confirm who handles ceiling repairs and rubbish.}</li></ul>\n\n<p>Daylight varies with the weather and time of day. A sun tunnel does not provide a view or normally open for fresh air, and ordinary electric lighting is still needed after dark.</p>\n\n<h2>{Guide costs for sun tunnel installation|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £500–£1,400. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for sun tunnel installation}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], can every dark room take a sun tunnel?</h3>\n\n<p>The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.</p>\n<h3>What affects sun tunnel installation costs in [COUNTY]?</h3>\n\n<p>The guide range is £500–£1,400. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], can every dark room take a sun tunnel?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel installation costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £500–£1,400. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-installation-town": "<article class=\"sun-tunnel-installation-town-content\">\n<h2>{Sun Tunnel Installation in [TOWN]|Compare sun tunnel installation quotes in [TOWN]|Local help with sun tunnel installation in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel installation in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{A sun tunnel brings daylight from a roof collector through a reflective tube to a diffuser in the ceiling. It can brighten an internal room below a loft or suitable flat roof without a full roof window. The route still needs a survey: roof shading, available space and obstructions all affect the result.|A roof collector, reflective light tube and ceiling diffuser work together to bring daylight into a room below. This can suit a space beneath a loft or compatible flat roof, provided a survey finds a viable route and useful roof exposure.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>A landing needs artificial light even on bright days.</li>\n<li>An internal WC or corridor has no external wall for a window.</li>\n<li>You want to assess a small roof opening before considering larger alterations.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Survey the roof slope or flat roof and check the covering, daylight exposure and safe access.|Check the roof covering, shading and working access during the first survey.}</li>\n<li>{Measure the roof-to-ceiling route, checking rafters, joists, pipes and cables before marking openings.|Measure the intended tube run and locate structural timbers, services and other obstructions.}</li>\n<li>{Specify a collector, compatible flashing, tube diameter and diffuser that suit the room and route.|Choose the diameter, roof kit and ceiling fitting for the room rather than ordering a generic kit.}</li>\n<li>{Protect the room, form the openings without unapproved timber alterations, fit the flashing and secure the tube.|Protect surfaces and install the collector and tube without unauthorised structural changes.}</li>\n<li>{Seal joints and the ceiling connection, reinstate insulation and agree plastering, decorating and waste removal.|Finish the seals, restore displaced insulation and confirm who handles ceiling repairs and rubbish.}</li></ul>\n\n<p>Daylight varies with the weather and time of day. A sun tunnel does not provide a view or normally open for fresh air, and ordinary electric lighting is still needed after dark.</p>\n\n<h2>{Guide costs for sun tunnel installation|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £500–£1,400. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for sun tunnel installation}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request sun tunnel installation quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], can every dark room take a sun tunnel?</h3>\n\n<p>The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.</p>\n<h3>What affects sun tunnel installation costs in [TOWN]?</h3>\n\n<p>The guide range is £500–£1,400. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], can every dark room take a sun tunnel?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel installation costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £500–£1,400. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-installation": "<article class=\"sun-tunnel-installation-content\">\n<h2>What is sun tunnel installation?</h2>\n\n<p>A sun tunnel brings daylight from a roof collector through a reflective tube to a diffuser in the ceiling. It can brighten an internal room below a loft or suitable flat roof without a full roof window. The route still needs a survey: roof shading, available space and obstructions all affect the result.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-roof-collector-tiled-roof.jpg\" alt=\"Sun tunnel roof collector and flashing fitted into a grey tiled roof\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need sun tunnel installation</h2>\n\n<ul><li>A landing needs artificial light even on bright days.</li>\n<li>An internal WC or corridor has no external wall for a window.</li>\n<li>You want to assess a small roof opening before considering larger alterations.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Survey the roof slope or flat roof and check the covering, daylight exposure and safe access.</li>\n<li>Measure the roof-to-ceiling route, checking rafters, joists, pipes and cables before marking openings.</li>\n<li>Specify a collector, compatible flashing, tube diameter and diffuser that suit the room and route.</li>\n<li>Protect the room, form the openings without unapproved timber alterations, fit the flashing and secure the tube.</li>\n<li>Seal joints and the ceiling connection, reinstate insulation and agree plastering, decorating and waste removal.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>Daylight varies with the weather and time of day. A sun tunnel does not provide a view or normally open for fresh air, and ordinary electric lighting is still needed after dark.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for sun tunnel installation is £500–£1,400. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Can every dark room take a sun tunnel?</h3>\n\n<p>The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can every dark room take a sun tunnel?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The room needs a workable route to a suitable roof collector. An installer must assess the distance, obstructions and roof exposure before recommending a system.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel installation, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-repairs-county": "<article class=\"sun-tunnel-repairs-county-content\">\n<h2>{Sun Tunnel Repairs in [COUNTY]|Compare sun tunnel repair quotes in [COUNTY]|Local help with sun tunnel repair in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel repair in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Sun tunnel repairs start with finding the source of the fault. Water around a diffuser can come from rain entering at roof level, moisture condensing in the tube or humid room air passing through a poor ceiling seal. Resealing the visible fitting alone may leave the cause untouched.|Tracing a sun tunnel fault involves more than checking the ceiling diffuser. A specialist should distinguish rainwater ingress from condensation and inspect the roof fittings, tube connections and ceiling air seal before proposing a repair.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>Drips, staining or damp insulation near the light tube.</li>\n<li>A cracked collector, loose diffuser or rattling roof fitting.</li>\n<li>Dust, insects or mist inside the diffuser and reduced light output.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Ask when drips appear and inspect the collector, flashing, nearby tiles and tube joints.|Inspect the roof fitting and ask whether the fault follows rainfall or indoor humidity.}</li>\n<li>{Check the ceiling air seal, loft insulation and signs of condensation before selecting a repair.|Look for insulation gaps and air leakage around the diffuser as well as damaged roof components.}</li>\n<li>{Replace compatible damaged parts or repair flashing where its condition allows.|Replace damaged fittings with compatible parts and repair the roof weathering where appropriate.}</li>\n<li>{Re-seal tube connections using the specified materials and address gaps in insulation.|Seal loose tube joints with the specified tape or seals and assess insulation around the tube.}</li>\n<li>{Explain whether damp plaster or insulation needs separate attention and record any follow-up checks.|Identify any remaining damp damage and explain how the repair should be monitored.}</li></ul>\n\n<p>Rainfall timing is a clue, not a diagnosis. Avoid climbing onto the roof or opening a fitting above electrical equipment. If water is near wiring, keep clear and seek appropriate professional help. A repair cannot be promised until the cause and parts availability are known.</p>\n\n<h2>{Guide costs for sun tunnel repair|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £120–£450. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for sun tunnel repair}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request sun tunnel repair quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], does mist inside a sun tunnel always mean a roof leak?</h3>\n\n<p>No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.</p>\n<h3>What affects sun tunnel repair costs in [COUNTY]?</h3>\n\n<p>The guide range is £120–£450. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], does mist inside a sun tunnel always mean a roof leak?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel repair costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £120–£450. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-repairs-town": "<article class=\"sun-tunnel-repairs-town-content\">\n<h2>{Sun Tunnel Repairs in [TOWN]|Compare sun tunnel repair quotes in [TOWN]|Local help with sun tunnel repair in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel repair in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Sun tunnel repairs start with finding the source of the fault. Water around a diffuser can come from rain entering at roof level, moisture condensing in the tube or humid room air passing through a poor ceiling seal. Resealing the visible fitting alone may leave the cause untouched.|Tracing a sun tunnel fault involves more than checking the ceiling diffuser. A specialist should distinguish rainwater ingress from condensation and inspect the roof fittings, tube connections and ceiling air seal before proposing a repair.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>Drips, staining or damp insulation near the light tube.</li>\n<li>A cracked collector, loose diffuser or rattling roof fitting.</li>\n<li>Dust, insects or mist inside the diffuser and reduced light output.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Ask when drips appear and inspect the collector, flashing, nearby tiles and tube joints.|Inspect the roof fitting and ask whether the fault follows rainfall or indoor humidity.}</li>\n<li>{Check the ceiling air seal, loft insulation and signs of condensation before selecting a repair.|Look for insulation gaps and air leakage around the diffuser as well as damaged roof components.}</li>\n<li>{Replace compatible damaged parts or repair flashing where its condition allows.|Replace damaged fittings with compatible parts and repair the roof weathering where appropriate.}</li>\n<li>{Re-seal tube connections using the specified materials and address gaps in insulation.|Seal loose tube joints with the specified tape or seals and assess insulation around the tube.}</li>\n<li>{Explain whether damp plaster or insulation needs separate attention and record any follow-up checks.|Identify any remaining damp damage and explain how the repair should be monitored.}</li></ul>\n\n<p>Rainfall timing is a clue, not a diagnosis. Avoid climbing onto the roof or opening a fitting above electrical equipment. If water is near wiring, keep clear and seek appropriate professional help. A repair cannot be promised until the cause and parts availability are known.</p>\n\n<h2>{Guide costs for sun tunnel repair|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £120–£450. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for sun tunnel repair}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request sun tunnel repair quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], does mist inside a sun tunnel always mean a roof leak?</h3>\n\n<p>No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.</p>\n<h3>What affects sun tunnel repair costs in [TOWN]?</h3>\n\n<p>The guide range is £120–£450. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], does mist inside a sun tunnel always mean a roof leak?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel repair costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £120–£450. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-repairs": "<article class=\"sun-tunnel-repairs-content\">\n<h2>What is sun tunnel repair?</h2>\n\n<p>Sun tunnel repairs start with finding the source of the fault. Water around a diffuser can come from rain entering at roof level, moisture condensing in the tube or humid room air passing through a poor ceiling seal. Resealing the visible fitting alone may leave the cause untouched.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-sealed-joints-insulation-repair.jpg\" alt=\"Sealed reflective tube joints and an insulation sleeve inside a loft\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need sun tunnel repair</h2>\n\n<ul><li>Drips, staining or damp insulation near the light tube.</li>\n<li>A cracked collector, loose diffuser or rattling roof fitting.</li>\n<li>Dust, insects or mist inside the diffuser and reduced light output.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Ask when drips appear and inspect the collector, flashing, nearby tiles and tube joints.</li>\n<li>Check the ceiling air seal, loft insulation and signs of condensation before selecting a repair.</li>\n<li>Replace compatible damaged parts or repair flashing where its condition allows.</li>\n<li>Re-seal tube connections using the specified materials and address gaps in insulation.</li>\n<li>Explain whether damp plaster or insulation needs separate attention and record any follow-up checks.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>Rainfall timing is a clue, not a diagnosis. Avoid climbing onto the roof or opening a fitting above electrical equipment. If water is near wiring, keep clear and seek appropriate professional help. A repair cannot be promised until the cause and parts availability are known.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for sun tunnel repair is £120–£450. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Does mist inside a sun tunnel always mean a roof leak?</h3>\n\n<p>No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel repair, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does mist inside a sun tunnel always mean a roof leak?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Condensation and failed seals can also cause mist or drips. The installer needs to inspect the roof end, tube and ceiling seal before deciding which repair is appropriate.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel repair, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-replacement-county": "<article class=\"sun-tunnel-replacement-county-content\">\n<h2>{Sun Tunnel Replacement in [COUNTY]|Compare sun tunnel replacement quotes in [COUNTY]|Local help with sun tunnel replacement in [COUNTY]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel replacement in [COUNTY], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Replacing a sun tunnel can restore daylight where the collector, tube or diffuser has deteriorated. A compatible modern unit may use the existing opening, but the installer must check its size, roof flashing and surrounding condition rather than assume the swap is straightforward.|An older daylight tube may benefit from replacement if damaged parts or poor performance cannot be addressed economically. The survey should establish which components can be retained and whether a compatible unit will fit the existing opening.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [COUNTY]</h2>\n\n<ul><li>A yellowed or damaged collector is reducing daylight.</li>\n<li>The original diffuser is brittle, discoloured or no longer seals properly.</li>\n<li>You want to improve an old system while other roof work is taking place.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Identify the existing make, diameter and roof opening, including parts that remain available.|Record the original unit’s make and size and check whether matching components can be sourced.}</li>\n<li>{Inspect the flashing, roof covering, tube route and any damp ceiling or insulation.|Examine the old opening and adjacent tiles, seals and insulation for damage.}</li>\n<li>{Compare a full replacement with replacing only the failed collector or diffuser.|Explain whether a partial upgrade or a complete replacement makes more sense.}</li>\n<li>{Remove agreed old components and fit a compatible replacement with new seals and sound flashing.|Remove only the components included in the quotation and install correctly matched new fittings.}</li>\n<li>{Check the completed joints, dispose of removed parts and agree any ceiling making-good.|Check the joints and leave the room tidy, with any ceiling finishing clearly agreed.}</li></ul>\n\n<p>New parts are not universally interchangeable. Mixing different manufacturers or diameters can compromise fit and sealing. Ask which existing components will be retained and how that affects warranty cover.</p>\n\n<h2>{Guide costs for sun tunnel replacement|Budgeting for the work|What affects the quotation} in [COUNTY]</h2>\n\n<p>The indicative service range is £450–£1,300. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [COUNTY]|Questions for a local installer|Comparing offers in [COUNTY]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [COUNTY]|Finding coverage near your home|Local availability for sun tunnel replacement}</h2>\n\n<p>{Give your postcode in [COUNTY] when requesting quotes|Coverage across [COUNTY] varies between installers|A postcode helps identify which part of [COUNTY] your enquiry concerns}. Availability depends on the job and businesses currently covering your area.</p>\n\n<h2>{Request sun tunnel replacement quotes|Tell us what needs doing|Start with an enquiry} in [COUNTY]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [COUNTY], can the existing roof opening be reused?</h3>\n\n<p>Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.</p>\n<h3>What affects sun tunnel replacement costs in [COUNTY]?</h3>\n\n<p>The guide range is £450–£1,300. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [COUNTY]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [COUNTY]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [COUNTY], can the existing roof opening be reused?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel replacement costs in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £450–£1,300. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-replacement-town": "<article class=\"sun-tunnel-replacement-town-content\">\n<h2>{Sun Tunnel Replacement in [TOWN]|Compare sun tunnel replacement quotes in [TOWN]|Local help with sun tunnel replacement in [TOWN]}</h2>\n\n<p>{A dark room or a faulty daylight tube needs advice based on the roof above it|The right approach starts with checking the roof, ceiling and route between them|A useful quotation should explain the proposed work as well as its price}. For sun tunnel replacement in [TOWN], submit one enquiry to hear from up to four independent specialists, subject to local availability.</p>\n\n<p>{Replacing a sun tunnel can restore daylight where the collector, tube or diffuser has deteriorated. A compatible modern unit may use the existing opening, but the installer must check its size, roof flashing and surrounding condition rather than assume the swap is straightforward.|An older daylight tube may benefit from replacement if damaged parts or poor performance cannot be addressed economically. The survey should establish which components can be retained and whether a compatible unit will fit the existing opening.}</p>\n\n<h2>{When homeowners ask for this work|Reasons to arrange an assessment|Problems and projects to discuss} in [TOWN]</h2>\n\n<ul><li>A yellowed or damaged collector is reducing daylight.</li>\n<li>The original diffuser is brittle, discoloured or no longer seals properly.</li>\n<li>You want to improve an old system while other roof work is taking place.</li></ul>\n\n<h2>{What the specialist may inspect and carry out|From the first survey to finishing the job|What to ask the installer to include}</h2>\n\n<ul><li>{Identify the existing make, diameter and roof opening, including parts that remain available.|Record the original unit’s make and size and check whether matching components can be sourced.}</li>\n<li>{Inspect the flashing, roof covering, tube route and any damp ceiling or insulation.|Examine the old opening and adjacent tiles, seals and insulation for damage.}</li>\n<li>{Compare a full replacement with replacing only the failed collector or diffuser.|Explain whether a partial upgrade or a complete replacement makes more sense.}</li>\n<li>{Remove agreed old components and fit a compatible replacement with new seals and sound flashing.|Remove only the components included in the quotation and install correctly matched new fittings.}</li>\n<li>{Check the completed joints, dispose of removed parts and agree any ceiling making-good.|Check the joints and leave the room tidy, with any ceiling finishing clearly agreed.}</li></ul>\n\n<p>New parts are not universally interchangeable. Mixing different manufacturers or diameters can compromise fit and sealing. Ask which existing components will be retained and how that affects warranty cover.</p>\n\n<h2>{Guide costs for sun tunnel replacement|Budgeting for the work|What affects the quotation} in [TOWN]</h2>\n\n<p>The indicative service range is £450–£1,300. {Use it as a starting allowance rather than a fixed local price|A survey may reveal costs outside this range|The written quotation should confirm what this allowance covers}. {Roof height and safe access can make a substantial difference|The route, materials and access arrangements affect the final figure|Local labour rates, roof condition and parts availability all influence the price}. Confirm VAT, waste disposal and ceiling making-good before agreeing the work.</p>[IMAGE]\n[YOUTUBE]<h2>{Planning, building control and roof details|Before making changes to your property|Checking the requirements for your home}</h2>\n\n<p>{Check property-specific requirements before work starts|Ask what permissions and building checks apply to the proposed work|Confirm the relevant approvals before changing the roof opening}. Rules depend on the work and the UK nation, with additional considerations for listed buildings and protected areas. Contact <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> for guidance on your property. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> provides an introduction for England. Routine repairs and alterations can have different requirements; avoid assuming every replacement is exempt.</p>\n\n<h2>{Choosing a specialist covering [TOWN]|Questions for a local installer|Comparing offers in [TOWN]}</h2>\n\n<p>{Ask for the exact product and installation specification|Request an itemised scope with the tube and roof components listed|Compare the materials, access arrangements and finishing work together}. Companies joining our network are asked for relevant insurance details and references. Check these with the business you choose. Sun-Tunnel.co.uk introduces enquiries; the independent installer provides the quote and carries out the work.</p>\n\n<h2>{Enquiries around [TOWN]|Finding coverage near your home|Local availability for sun tunnel replacement}</h2>\n\n<p>{Tell us your postcode in [TOWN] so that coverage can be checked|An enquiry for [TOWN] helps identify businesses serving that part of [COUNTY]|Availability in [TOWN] depends on which specialists cover your postcode}. {You can also mention a project near [NEARBY_AREAS]|Nearby places to consider include [NEARBY_AREAS]|For homes around [TOWN], nearby areas include [NEARBY_AREAS]}. These local links do not guarantee that an installer is available.</p>\n\n<h2>{Request sun tunnel replacement quotes|Tell us what needs doing|Start with an enquiry} in [TOWN]</h2>\n\n<p>{Use the online form to describe your project|Send the room, roof or fault details through our enquiry form|Explain what you want to change and any known access issues}. You may receive up to four quotations, with no obligation to proceed. {Ask about the proposed route before selecting a kit|Compare the written scope before choosing an installer|Clarify exclusions before accepting a price}.</p>\n\n<h2>{Common questions about this service|Questions to ask before arranging the work|Local homeowner questions}</h2>\n\n<h3>For a home in [TOWN], can the existing roof opening be reused?</h3>\n\n<p>Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.</p>\n<h3>What affects sun tunnel replacement costs in [TOWN]?</h3>\n\n<p>The guide range is £450–£1,300. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.</p>\n<h3>Will I get four quotes for a property in [TOWN]?</h3>\n\n<p>You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.</p>\n<h3>Who can advise on permissions in [TOWN]?</h3>\n\n<p>Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"For a home in [TOWN], can the existing roof opening be reused?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What affects sun tunnel replacement costs in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The guide range is £450–£1,300. The actual price depends on the specification, roof condition, access and any additional finishing or repair work. Ask for a written quotation confirming VAT and exclusions.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will I get four quotes for a property in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"You may receive up to four quotations from independent specialists. The number depends on your postcode, the work requested and local installer availability.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who can advise on permissions in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Ask [COUNCIL_NAME] about the proposed work and your property. Requirements vary with the project, location and any protected status, so do not assume that every sun tunnel alteration is exempt.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "sun-tunnel-replacement": "<article class=\"sun-tunnel-replacement-content\">\n<h2>What is sun tunnel replacement?</h2>\n\n<p>Replacing a sun tunnel can restore daylight where the collector, tube or diffuser has deteriorated. A compatible modern unit may use the existing opening, but the installer must check its size, roof flashing and surrounding condition rather than assume the swap is straightforward.</p>\n\n<img src=\"/sites/sun-tunnel-co-uk/images/sun-tunnel-old-new-collector-replacement.jpg\" alt=\"Old yellowed roof collector beside a new white framed replacement\" loading=\"lazy\" width=\"1536\" height=\"1024\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n\n<h2>Signs you may need sun tunnel replacement</h2>\n\n<ul><li>A yellowed or damaged collector is reducing daylight.</li>\n<li>The original diffuser is brittle, discoloured or no longer seals properly.</li>\n<li>You want to improve an old system while other roof work is taking place.</li></ul>\n\n<h2>What a specialist may do</h2>\n\n<ul><li>Identify the existing make, diameter and roof opening, including parts that remain available.</li>\n<li>Inspect the flashing, roof covering, tube route and any damp ceiling or insulation.</li>\n<li>Compare a full replacement with replacing only the failed collector or diffuser.</li>\n<li>Remove agreed old components and fit a compatible replacement with new seals and sound flashing.</li>\n<li>Check the completed joints, dispose of removed parts and agree any ceiling making-good.</li></ul>\n\n<h2>Details worth discussing</h2>\n\n<p>New parts are not universally interchangeable. Mixing different manufacturers or diameters can compromise fit and sealing. Ask which existing components will be retained and how that affects warranty cover.</p>\n\n<h2>Costs and the written specification</h2>\n\n<p>The indicative UK range for sun tunnel replacement is £450–£1,300. Treat this as a guide for one unit or agreed repair, not a guaranteed price. Tube length, parts, roof condition, property height and safe access can change the total. Confirm VAT, waste removal and ceiling finishing, and ask the firm to list anything excluded.</p>\n\n<h2>Roof work and approvals</h2>\n\n<p>A roof opening needs careful attention to structure, weatherproofing and insulation. Planning permission and building control requirements depend on the building, proposed changes and the rules in your part of the UK. Listed buildings and protected areas need particular care. Ask your installer what approvals apply before work starts; do not assume a small opening is automatically exempt. The <a href=\"https://www.planningportal.co.uk/permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal</a> is a starting point for guidance in England, with local authorities able to advise on your property.</p>\n\n<h2>Find a suitable independent installer</h2>\n\n<p>Sun-Tunnel.co.uk is a homeowner matching service. Send one online enquiry and you may receive up to four quotations from independent local sun tunnel specialists. The number depends on your postcode, the work requested and installer availability. There is no charge to request quotes and no obligation to accept one.</p>\n\n<p>Companies joining the network are asked to provide relevant insurance details and references. Before appointing a firm, check its current cover, ask to see similar installations and agree the specification in writing. The installer surveys the property, gives its own price and carries out the work; your contract is with that business.</p>\n\n<h2>Frequently asked questions</h2>\n\n<h3>Can the existing roof opening be reused?</h3>\n\n<p>Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.</p>\n<h3>What should I include in my enquiry?</h3>\n\n<p>Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel replacement, clear details help the installer decide what needs measuring or inspecting before a written quote.</p>\n\n<script type=\"application/ld+json\">{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can the existing roof opening be reused?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Often it can, provided the replacement matches the opening and the surrounding roof is sound. An installer may need to alter the opening or flashing, which changes the price and scope.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What should I include in my enquiry?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Describe the room or fault, your roof type if known and any access restrictions. For sun tunnel replacement, clear details help the installer decide what needs measuring or inspecting before a written quote.\"\n      }\n    }\n  ]\n}</script>\n</article>\n",
    "terms": "<article class=\"terms-content\">\n\n    <p>These terms and conditions apply when you visit sun-tunnel.co.uk, submit an enquiry or use our sun tunnel quote-matching service.</p>\n\n    <p>The service is provided by <strong>Leads Do Work Ltd</strong>. References in these terms to “we”, “us” or “our” mean Leads Do Work Ltd.</p>\n\n    <p>By using this website or submitting an enquiry, you confirm that you have read and agree to these terms. Please do not use the service if you do not accept them.</p>\n\n    <h2>About Our Service</h2>\n\n    <p>sun-tunnel.co.uk is an introduction and quote-matching service. It helps homeowners, landlords, property buyers, property managers and businesses connect with independent contractors who may be interested in inspecting a property or providing a quotation for sun tunnel and related daylighting work.</p>\n\n    <p>Our service may cover work such as sun tunnel installation, sun tunnel replacement, sun tunnel repairs, rigid and flexible sun tunnel installation, sun tunnels for bathrooms and hallways, and related roofing and ceiling work.</p>\n\n    <p>The quote-matching service is free for people requesting quotations. Contractors may pay Leads Do Work Ltd for access to suitable enquiries or participate through another commercial arrangement with us.</p>\n\n    <h2>Our Role Is Limited to Making Introductions</h2>\n\n    <p>Leads Do Work Ltd is not a sun tunnel installer, roofing contractor, building contractor, surveyor, engineer, architect, insurer or professional adviser.</p>\n\n    <p>We do not:</p>\n\n    <ul>\n        <li>Carry out sun tunnel installation, repair or building work.</li>\n        <li>Visit or inspect the property.</li>\n        <li>Diagnose the cause of a leak, condensation or poor light output.</li>\n        <li>Prepare specifications or scopes of work.</li>\n        <li>Provide professional, structural or technical advice.</li>\n        <li>Set or approve contractors’ prices.</li>\n        <li>Negotiate contracts on behalf of homeowners or contractors.</li>\n        <li>Supervise, manage or inspect work carried out by contractors.</li>\n        <li>Employ the contractors introduced through the service.</li>\n        <li>Act as an agent, partner or representative of a contractor.</li>\n        <li>Guarantee that a contractor will contact you or provide a quotation.</li>\n        <li>Guarantee that any quotation will be suitable or competitive.</li>\n    </ul>\n\n    <p>Our role is limited to receiving your enquiry and attempting to introduce you to independent contractors who may cover your location and type of work.</p>\n\n    <h2>Independent Contractors</h2>\n\n    <p>Every contractor introduced through the service operates as an independent business. Contractors are not employees, workers, subcontractors, agents, partners or representatives of Leads Do Work Ltd.</p>\n\n    <p>Contractors decide independently:</p>\n\n    <ul>\n        <li>Whether to contact you.</li>\n        <li>Whether to inspect your property.</li>\n        <li>What product, tube type or repair to recommend.</li>\n        <li>Whether to provide a quotation.</li>\n        <li>What price to charge.</li>\n        <li>What terms and payment arrangements to offer.</li>\n        <li>Whether they are willing and available to carry out the work.</li>\n    </ul>\n\n    <p>We do not control how a contractor conducts its business or performs its work.</p>\n\n    <h2>No Recommendation, Endorsement or Guarantee</h2>\n\n    <p>An introduction through our service must not be treated as a recommendation, endorsement, certification or guarantee of a contractor.</p>\n\n    <p>Although we may collect or display information about contractors, we do not guarantee that any contractor:</p>\n\n    <ul>\n        <li>Is suitable for your particular property or project.</li>\n        <li>Has all qualifications, skills or experience required for the work.</li>\n        <li>Holds current or sufficient insurance.</li>\n        <li>Belongs to a particular trade association or accreditation scheme.</li>\n        <li>Is financially stable or creditworthy.</li>\n        <li>Will provide a quotation.</li>\n        <li>Will offer the lowest or best price.</li>\n        <li>Will start or complete work within a particular period.</li>\n        <li>Will perform work to a particular standard.</li>\n        <li>Will provide or honour a guarantee.</li>\n        <li>Will comply with every legal, regulatory or professional requirement.</li>\n    </ul>\n\n    <p>The fact that a contractor appears on our network or receives your enquiry does not mean that Leads Do Work Ltd has approved the contractor for your particular project.</p>\n\n    <h2>Information About Contractors</h2>\n\n    <p>Information about a contractor may include its business name, contact details, service area, experience, qualifications, accreditations, trade memberships, insurance details, reviews and other profile information.</p>\n\n    <p>This information may be:</p>\n\n    <ul>\n        <li>Provided directly by the contractor.</li>\n        <li>Collected from publicly available records.</li>\n        <li>Provided by customers or third parties.</li>\n        <li>Based on documents that were current when checked.</li>\n    </ul>\n\n    <p>We may carry out reasonable checks, but we cannot guarantee that contractor information is always accurate, complete or up to date. Qualifications, memberships, insurance policies, company status and personnel may change after checks have been completed.</p>\n\n    <p>You must verify all important information directly with the contractor before appointing it or allowing work to begin.</p>\n\n    <h2>Your Responsibility to Check the Contractor</h2>\n\n    <p>You are solely responsible for deciding whether a contractor is suitable for your project. Before appointing a contractor, paying any money or allowing work to begin, you should carry out your own checks.</p>\n\n    <p>These checks should include, where relevant:</p>\n\n    <ul>\n        <li>Confirming the contractor’s full legal or trading name.</li>\n        <li>Confirming its business address and contact details.</li>\n        <li>Checking how long the business has been trading.</li>\n        <li>Checking Companies House details where the contractor operates through a limited company.</li>\n        <li>Requesting recent references and independently contacting previous customers.</li>\n        <li>Reviewing genuine customer feedback from more than one source.</li>\n        <li>Checking relevant qualifications, training and experience.</li>\n        <li>Checking trade association memberships or accreditations directly with the issuing organisation.</li>\n        <li>Confirming whether specialist survey or waterproofing qualifications are appropriate for the proposed work.</li>\n        <li>Requesting a current public liability insurance certificate.</li>\n        <li>Checking the insurer, policy number, expiry date and level of cover.</li>\n        <li>Confirming that the policy covers the specific type of work being proposed.</li>\n        <li>Checking whether employers’ liability insurance is held where required.</li>\n        <li>Checking whether planning permission, listed building consent, building regulations approval or another permission is required.</li>\n        <li>Checking whether the contractor will arrange necessary approvals or whether this remains your responsibility.</li>\n        <li>Obtaining a written diagnosis and detailed quotation.</li>\n        <li>Reading all proposed contract terms before signing or paying.</li>\n        <li>Confirming who will actually carry out the work and whether subcontractors will be used.</li>\n        <li>Checking the terms and provider of any guarantee or warranty.</li>\n    </ul>\n\n    <p>You should not rely solely on information displayed on this website or provided by Leads Do Work Ltd when choosing a contractor.</p>\n\n    <h2>Specialist Advice and Fault Diagnosis</h2>\n\n    <p>Leaks, condensation, drips and poor light output from a sun tunnel can have several possible causes. Similar visible symptoms may require different repairs.</p>\n\n    <p>Information on this website is general information only. It is not a diagnosis of your property and must not be treated as professional surveying, structural, engineering, legal, financial, health or safety advice.</p>\n\n    <p>You are responsible for deciding whether you need advice from an appropriately qualified independent professional. This may include a building surveyor, structural engineer, architect, conservation specialist, drainage specialist, environmental health professional or another suitably qualified adviser.</p>\n\n    <p>Where you are buying a property, arranging a mortgage, dealing with a listed building or planning substantial work, you should consider obtaining an independent survey rather than relying only on a survey or quotation provided by a contractor seeking to carry out the work.</p>\n\n    <h2>Your Enquiry</h2>\n\n    <p>When submitting an enquiry, you agree to provide information that is accurate, current and complete to the best of your knowledge.</p>\n\n    <p>This may include:</p>\n\n    <ul>\n        <li>Your name and contact details.</li>\n        <li>The property address or postcode.</li>\n        <li>Your relationship to the property.</li>\n        <li>The property type.</li>\n        <li>A description of the sun tunnel work or problem.</li>\n        <li>The work or inspection you require.</li>\n        <li>Your preferred timescale.</li>\n        <li>Any photographs or documents you upload.</li>\n    </ul>\n\n    <p>You must have permission to submit an enquiry relating to the property and to provide any personal information included in it.</p>\n\n    <p>You must not submit:</p>\n\n    <ul>\n        <li>False, misleading or fraudulent information.</li>\n        <li>Another person’s contact details without permission.</li>\n        <li>Enquiries for properties where you have no authority to seek quotations.</li>\n        <li>Offensive, threatening, unlawful or abusive content.</li>\n        <li>Files containing malware or harmful code.</li>\n        <li>Enquiries intended to waste contractors’ time.</li>\n        <li>Enquiries intended to gather prices or business information for improper purposes.</li>\n    </ul>\n\n    <p>We may reject, suspend, edit or remove an enquiry that appears incomplete, duplicate, fraudulent, abusive, unlawful or unsuitable for the service.</p>\n\n    <h2>Sharing Your Enquiry</h2>\n\n    <p>By submitting a quote request, you ask us to attempt to match your enquiry with independent contractors who may be able to help.</p>\n\n    <p>Your enquiry and contact details may be shared with one or more relevant contractors. Those contractors may contact you directly by telephone, text message, email or another reasonable communication method to:</p>\n\n    <ul>\n        <li>Discuss the work.</li>\n        <li>Ask for additional information.</li>\n        <li>Arrange a property visit.</li>\n        <li>Provide a quotation.</li>\n        <li>Follow up on the enquiry.</li>\n    </ul>\n\n    <p>Submission of an enquiry does not guarantee that any contractor will be available, contact you, visit the property or provide a quotation.</p>\n\n    <h2>No Obligation to Appoint a Contractor</h2>\n\n    <p>Submitting an enquiry does not require you to:</p>\n\n    <ul>\n        <li>Accept a quotation.</li>\n        <li>Arrange a property visit.</li>\n        <li>Appoint a contractor.</li>\n        <li>Purchase goods or services.</li>\n        <li>Pay Leads Do Work Ltd for the introduction.</li>\n    </ul>\n\n    <p>You may decline any quotation or decide not to proceed.</p>\n\n    <p>Contractors are also free to decline an enquiry, refuse a visit or decide not to provide a quotation.</p>\n\n    <h2>Property Visits</h2>\n\n    <p>Any visit arranged with a contractor is an arrangement between you and that contractor. Leads Do Work Ltd does not attend, supervise or control contractor visits.</p>\n\n    <p>You are responsible for:</p>\n\n    <ul>\n        <li>Checking the identity of anyone attending the property.</li>\n        <li>Ensuring that an adult is present where appropriate.</li>\n        <li>Providing safe and reasonable access.</li>\n        <li>Informing the contractor about known hazards.</li>\n        <li>Protecting children, pets, valuables and personal possessions.</li>\n        <li>Deciding whether the contractor may enter or inspect particular areas.</li>\n    </ul>\n\n    <p>You should not allow a person into your property if you are unable to confirm their identity or do not feel comfortable doing so.</p>\n\n    <h2>Quotations and Estimates</h2>\n\n    <p>Any quotation, estimate, diagnosis, survey, report or recommendation is provided by the contractor and not by Leads Do Work Ltd.</p>\n\n    <p>Before agreeing to work, you should obtain a written quotation that clearly states:</p>\n\n    <ul>\n        <li>The contractor’s legal or trading name.</li>\n        <li>The property and areas covered.</li>\n        <li>The contractor’s diagnosis of the problem.</li>\n        <li>The proposed product, installation or repair method.</li>\n        <li>Any preparation, removal or disposal work.</li>\n        <li>Whether plaster removal and replastering are included.</li>\n        <li>Whether decorating and making good are included.</li>\n        <li>The materials and systems to be used.</li>\n        <li>The total price.</li>\n        <li>Whether VAT is included.</li>\n        <li>Any provisional sums or possible extra costs.</li>\n        <li>The payment schedule and deposit required.</li>\n        <li>The expected start date and duration.</li>\n        <li>What happens if additional work is discovered.</li>\n        <li>Any cancellation rights.</li>\n        <li>Details and limitations of guarantees or warranties.</li>\n    </ul>\n\n    <p>You should obtain more than one quotation where practical and compare them on a like-for-like basis.</p>\n\n    <p>Leads Do Work Ltd is not responsible for errors, omissions, price changes or disagreements relating to a contractor’s quotation.</p>\n\n    <h2>Your Contract Is With the Contractor</h2>\n\n    <p>If you appoint a contractor, any contract for surveys, goods, materials, installation, repairs or other services is made directly between you and that contractor.</p>\n\n    <p>Leads Do Work Ltd is not a party to that contract and has no responsibility for negotiating, performing, enforcing, cancelling or refunding it.</p>\n\n    <p>Your contract with the contractor should cover matters such as:</p>\n\n    <ul>\n        <li>The agreed scope of work.</li>\n        <li>The price and payment terms.</li>\n        <li>Start and completion dates.</li>\n        <li>Changes and additional work.</li>\n        <li>Materials and product specifications.</li>\n        <li>Access to the property.</li>\n        <li>Insurance and responsibility for damage.</li>\n        <li>Waste removal and cleaning.</li>\n        <li>Guarantees and warranties.</li>\n        <li>Cancellation and termination.</li>\n        <li>Complaints and dispute resolution.</li>\n    </ul>\n\n    <p>You should read the contractor’s terms carefully and seek independent advice where necessary before entering into a contract.</p>\n\n    <h2>Deposits and Payments</h2>\n\n    <p>Payments for sun tunnel work are made directly between you and the contractor. Leads Do Work Ltd does not normally collect, hold or protect money paid to contractors.</p>\n\n    <p>You are responsible for deciding whether a requested deposit or payment schedule is reasonable.</p>\n\n    <p>Before making payment, you should:</p>\n\n    <ul>\n        <li>Confirm the contractor’s identity.</li>\n        <li>Check that the bank account details belong to the correct business or person.</li>\n        <li>Obtain a written quotation or contract.</li>\n        <li>Understand what the payment covers.</li>\n        <li>Ask for a written receipt.</li>\n        <li>Be cautious about large advance payments.</li>\n        <li>Verify any change of bank details through a trusted contact method.</li>\n    </ul>\n\n    <p>Leads Do Work Ltd is not responsible for deposits, advance payments, payment disputes, contractor insolvency, bank-transfer fraud or money paid for work that is delayed, incomplete or not carried out.</p>\n\n    <h2>Changes and Additional Work</h2>\n\n    <p>If the contractor discovers additional problems after work begins, you should request a written explanation and revised price before authorising extra work.</p>\n\n    <p>Leads Do Work Ltd is not responsible for:</p>\n\n    <ul>\n        <li>Changes to the contractor’s diagnosis.</li>\n        <li>Unexpected defects or hidden damage.</li>\n        <li>Additional work or increased costs.</li>\n        <li>Delays caused by further investigations.</li>\n        <li>Disagreements about what was included in the original quotation.</li>\n    </ul>\n\n    <h2>Guarantees and Warranties</h2>\n\n    <p>Any guarantee or warranty is offered by the contractor, manufacturer, insurer or separate guarantee provider named in its terms. It is not provided by Leads Do Work Ltd unless we expressly confirm otherwise in writing.</p>\n\n    <p>Before relying on a guarantee, you should check:</p>\n\n    <ul>\n        <li>Who provides and backs the guarantee.</li>\n        <li>How long the guarantee lasts.</li>\n        <li>What work and materials it covers.</li>\n        <li>What exclusions and maintenance requirements apply.</li>\n        <li>Whether it is transferable to a future property owner.</li>\n        <li>Whether it remains valid if the contractor stops trading.</li>\n        <li>How a claim must be made.</li>\n    </ul>\n\n    <p>Leads Do Work Ltd does not guarantee that a contractor will remain trading or that a guarantee provider will accept a future claim.</p>\n\n    <h2>Workmanship, Damage and Delays</h2>\n\n    <p>Leads Do Work Ltd does not carry out, control, supervise or inspect contractors’ work. We are not responsible for:</p>\n\n    <ul>\n        <li>Incorrect or incomplete fault diagnoses.</li>\n        <li>Unsuitable or unnecessary work or products.</li>\n        <li>Poor, defective or incomplete workmanship.</li>\n        <li>Failure to follow manufacturer instructions or recognised practices.</li>\n        <li>Damage to the property, contents, fixtures or neighbouring property.</li>\n        <li>Leaks, condensation or water ingress continuing or returning.</li>\n        <li>Work that does not comply with planning, building or other legal requirements.</li>\n        <li>Delays, missed appointments or failure to complete work.</li>\n        <li>Noise, dust, disruption or inconvenience.</li>\n        <li>Health and safety failures.</li>\n        <li>Losses caused by a contractor or its employees, workers or subcontractors.</li>\n        <li>Failure to honour a quotation, contract, guarantee or warranty.</li>\n        <li>A contractor becoming insolvent or ceasing to trade.</li>\n    </ul>\n\n    <p>Any concerns about workmanship, damage, delays or the contractor’s conduct must be raised directly with the contractor.</p>\n\n    <h2>Disputes With Contractors</h2>\n\n    <p>A dispute concerning a contractor’s quotation, diagnosis, conduct, payment, workmanship, delay, damage, guarantee or contract is a dispute between you and the contractor.</p>\n\n    <p>You should normally:</p>\n\n    <ul>\n        <li>Raise the complaint with the contractor in writing.</li>\n        <li>Explain the problem clearly and provide supporting evidence.</li>\n        <li>Give the contractor a reasonable opportunity to inspect and resolve the issue.</li>\n        <li>Keep copies of quotations, contracts, invoices, messages and photographs.</li>\n        <li>Check whether the contractor belongs to a trade association or dispute-resolution scheme.</li>\n        <li>Contact your payment provider, insurer, consumer advice service or legal adviser where appropriate.</li>\n    </ul>\n\n    <p>We may choose to record a complaint, request information from the contractor or review whether the contractor should remain in our network. However, we are not required to mediate, investigate or resolve disputes, and we cannot order a contractor to refund money, return to the property or carry out remedial work.</p>\n\n    <h2>Website Information</h2>\n\n    <p>We try to keep information on sun-tunnel.co.uk useful and reasonably current. However, website content is provided for general guidance and may contain errors, omissions or information that is no longer current.</p>\n\n    <p>Prices, product descriptions, timescales and other examples are illustrative only. They are not quotations or promises that a particular method, price or outcome will apply to your property.</p>\n\n    <p>We may change, remove or update website content without notice.</p>\n\n    <h2>Website Availability</h2>\n\n    <p>We do not guarantee that the website or quote service will always be available, secure or free from errors.</p>\n\n    <p>We may suspend or restrict access for maintenance, security, technical, commercial or legal reasons.</p>\n\n    <p>We are not responsible for delays or failures caused by circumstances beyond our reasonable control, including:</p>\n\n    <ul>\n        <li>Internet or telecommunications failures.</li>\n        <li>Hosting or software problems.</li>\n        <li>Cyberattacks or malicious activity.</li>\n        <li>Power failures.</li>\n        <li>Industrial disputes.</li>\n        <li>Severe weather or natural events.</li>\n        <li>Government action or changes in law.</li>\n    </ul>\n\n    <h2>Acceptable Use</h2>\n\n    <p>You must not use the website:</p>\n\n    <ul>\n        <li>For any unlawful or fraudulent purpose.</li>\n        <li>To impersonate another person or business.</li>\n        <li>To submit false or misleading enquiries.</li>\n        <li>To harass contractors, employees or other users.</li>\n        <li>To send spam or unauthorised advertising.</li>\n        <li>To introduce viruses, malware or harmful code.</li>\n        <li>To attempt unauthorised access to our systems or data.</li>\n        <li>To scrape, copy or extract data using automated tools without permission.</li>\n        <li>To interfere with the website’s operation or security.</li>\n        <li>To reproduce or commercially exploit website content without permission.</li>\n    </ul>\n\n    <p>We may block access, remove content or report activity to the relevant authorities where we reasonably believe these terms have been breached.</p>\n\n    <h2>Third-Party Websites</h2>\n\n    <p>The website may contain links to contractor websites, trade associations, review platforms, social media services and other third-party websites.</p>\n\n    <p>These websites are operated independently. We do not control and are not responsible for their content, availability, security, products, services or privacy practices.</p>\n\n    <p>A link does not mean that we recommend or endorse the third party.</p>\n\n    <h2>Our Liability</h2>\n\n    <p>Nothing in these terms excludes or limits liability where it would be unlawful to do so. This includes liability for death or personal injury caused by our negligence, fraud, fraudulent misrepresentation or any other liability that cannot legally be excluded.</p>\n\n    <p>Subject to the paragraph above, Leads Do Work Ltd is not responsible for losses arising from:</p>\n\n    <ul>\n        <li>The acts or omissions of an independent contractor.</li>\n        <li>A contractor’s advice, diagnosis, survey, report or quotation.</li>\n        <li>Work carried out or not carried out by a contractor.</li>\n        <li>Poor, defective, unsuitable, delayed or incomplete workmanship.</li>\n        <li>Property damage caused by a contractor.</li>\n        <li>Payments made to a contractor.</li>\n        <li>A contractor’s insolvency or failure to honour a guarantee.</li>\n        <li>Your decision to appoint or not appoint a contractor.</li>\n        <li>Your failure to check qualifications, insurance, references or contract terms.</li>\n        <li>Information provided by a contractor or another third party.</li>\n        <li>Loss of profits, income, business, opportunity, goodwill or anticipated savings.</li>\n        <li>Indirect or consequential losses that were not reasonably foreseeable when you used the service.</li>\n    </ul>\n\n    <p>Our responsibility is limited to operating the introduction service with reasonable care and skill.</p>\n\n    <p>We do not guarantee that using the service will result in:</p>\n\n    <ul>\n        <li>A particular number of contractor contacts.</li>\n        <li>A property inspection.</li>\n        <li>A quotation.</li>\n        <li>A suitable contractor being available.</li>\n        <li>A particular price or saving.</li>\n        <li>A successful installation or repair.</li>\n    </ul>\n\n    <p>These terms do not affect any rights you have under consumer law that cannot legally be excluded or restricted.</p>\n\n    <h2>Your Responsibility for Losses</h2>\n\n    <p>You may be responsible for reasonable losses or costs suffered by us as a direct result of your fraudulent, unlawful or deliberate misuse of the website, or a serious breach of these terms.</p>\n\n    <h2>Privacy</h2>\n\n    <p>Personal information submitted through the website is handled in accordance with our privacy policy.</p>\n\n    <p>When your enquiry is shared with an independent contractor, that contractor will normally become responsible for its own use of the information it receives. You should read the contractor’s privacy policy and contact it directly about information held in its systems.</p>\n\n    <h2>Changes to These Terms</h2>\n\n    <p>We may update these terms to reflect changes to our service, business practices, technology or legal requirements.</p>\n\n    <p>The latest version will be published on this page. The date at the top will show when the terms were last updated.</p>\n\n    <p>The terms in force when you submit an enquiry will normally apply to that use of the quote service. Your continued use of the website after updated terms are published will be treated as acceptance of the updated terms.</p>\n\n    <h2>Transfer of Our Rights</h2>\n\n    <p>We may transfer our rights and obligations under these terms to another organisation, for example as part of a business sale, restructuring or transfer of the website. Where required, we will take reasonable steps to ensure that this does not reduce your rights.</p>\n\n    <p>You may not transfer your rights or obligations under these terms to another person without our written agreement.</p>\n\n    <h2>Severability</h2>\n\n    <p>If any part of these terms is found to be unlawful, invalid or unenforceable, the remaining provisions will continue to apply.</p>\n\n    <h2>No Waiver</h2>\n\n    <p>If we delay or do not enforce a provision of these terms, that does not mean we have waived our right to enforce it later.</p>\n\n    <h2>Third-Party Rights</h2>\n\n    <p>Unless these terms expressly state otherwise, no person other than you and Leads Do Work Ltd has a right to enforce them.</p>\n\n    <h2>Governing Law and Courts</h2>\n\n    <p>These terms and your use of the service are governed by the laws of England and Wales, subject to any mandatory consumer protections that apply where you live.</p>\n\n    <p>If you live in England or Wales, the courts of England and Wales will have jurisdiction over disputes relating to these terms.</p>\n\n    <p>If you live in Scotland, Northern Ireland or another part of the United Kingdom, you may also be entitled to bring proceedings in the courts serving the part of the UK where you live.</p>\n\n    <h2>Contacting Leads Do Work Ltd</h2>\n\n    <p>Questions about these terms or the operation of the quote service should be directed to Leads Do Work Ltd through the contact options available at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <p><strong>Last updated: 10 July 2026</strong></p>\n\n</article>\n"
  },
  "svgImageTemplate": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1600\" height=\"900\" viewBox=\"0 0 1600 900\" role=\"img\" aria-label=\"Sun tunnel daylight guide\" style=\"max-width:100%;height:auto;display:block;\">\n  <title>Sun tunnel daylight guide: [SERVICE] in [LOCATION]</title>\n  <desc>Compare free quotes for sun tunnel installation, replacement and repairs. Local installers fit rigid and flexible sun tunnels, sun pipes and tubular skylights for dark hallways, landings and bathrooms across the UK. This cutaway illustration shows a roof collector, a reflective tube and a ceiling diffuser carrying daylight into a room below.</desc>\n  <defs>\n    <linearGradient id=\"st-guide-header\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n      <stop offset=\"0\" stop-color=\"#1f1d3a\"/>\n      <stop offset=\"1\" stop-color=\"#3b3a76\"/>\n    </linearGradient>\n    <linearGradient id=\"st-guide-tube\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"0\">\n      <stop offset=\"0\" stop-color=\"#c0cbd5\"/>\n      <stop offset=\"0.45\" stop-color=\"#ffffff\"/>\n      <stop offset=\"1\" stop-color=\"#8c9aa8\"/>\n    </linearGradient>\n    <linearGradient id=\"st-guide-daylight\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\">\n      <stop offset=\"0\" stop-color=\"#f5be3c\" stop-opacity=\"0.55\"/>\n      <stop offset=\"1\" stop-color=\"#f5be3c\" stop-opacity=\"0.04\"/>\n    </linearGradient>\n  </defs>\n\n  <rect width=\"1600\" height=\"900\" rx=\"28\" fill=\"#fbfaf6\"/>\n  <path d=\"M28 0H1572Q1600 0 1600 28V184H0V28Q0 0 28 0Z\" fill=\"url(#st-guide-header)\"/>\n  <g font-family=\"Arial, Helvetica, sans-serif\">\n    <text x=\"60\" y=\"55\" font-size=\"21\" font-weight=\"700\" letter-spacing=\"3\" fill=\"#f5be3c\">SUN-TUNNEL.CO.UK</text>\n    <text x=\"60\" y=\"116\" font-size=\"54\" font-weight=\"700\" fill=\"#ffffff\">Daylight from roof to room</text>\n    <text x=\"63\" y=\"157\" font-size=\"27\" fill=\"#eeeef8\">Free Quotes from Local Sun Tunnel Installers</text>\n    <g transform=\"translate(1470 93)\" fill=\"none\" stroke=\"#f5be3c\" stroke-width=\"5\" stroke-linecap=\"round\">\n      <circle r=\"27\" fill=\"#f5be3c\" stroke=\"none\"/>\n      <path d=\"M0-48V-60M0 48V60M-48 0H-60M48 0H60M-34-34L-43-43M34-34L43-43M-34 34L-43 43M34 34L43 43\"/>\n    </g>\n\n    <rect x=\"60\" y=\"222\" width=\"824\" height=\"590\" rx=\"24\" fill=\"#eef2f5\" stroke=\"#dce3e8\" stroke-width=\"2\"/>\n    <text x=\"94\" y=\"264\" font-size=\"23\" font-weight=\"700\" fill=\"#3b3a76\">HOW A SUN TUNNEL WORKS</text>\n\n    <!-- Schematic roof and room cutaway; the tube ends at the ceiling. -->\n    <path d=\"M160 525L440 325L760 525V764H160Z\" fill=\"#ffffff\" stroke=\"#bec9d1\" stroke-width=\"3\"/>\n    <path d=\"M160 525L440 325L760 525V592H160Z\" fill=\"#e0e6eb\"/>\n    <path d=\"M128 535L440 310L794 535\" fill=\"none\" stroke=\"#1f1d3a\" stroke-width=\"19\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M466 328L481 352M506 354L521 378M547 380L562 404M587 406L602 430M627 432L642 456M668 458L683 482M709 484L724 508M749 510L764 534\" stroke=\"#636180\" stroke-width=\"4\"/>\n    <path d=\"M160 592H760\" stroke=\"#a9b7c2\" stroke-width=\"9\"/>\n    <rect x=\"586\" y=\"421\" width=\"42\" height=\"173\" rx=\"5\" fill=\"url(#st-guide-tube)\" stroke=\"#667585\" stroke-width=\"3\"/>\n    <path d=\"M587 474H627M587 535H627\" stroke=\"#748393\" stroke-width=\"3\"/>\n    <path d=\"M607 437V575\" stroke=\"#f5be3c\" stroke-width=\"11\" stroke-linecap=\"round\"/>\n    <path d=\"M600 564L607 578L614 564\" fill=\"none\" stroke=\"#c9681c\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n\n    <!-- Collector and flashing sit on the exterior roof slope. -->\n    <g transform=\"translate(607 416) rotate(32.5)\">\n      <rect x=\"-43\" y=\"-8\" width=\"86\" height=\"15\" rx=\"4\" fill=\"#647382\"/>\n      <path d=\"M-29-9Q-29-42 0-42Q29-42 29-9Z\" fill=\"#d5eff8\" stroke=\"#3b3a76\" stroke-width=\"3\"/>\n      <path d=\"M-17-15Q-18-29-5-33\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"4\" stroke-linecap=\"round\"/>\n    </g>\n    <g stroke=\"#f5be3c\" stroke-width=\"5\" stroke-linecap=\"round\">\n      <path d=\"M681 310L637 367M736 347L660 386M621 291L612 365\"/>\n    </g>\n    <path d=\"M585 607L480 754H729L628 607Z\" fill=\"url(#st-guide-daylight)\"/>\n    <ellipse cx=\"607\" cy=\"597\" rx=\"40\" ry=\"10\" fill=\"#ffffff\" stroke=\"#667585\" stroke-width=\"3\"/>\n    <ellipse cx=\"607\" cy=\"598\" rx=\"27\" ry=\"5\" fill=\"#fce8a9\"/>\n    <path d=\"M160 766H760\" stroke=\"#c3a383\" stroke-width=\"9\"/>\n\n    <g fill=\"none\" stroke=\"#c9681c\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n      <path d=\"M320 338H520L579 393\"/>\n      <path d=\"M446 522H555L582 530\"/>\n      <path d=\"M421 658H517L566 608\"/>\n    </g>\n    <g fill=\"#c9681c\">\n      <circle cx=\"108\" cy=\"322\" r=\"18\"/>\n      <circle cx=\"230\" cy=\"506\" r=\"18\"/>\n      <circle cx=\"197\" cy=\"645\" r=\"18\"/>\n    </g>\n    <g font-size=\"20\" font-weight=\"700\" fill=\"#ffffff\" text-anchor=\"middle\">\n      <text x=\"108\" y=\"329\">1</text><text x=\"230\" y=\"513\">2</text><text x=\"197\" y=\"652\">3</text>\n    </g>\n    <g fill=\"#1f1d3a\" font-size=\"24\" font-weight=\"700\">\n      <text x=\"136\" y=\"329\">Roof collector</text>\n      <text x=\"258\" y=\"513\">Reflective tube</text>\n      <text x=\"225\" y=\"652\">Ceiling diffuser</text>\n    </g>\n    <text x=\"94\" y=\"797\" font-size=\"18\" fill=\"#536171\">Illustration only. The route and fittings depend on your property.</text>\n\n    <rect x=\"916\" y=\"222\" width=\"624\" height=\"260\" rx=\"24\" fill=\"#ffffff\" stroke=\"#e4e2ed\" stroke-width=\"2\"/>\n    <rect x=\"916\" y=\"248\" width=\"6\" height=\"208\" rx=\"3\" fill=\"#c9681c\"/>\n    <!-- Text sizes accommodate every current service and UK location name. -->\n    <text x=\"950\" y=\"271\" font-size=\"18\" font-weight=\"700\" letter-spacing=\"2\" fill=\"#c9681c\">YOUR SUN TUNNEL SERVICE</text>\n    <text x=\"950\" y=\"321\" font-size=\"26\" font-weight=\"700\" fill=\"#1f1d3a\">[SERVICE]</text>\n    <path d=\"M950 349H1506\" stroke=\"#ebe9f1\" stroke-width=\"2\"/>\n    <text x=\"950\" y=\"387\" font-size=\"18\" fill=\"#667085\">Local quotations in</text>\n    <text x=\"950\" y=\"440\" font-size=\"38\" font-weight=\"700\" fill=\"#3b3a76\">[LOCATION]</text>\n\n    <text x=\"950\" y=\"539\" font-size=\"27\" font-weight=\"700\" fill=\"#1f1d3a\">Start with the roof and the route</text>\n    <g fill=\"#c9681c\"><circle cx=\"960\" cy=\"580\" r=\"5\"/><circle cx=\"960\" cy=\"623\" r=\"5\"/><circle cx=\"960\" cy=\"666\" r=\"5\"/></g>\n    <g font-size=\"23\" fill=\"#3b3a76\">\n      <text x=\"978\" y=\"588\">Roof covering, shading and access</text>\n      <text x=\"978\" y=\"631\">Tube length, bends and insulation</text>\n      <text x=\"978\" y=\"674\">Diffuser position and ceiling finish</text>\n    </g>\n    <rect x=\"916\" y=\"709\" width=\"624\" height=\"103\" rx=\"20\" fill=\"#fdf1e2\"/>\n    <text x=\"950\" y=\"748\" font-size=\"25\" font-weight=\"700\" fill=\"#1f1d3a\">Compare up to four free quotes</text>\n    <text x=\"950\" y=\"783\" font-size=\"19\" fill=\"#70471f\">Independent installers. Subject to local availability.</text>\n\n    <text x=\"60\" y=\"862\" font-size=\"22\" fill=\"#536171\">Rigid and flexible sun tunnels · Sun pipes · Tubular skylights</text>\n    <text x=\"1540\" y=\"862\" font-size=\"22\" font-weight=\"700\" text-anchor=\"end\" fill=\"#3b3a76\">sun-tunnel.co.uk</text>\n  </g>\n</svg>\n"
};
